var D$ = Object.defineProperty;
var A$ = (n, e, t) => e in n ? D$(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Un = (n, e, t) => (A$(n, typeof e != "symbol" ? e + "" : e, t), t);
import Lr, { createElement as L$ } from "react";
import { jsx as O$ } from "react/jsx-runtime";
import "react-dom";
const _$ = "nylas-web-elements", Or = (
  /* nylas-web-elements */
  { allRenderFn: !0, appendChildSlotFix: !1, asyncLoading: !0, asyncQueue: !1, attachStyles: !0, cloneNodeFix: !1, cmpDidLoad: !0, cmpDidRender: !0, cmpDidUnload: !1, cmpDidUpdate: !0, cmpShouldUpdate: !1, cmpWillLoad: !0, cmpWillRender: !0, cmpWillUpdate: !0, connectedCallback: !0, constructableCSS: !0, cssAnnotations: !0, devTools: !1, disconnectedCallback: !0, element: !1, event: !0, experimentalScopedSlotChanges: !1, experimentalSlotFixes: !1, formAssociated: !0, hasRenderFn: !0, hostListener: !0, hostListenerTarget: !0, hostListenerTargetBody: !0, hostListenerTargetDocument: !0, hostListenerTargetParent: !1, hostListenerTargetWindow: !0, hotModuleReplacement: !1, hydrateClientSide: !1, hydrateServerSide: !1, hydratedAttribute: !1, hydratedClass: !0, initializeNextTick: !1, invisiblePrehydration: !0, isDebug: !1, isDev: !1, isTesting: !1, lazyLoad: !0, lifecycle: !0, lifecycleDOMEvents: !1, member: !0, method: !0, mode: !1, observeAttribute: !0, profile: !1, prop: !0, propBoolean: !0, propMutable: !0, propNumber: !0, propString: !0, reflect: !0, scoped: !0, scopedSlotTextContentFix: !1, scriptDataOpts: !1, shadowDelegatesFocus: !1, shadowDom: !0, slot: !0, slotChildNodesFix: !1, slotRelocation: !0, state: !0, style: !0, svg: !0, taskQueue: !0, transformTagName: !1, updatable: !0, vdomAttribute: !0, vdomClass: !0, vdomFunctional: !0, vdomKey: !0, vdomListener: !0, vdomPropOrAttr: !0, vdomRef: !0, vdomRender: !0, vdomStyle: !0, vdomText: !0, vdomXlink: !1, watchCallback: !0 }
);
let lt, Xn, Sn, _r = !1, nn = !1, Di = !1, ye = !1, ei = null, ti = !1;
const Ge = (n, e = "") => () => {
}, I$ = (n, e) => () => {
}, R$ = "{visibility:hidden}.hydrated{visibility:inherit}", Ir = "slot-fb{display:contents}slot-fb[hidden]{display:none}", N$ = [
  "formAssociatedCallback",
  "formResetCallback",
  "formDisabledCallback",
  "formStateRestoreCallback"
], ca = {}, F$ = "http://www.w3.org/2000/svg", U$ = "http://www.w3.org/1999/xhtml", z$ = (n) => n != null, Ai = (n) => (n = typeof n, n === "object" || n === "function");
function Rr(n) {
  var e, t, i;
  return (i = (t = (e = n.head) === null || e === void 0 ? void 0 : e.querySelector('meta[name="csp-nonce"]')) === null || t === void 0 ? void 0 : t.getAttribute("content")) !== null && i !== void 0 ? i : void 0;
}
const Nr = (n, e, ...t) => {
  let i = null, a = null, r = null, o = !1, l = !1;
  const s = [], u = (f) => {
    for (let d = 0; d < f.length; d++)
      i = f[d], Array.isArray(i) ? u(i) : i != null && typeof i != "boolean" && ((o = typeof n != "function" && !Ai(i)) && (i = String(i)), o && l ? s[s.length - 1].$text$ += i : s.push(o ? an(null, i) : i), l = o);
  };
  if (u(t), e) {
    e.key && (a = e.key), e.name && (r = e.name);
    {
      const f = e.className || e.class;
      f && (e.class = typeof f != "object" ? f : Object.keys(f).filter((d) => f[d]).join(" "));
    }
  }
  if (typeof n == "function")
    return n(e === null ? {} : e, s, q$);
  const c = an(n, null);
  return c.$attrs$ = e, s.length > 0 && (c.$children$ = s), c.$key$ = a, c.$name$ = r, c;
}, an = (n, e) => {
  const t = {
    $flags$: 0,
    $tag$: n,
    $text$: e,
    $elm$: null,
    $children$: null
  };
  return t.$attrs$ = null, t.$key$ = null, t.$name$ = null, t;
}, H$ = {}, j$ = (n) => n && n.$tag$ === H$, q$ = {
  forEach: (n, e) => n.map(da).forEach(e),
  map: (n, e) => n.map(da).map(e).map(Y$)
}, da = (n) => ({
  vattrs: n.$attrs$,
  vchildren: n.$children$,
  vkey: n.$key$,
  vname: n.$name$,
  vtag: n.$tag$,
  vtext: n.$text$
}), Y$ = (n) => {
  if (typeof n.vtag == "function") {
    const t = Object.assign({}, n.vattrs);
    return n.vkey && (t.key = n.vkey), n.vname && (t.name = n.vname), Nr(n.vtag, t, ...n.vchildren || []);
  }
  const e = an(n.vtag, n.vtext);
  return e.$attrs$ = n.vattrs, e.$children$ = n.vchildren, e.$key$ = n.vkey, e.$name$ = n.vname, e;
}, V$ = (n, e) => n != null && !Ai(n) ? e & 4 ? n === "false" ? !1 : n === "" || !!n : e & 2 ? parseFloat(n) : e & 1 ? String(n) : n : n, G$ = (n) => Re(n).$hostElement$, NA = (n, e, t) => {
  const i = G$(n);
  return {
    emit: (a) => Fr(i, e, {
      bubbles: !!(t & 4),
      composed: !!(t & 2),
      cancelable: !!(t & 1),
      detail: a
    })
  };
}, Fr = (n, e, t) => {
  const i = te.ce(e, t);
  return n.dispatchEvent(i), i;
}, fa = /* @__PURE__ */ new WeakMap(), W$ = (n, e, t) => {
  let i = on.get(n);
  TB && t ? (i = i || new CSSStyleSheet(), typeof i == "string" ? i = e : i.replaceSync(e)) : i = e, on.set(n, i);
}, K$ = (n, e, t) => {
  var i;
  const a = Ur(e), r = on.get(a);
  if (n = n.nodeType === 11 ? n : de, r)
    if (typeof r == "string") {
      n = n.head || n;
      let o = fa.get(n), l;
      if (o || fa.set(n, o = /* @__PURE__ */ new Set()), !o.has(a)) {
        {
          l = de.createElement("style"), l.innerHTML = r;
          const s = (i = te.$nonce$) !== null && i !== void 0 ? i : Rr(de);
          s != null && l.setAttribute("nonce", s), n.insertBefore(l, n.querySelector("link"));
        }
        e.$flags$ & 4 && (l.innerHTML += Ir), o && o.add(a);
      }
    } else
      n.adoptedStyleSheets.includes(r) || (n.adoptedStyleSheets = [...n.adoptedStyleSheets, r]);
  return a;
}, Z$ = (n) => {
  const e = n.$cmpMeta$, t = n.$hostElement$, i = e.$flags$, a = Ge("attachStyles", e.$tagName$), r = K$(t.shadowRoot ? t.shadowRoot : t.getRootNode(), e);
  i & 10 && (t["s-sc"] = r, t.classList.add(r + "-h"), i & 2 && t.classList.add(r + "-s")), a();
}, Ur = (n, e) => "sc-" + n.$tagName$, ga = (n, e, t, i, a, r) => {
  if (t !== i) {
    let o = Ta(n, e), l = e.toLowerCase();
    if (e === "class") {
      const s = n.classList, u = ha(t), c = ha(i);
      s.remove(...u.filter((f) => f && !c.includes(f))), s.add(...c.filter((f) => f && !u.includes(f)));
    } else if (e === "style") {
      for (const s in t)
        (!i || i[s] == null) && (s.includes("-") ? n.style.removeProperty(s) : n.style[s] = "");
      for (const s in i)
        (!t || i[s] !== t[s]) && (s.includes("-") ? n.style.setProperty(s, i[s]) : n.style[s] = i[s]);
    } else if (e !== "key")
      if (e === "ref")
        i && i(n);
      else if (!o && e[0] === "o" && e[1] === "n") {
        if (e[2] === "-" ? e = e.slice(3) : Ta(It, l) ? e = l.slice(2) : e = l[2] + e.slice(3), t || i) {
          const s = e.endsWith(zr);
          e = e.replace(Q$, ""), t && te.rel(n, e, t, s), i && te.ael(n, e, i, s);
        }
      } else {
        const s = Ai(i);
        if ((o || s && i !== null) && !a)
          try {
            if (n.tagName.includes("-"))
              n[e] = i;
            else {
              const u = i ?? "";
              e === "list" ? o = !1 : (t == null || n[e] != u) && (n[e] = u);
            }
          } catch {
          }
        i == null || i === !1 ? (i !== !1 || n.getAttribute(e) === "") && n.removeAttribute(e) : (!o || r & 4 || a) && !s && (i = i === !0 ? "" : i, n.setAttribute(e, i));
      }
  }
}, J$ = /\s/, ha = (n) => n ? n.split(J$) : [], zr = "Capture", Q$ = new RegExp(zr + "$"), Hr = (n, e, t, i) => {
  const a = e.$elm$.nodeType === 11 && e.$elm$.host ? e.$elm$.host : e.$elm$, r = n && n.$attrs$ || ca, o = e.$attrs$ || ca;
  for (i in r)
    i in o || ga(a, i, r[i], void 0, t, e.$flags$);
  for (i in o)
    ga(a, i, r[i], o[i], t, e.$flags$);
}, rn = (n, e, t, i) => {
  const a = e.$children$[t];
  let r = 0, o, l, s;
  if (_r || (Di = !0, a.$tag$ === "slot" && (lt && i.classList.add(lt + "-s"), a.$flags$ |= a.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), a.$text$ !== null)
    o = a.$elm$ = de.createTextNode(a.$text$);
  else if (a.$flags$ & 1)
    o = a.$elm$ = de.createTextNode("");
  else {
    if (ye || (ye = a.$tag$ === "svg"), o = a.$elm$ = de.createElementNS(ye ? F$ : U$, a.$flags$ & 2 ? "slot-fb" : a.$tag$), ye && a.$tag$ === "foreignObject" && (ye = !1), Hr(null, a, ye), z$(lt) && o["s-si"] !== lt && o.classList.add(o["s-si"] = lt), a.$children$)
      for (r = 0; r < a.$children$.length; ++r)
        l = rn(n, a, r, o), l && o.appendChild(l);
    a.$tag$ === "svg" ? ye = !1 : o.tagName === "foreignObject" && (ye = !0);
  }
  return o["s-hn"] = Sn, a.$flags$ & 3 && (o["s-sr"] = !0, o["s-cr"] = Xn, o["s-sn"] = a.$name$ || "", s = n && n.$children$ && n.$children$[t], s && s.$tag$ === a.$tag$ && n.$elm$ && wt(n.$elm$, !1)), o;
}, wt = (n, e) => {
  te.$flags$ |= 1;
  const t = n.childNodes;
  for (let i = t.length - 1; i >= 0; i--) {
    const a = t[i];
    a["s-hn"] !== Sn && a["s-ol"] && (Yr(a).insertBefore(a, Li(a)), a["s-ol"].remove(), a["s-ol"] = void 0, a["s-sh"] = void 0, Di = !0), e && wt(a, e);
  }
  te.$flags$ &= -2;
}, jr = (n, e, t, i, a, r) => {
  let o = n["s-cr"] && n["s-cr"].parentNode || n, l;
  for (o.shadowRoot && o.tagName === Sn && (o = o.shadowRoot); a <= r; ++a)
    i[a] && (l = rn(null, t, a, n), l && (i[a].$elm$ = l, o.insertBefore(l, Li(e))));
}, qr = (n, e, t) => {
  for (let i = e; i <= t; ++i) {
    const a = n[i];
    if (a) {
      const r = a.$elm$;
      Wr(a), r && (nn = !0, r["s-ol"] ? r["s-ol"].remove() : wt(r, !0), r.remove());
    }
  }
}, X$ = (n, e, t, i, a = !1) => {
  let r = 0, o = 0, l = 0, s = 0, u = e.length - 1, c = e[0], f = e[u], d = i.length - 1, g = i[0], b = i[d], p, h;
  for (; r <= u && o <= d; )
    if (c == null)
      c = e[++r];
    else if (f == null)
      f = e[--u];
    else if (g == null)
      g = i[++o];
    else if (b == null)
      b = i[--d];
    else if (zt(c, g, a))
      ut(c, g, a), c = e[++r], g = i[++o];
    else if (zt(f, b, a))
      ut(f, b, a), f = e[--u], b = i[--d];
    else if (zt(c, b, a))
      (c.$tag$ === "slot" || b.$tag$ === "slot") && wt(c.$elm$.parentNode, !1), ut(c, b, a), n.insertBefore(c.$elm$, f.$elm$.nextSibling), c = e[++r], b = i[--d];
    else if (zt(f, g, a))
      (c.$tag$ === "slot" || b.$tag$ === "slot") && wt(f.$elm$.parentNode, !1), ut(f, g, a), n.insertBefore(f.$elm$, c.$elm$), f = e[--u], g = i[++o];
    else {
      for (l = -1, s = r; s <= u; ++s)
        if (e[s] && e[s].$key$ !== null && e[s].$key$ === g.$key$) {
          l = s;
          break;
        }
      l >= 0 ? (h = e[l], h.$tag$ !== g.$tag$ ? p = rn(e && e[o], t, l, n) : (ut(h, g, a), e[l] = void 0, p = h.$elm$), g = i[++o]) : (p = rn(e && e[o], t, o, n), g = i[++o]), p && Yr(c.$elm$).insertBefore(p, Li(c.$elm$));
    }
  r > u ? jr(n, i[d + 1] == null ? null : i[d + 1].$elm$, t, i, o, d) : o > d && qr(e, r, u);
}, zt = (n, e, t = !1) => n.$tag$ === e.$tag$ ? n.$tag$ === "slot" ? n.$name$ === e.$name$ : t ? !0 : n.$key$ === e.$key$ : !1, Li = (n) => n && n["s-ol"] || n, Yr = (n) => (n["s-ol"] ? n["s-ol"] : n).parentNode, ut = (n, e, t = !1) => {
  const i = e.$elm$ = n.$elm$, a = n.$children$, r = e.$children$, o = e.$tag$, l = e.$text$;
  let s;
  l === null ? (ye = o === "svg" ? !0 : o === "foreignObject" ? !1 : ye, o === "slot" || Hr(n, e, ye), a !== null && r !== null ? X$(i, a, e, r, t) : r !== null ? (n.$text$ !== null && (i.textContent = ""), jr(i, null, e, r, 0, r.length - 1)) : a !== null && qr(a, 0, a.length - 1), ye && o === "svg" && (ye = !1)) : (s = i["s-cr"]) ? s.parentNode.textContent = l : n.$text$ !== l && (i.data = l);
}, Vr = (n) => {
  const e = n.childNodes;
  for (const t of e)
    if (t.nodeType === 1) {
      if (t["s-sr"]) {
        const i = t["s-sn"];
        t.hidden = !1;
        for (const a of e)
          if (a !== t) {
            if (a["s-hn"] !== t["s-hn"] || i !== "") {
              if (a.nodeType === 1 && (i === a.getAttribute("slot") || i === a["s-sn"])) {
                t.hidden = !0;
                break;
              }
            } else if (a.nodeType === 1 || a.nodeType === 3 && a.textContent.trim() !== "") {
              t.hidden = !0;
              break;
            }
          }
      }
      Vr(t);
    }
}, qe = [], Gr = (n) => {
  let e, t, i;
  for (const a of n.childNodes) {
    if (a["s-sr"] && (e = a["s-cr"]) && e.parentNode) {
      t = e.parentNode.childNodes;
      const r = a["s-sn"];
      for (i = t.length - 1; i >= 0; i--)
        if (e = t[i], !e["s-cn"] && !e["s-nr"] && e["s-hn"] !== a["s-hn"] && !Or.experimentalSlotFixes)
          if (ma(e, r)) {
            let o = qe.find((l) => l.$nodeToRelocate$ === e);
            nn = !0, e["s-sn"] = e["s-sn"] || r, o ? (o.$nodeToRelocate$["s-sh"] = a["s-hn"], o.$slotRefNode$ = a) : (e["s-sh"] = a["s-hn"], qe.push({
              $slotRefNode$: a,
              $nodeToRelocate$: e
            })), e["s-sr"] && qe.map((l) => {
              ma(l.$nodeToRelocate$, e["s-sn"]) && (o = qe.find((s) => s.$nodeToRelocate$ === e), o && !l.$slotRefNode$ && (l.$slotRefNode$ = o.$slotRefNode$));
            });
          } else
            qe.some((o) => o.$nodeToRelocate$ === e) || qe.push({
              $nodeToRelocate$: e
            });
    }
    a.nodeType === 1 && Gr(a);
  }
}, ma = (n, e) => n.nodeType === 1 ? n.getAttribute("slot") === null && e === "" || n.getAttribute("slot") === e : n["s-sn"] === e ? !0 : e === "", Wr = (n) => {
  n.$attrs$ && n.$attrs$.ref && n.$attrs$.ref(null), n.$children$ && n.$children$.map(Wr);
}, eB = (n, e, t = !1) => {
  var i, a, r, o;
  const l = n.$hostElement$, s = n.$cmpMeta$, u = n.$vnode$ || an(null, null), c = j$(e) ? e : Nr(null, null, e);
  if (Sn = l.tagName, s.$attrsToReflect$ && (c.$attrs$ = c.$attrs$ || {}, s.$attrsToReflect$.map(([f, d]) => c.$attrs$[d] = l[f])), t && c.$attrs$)
    for (const f of Object.keys(c.$attrs$))
      l.hasAttribute(f) && !["key", "ref", "style", "class"].includes(f) && (c.$attrs$[f] = l[f]);
  c.$tag$ = null, c.$flags$ |= 4, n.$vnode$ = c, c.$elm$ = u.$elm$ = l.shadowRoot || l, lt = l["s-sc"], Xn = l["s-cr"], _r = (s.$flags$ & 1) !== 0, nn = !1, ut(u, c, t);
  {
    if (te.$flags$ |= 1, Di) {
      Gr(c.$elm$);
      for (const f of qe) {
        const d = f.$nodeToRelocate$;
        if (!d["s-ol"]) {
          const g = de.createTextNode("");
          g["s-nr"] = d, d.parentNode.insertBefore(d["s-ol"] = g, d);
        }
      }
      for (const f of qe) {
        const d = f.$nodeToRelocate$, g = f.$slotRefNode$;
        if (g) {
          const b = g.parentNode;
          let p = g.nextSibling;
          {
            let h = (i = d["s-ol"]) === null || i === void 0 ? void 0 : i.previousSibling;
            for (; h; ) {
              let E = (a = h["s-nr"]) !== null && a !== void 0 ? a : null;
              if (E && E["s-sn"] === d["s-sn"] && b === E.parentNode && (E = E.nextSibling, !E || !E["s-nr"])) {
                p = E;
                break;
              }
              h = h.previousSibling;
            }
          }
          (!p && b !== d.parentNode || d.nextSibling !== p) && d !== p && (!d["s-hn"] && d["s-ol"] && (d["s-hn"] = d["s-ol"].parentNode.nodeName), b.insertBefore(d, p), d.nodeType === 1 && (d.hidden = (r = d["s-ih"]) !== null && r !== void 0 ? r : !1));
        } else
          d.nodeType === 1 && (t && (d["s-ih"] = (o = d.hidden) !== null && o !== void 0 ? o : !1), d.hidden = !0);
      }
    }
    nn && Vr(c.$elm$), te.$flags$ &= -2, qe.length = 0;
  }
  Xn = void 0;
}, Kr = (n, e) => {
  e && !n.$onRenderResolve$ && e["s-p"] && e["s-p"].push(new Promise((t) => n.$onRenderResolve$ = t));
}, Cn = (n, e) => {
  if (n.$flags$ |= 16, n.$flags$ & 4) {
    n.$flags$ |= 512;
    return;
  }
  return Kr(n, n.$ancestorComponent$), EB(() => tB(n, e));
}, tB = (n, e) => {
  const t = Ge("scheduleUpdate", n.$cmpMeta$.$tagName$), i = n.$lazyInstance$;
  let a;
  return e ? (n.$flags$ |= 256, n.$queuedListeners$ && (n.$queuedListeners$.map(([r, o]) => Ye(i, r, o)), n.$queuedListeners$ = void 0), a = Ye(i, "componentWillLoad")) : a = Ye(i, "componentWillUpdate"), a = pa(a, () => Ye(i, "componentWillRender")), t(), pa(a, () => iB(n, i, e));
}, pa = (n, e) => nB(n) ? n.then(e) : e(), nB = (n) => n instanceof Promise || n && n.then && typeof n.then == "function", iB = async (n, e, t) => {
  var i;
  const a = n.$hostElement$, r = Ge("update", n.$cmpMeta$.$tagName$), o = a["s-rc"];
  t && Z$(n);
  const l = Ge("render", n.$cmpMeta$.$tagName$);
  aB(n, e, a, t), o && (o.map((s) => s()), a["s-rc"] = void 0), l(), r();
  {
    const s = (i = a["s-p"]) !== null && i !== void 0 ? i : [], u = () => rB(n);
    s.length === 0 ? u() : (Promise.all(s).then(u), n.$flags$ |= 4, s.length = 0);
  }
}, aB = (n, e, t, i) => {
  try {
    ei = e, e = e.render(), n.$flags$ &= -17, n.$flags$ |= 2, eB(n, e, i);
  } catch (a) {
    N(a, n.$hostElement$);
  }
  return ei = null, null;
}, ba = () => ei, rB = (n) => {
  const e = n.$cmpMeta$.$tagName$, t = n.$hostElement$, i = Ge("postUpdate", e), a = n.$lazyInstance$, r = n.$ancestorComponent$;
  Ye(a, "componentDidRender"), n.$flags$ & 64 ? (Ye(a, "componentDidUpdate"), i()) : (n.$flags$ |= 64, Jr(t), Ye(a, "componentDidLoad"), i(), n.$onReadyResolve$(t), r || Zr()), n.$onInstanceResolve$(t), n.$onRenderResolve$ && (n.$onRenderResolve$(), n.$onRenderResolve$ = void 0), n.$flags$ & 512 && _i(() => Cn(n, !1)), n.$flags$ &= -517;
}, ya = (n) => {
  {
    const e = Re(n), t = e.$hostElement$.isConnected;
    return t && (e.$flags$ & 18) === 2 && Cn(e, !1), t;
  }
}, Zr = (n) => {
  Jr(de.documentElement), _i(() => Fr(It, "appload", { detail: { namespace: _$ } }));
}, Ye = (n, e, t) => {
  if (n && n[e])
    try {
      return n[e](t);
    } catch (i) {
      N(i);
    }
}, Jr = (n) => n.classList.add("hydrated"), oB = (n, e) => Re(n).$instanceValues$.get(e), sB = (n, e, t, i) => {
  const a = Re(n), r = a.$hostElement$, o = a.$instanceValues$.get(e), l = a.$flags$, s = a.$lazyInstance$;
  t = V$(t, i.$members$[e][0]);
  const u = Number.isNaN(o) && Number.isNaN(t), c = t !== o && !u;
  if ((!(l & 8) || o === void 0) && c && (a.$instanceValues$.set(e, t), s)) {
    if (i.$watchers$ && l & 128) {
      const f = i.$watchers$[e];
      f && f.map((d) => {
        try {
          s[d](t, o, e);
        } catch (g) {
          N(g, r);
        }
      });
    }
    (l & 18) === 2 && Cn(a, !1);
  }
}, Qr = (n, e, t) => {
  var i;
  const a = n.prototype;
  if (e.$flags$ & 64 && t & 1 && N$.forEach((r) => Object.defineProperty(a, r, {
    value(...o) {
      const l = Re(this), s = l.$lazyInstance$;
      if (!s)
        l.$onReadyPromise$.then((u) => {
          const c = u[r];
          typeof c == "function" && c.call(u, ...o);
        });
      else {
        const u = s[r];
        typeof u == "function" && u.call(s, ...o);
      }
    }
  })), e.$members$) {
    n.watchers && (e.$watchers$ = n.watchers);
    const r = Object.entries(e.$members$);
    if (r.map(([o, [l]]) => {
      l & 31 || t & 2 && l & 32 ? Object.defineProperty(a, o, {
        get() {
          return oB(this, o);
        },
        set(s) {
          sB(this, o, s, e);
        },
        configurable: !0,
        enumerable: !0
      }) : t & 1 && l & 64 && Object.defineProperty(a, o, {
        value(...s) {
          var u;
          const c = Re(this);
          return (u = c == null ? void 0 : c.$onInstancePromise$) === null || u === void 0 ? void 0 : u.then(() => {
            var f;
            return (f = c.$lazyInstance$) === null || f === void 0 ? void 0 : f[o](...s);
          });
        }
      });
    }), t & 1) {
      const o = /* @__PURE__ */ new Map();
      a.attributeChangedCallback = function(l, s, u) {
        te.jmp(() => {
          var c;
          const f = o.get(l);
          if (this.hasOwnProperty(f))
            u = this[f], delete this[f];
          else {
            if (a.hasOwnProperty(f) && typeof this[f] == "number" && this[f] == u)
              return;
            if (f == null) {
              const d = Re(this), g = d == null ? void 0 : d.$flags$;
              if (g && !(g & 8) && g & 128 && u !== s) {
                const b = d.$lazyInstance$, p = (c = e.$watchers$) === null || c === void 0 ? void 0 : c[l];
                p == null || p.forEach((h) => {
                  b[h] != null && b[h].call(b, u, s, l);
                });
              }
              return;
            }
          }
          this[f] = u === null && typeof this[f] == "boolean" ? !1 : u;
        });
      }, n.observedAttributes = Array.from(/* @__PURE__ */ new Set([
        ...Object.keys((i = e.$watchers$) !== null && i !== void 0 ? i : {}),
        ...r.filter(
          ([l, s]) => s[0] & 15
          /* MEMBER_FLAGS.HasAttribute */
        ).map(([l, s]) => {
          var u;
          const c = s[1] || l;
          return o.set(c, l), s[0] & 512 && ((u = e.$attrsToReflect$) === null || u === void 0 || u.push([l, c])), c;
        })
      ]));
    }
  }
  return n;
}, lB = async (n, e, t, i) => {
  let a;
  if (!(e.$flags$ & 32)) {
    e.$flags$ |= 32;
    {
      if (a = bB(t), a.then) {
        const s = I$();
        a = await a, s();
      }
      a.isProxied || (t.$watchers$ = a.watchers, Qr(
        a,
        t,
        2
        /* PROXY_FLAGS.proxyState */
      ), a.isProxied = !0);
      const l = Ge("createInstance", t.$tagName$);
      e.$flags$ |= 8;
      try {
        new a(e);
      } catch (s) {
        N(s);
      }
      e.$flags$ &= -9, e.$flags$ |= 128, l(), ni(e.$lazyInstance$);
    }
    if (a.style) {
      let l = a.style;
      const s = Ur(t);
      if (!on.has(s)) {
        const u = Ge("registerStyles", t.$tagName$);
        W$(s, l, !!(t.$flags$ & 1)), u();
      }
    }
  }
  const r = e.$ancestorComponent$, o = () => Cn(e, !0);
  r && r["s-rc"] ? r["s-rc"].push(o) : o();
}, ni = (n) => {
  Ye(n, "connectedCallback");
}, uB = (n) => {
  if (!(te.$flags$ & 1)) {
    const e = Re(n), t = e.$cmpMeta$, i = Ge("connectedCallback", t.$tagName$);
    if (e.$flags$ & 1)
      Xr(n, e, t.$listeners$), e != null && e.$lazyInstance$ ? ni(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => ni(e.$lazyInstance$));
    else {
      e.$flags$ |= 1, // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      t.$flags$ & 12 && cB(n);
      {
        let a = n;
        for (; a = a.parentNode || a.host; )
          if (a["s-p"]) {
            Kr(e, e.$ancestorComponent$ = a);
            break;
          }
      }
      t.$members$ && Object.entries(t.$members$).map(([a, [r]]) => {
        if (r & 31 && n.hasOwnProperty(a)) {
          const o = n[a];
          delete n[a], n[a] = o;
        }
      }), lB(n, e, t);
    }
    i();
  }
}, cB = (n) => {
  const e = n["s-cr"] = de.createComment("");
  e["s-cn"] = !0, n.insertBefore(e, n.firstChild);
}, va = (n) => {
  Ye(n, "disconnectedCallback");
}, dB = async (n) => {
  if (!(te.$flags$ & 1)) {
    const e = Re(n);
    e.$rmListeners$ && (e.$rmListeners$.map((t) => t()), e.$rmListeners$ = void 0), e != null && e.$lazyInstance$ ? va(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => va(e.$lazyInstance$));
  }
}, fB = (n, e = {}) => {
  var t;
  const i = Ge(), a = [], r = e.exclude || [], o = It.customElements, l = de.head, s = /* @__PURE__ */ l.querySelector("meta[charset]"), u = /* @__PURE__ */ de.createElement("style"), c = [];
  let f, d = !0;
  Object.assign(te, e), te.$resourcesUrl$ = new URL(e.resourcesUrl || "./", de.baseURI).href;
  let g = !1;
  if (n.map((b) => {
    b[1].map((p) => {
      var h;
      const E = {
        $flags$: p[0],
        $tagName$: p[1],
        $members$: p[2],
        $listeners$: p[3]
      };
      E.$flags$ & 4 && (g = !0), E.$members$ = p[2], E.$listeners$ = p[3], E.$attrsToReflect$ = [], E.$watchers$ = (h = p[4]) !== null && h !== void 0 ? h : {};
      const B = E.$tagName$, _ = class extends HTMLElement {
        // StencilLazyHost
        constructor(D) {
          super(D), D = this, pB(D, E), E.$flags$ & 1 && D.attachShadow({ mode: "open" });
        }
        connectedCallback() {
          f && (clearTimeout(f), f = null), d ? c.push(this) : te.jmp(() => uB(this));
        }
        disconnectedCallback() {
          te.jmp(() => dB(this));
        }
        componentOnReady() {
          return Re(this).$onReadyPromise$;
        }
      };
      E.$flags$ & 64 && (_.formAssociated = !0), E.$lazyBundleId$ = b[0], !r.includes(B) && !o.get(B) && (a.push(B), o.define(B, Qr(
        _,
        E,
        1
        /* PROXY_FLAGS.isElementConstructor */
      )));
    });
  }), g && (u.innerHTML += Ir), u.innerHTML += a + R$, u.innerHTML.length) {
    u.setAttribute("data-styles", "");
    const b = (t = te.$nonce$) !== null && t !== void 0 ? t : Rr(de);
    b != null && u.setAttribute("nonce", b), l.insertBefore(u, s ? s.nextSibling : l.firstChild);
  }
  d = !1, c.length ? c.map((b) => b.connectedCallback()) : te.jmp(() => f = setTimeout(Zr, 30)), i();
}, FA = (n, e) => e, Xr = (n, e, t, i) => {
  t && t.map(([a, r, o]) => {
    const l = hB(n, a), s = gB(e, o), u = mB(a);
    te.ael(l, r, s, u), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => te.rel(l, r, s, u));
  });
}, gB = (n, e) => (t) => {
  try {
    n.$flags$ & 256 ? n.$lazyInstance$[e](t) : (n.$queuedListeners$ = n.$queuedListeners$ || []).push([e, t]);
  } catch (i) {
    N(i);
  }
}, hB = (n, e) => e & 4 ? de : e & 8 ? It : e & 16 ? de.body : n, mB = (n) => yB ? {
  passive: (n & 1) !== 0,
  capture: (n & 2) !== 0
} : (n & 2) !== 0, UA = (n) => te.$nonce$ = n, Oi = /* @__PURE__ */ new WeakMap(), Re = (n) => Oi.get(n), zA = (n, e) => Oi.set(e.$lazyInstance$ = n, e), pB = (n, e) => {
  const t = {
    $flags$: 0,
    $hostElement$: n,
    $cmpMeta$: e,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return t.$onInstancePromise$ = new Promise((i) => t.$onInstanceResolve$ = i), t.$onReadyPromise$ = new Promise((i) => t.$onReadyResolve$ = i), n["s-p"] = [], n["s-rc"] = [], Xr(n, t, e.$listeners$), Oi.set(n, t);
}, Ta = (n, e) => e in n, N = (n, e) => (0, console.error)(n, e), zn = /* @__PURE__ */ new Map(), bB = (n, e, t) => {
  const i = n.$tagName$.replace(/-/g, "_"), a = n.$lazyBundleId$, r = zn.get(a);
  if (r)
    return r[i];
  if (!t || !Or.hotModuleReplacement) {
    const o = (l) => (zn.set(a, l), l[i]);
    switch (a) {
      case "archive-icon":
        return import(
          /* webpackMode: "lazy" */
          "./archive-icon.entry-a2492cf3.js"
        ).then(o, N);
      case "arrow-icon":
        return import(
          /* webpackMode: "lazy" */
          "./arrow-icon.entry-9414299f.js"
        ).then(o, N);
      case "bold-icon":
        return import(
          /* webpackMode: "lazy" */
          "./bold-icon.entry-b72aed9f.js"
        ).then(o, N);
      case "document-refresh-icon":
        return import(
          /* webpackMode: "lazy" */
          "./document-refresh-icon.entry-e500b4e3.js"
        ).then(o, N);
      case "folder-icon":
        return import(
          /* webpackMode: "lazy" */
          "./folder-icon.entry-54c3cc66.js"
        ).then(o, N);
      case "forward-icon":
        return import(
          /* webpackMode: "lazy" */
          "./forward-icon.entry-5e540f05.js"
        ).then(o, N);
      case "inbox-icon":
        return import(
          /* webpackMode: "lazy" */
          "./inbox-icon.entry-aa78ba8c.js"
        ).then(o, N);
      case "italic-icon":
        return import(
          /* webpackMode: "lazy" */
          "./italic-icon.entry-0e85d0d9.js"
        ).then(o, N);
      case "nylas-scheduler-editor":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-scheduler-editor.entry-7b188a38.js"
        ).then(o, N);
      case "nylas-scheduling":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-scheduling.entry-e9929b03.js"
        ).then(o, N);
      case "play-icon":
        return import(
          /* webpackMode: "lazy" */
          "./play-icon.entry-f949a80f.js"
        ).then(o, N);
      case "refresh-icon":
        return import(
          /* webpackMode: "lazy" */
          "./refresh-icon.entry-d6df8b1c.js"
        ).then(o, N);
      case "reply-all-icon":
        return import(
          /* webpackMode: "lazy" */
          "./reply-all-icon.entry-7ebf01a0.js"
        ).then(o, N);
      case "reply-icon":
        return import(
          /* webpackMode: "lazy" */
          "./reply-icon.entry-d1622d85.js"
        ).then(o, N);
      case "sent-icon":
        return import(
          /* webpackMode: "lazy" */
          "./sent-icon.entry-fe12bc2f.js"
        ).then(o, N);
      case "spam-icon":
        return import(
          /* webpackMode: "lazy" */
          "./spam-icon.entry-b97c7709.js"
        ).then(o, N);
      case "star-icon":
        return import(
          /* webpackMode: "lazy" */
          "./star-icon.entry-98b80645.js"
        ).then(o, N);
      case "stop-icon":
        return import(
          /* webpackMode: "lazy" */
          "./stop-icon.entry-0290fd30.js"
        ).then(o, N);
      case "trash-fill-icon":
        return import(
          /* webpackMode: "lazy" */
          "./trash-fill-icon.entry-825055fd.js"
        ).then(o, N);
      case "underline-icon":
        return import(
          /* webpackMode: "lazy" */
          "./underline-icon.entry-40028bc6.js"
        ).then(o, N);
      case "google-logo-icon_6":
        return import(
          /* webpackMode: "lazy" */
          "./google-logo-icon_6.entry-00d40db2.js"
        ).then(o, N);
      case "nylas-booked-event-card_12":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-booked-event-card_12.entry-e7464ae7.js"
        ).then(o, N);
      case "calendar-agenda-fill-icon_36":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-agenda-fill-icon_36.entry-efa7ad26.js"
        ).then(o, N);
      case "calendar-check-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-check-icon_2.entry-dfb0036d.js"
        ).then(o, N);
      case "delete-icon":
        return import(
          /* webpackMode: "lazy" */
          "./delete-icon.entry-580bfcc9.js"
        ).then(o, N);
      case "nylas-event-calendar_3":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-event-calendar_3.entry-9abd46c2.js"
        ).then(o, N);
      case "person-icon":
        return import(
          /* webpackMode: "lazy" */
          "./person-icon.entry-d2856f08.js"
        ).then(o, N);
      case "warning-icon":
        return import(
          /* webpackMode: "lazy" */
          "./warning-icon.entry-24e37759.js"
        ).then(o, N);
      case "calendar-cancel-icon":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-cancel-icon.entry-0f739a8a.js"
        ).then(o, N);
      case "calendar-icon":
        return import(
          /* webpackMode: "lazy" */
          "./calendar-icon.entry-f197396d.js"
        ).then(o, N);
      case "checkmark-icon_15":
        return import(
          /* webpackMode: "lazy" */
          "./checkmark-icon_15.entry-5c09cff5.js"
        ).then(o, N);
      case "google-meet-icon_5":
        return import(
          /* webpackMode: "lazy" */
          "./google-meet-icon_5.entry-f1f05903.js"
        ).then(o, N);
      case "clock-icon_4":
        return import(
          /* webpackMode: "lazy" */
          "./clock-icon_4.entry-0afe79c2.js"
        ).then(o, N);
      case "radio-button-group":
        return import(
          /* webpackMode: "lazy" */
          "./radio-button-group.entry-bc3b12fd.js"
        ).then(o, N);
      case "checkbox-component":
        return import(
          /* webpackMode: "lazy" */
          "./checkbox-component.entry-72a6aa72.js"
        ).then(o, N);
      case "toggle-switch":
        return import(
          /* webpackMode: "lazy" */
          "./toggle-switch.entry-e423b793.js"
        ).then(o, N);
      case "translate-icon":
        return import(
          /* webpackMode: "lazy" */
          "./translate-icon.entry-60c55a2e.js"
        ).then(o, N);
      case "globe-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./globe-icon_2.entry-aaceb196.js"
        ).then(o, N);
      case "multi-select-dropdown_2":
        return import(
          /* webpackMode: "lazy" */
          "./multi-select-dropdown_2.entry-3eecf18a.js"
        ).then(o, N);
      case "nylas-form-card":
        return import(
          /* webpackMode: "lazy" */
          "./nylas-form-card.entry-a3186807.js"
        ).then(o, N);
      case "textarea-component":
        return import(
          /* webpackMode: "lazy" */
          "./textarea-component.entry-a62c257b.js"
        ).then(o, N);
      case "add-circle-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./add-circle-icon_2.entry-b4bbcfee.js"
        ).then(o, N);
      case "input-dropdown_2":
        return import(
          /* webpackMode: "lazy" */
          "./input-dropdown_2.entry-c37f392c.js"
        ).then(o, N);
      case "input-component":
        return import(
          /* webpackMode: "lazy" */
          "./input-component.entry-401b9ba5.js"
        ).then(o, N);
      case "button-component_2":
        return import(
          /* webpackMode: "lazy" */
          "./button-component_2.entry-36e49459.js"
        ).then(o, N);
      case "chevron-icon_3":
        return import(
          /* webpackMode: "lazy" */
          "./chevron-icon_3.entry-4a72f211.js"
        ).then(o, N);
      case "info-icon_2":
        return import(
          /* webpackMode: "lazy" */
          "./info-icon_2.entry-b3b313ab.js"
        ).then(o, N);
    }
  }
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${a}.entry.js`
  ).then((o) => (zn.set(a, o), o[i]), N);
}, on = /* @__PURE__ */ new Map(), It = typeof window < "u" ? window : {}, de = It.document || { head: {} }, te = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (n) => n(),
  raf: (n) => requestAnimationFrame(n),
  ael: (n, e, t, i) => n.addEventListener(e, t, i),
  rel: (n, e, t, i) => n.removeEventListener(e, t, i),
  ce: (n, e) => new CustomEvent(n, e)
}, yB = /* @__PURE__ */ (() => {
  let n = !1;
  try {
    de.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        n = !0;
      }
    }));
  } catch {
  }
  return n;
})(), vB = (n) => Promise.resolve(n), TB = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), ka = [], eo = [], kB = (n, e) => (t) => {
  n.push(t), ti || (ti = !0, e && te.$flags$ & 4 ? _i(ii) : te.raf(ii));
}, Ea = (n) => {
  for (let e = 0; e < n.length; e++)
    try {
      n[e](performance.now());
    } catch (t) {
      N(t);
    }
  n.length = 0;
}, ii = () => {
  Ea(ka), Ea(eo), (ti = ka.length > 0) && te.raf(ii);
}, _i = (n) => vB().then(n), EB = /* @__PURE__ */ kB(eo, !0), xB = (n, e, t) => {
  const i = n.get(e);
  i ? i.includes(t) || i.push(t) : n.set(e, [t]);
}, SB = (n, e) => {
  let t;
  return (...i) => {
    t && clearTimeout(t), t = setTimeout(() => {
      t = 0, n(...i);
    }, e);
  };
}, CB = (n) => !("isConnected" in n) || n.isConnected, xa = SB((n) => {
  for (let e of n.keys())
    n.set(e, n.get(e).filter(CB));
}, 2e3), wB = () => {
  if (typeof ba != "function")
    return {};
  const n = /* @__PURE__ */ new Map();
  return {
    dispose: () => n.clear(),
    get: (e) => {
      const t = ba();
      t && xB(n, e, t);
    },
    set: (e) => {
      const t = n.get(e);
      t && n.set(e, t.filter(ya)), xa(n);
    },
    reset: () => {
      n.forEach((e) => e.forEach(ya)), xa(n);
    }
  };
}, Hn = (n) => typeof n == "function" ? n() : n, $B = (n, e = (t, i) => t !== i) => {
  const t = Hn(n);
  let i = new Map(Object.entries(t ?? {}));
  const a = {
    dispose: [],
    get: [],
    set: [],
    reset: []
  }, r = () => {
    var b;
    i = new Map(Object.entries((b = Hn(n)) !== null && b !== void 0 ? b : {})), a.reset.forEach((p) => p());
  }, o = () => {
    a.dispose.forEach((b) => b()), r();
  }, l = (b) => (a.get.forEach((p) => p(b)), i.get(b)), s = (b, p) => {
    const h = i.get(b);
    e(p, h, b) && (i.set(b, p), a.set.forEach((E) => E(b, p, h)));
  }, u = typeof Proxy > "u" ? {} : new Proxy(t, {
    get(b, p) {
      return l(p);
    },
    ownKeys(b) {
      return Array.from(i.keys());
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    },
    has(b, p) {
      return i.has(p);
    },
    set(b, p, h) {
      return s(p, h), !0;
    }
  }), c = (b, p) => (a[b].push(p), () => {
    BB(a[b], p);
  });
  return {
    state: u,
    get: l,
    set: s,
    on: c,
    onChange: (b, p) => {
      const h = c("set", (B, _) => {
        B === b && p(_);
      }), E = c("reset", () => p(Hn(n)[b]));
      return () => {
        h(), E();
      };
    },
    use: (...b) => {
      const p = b.reduce((h, E) => (E.set && h.push(c("set", E.set)), E.get && h.push(c("get", E.get)), E.reset && h.push(c("reset", E.reset)), E.dispose && h.push(c("dispose", E.dispose)), h), []);
      return () => p.forEach((h) => h());
    },
    dispose: o,
    reset: r,
    forceUpdate: (b) => {
      const p = i.get(b);
      a.set.forEach((h) => h(b, p, p));
    }
  };
}, BB = (n, e) => {
  const t = n.indexOf(e);
  t >= 0 && (n[t] = n[n.length - 1], n.length--);
}, PB = (n, e) => {
  const t = $B(n, e);
  return t.use(wB()), t;
}, Sa = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
var Oe = [], xe = [], MB = typeof Uint8Array < "u" ? Uint8Array : Array, Ii = !1;
function to() {
  Ii = !0;
  for (var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, t = n.length; e < t; ++e)
    Oe[e] = n[e], xe[n.charCodeAt(e)] = e;
  xe["-".charCodeAt(0)] = 62, xe["_".charCodeAt(0)] = 63;
}
function DB(n) {
  Ii || to();
  var e, t, i, a, r, o, l = n.length;
  if (l % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  r = n[l - 2] === "=" ? 2 : n[l - 1] === "=" ? 1 : 0, o = new MB(l * 3 / 4 - r), i = r > 0 ? l - 4 : l;
  var s = 0;
  for (e = 0, t = 0; e < i; e += 4, t += 3)
    a = xe[n.charCodeAt(e)] << 18 | xe[n.charCodeAt(e + 1)] << 12 | xe[n.charCodeAt(e + 2)] << 6 | xe[n.charCodeAt(e + 3)], o[s++] = a >> 16 & 255, o[s++] = a >> 8 & 255, o[s++] = a & 255;
  return r === 2 ? (a = xe[n.charCodeAt(e)] << 2 | xe[n.charCodeAt(e + 1)] >> 4, o[s++] = a & 255) : r === 1 && (a = xe[n.charCodeAt(e)] << 10 | xe[n.charCodeAt(e + 1)] << 4 | xe[n.charCodeAt(e + 2)] >> 2, o[s++] = a >> 8 & 255, o[s++] = a & 255), o;
}
function AB(n) {
  return Oe[n >> 18 & 63] + Oe[n >> 12 & 63] + Oe[n >> 6 & 63] + Oe[n & 63];
}
function LB(n, e, t) {
  for (var i, a = [], r = e; r < t; r += 3)
    i = (n[r] << 16) + (n[r + 1] << 8) + n[r + 2], a.push(AB(i));
  return a.join("");
}
function Ca(n) {
  Ii || to();
  for (var e, t = n.length, i = t % 3, a = "", r = [], o = 16383, l = 0, s = t - i; l < s; l += o)
    r.push(LB(n, l, l + o > s ? s : l + o));
  return i === 1 ? (e = n[t - 1], a += Oe[e >> 2], a += Oe[e << 4 & 63], a += "==") : i === 2 && (e = (n[t - 2] << 8) + n[t - 1], a += Oe[e >> 10], a += Oe[e >> 4 & 63], a += Oe[e << 2 & 63], a += "="), r.push(a), r.join("");
}
function wn(n, e, t, i, a) {
  var r, o, l = a * 8 - i - 1, s = (1 << l) - 1, u = s >> 1, c = -7, f = t ? a - 1 : 0, d = t ? -1 : 1, g = n[e + f];
  for (f += d, r = g & (1 << -c) - 1, g >>= -c, c += l; c > 0; r = r * 256 + n[e + f], f += d, c -= 8)
    ;
  for (o = r & (1 << -c) - 1, r >>= -c, c += i; c > 0; o = o * 256 + n[e + f], f += d, c -= 8)
    ;
  if (r === 0)
    r = 1 - u;
  else {
    if (r === s)
      return o ? NaN : (g ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, i), r = r - u;
  }
  return (g ? -1 : 1) * o * Math.pow(2, r - i);
}
function no(n, e, t, i, a, r) {
  var o, l, s, u = r * 8 - a - 1, c = (1 << u) - 1, f = c >> 1, d = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = i ? 0 : r - 1, b = i ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (l = isNaN(e) ? 1 : 0, o = c) : (o = Math.floor(Math.log(e) / Math.LN2), e * (s = Math.pow(2, -o)) < 1 && (o--, s *= 2), o + f >= 1 ? e += d / s : e += d * Math.pow(2, 1 - f), e * s >= 2 && (o++, s /= 2), o + f >= c ? (l = 0, o = c) : o + f >= 1 ? (l = (e * s - 1) * Math.pow(2, a), o = o + f) : (l = e * Math.pow(2, f - 1) * Math.pow(2, a), o = 0)); a >= 8; n[t + g] = l & 255, g += b, l /= 256, a -= 8)
    ;
  for (o = o << a | l, u += a; u > 0; n[t + g] = o & 255, g += b, o /= 256, u -= 8)
    ;
  n[t + g - b] |= p * 128;
}
var OB = {}.toString, io = Array.isArray || function(n) {
  return OB.call(n) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var _B = 50;
$.TYPED_ARRAY_SUPPORT = Sa.TYPED_ARRAY_SUPPORT !== void 0 ? Sa.TYPED_ARRAY_SUPPORT : !0;
function ai() {
  return $.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Ve(n, e) {
  if (ai() < e)
    throw new RangeError("Invalid typed array length");
  return $.TYPED_ARRAY_SUPPORT ? (n = new Uint8Array(e), n.__proto__ = $.prototype) : (n === null && (n = new $(e)), n.length = e), n;
}
function $(n, e, t) {
  if (!$.TYPED_ARRAY_SUPPORT && !(this instanceof $))
    return new $(n, e, t);
  if (typeof n == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return Ri(this, n);
  }
  return ao(this, n, e, t);
}
$.poolSize = 8192;
$._augment = function(n) {
  return n.__proto__ = $.prototype, n;
};
function ao(n, e, t, i) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? NB(n, e, t, i) : typeof e == "string" ? RB(n, e, t) : FB(n, e);
}
$.from = function(n, e, t) {
  return ao(null, n, e, t);
};
$.TYPED_ARRAY_SUPPORT && ($.prototype.__proto__ = Uint8Array.prototype, $.__proto__ = Uint8Array);
function ro(n) {
  if (typeof n != "number")
    throw new TypeError('"size" argument must be a number');
  if (n < 0)
    throw new RangeError('"size" argument must not be negative');
}
function IB(n, e, t, i) {
  return ro(e), e <= 0 ? Ve(n, e) : t !== void 0 ? typeof i == "string" ? Ve(n, e).fill(t, i) : Ve(n, e).fill(t) : Ve(n, e);
}
$.alloc = function(n, e, t) {
  return IB(null, n, e, t);
};
function Ri(n, e) {
  if (ro(e), n = Ve(n, e < 0 ? 0 : Ni(e) | 0), !$.TYPED_ARRAY_SUPPORT)
    for (var t = 0; t < e; ++t)
      n[t] = 0;
  return n;
}
$.allocUnsafe = function(n) {
  return Ri(null, n);
};
$.allocUnsafeSlow = function(n) {
  return Ri(null, n);
};
function RB(n, e, t) {
  if ((typeof t != "string" || t === "") && (t = "utf8"), !$.isEncoding(t))
    throw new TypeError('"encoding" must be a valid string encoding');
  var i = oo(e, t) | 0;
  n = Ve(n, i);
  var a = n.write(e, t);
  return a !== i && (n = n.slice(0, a)), n;
}
function ri(n, e) {
  var t = e.length < 0 ? 0 : Ni(e.length) | 0;
  n = Ve(n, t);
  for (var i = 0; i < t; i += 1)
    n[i] = e[i] & 255;
  return n;
}
function NB(n, e, t, i) {
  if (t < 0 || e.byteLength < t)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < t + (i || 0))
    throw new RangeError("'length' is out of bounds");
  return t === void 0 && i === void 0 ? e = new Uint8Array(e) : i === void 0 ? e = new Uint8Array(e, t) : e = new Uint8Array(e, t, i), $.TYPED_ARRAY_SUPPORT ? (n = e, n.__proto__ = $.prototype) : n = ri(n, e), n;
}
function FB(n, e) {
  if (Ne(e)) {
    var t = Ni(e.length) | 0;
    return n = Ve(n, t), n.length === 0 || e.copy(n, 0, 0, t), n;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || a4(e.length) ? Ve(n, 0) : ri(n, e);
    if (e.type === "Buffer" && io(e.data))
      return ri(n, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Ni(n) {
  if (n >= ai())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + ai().toString(16) + " bytes");
  return n | 0;
}
$.isBuffer = r4;
function Ne(n) {
  return !!(n != null && n._isBuffer);
}
$.compare = function(e, t) {
  if (!Ne(e) || !Ne(t))
    throw new TypeError("Arguments must be Buffers");
  if (e === t)
    return 0;
  for (var i = e.length, a = t.length, r = 0, o = Math.min(i, a); r < o; ++r)
    if (e[r] !== t[r]) {
      i = e[r], a = t[r];
      break;
    }
  return i < a ? -1 : a < i ? 1 : 0;
};
$.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
$.concat = function(e, t) {
  if (!io(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return $.alloc(0);
  var i;
  if (t === void 0)
    for (t = 0, i = 0; i < e.length; ++i)
      t += e[i].length;
  var a = $.allocUnsafe(t), r = 0;
  for (i = 0; i < e.length; ++i) {
    var o = e[i];
    if (!Ne(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(a, r), r += o.length;
  }
  return a;
};
function oo(n, e) {
  if (Ne(n))
    return n.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(n) || n instanceof ArrayBuffer))
    return n.byteLength;
  typeof n != "string" && (n = "" + n);
  var t = n.length;
  if (t === 0)
    return 0;
  for (var i = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return t;
      case "utf8":
      case "utf-8":
      case void 0:
        return sn(n).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return t * 2;
      case "hex":
        return t >>> 1;
      case "base64":
        return ho(n).length;
      default:
        if (i)
          return sn(n).length;
        e = ("" + e).toLowerCase(), i = !0;
    }
}
$.byteLength = oo;
function UB(n, e, t) {
  var i = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
    return "";
  for (n || (n = "utf8"); ; )
    switch (n) {
      case "hex":
        return ZB(this, e, t);
      case "utf8":
      case "utf-8":
        return uo(this, e, t);
      case "ascii":
        return WB(this, e, t);
      case "latin1":
      case "binary":
        return KB(this, e, t);
      case "base64":
        return VB(this, e, t);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return JB(this, e, t);
      default:
        if (i)
          throw new TypeError("Unknown encoding: " + n);
        n = (n + "").toLowerCase(), i = !0;
    }
}
$.prototype._isBuffer = !0;
function et(n, e, t) {
  var i = n[e];
  n[e] = n[t], n[t] = i;
}
$.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2)
    et(this, t, t + 1);
  return this;
};
$.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4)
    et(this, t, t + 3), et(this, t + 1, t + 2);
  return this;
};
$.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8)
    et(this, t, t + 7), et(this, t + 1, t + 6), et(this, t + 2, t + 5), et(this, t + 3, t + 4);
  return this;
};
$.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? uo(this, 0, e) : UB.apply(this, arguments);
};
$.prototype.equals = function(e) {
  if (!Ne(e))
    throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : $.compare(this, e) === 0;
};
$.prototype.inspect = function() {
  var e = "", t = _B;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
};
$.prototype.compare = function(e, t, i, a, r) {
  if (!Ne(e))
    throw new TypeError("Argument must be a Buffer");
  if (t === void 0 && (t = 0), i === void 0 && (i = e ? e.length : 0), a === void 0 && (a = 0), r === void 0 && (r = this.length), t < 0 || i > e.length || a < 0 || r > this.length)
    throw new RangeError("out of range index");
  if (a >= r && t >= i)
    return 0;
  if (a >= r)
    return -1;
  if (t >= i)
    return 1;
  if (t >>>= 0, i >>>= 0, a >>>= 0, r >>>= 0, this === e)
    return 0;
  for (var o = r - a, l = i - t, s = Math.min(o, l), u = this.slice(a, r), c = e.slice(t, i), f = 0; f < s; ++f)
    if (u[f] !== c[f]) {
      o = u[f], l = c[f];
      break;
    }
  return o < l ? -1 : l < o ? 1 : 0;
};
function so(n, e, t, i, a) {
  if (n.length === 0)
    return -1;
  if (typeof t == "string" ? (i = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = a ? 0 : n.length - 1), t < 0 && (t = n.length + t), t >= n.length) {
    if (a)
      return -1;
    t = n.length - 1;
  } else if (t < 0)
    if (a)
      t = 0;
    else
      return -1;
  if (typeof e == "string" && (e = $.from(e, i)), Ne(e))
    return e.length === 0 ? -1 : wa(n, e, t, i, a);
  if (typeof e == "number")
    return e = e & 255, $.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? a ? Uint8Array.prototype.indexOf.call(n, e, t) : Uint8Array.prototype.lastIndexOf.call(n, e, t) : wa(n, [e], t, i, a);
  throw new TypeError("val must be string, number or Buffer");
}
function wa(n, e, t, i, a) {
  var r = 1, o = n.length, l = e.length;
  if (i !== void 0 && (i = String(i).toLowerCase(), i === "ucs2" || i === "ucs-2" || i === "utf16le" || i === "utf-16le")) {
    if (n.length < 2 || e.length < 2)
      return -1;
    r = 2, o /= 2, l /= 2, t /= 2;
  }
  function s(g, b) {
    return r === 1 ? g[b] : g.readUInt16BE(b * r);
  }
  var u;
  if (a) {
    var c = -1;
    for (u = t; u < o; u++)
      if (s(n, u) === s(e, c === -1 ? 0 : u - c)) {
        if (c === -1 && (c = u), u - c + 1 === l)
          return c * r;
      } else
        c !== -1 && (u -= u - c), c = -1;
  } else
    for (t + l > o && (t = o - l), u = t; u >= 0; u--) {
      for (var f = !0, d = 0; d < l; d++)
        if (s(n, u + d) !== s(e, d)) {
          f = !1;
          break;
        }
      if (f)
        return u;
    }
  return -1;
}
$.prototype.includes = function(e, t, i) {
  return this.indexOf(e, t, i) !== -1;
};
$.prototype.indexOf = function(e, t, i) {
  return so(this, e, t, i, !0);
};
$.prototype.lastIndexOf = function(e, t, i) {
  return so(this, e, t, i, !1);
};
function zB(n, e, t, i) {
  t = Number(t) || 0;
  var a = n.length - t;
  i ? (i = Number(i), i > a && (i = a)) : i = a;
  var r = e.length;
  if (r % 2 !== 0)
    throw new TypeError("Invalid hex string");
  i > r / 2 && (i = r / 2);
  for (var o = 0; o < i; ++o) {
    var l = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(l))
      return o;
    n[t + o] = l;
  }
  return o;
}
function HB(n, e, t, i) {
  return Pn(sn(e, n.length - t), n, t, i);
}
function lo(n, e, t, i) {
  return Pn(n4(e), n, t, i);
}
function jB(n, e, t, i) {
  return lo(n, e, t, i);
}
function qB(n, e, t, i) {
  return Pn(ho(e), n, t, i);
}
function YB(n, e, t, i) {
  return Pn(i4(e, n.length - t), n, t, i);
}
$.prototype.write = function(e, t, i, a) {
  if (t === void 0)
    a = "utf8", i = this.length, t = 0;
  else if (i === void 0 && typeof t == "string")
    a = t, i = this.length, t = 0;
  else if (isFinite(t))
    t = t | 0, isFinite(i) ? (i = i | 0, a === void 0 && (a = "utf8")) : (a = i, i = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var r = this.length - t;
  if ((i === void 0 || i > r) && (i = r), e.length > 0 && (i < 0 || t < 0) || t > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  a || (a = "utf8");
  for (var o = !1; ; )
    switch (a) {
      case "hex":
        return zB(this, e, t, i);
      case "utf8":
      case "utf-8":
        return HB(this, e, t, i);
      case "ascii":
        return lo(this, e, t, i);
      case "latin1":
      case "binary":
        return jB(this, e, t, i);
      case "base64":
        return qB(this, e, t, i);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return YB(this, e, t, i);
      default:
        if (o)
          throw new TypeError("Unknown encoding: " + a);
        a = ("" + a).toLowerCase(), o = !0;
    }
};
$.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function VB(n, e, t) {
  return e === 0 && t === n.length ? Ca(n) : Ca(n.slice(e, t));
}
function uo(n, e, t) {
  t = Math.min(n.length, t);
  for (var i = [], a = e; a < t; ) {
    var r = n[a], o = null, l = r > 239 ? 4 : r > 223 ? 3 : r > 191 ? 2 : 1;
    if (a + l <= t) {
      var s, u, c, f;
      switch (l) {
        case 1:
          r < 128 && (o = r);
          break;
        case 2:
          s = n[a + 1], (s & 192) === 128 && (f = (r & 31) << 6 | s & 63, f > 127 && (o = f));
          break;
        case 3:
          s = n[a + 1], u = n[a + 2], (s & 192) === 128 && (u & 192) === 128 && (f = (r & 15) << 12 | (s & 63) << 6 | u & 63, f > 2047 && (f < 55296 || f > 57343) && (o = f));
          break;
        case 4:
          s = n[a + 1], u = n[a + 2], c = n[a + 3], (s & 192) === 128 && (u & 192) === 128 && (c & 192) === 128 && (f = (r & 15) << 18 | (s & 63) << 12 | (u & 63) << 6 | c & 63, f > 65535 && f < 1114112 && (o = f));
      }
    }
    o === null ? (o = 65533, l = 1) : o > 65535 && (o -= 65536, i.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), i.push(o), a += l;
  }
  return GB(i);
}
var $a = 4096;
function GB(n) {
  var e = n.length;
  if (e <= $a)
    return String.fromCharCode.apply(String, n);
  for (var t = "", i = 0; i < e; )
    t += String.fromCharCode.apply(
      String,
      n.slice(i, i += $a)
    );
  return t;
}
function WB(n, e, t) {
  var i = "";
  t = Math.min(n.length, t);
  for (var a = e; a < t; ++a)
    i += String.fromCharCode(n[a] & 127);
  return i;
}
function KB(n, e, t) {
  var i = "";
  t = Math.min(n.length, t);
  for (var a = e; a < t; ++a)
    i += String.fromCharCode(n[a]);
  return i;
}
function ZB(n, e, t) {
  var i = n.length;
  (!e || e < 0) && (e = 0), (!t || t < 0 || t > i) && (t = i);
  for (var a = "", r = e; r < t; ++r)
    a += t4(n[r]);
  return a;
}
function JB(n, e, t) {
  for (var i = n.slice(e, t), a = "", r = 0; r < i.length; r += 2)
    a += String.fromCharCode(i[r] + i[r + 1] * 256);
  return a;
}
$.prototype.slice = function(e, t) {
  var i = this.length;
  e = ~~e, t = t === void 0 ? i : ~~t, e < 0 ? (e += i, e < 0 && (e = 0)) : e > i && (e = i), t < 0 ? (t += i, t < 0 && (t = 0)) : t > i && (t = i), t < e && (t = e);
  var a;
  if ($.TYPED_ARRAY_SUPPORT)
    a = this.subarray(e, t), a.__proto__ = $.prototype;
  else {
    var r = t - e;
    a = new $(r, void 0);
    for (var o = 0; o < r; ++o)
      a[o] = this[o + e];
  }
  return a;
};
function se(n, e, t) {
  if (n % 1 !== 0 || n < 0)
    throw new RangeError("offset is not uint");
  if (n + e > t)
    throw new RangeError("Trying to access beyond buffer length");
}
$.prototype.readUIntLE = function(e, t, i) {
  e = e | 0, t = t | 0, i || se(e, t, this.length);
  for (var a = this[e], r = 1, o = 0; ++o < t && (r *= 256); )
    a += this[e + o] * r;
  return a;
};
$.prototype.readUIntBE = function(e, t, i) {
  e = e | 0, t = t | 0, i || se(e, t, this.length);
  for (var a = this[e + --t], r = 1; t > 0 && (r *= 256); )
    a += this[e + --t] * r;
  return a;
};
$.prototype.readUInt8 = function(e, t) {
  return t || se(e, 1, this.length), this[e];
};
$.prototype.readUInt16LE = function(e, t) {
  return t || se(e, 2, this.length), this[e] | this[e + 1] << 8;
};
$.prototype.readUInt16BE = function(e, t) {
  return t || se(e, 2, this.length), this[e] << 8 | this[e + 1];
};
$.prototype.readUInt32LE = function(e, t) {
  return t || se(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
$.prototype.readUInt32BE = function(e, t) {
  return t || se(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
$.prototype.readIntLE = function(e, t, i) {
  e = e | 0, t = t | 0, i || se(e, t, this.length);
  for (var a = this[e], r = 1, o = 0; ++o < t && (r *= 256); )
    a += this[e + o] * r;
  return r *= 128, a >= r && (a -= Math.pow(2, 8 * t)), a;
};
$.prototype.readIntBE = function(e, t, i) {
  e = e | 0, t = t | 0, i || se(e, t, this.length);
  for (var a = t, r = 1, o = this[e + --a]; a > 0 && (r *= 256); )
    o += this[e + --a] * r;
  return r *= 128, o >= r && (o -= Math.pow(2, 8 * t)), o;
};
$.prototype.readInt8 = function(e, t) {
  return t || se(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
$.prototype.readInt16LE = function(e, t) {
  t || se(e, 2, this.length);
  var i = this[e] | this[e + 1] << 8;
  return i & 32768 ? i | 4294901760 : i;
};
$.prototype.readInt16BE = function(e, t) {
  t || se(e, 2, this.length);
  var i = this[e + 1] | this[e] << 8;
  return i & 32768 ? i | 4294901760 : i;
};
$.prototype.readInt32LE = function(e, t) {
  return t || se(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
$.prototype.readInt32BE = function(e, t) {
  return t || se(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
$.prototype.readFloatLE = function(e, t) {
  return t || se(e, 4, this.length), wn(this, e, !0, 23, 4);
};
$.prototype.readFloatBE = function(e, t) {
  return t || se(e, 4, this.length), wn(this, e, !1, 23, 4);
};
$.prototype.readDoubleLE = function(e, t) {
  return t || se(e, 8, this.length), wn(this, e, !0, 52, 8);
};
$.prototype.readDoubleBE = function(e, t) {
  return t || se(e, 8, this.length), wn(this, e, !1, 52, 8);
};
function pe(n, e, t, i, a, r) {
  if (!Ne(n))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > a || e < r)
    throw new RangeError('"value" argument is out of bounds');
  if (t + i > n.length)
    throw new RangeError("Index out of range");
}
$.prototype.writeUIntLE = function(e, t, i, a) {
  if (e = +e, t = t | 0, i = i | 0, !a) {
    var r = Math.pow(2, 8 * i) - 1;
    pe(this, e, t, i, r, 0);
  }
  var o = 1, l = 0;
  for (this[t] = e & 255; ++l < i && (o *= 256); )
    this[t + l] = e / o & 255;
  return t + i;
};
$.prototype.writeUIntBE = function(e, t, i, a) {
  if (e = +e, t = t | 0, i = i | 0, !a) {
    var r = Math.pow(2, 8 * i) - 1;
    pe(this, e, t, i, r, 0);
  }
  var o = i - 1, l = 1;
  for (this[t + o] = e & 255; --o >= 0 && (l *= 256); )
    this[t + o] = e / l & 255;
  return t + i;
};
$.prototype.writeUInt8 = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 1, 255, 0), $.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function $n(n, e, t, i) {
  e < 0 && (e = 65535 + e + 1);
  for (var a = 0, r = Math.min(n.length - t, 2); a < r; ++a)
    n[t + a] = (e & 255 << 8 * (i ? a : 1 - a)) >>> (i ? a : 1 - a) * 8;
}
$.prototype.writeUInt16LE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 2, 65535, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : $n(this, e, t, !0), t + 2;
};
$.prototype.writeUInt16BE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 2, 65535, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : $n(this, e, t, !1), t + 2;
};
function Bn(n, e, t, i) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var a = 0, r = Math.min(n.length - t, 4); a < r; ++a)
    n[t + a] = e >>> (i ? a : 3 - a) * 8 & 255;
}
$.prototype.writeUInt32LE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 4, 4294967295, 0), $.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : Bn(this, e, t, !0), t + 4;
};
$.prototype.writeUInt32BE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 4, 4294967295, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : Bn(this, e, t, !1), t + 4;
};
$.prototype.writeIntLE = function(e, t, i, a) {
  if (e = +e, t = t | 0, !a) {
    var r = Math.pow(2, 8 * i - 1);
    pe(this, e, t, i, r - 1, -r);
  }
  var o = 0, l = 1, s = 0;
  for (this[t] = e & 255; ++o < i && (l *= 256); )
    e < 0 && s === 0 && this[t + o - 1] !== 0 && (s = 1), this[t + o] = (e / l >> 0) - s & 255;
  return t + i;
};
$.prototype.writeIntBE = function(e, t, i, a) {
  if (e = +e, t = t | 0, !a) {
    var r = Math.pow(2, 8 * i - 1);
    pe(this, e, t, i, r - 1, -r);
  }
  var o = i - 1, l = 1, s = 0;
  for (this[t + o] = e & 255; --o >= 0 && (l *= 256); )
    e < 0 && s === 0 && this[t + o + 1] !== 0 && (s = 1), this[t + o] = (e / l >> 0) - s & 255;
  return t + i;
};
$.prototype.writeInt8 = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 1, 127, -128), $.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
};
$.prototype.writeInt16LE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 2, 32767, -32768), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : $n(this, e, t, !0), t + 2;
};
$.prototype.writeInt16BE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 2, 32767, -32768), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : $n(this, e, t, !1), t + 2;
};
$.prototype.writeInt32LE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 4, 2147483647, -2147483648), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : Bn(this, e, t, !0), t + 4;
};
$.prototype.writeInt32BE = function(e, t, i) {
  return e = +e, t = t | 0, i || pe(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : Bn(this, e, t, !1), t + 4;
};
function co(n, e, t, i, a, r) {
  if (t + i > n.length)
    throw new RangeError("Index out of range");
  if (t < 0)
    throw new RangeError("Index out of range");
}
function fo(n, e, t, i, a) {
  return a || co(n, e, t, 4), no(n, e, t, i, 23, 4), t + 4;
}
$.prototype.writeFloatLE = function(e, t, i) {
  return fo(this, e, t, !0, i);
};
$.prototype.writeFloatBE = function(e, t, i) {
  return fo(this, e, t, !1, i);
};
function go(n, e, t, i, a) {
  return a || co(n, e, t, 8), no(n, e, t, i, 52, 8), t + 8;
}
$.prototype.writeDoubleLE = function(e, t, i) {
  return go(this, e, t, !0, i);
};
$.prototype.writeDoubleBE = function(e, t, i) {
  return go(this, e, t, !1, i);
};
$.prototype.copy = function(e, t, i, a) {
  if (i || (i = 0), !a && a !== 0 && (a = this.length), t >= e.length && (t = e.length), t || (t = 0), a > 0 && a < i && (a = i), a === i || e.length === 0 || this.length === 0)
    return 0;
  if (t < 0)
    throw new RangeError("targetStart out of bounds");
  if (i < 0 || i >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (a < 0)
    throw new RangeError("sourceEnd out of bounds");
  a > this.length && (a = this.length), e.length - t < a - i && (a = e.length - t + i);
  var r = a - i, o;
  if (this === e && i < t && t < a)
    for (o = r - 1; o >= 0; --o)
      e[o + t] = this[o + i];
  else if (r < 1e3 || !$.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < r; ++o)
      e[o + t] = this[o + i];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(i, i + r),
      t
    );
  return r;
};
$.prototype.fill = function(e, t, i, a) {
  if (typeof e == "string") {
    if (typeof t == "string" ? (a = t, t = 0, i = this.length) : typeof i == "string" && (a = i, i = this.length), e.length === 1) {
      var r = e.charCodeAt(0);
      r < 256 && (e = r);
    }
    if (a !== void 0 && typeof a != "string")
      throw new TypeError("encoding must be a string");
    if (typeof a == "string" && !$.isEncoding(a))
      throw new TypeError("Unknown encoding: " + a);
  } else
    typeof e == "number" && (e = e & 255);
  if (t < 0 || this.length < t || this.length < i)
    throw new RangeError("Out of range index");
  if (i <= t)
    return this;
  t = t >>> 0, i = i === void 0 ? this.length : i >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = t; o < i; ++o)
      this[o] = e;
  else {
    var l = Ne(e) ? e : sn(new $(e, a).toString()), s = l.length;
    for (o = 0; o < i - t; ++o)
      this[o + t] = l[o % s];
  }
  return this;
};
var QB = /[^+\/0-9A-Za-z-_]/g;
function XB(n) {
  if (n = e4(n).replace(QB, ""), n.length < 2)
    return "";
  for (; n.length % 4 !== 0; )
    n = n + "=";
  return n;
}
function e4(n) {
  return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
}
function t4(n) {
  return n < 16 ? "0" + n.toString(16) : n.toString(16);
}
function sn(n, e) {
  e = e || 1 / 0;
  for (var t, i = n.length, a = null, r = [], o = 0; o < i; ++o) {
    if (t = n.charCodeAt(o), t > 55295 && t < 57344) {
      if (!a) {
        if (t > 56319) {
          (e -= 3) > -1 && r.push(239, 191, 189);
          continue;
        } else if (o + 1 === i) {
          (e -= 3) > -1 && r.push(239, 191, 189);
          continue;
        }
        a = t;
        continue;
      }
      if (t < 56320) {
        (e -= 3) > -1 && r.push(239, 191, 189), a = t;
        continue;
      }
      t = (a - 55296 << 10 | t - 56320) + 65536;
    } else
      a && (e -= 3) > -1 && r.push(239, 191, 189);
    if (a = null, t < 128) {
      if ((e -= 1) < 0)
        break;
      r.push(t);
    } else if (t < 2048) {
      if ((e -= 2) < 0)
        break;
      r.push(
        t >> 6 | 192,
        t & 63 | 128
      );
    } else if (t < 65536) {
      if ((e -= 3) < 0)
        break;
      r.push(
        t >> 12 | 224,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else if (t < 1114112) {
      if ((e -= 4) < 0)
        break;
      r.push(
        t >> 18 | 240,
        t >> 12 & 63 | 128,
        t >> 6 & 63 | 128,
        t & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return r;
}
function n4(n) {
  for (var e = [], t = 0; t < n.length; ++t)
    e.push(n.charCodeAt(t) & 255);
  return e;
}
function i4(n, e) {
  for (var t, i, a, r = [], o = 0; o < n.length && !((e -= 2) < 0); ++o)
    t = n.charCodeAt(o), i = t >> 8, a = t % 256, r.push(a), r.push(i);
  return r;
}
function ho(n) {
  return DB(XB(n));
}
function Pn(n, e, t, i) {
  for (var a = 0; a < i && !(a + t >= e.length || a >= n.length); ++a)
    e[a + t] = n[a];
  return a;
}
function a4(n) {
  return n !== n;
}
function r4(n) {
  return n != null && (!!n._isBuffer || mo(n) || o4(n));
}
function mo(n) {
  return !!n.constructor && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n);
}
function o4(n) {
  return typeof n.readFloatLE == "function" && typeof n.slice == "function" && mo(n.slice(0, 0));
}
var ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mn(n) {
  if (n.__esModule)
    return n;
  var e = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(n).forEach(function(t) {
    var i = Object.getOwnPropertyDescriptor(n, t);
    Object.defineProperty(e, t, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[t];
      }
    });
  }), e;
}
var Fe = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i();
  })(ne, function() {
    var t = 1e3, i = 6e4, a = 36e5, r = "millisecond", o = "second", l = "minute", s = "hour", u = "day", c = "week", f = "month", d = "quarter", g = "year", b = "date", p = "Invalid Date", h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, B = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(S) {
      var x = ["th", "st", "nd", "rd"], m = S % 100;
      return "[" + S + (x[(m - 20) % 10] || x[m] || x[0]) + "]";
    } }, _ = function(S, x, m) {
      var T = String(S);
      return !T || T.length >= x ? S : "" + Array(x + 1 - T.length).join(m) + S;
    }, D = { s: _, z: function(S) {
      var x = -S.utcOffset(), m = Math.abs(x), T = Math.floor(m / 60), y = m % 60;
      return (x <= 0 ? "+" : "-") + _(T, 2, "0") + ":" + _(y, 2, "0");
    }, m: function S(x, m) {
      if (x.date() < m.date())
        return -S(m, x);
      var T = 12 * (m.year() - x.year()) + (m.month() - x.month()), y = x.clone().add(T, f), w = m - y < 0, A = x.clone().add(T + (w ? -1 : 1), f);
      return +(-(T + (m - y) / (w ? y - A : A - y)) || 0);
    }, a: function(S) {
      return S < 0 ? Math.ceil(S) || 0 : Math.floor(S);
    }, p: function(S) {
      return { M: f, y: g, w: c, d: u, D: b, h: s, m: l, s: o, ms: r, Q: d }[S] || String(S || "").toLowerCase().replace(/s$/, "");
    }, u: function(S) {
      return S === void 0;
    } }, I = "en", F = {};
    F[I] = B;
    var j = function(S) {
      return S instanceof v;
    }, W = function S(x, m, T) {
      var y;
      if (!x)
        return I;
      if (typeof x == "string") {
        var w = x.toLowerCase();
        F[w] && (y = w), m && (F[w] = m, y = w);
        var A = x.split("-");
        if (!y && A.length > 1)
          return S(A[0]);
      } else {
        var R = x.name;
        F[R] = x, y = R;
      }
      return !T && y && (I = y), y || !T && I;
    }, q = function(S, x) {
      if (j(S))
        return S.clone();
      var m = typeof x == "object" ? x : {};
      return m.date = S, m.args = arguments, new v(m);
    }, U = D;
    U.l = W, U.i = j, U.w = function(S, x) {
      return q(S, { locale: x.$L, utc: x.$u, x: x.$x, $offset: x.$offset });
    };
    var v = function() {
      function S(m) {
        this.$L = W(m.locale, null, !0), this.parse(m);
      }
      var x = S.prototype;
      return x.parse = function(m) {
        this.$d = function(T) {
          var y = T.date, w = T.utc;
          if (y === null)
            return /* @__PURE__ */ new Date(NaN);
          if (U.u(y))
            return /* @__PURE__ */ new Date();
          if (y instanceof Date)
            return new Date(y);
          if (typeof y == "string" && !/Z$/i.test(y)) {
            var A = y.match(h);
            if (A) {
              var R = A[2] - 1 || 0, H = (A[7] || "0").substring(0, 3);
              return w ? new Date(Date.UTC(A[1], R, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, H)) : new Date(A[1], R, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, H);
            }
          }
          return new Date(y);
        }(m), this.$x = m.x || {}, this.init();
      }, x.init = function() {
        var m = this.$d;
        this.$y = m.getFullYear(), this.$M = m.getMonth(), this.$D = m.getDate(), this.$W = m.getDay(), this.$H = m.getHours(), this.$m = m.getMinutes(), this.$s = m.getSeconds(), this.$ms = m.getMilliseconds();
      }, x.$utils = function() {
        return U;
      }, x.isValid = function() {
        return this.$d.toString() !== p;
      }, x.isSame = function(m, T) {
        var y = q(m);
        return this.startOf(T) <= y && y <= this.endOf(T);
      }, x.isAfter = function(m, T) {
        return q(m) < this.startOf(T);
      }, x.isBefore = function(m, T) {
        return this.endOf(T) < q(m);
      }, x.$g = function(m, T, y) {
        return U.u(m) ? this[T] : this.set(y, m);
      }, x.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, x.valueOf = function() {
        return this.$d.getTime();
      }, x.startOf = function(m, T) {
        var y = this, w = !!U.u(T) || T, A = U.p(m), R = function(re, le) {
          var Pe = U.w(y.$u ? Date.UTC(y.$y, le, re) : new Date(y.$y, le, re), y);
          return w ? Pe : Pe.endOf(u);
        }, H = function(re, le) {
          return U.w(y.toDate()[re].apply(y.toDate("s"), (w ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), y);
        }, z = this.$W, ie = this.$M, G = this.$D, V = "set" + (this.$u ? "UTC" : "");
        switch (A) {
          case g:
            return w ? R(1, 0) : R(31, 11);
          case f:
            return w ? R(1, ie) : R(0, ie + 1);
          case c:
            var be = this.$locale().weekStart || 0, fe = (z < be ? z + 7 : z) - be;
            return R(w ? G - fe : G + (6 - fe), ie);
          case u:
          case b:
            return H(V + "Hours", 0);
          case s:
            return H(V + "Minutes", 1);
          case l:
            return H(V + "Seconds", 2);
          case o:
            return H(V + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, x.endOf = function(m) {
        return this.startOf(m, !1);
      }, x.$set = function(m, T) {
        var y, w = U.p(m), A = "set" + (this.$u ? "UTC" : ""), R = (y = {}, y[u] = A + "Date", y[b] = A + "Date", y[f] = A + "Month", y[g] = A + "FullYear", y[s] = A + "Hours", y[l] = A + "Minutes", y[o] = A + "Seconds", y[r] = A + "Milliseconds", y)[w], H = w === u ? this.$D + (T - this.$W) : T;
        if (w === f || w === g) {
          var z = this.clone().set(b, 1);
          z.$d[R](H), z.init(), this.$d = z.set(b, Math.min(this.$D, z.daysInMonth())).$d;
        } else
          R && this.$d[R](H);
        return this.init(), this;
      }, x.set = function(m, T) {
        return this.clone().$set(m, T);
      }, x.get = function(m) {
        return this[U.p(m)]();
      }, x.add = function(m, T) {
        var y, w = this;
        m = Number(m);
        var A = U.p(T), R = function(ie) {
          var G = q(w);
          return U.w(G.date(G.date() + Math.round(ie * m)), w);
        };
        if (A === f)
          return this.set(f, this.$M + m);
        if (A === g)
          return this.set(g, this.$y + m);
        if (A === u)
          return R(1);
        if (A === c)
          return R(7);
        var H = (y = {}, y[l] = i, y[s] = a, y[o] = t, y)[A] || 1, z = this.$d.getTime() + m * H;
        return U.w(z, this);
      }, x.subtract = function(m, T) {
        return this.add(-1 * m, T);
      }, x.format = function(m) {
        var T = this, y = this.$locale();
        if (!this.isValid())
          return y.invalidDate || p;
        var w = m || "YYYY-MM-DDTHH:mm:ssZ", A = U.z(this), R = this.$H, H = this.$m, z = this.$M, ie = y.weekdays, G = y.months, V = function(le, Pe, Fn, Ut) {
          return le && (le[Pe] || le(T, w)) || Fn[Pe].slice(0, Ut);
        }, be = function(le) {
          return U.s(R % 12 || 12, le, "0");
        }, fe = y.meridiem || function(le, Pe, Fn) {
          var Ut = le < 12 ? "AM" : "PM";
          return Fn ? Ut.toLowerCase() : Ut;
        }, re = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: z + 1, MM: U.s(z + 1, 2, "0"), MMM: V(y.monthsShort, z, G, 3), MMMM: V(G, z), D: this.$D, DD: U.s(this.$D, 2, "0"), d: String(this.$W), dd: V(y.weekdaysMin, this.$W, ie, 2), ddd: V(y.weekdaysShort, this.$W, ie, 3), dddd: ie[this.$W], H: String(R), HH: U.s(R, 2, "0"), h: be(1), hh: be(2), a: fe(R, H, !0), A: fe(R, H, !1), m: String(H), mm: U.s(H, 2, "0"), s: String(this.$s), ss: U.s(this.$s, 2, "0"), SSS: U.s(this.$ms, 3, "0"), Z: A };
        return w.replace(E, function(le, Pe) {
          return Pe || re[le] || A.replace(":", "");
        });
      }, x.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, x.diff = function(m, T, y) {
        var w, A = U.p(T), R = q(m), H = (R.utcOffset() - this.utcOffset()) * i, z = this - R, ie = U.m(this, R);
        return ie = (w = {}, w[g] = ie / 12, w[f] = ie, w[d] = ie / 3, w[c] = (z - H) / 6048e5, w[u] = (z - H) / 864e5, w[s] = z / a, w[l] = z / i, w[o] = z / t, w)[A] || z, y ? ie : U.a(ie);
      }, x.daysInMonth = function() {
        return this.endOf(f).$D;
      }, x.$locale = function() {
        return F[this.$L];
      }, x.locale = function(m, T) {
        if (!m)
          return this.$L;
        var y = this.clone(), w = W(m, T, !0);
        return w && (y.$L = w), y;
      }, x.clone = function() {
        return U.w(this.$d, this);
      }, x.toDate = function() {
        return new Date(this.valueOf());
      }, x.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, x.toISOString = function() {
        return this.$d.toISOString();
      }, x.toString = function() {
        return this.$d.toUTCString();
      }, S;
    }(), P = v.prototype;
    return q.prototype = P, [["$ms", r], ["$s", o], ["$m", l], ["$H", s], ["$W", u], ["$M", f], ["$y", g], ["$D", b]].forEach(function(S) {
      P[S[1]] = function(x) {
        return this.$g(x, S[0], S[1]);
      };
    }), q.extend = function(S, x) {
      return S.$i || (S(x, v, q), S.$i = !0), q;
    }, q.locale = W, q.isDayjs = j, q.unix = function(S) {
      return q(1e3 * S);
    }, q.en = F[I], q.Ls = F, q.p = {}, q;
  });
})(Fe);
const ve = Fe.exports;
var oi = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU"
], ge = (
  /** @class */
  function() {
    function n(e, t) {
      if (t === 0)
        throw new Error("Can't create weekday with n == 0");
      this.weekday = e, this.n = t;
    }
    return n.fromStr = function(e) {
      return new n(oi.indexOf(e));
    }, n.prototype.nth = function(e) {
      return this.n === e ? this : new n(this.weekday, e);
    }, n.prototype.equals = function(e) {
      return this.weekday === e.weekday && this.n === e.n;
    }, n.prototype.toString = function() {
      var e = oi[this.weekday];
      return this.n && (e = (this.n > 0 ? "+" : "") + String(this.n) + e), e;
    }, n.prototype.getJsWeekday = function() {
      return this.weekday === 6 ? 0 : this.weekday + 1;
    }, n;
  }()
), ae = function(n) {
  return n != null;
}, De = function(n) {
  return typeof n == "number";
}, Ba = function(n) {
  return typeof n == "string" && oi.includes(n);
}, Te = Array.isArray, Ue = function(n, e) {
  e === void 0 && (e = n), arguments.length === 1 && (e = n, n = 0);
  for (var t = [], i = n; i < e; i++)
    t.push(i);
  return t;
}, K = function(n, e) {
  var t = 0, i = [];
  if (Te(n))
    for (; t < e; t++)
      i[t] = [].concat(n);
  else
    for (; t < e; t++)
      i[t] = n;
  return i;
}, s4 = function(n) {
  return Te(n) ? n : [n];
};
function at(n, e, t) {
  t === void 0 && (t = " ");
  var i = String(n);
  return e = e >> 0, i.length > e ? String(i) : (e = e - i.length, e > t.length && (t += K(t, e / t.length)), t.slice(0, e) + String(i));
}
var l4 = function(n, e, t) {
  var i = n.split(e);
  return t ? i.slice(0, t).concat([i.slice(t).join(e)]) : i;
}, Ce = function(n, e) {
  var t = n % e;
  return t * e < 0 ? t + e : t;
}, jn = function(n, e) {
  return { div: Math.floor(n / e), mod: Ce(n, e) };
}, Le = function(n) {
  return !ae(n) || n.length === 0;
}, oe = function(n) {
  return !Le(n);
}, ee = function(n, e) {
  return oe(n) && n.indexOf(e) !== -1;
}, tt = function(n, e, t, i, a, r) {
  return i === void 0 && (i = 0), a === void 0 && (a = 0), r === void 0 && (r = 0), new Date(Date.UTC(n, e - 1, t, i, a, r));
}, u4 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], po = 1e3 * 60 * 60 * 24, bo = 9999, yo = tt(1970, 1, 1), c4 = [6, 0, 1, 2, 3, 4, 5], St = function(n) {
  return n % 4 === 0 && n % 100 !== 0 || n % 400 === 0;
}, vo = function(n) {
  return n instanceof Date;
}, Et = function(n) {
  return vo(n) && !isNaN(n.getTime());
}, d4 = function(n, e) {
  var t = n.getTime(), i = e.getTime(), a = t - i;
  return Math.round(a / po);
}, si = function(n) {
  return d4(n, yo);
}, To = function(n) {
  return new Date(yo.getTime() + n * po);
}, f4 = function(n) {
  var e = n.getUTCMonth();
  return e === 1 && St(n.getUTCFullYear()) ? 29 : u4[e];
}, dt = function(n) {
  return c4[n.getUTCDay()];
}, Pa = function(n, e) {
  var t = tt(n, e + 1, 1);
  return [dt(t), f4(t)];
}, ko = function(n, e) {
  return e = e || n, new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
}, li = function(n) {
  var e = new Date(n.getTime());
  return e;
}, Ma = function(n) {
  for (var e = [], t = 0; t < n.length; t++)
    e.push(li(n[t]));
  return e;
}, $t = function(n) {
  n.sort(function(e, t) {
    return e.getTime() - t.getTime();
  });
}, Fi = function(n, e) {
  e === void 0 && (e = !0);
  var t = new Date(n);
  return [
    at(t.getUTCFullYear().toString(), 4, "0"),
    at(t.getUTCMonth() + 1, 2, "0"),
    at(t.getUTCDate(), 2, "0"),
    "T",
    at(t.getUTCHours(), 2, "0"),
    at(t.getUTCMinutes(), 2, "0"),
    at(t.getUTCSeconds(), 2, "0"),
    e ? "Z" : ""
  ].join("");
}, Ui = function(n) {
  var e = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/, t = e.exec(n);
  if (!t)
    throw new Error("Invalid UNTIL value: ".concat(n));
  return new Date(Date.UTC(parseInt(t[1], 10), parseInt(t[2], 10) - 1, parseInt(t[3], 10), parseInt(t[5], 10) || 0, parseInt(t[6], 10) || 0, parseInt(t[7], 10) || 0));
}, Da = function(n, e) {
  var t = n.toLocaleString("sv-SE", { timeZone: e });
  return t.replace(" ", "T") + "Z";
}, g4 = function(n, e) {
  var t = Intl.DateTimeFormat().resolvedOptions().timeZone, i = new Date(Da(n, t)), a = new Date(Da(n, e ?? "UTC")), r = a.getTime() - i.getTime();
  return new Date(n.getTime() - r);
}, ct = (
  /** @class */
  function() {
    function n(e, t) {
      this.minDate = null, this.maxDate = null, this._result = [], this.total = 0, this.method = e, this.args = t, e === "between" ? (this.maxDate = t.inc ? t.before : new Date(t.before.getTime() - 1), this.minDate = t.inc ? t.after : new Date(t.after.getTime() + 1)) : e === "before" ? this.maxDate = t.inc ? t.dt : new Date(t.dt.getTime() - 1) : e === "after" && (this.minDate = t.inc ? t.dt : new Date(t.dt.getTime() + 1));
    }
    return n.prototype.accept = function(e) {
      ++this.total;
      var t = this.minDate && e < this.minDate, i = this.maxDate && e > this.maxDate;
      if (this.method === "between") {
        if (t)
          return !0;
        if (i)
          return !1;
      } else if (this.method === "before") {
        if (i)
          return !1;
      } else if (this.method === "after")
        return t ? !0 : (this.add(e), !1);
      return this.add(e);
    }, n.prototype.add = function(e) {
      return this._result.push(e), !0;
    }, n.prototype.getValue = function() {
      var e = this._result;
      switch (this.method) {
        case "all":
        case "between":
          return e;
        case "before":
        case "after":
        default:
          return e.length ? e[e.length - 1] : null;
      }
    }, n.prototype.clone = function() {
      return new n(this.method, this.args);
    }, n;
  }()
), ui = function(n, e) {
  return ui = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, i) {
    t.__proto__ = i;
  } || function(t, i) {
    for (var a in i)
      Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
  }, ui(n, e);
};
function zi(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  ui(n, e);
  function t() {
    this.constructor = n;
  }
  n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var Ee = function() {
  return Ee = Object.assign || function(e) {
    for (var t, i = 1, a = arguments.length; i < a; i++) {
      t = arguments[i];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Ee.apply(this, arguments);
};
function M(n, e, t) {
  if (t || arguments.length === 2)
    for (var i = 0, a = e.length, r; i < a; i++)
      (r || !(i in e)) && (r || (r = Array.prototype.slice.call(e, 0, i)), r[i] = e[i]);
  return n.concat(r || Array.prototype.slice.call(e));
}
var Aa = (
  /** @class */
  function(n) {
    zi(e, n);
    function e(t, i, a) {
      var r = n.call(this, t, i) || this;
      return r.iterator = a, r;
    }
    return e.prototype.add = function(t) {
      return this.iterator(t, this._result.length) ? (this._result.push(t), !0) : !1;
    }, e;
  }(ct)
), ln = {
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  tokens: {
    SKIP: /^[ \r\n\t]+|^\.$/,
    number: /^[1-9][0-9]*/,
    numberAsText: /^(one|two|three)/i,
    every: /^every/i,
    "day(s)": /^days?/i,
    "weekday(s)": /^weekdays?/i,
    "week(s)": /^weeks?/i,
    "hour(s)": /^hours?/i,
    "minute(s)": /^minutes?/i,
    "month(s)": /^months?/i,
    "year(s)": /^years?/i,
    on: /^(on|in)/i,
    at: /^(at)/i,
    the: /^the/i,
    first: /^first/i,
    second: /^second/i,
    third: /^third/i,
    nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
    last: /^last/i,
    for: /^for/i,
    "time(s)": /^times?/i,
    until: /^(un)?til/i,
    monday: /^mo(n(day)?)?/i,
    tuesday: /^tu(e(s(day)?)?)?/i,
    wednesday: /^we(d(n(esday)?)?)?/i,
    thursday: /^th(u(r(sday)?)?)?/i,
    friday: /^fr(i(day)?)?/i,
    saturday: /^sa(t(urday)?)?/i,
    sunday: /^su(n(day)?)?/i,
    january: /^jan(uary)?/i,
    february: /^feb(ruary)?/i,
    march: /^mar(ch)?/i,
    april: /^apr(il)?/i,
    may: /^may/i,
    june: /^june?/i,
    july: /^july?/i,
    august: /^aug(ust)?/i,
    september: /^sep(t(ember)?)?/i,
    october: /^oct(ober)?/i,
    november: /^nov(ember)?/i,
    december: /^dec(ember)?/i,
    comma: /^(,\s*|(and|or)\s*)+/i
  }
}, La = function(n, e) {
  return n.indexOf(e) !== -1;
}, h4 = function(n) {
  return n.toString();
}, m4 = function(n, e, t) {
  return "".concat(e, " ").concat(t, ", ").concat(n);
}, We = (
  /** @class */
  function() {
    function n(e, t, i, a) {
      if (t === void 0 && (t = h4), i === void 0 && (i = ln), a === void 0 && (a = m4), this.text = [], this.language = i || ln, this.gettext = t, this.dateFormatter = a, this.rrule = e, this.options = e.options, this.origOptions = e.origOptions, this.origOptions.bymonthday) {
        var r = [].concat(this.options.bymonthday), o = [].concat(this.options.bynmonthday);
        r.sort(function(c, f) {
          return c - f;
        }), o.sort(function(c, f) {
          return f - c;
        }), this.bymonthday = r.concat(o), this.bymonthday.length || (this.bymonthday = null);
      }
      if (ae(this.origOptions.byweekday)) {
        var l = Te(this.origOptions.byweekday) ? this.origOptions.byweekday : [this.origOptions.byweekday], s = String(l);
        this.byweekday = {
          allWeeks: l.filter(function(c) {
            return !c.n;
          }),
          someWeeks: l.filter(function(c) {
            return !!c.n;
          }),
          isWeekdays: s.indexOf("MO") !== -1 && s.indexOf("TU") !== -1 && s.indexOf("WE") !== -1 && s.indexOf("TH") !== -1 && s.indexOf("FR") !== -1 && s.indexOf("SA") === -1 && s.indexOf("SU") === -1,
          isEveryDay: s.indexOf("MO") !== -1 && s.indexOf("TU") !== -1 && s.indexOf("WE") !== -1 && s.indexOf("TH") !== -1 && s.indexOf("FR") !== -1 && s.indexOf("SA") !== -1 && s.indexOf("SU") !== -1
        };
        var u = function(c, f) {
          return c.weekday - f.weekday;
        };
        this.byweekday.allWeeks.sort(u), this.byweekday.someWeeks.sort(u), this.byweekday.allWeeks.length || (this.byweekday.allWeeks = null), this.byweekday.someWeeks.length || (this.byweekday.someWeeks = null);
      } else
        this.byweekday = null;
    }
    return n.isFullyConvertible = function(e) {
      var t = !0;
      if (!(e.options.freq in n.IMPLEMENTED) || e.origOptions.until && e.origOptions.count)
        return !1;
      for (var i in e.origOptions) {
        if (La(["dtstart", "tzid", "wkst", "freq"], i))
          return !0;
        if (!La(n.IMPLEMENTED[e.options.freq], i))
          return !1;
      }
      return t;
    }, n.prototype.isFullyConvertible = function() {
      return n.isFullyConvertible(this.rrule);
    }, n.prototype.toString = function() {
      var e = this.gettext;
      if (!(this.options.freq in n.IMPLEMENTED))
        return e("RRule error: Unable to fully convert this rrule to text");
      if (this.text = [e("every")], this[L.FREQUENCIES[this.options.freq]](), this.options.until) {
        this.add(e("until"));
        var t = this.options.until;
        this.add(this.dateFormatter(t.getUTCFullYear(), this.language.monthNames[t.getUTCMonth()], t.getUTCDate()));
      } else
        this.options.count && this.add(e("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? e("times") : e("time"));
      return this.isFullyConvertible() || this.add(e("(~ approximate)")), this.text.join("");
    }, n.prototype.HOURLY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("hours") : e("hour"));
    }, n.prototype.MINUTELY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("minutes") : e("minute"));
    }, n.prototype.DAILY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.byweekday && this.byweekday.isWeekdays ? this.add(this.plural(this.options.interval) ? e("weekdays") : e("weekday")) : this.add(this.plural(this.options.interval) ? e("days") : e("day")), this.origOptions.bymonth && (this.add(e("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday ? this._byweekday() : this.origOptions.byhour && this._byhour();
    }, n.prototype.WEEKLY = function() {
      var e = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? e("weeks") : e("week")), this.byweekday && this.byweekday.isWeekdays ? this.options.interval === 1 ? this.add(this.plural(this.options.interval) ? e("weekdays") : e("weekday")) : this.add(e("on")).add(e("weekdays")) : this.byweekday && this.byweekday.isEveryDay ? this.add(this.plural(this.options.interval) ? e("days") : e("day")) : (this.options.interval === 1 && this.add(e("week")), this.origOptions.bymonth && (this.add(e("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.origOptions.byhour && this._byhour());
    }, n.prototype.MONTHLY = function() {
      var e = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()).add(e("months")), this.plural(this.options.interval) && this.add(e("in"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("months") : e("month"))), this.bymonthday ? this._bymonthday() : this.byweekday && this.byweekday.isWeekdays ? this.add(e("on")).add(e("weekdays")) : this.byweekday && this._byweekday();
    }, n.prototype.YEARLY = function() {
      var e = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()), this.add(e("years"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? e("years") : e("year"))), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.options.byyearday && this.add(e("on the")).add(this.list(this.options.byyearday, this.nth, e("and"))).add(e("day")), this.options.byweekno && this.add(e("in")).add(this.plural(this.options.byweekno.length) ? e("weeks") : e("week")).add(this.list(this.options.byweekno, void 0, e("and")));
    }, n.prototype._bymonthday = function() {
      var e = this.gettext;
      this.byweekday && this.byweekday.allWeeks ? this.add(e("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, e("or"))).add(e("the")).add(this.list(this.bymonthday, this.nth, e("or"))) : this.add(e("on the")).add(this.list(this.bymonthday, this.nth, e("and")));
    }, n.prototype._byweekday = function() {
      var e = this.gettext;
      this.byweekday.allWeeks && !this.byweekday.isWeekdays && this.add(e("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext)), this.byweekday.someWeeks && (this.byweekday.allWeeks && this.add(e("and")), this.add(e("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, e("and"))));
    }, n.prototype._byhour = function() {
      var e = this.gettext;
      this.add(e("at")).add(this.list(this.origOptions.byhour, void 0, e("and")));
    }, n.prototype._bymonth = function() {
      this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")));
    }, n.prototype.nth = function(e) {
      e = parseInt(e.toString(), 10);
      var t, i = this.gettext;
      if (e === -1)
        return i("last");
      var a = Math.abs(e);
      switch (a) {
        case 1:
        case 21:
        case 31:
          t = a + i("st");
          break;
        case 2:
        case 22:
          t = a + i("nd");
          break;
        case 3:
        case 23:
          t = a + i("rd");
          break;
        default:
          t = a + i("th");
      }
      return e < 0 ? t + " " + i("last") : t;
    }, n.prototype.monthtext = function(e) {
      return this.language.monthNames[e - 1];
    }, n.prototype.weekdaytext = function(e) {
      var t = De(e) ? (e + 1) % 7 : e.getJsWeekday();
      return (e.n ? this.nth(e.n) + " " : "") + this.language.dayNames[t];
    }, n.prototype.plural = function(e) {
      return e % 100 !== 1;
    }, n.prototype.add = function(e) {
      return this.text.push(" "), this.text.push(e), this;
    }, n.prototype.list = function(e, t, i, a) {
      var r = this;
      a === void 0 && (a = ","), Te(e) || (e = [e]);
      var o = function(s, u, c) {
        for (var f = "", d = 0; d < s.length; d++)
          d !== 0 && (d === s.length - 1 ? f += " " + c + " " : f += u + " "), f += s[d];
        return f;
      };
      t = t || function(s) {
        return s.toString();
      };
      var l = function(s) {
        return t && t.call(r, s);
      };
      return i ? o(e.map(l), a, i) : e.map(l).join(a + " ");
    }, n;
  }()
), p4 = (
  /** @class */
  function() {
    function n(e) {
      this.done = !0, this.rules = e;
    }
    return n.prototype.start = function(e) {
      return this.text = e, this.done = !1, this.nextSymbol();
    }, n.prototype.isDone = function() {
      return this.done && this.symbol === null;
    }, n.prototype.nextSymbol = function() {
      var e, t;
      this.symbol = null, this.value = null;
      do {
        if (this.done)
          return !1;
        var i = void 0;
        e = null;
        for (var a in this.rules) {
          i = this.rules[a];
          var r = i.exec(this.text);
          r && (e === null || r[0].length > e[0].length) && (e = r, t = a);
        }
        if (e != null && (this.text = this.text.substr(e[0].length), this.text === "" && (this.done = !0)), e == null) {
          this.done = !0, this.symbol = null, this.value = null;
          return;
        }
      } while (t === "SKIP");
      return this.symbol = t, this.value = e, !0;
    }, n.prototype.accept = function(e) {
      if (this.symbol === e) {
        if (this.value) {
          var t = this.value;
          return this.nextSymbol(), t;
        }
        return this.nextSymbol(), !0;
      }
      return !1;
    }, n.prototype.acceptNumber = function() {
      return this.accept("number");
    }, n.prototype.expect = function(e) {
      if (this.accept(e))
        return !0;
      throw new Error("expected " + e + " but found " + this.symbol);
    }, n;
  }()
);
function Eo(n, e) {
  e === void 0 && (e = ln);
  var t = {}, i = new p4(e.tokens);
  if (!i.start(n))
    return null;
  return a(), t;
  function a() {
    i.expect("every");
    var d = i.acceptNumber();
    if (d && (t.interval = parseInt(d[0], 10)), i.isDone())
      throw new Error("Unexpected end");
    switch (i.symbol) {
      case "day(s)":
        t.freq = L.DAILY, i.nextSymbol() && (o(), f());
        break;
      case "weekday(s)":
        t.freq = L.WEEKLY, t.byweekday = [L.MO, L.TU, L.WE, L.TH, L.FR], i.nextSymbol(), o(), f();
        break;
      case "week(s)":
        t.freq = L.WEEKLY, i.nextSymbol() && (r(), o(), f());
        break;
      case "hour(s)":
        t.freq = L.HOURLY, i.nextSymbol() && (r(), f());
        break;
      case "minute(s)":
        t.freq = L.MINUTELY, i.nextSymbol() && (r(), f());
        break;
      case "month(s)":
        t.freq = L.MONTHLY, i.nextSymbol() && (r(), f());
        break;
      case "year(s)":
        t.freq = L.YEARLY, i.nextSymbol() && (r(), f());
        break;
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        t.freq = L.WEEKLY;
        var g = i.symbol.substr(0, 2).toUpperCase();
        if (t.byweekday = [L[g]], !i.nextSymbol())
          return;
        for (; i.accept("comma"); ) {
          if (i.isDone())
            throw new Error("Unexpected end");
          var b = s();
          if (!b)
            throw new Error("Unexpected symbol " + i.symbol + ", expected weekday");
          t.byweekday.push(L[b]), i.nextSymbol();
        }
        o(), c(), f();
        break;
      case "january":
      case "february":
      case "march":
      case "april":
      case "may":
      case "june":
      case "july":
      case "august":
      case "september":
      case "october":
      case "november":
      case "december":
        if (t.freq = L.YEARLY, t.bymonth = [l()], !i.nextSymbol())
          return;
        for (; i.accept("comma"); ) {
          if (i.isDone())
            throw new Error("Unexpected end");
          var p = l();
          if (!p)
            throw new Error("Unexpected symbol " + i.symbol + ", expected month");
          t.bymonth.push(p), i.nextSymbol();
        }
        r(), f();
        break;
      default:
        throw new Error("Unknown symbol");
    }
  }
  function r() {
    var d = i.accept("on"), g = i.accept("the");
    if (d || g)
      do {
        var b = u(), p = s(), h = l();
        if (b)
          p ? (i.nextSymbol(), t.byweekday || (t.byweekday = []), t.byweekday.push(L[p].nth(b))) : (t.bymonthday || (t.bymonthday = []), t.bymonthday.push(b), i.accept("day(s)"));
        else if (p)
          i.nextSymbol(), t.byweekday || (t.byweekday = []), t.byweekday.push(L[p]);
        else if (i.symbol === "weekday(s)")
          i.nextSymbol(), t.byweekday || (t.byweekday = [L.MO, L.TU, L.WE, L.TH, L.FR]);
        else if (i.symbol === "week(s)") {
          i.nextSymbol();
          var E = i.acceptNumber();
          if (!E)
            throw new Error("Unexpected symbol " + i.symbol + ", expected week number");
          for (t.byweekno = [parseInt(E[0], 10)]; i.accept("comma"); ) {
            if (E = i.acceptNumber(), !E)
              throw new Error("Unexpected symbol " + i.symbol + "; expected monthday");
            t.byweekno.push(parseInt(E[0], 10));
          }
        } else if (h)
          i.nextSymbol(), t.bymonth || (t.bymonth = []), t.bymonth.push(h);
        else
          return;
      } while (i.accept("comma") || i.accept("the") || i.accept("on"));
  }
  function o() {
    var d = i.accept("at");
    if (d)
      do {
        var g = i.acceptNumber();
        if (!g)
          throw new Error("Unexpected symbol " + i.symbol + ", expected hour");
        for (t.byhour = [parseInt(g[0], 10)]; i.accept("comma"); ) {
          if (g = i.acceptNumber(), !g)
            throw new Error("Unexpected symbol " + i.symbol + "; expected hour");
          t.byhour.push(parseInt(g[0], 10));
        }
      } while (i.accept("comma") || i.accept("at"));
  }
  function l() {
    switch (i.symbol) {
      case "january":
        return 1;
      case "february":
        return 2;
      case "march":
        return 3;
      case "april":
        return 4;
      case "may":
        return 5;
      case "june":
        return 6;
      case "july":
        return 7;
      case "august":
        return 8;
      case "september":
        return 9;
      case "october":
        return 10;
      case "november":
        return 11;
      case "december":
        return 12;
      default:
        return !1;
    }
  }
  function s() {
    switch (i.symbol) {
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        return i.symbol.substr(0, 2).toUpperCase();
      default:
        return !1;
    }
  }
  function u() {
    switch (i.symbol) {
      case "last":
        return i.nextSymbol(), -1;
      case "first":
        return i.nextSymbol(), 1;
      case "second":
        return i.nextSymbol(), i.accept("last") ? -2 : 2;
      case "third":
        return i.nextSymbol(), i.accept("last") ? -3 : 3;
      case "nth":
        var d = parseInt(i.value[1], 10);
        if (d < -366 || d > 366)
          throw new Error("Nth out of range: " + d);
        return i.nextSymbol(), i.accept("last") ? -d : d;
      default:
        return !1;
    }
  }
  function c() {
    i.accept("on"), i.accept("the");
    var d = u();
    if (d)
      for (t.bymonthday = [d], i.nextSymbol(); i.accept("comma"); ) {
        if (d = u(), !d)
          throw new Error("Unexpected symbol " + i.symbol + "; expected monthday");
        t.bymonthday.push(d), i.nextSymbol();
      }
  }
  function f() {
    if (i.symbol === "until") {
      var d = Date.parse(i.text);
      if (!d)
        throw new Error("Cannot parse until date:" + i.text);
      t.until = new Date(d);
    } else
      i.accept("for") && (t.count = parseInt(i.value[0], 10), i.expect("number"));
  }
}
var Z;
(function(n) {
  n[n.YEARLY = 0] = "YEARLY", n[n.MONTHLY = 1] = "MONTHLY", n[n.WEEKLY = 2] = "WEEKLY", n[n.DAILY = 3] = "DAILY", n[n.HOURLY = 4] = "HOURLY", n[n.MINUTELY = 5] = "MINUTELY", n[n.SECONDLY = 6] = "SECONDLY";
})(Z || (Z = {}));
function Hi(n) {
  return n < Z.HOURLY;
}
var b4 = function(n, e) {
  return e === void 0 && (e = ln), new L(Eo(n, e) || void 0);
}, mt = [
  "count",
  "until",
  "interval",
  "byweekday",
  "bymonthday",
  "bymonth"
];
We.IMPLEMENTED = [];
We.IMPLEMENTED[Z.HOURLY] = mt;
We.IMPLEMENTED[Z.MINUTELY] = mt;
We.IMPLEMENTED[Z.DAILY] = ["byhour"].concat(mt);
We.IMPLEMENTED[Z.WEEKLY] = mt;
We.IMPLEMENTED[Z.MONTHLY] = mt;
We.IMPLEMENTED[Z.YEARLY] = ["byweekno", "byyearday"].concat(mt);
var y4 = function(n, e, t, i) {
  return new We(n, e, t, i).toString();
}, v4 = We.isFullyConvertible, un = (
  /** @class */
  function() {
    function n(e, t, i, a) {
      this.hour = e, this.minute = t, this.second = i, this.millisecond = a || 0;
    }
    return n.prototype.getHours = function() {
      return this.hour;
    }, n.prototype.getMinutes = function() {
      return this.minute;
    }, n.prototype.getSeconds = function() {
      return this.second;
    }, n.prototype.getMilliseconds = function() {
      return this.millisecond;
    }, n.prototype.getTime = function() {
      return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1e3 + this.millisecond;
    }, n;
  }()
), T4 = (
  /** @class */
  function(n) {
    zi(e, n);
    function e(t, i, a, r, o, l, s) {
      var u = n.call(this, r, o, l, s) || this;
      return u.year = t, u.month = i, u.day = a, u;
    }
    return e.fromDate = function(t) {
      return new this(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.valueOf() % 1e3);
    }, e.prototype.getWeekday = function() {
      return dt(new Date(this.getTime()));
    }, e.prototype.getTime = function() {
      return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    }, e.prototype.getDay = function() {
      return this.day;
    }, e.prototype.getMonth = function() {
      return this.month;
    }, e.prototype.getYear = function() {
      return this.year;
    }, e.prototype.addYears = function(t) {
      this.year += t;
    }, e.prototype.addMonths = function(t) {
      if (this.month += t, this.month > 12) {
        var i = Math.floor(this.month / 12), a = Ce(this.month, 12);
        this.month = a, this.year += i, this.month === 0 && (this.month = 12, --this.year);
      }
    }, e.prototype.addWeekly = function(t, i) {
      i > this.getWeekday() ? this.day += -(this.getWeekday() + 1 + (6 - i)) + t * 7 : this.day += -(this.getWeekday() - i) + t * 7, this.fixDay();
    }, e.prototype.addDaily = function(t) {
      this.day += t, this.fixDay();
    }, e.prototype.addHours = function(t, i, a) {
      for (i && (this.hour += Math.floor((23 - this.hour) / t) * t); ; ) {
        this.hour += t;
        var r = jn(this.hour, 24), o = r.div, l = r.mod;
        if (o && (this.hour = l, this.addDaily(o)), Le(a) || ee(a, this.hour))
          break;
      }
    }, e.prototype.addMinutes = function(t, i, a, r) {
      for (i && (this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / t) * t); ; ) {
        this.minute += t;
        var o = jn(this.minute, 60), l = o.div, s = o.mod;
        if (l && (this.minute = s, this.addHours(l, !1, a)), (Le(a) || ee(a, this.hour)) && (Le(r) || ee(r, this.minute)))
          break;
      }
    }, e.prototype.addSeconds = function(t, i, a, r, o) {
      for (i && (this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / t) * t); ; ) {
        this.second += t;
        var l = jn(this.second, 60), s = l.div, u = l.mod;
        if (s && (this.second = u, this.addMinutes(s, !1, a, r)), (Le(a) || ee(a, this.hour)) && (Le(r) || ee(r, this.minute)) && (Le(o) || ee(o, this.second)))
          break;
      }
    }, e.prototype.fixDay = function() {
      if (!(this.day <= 28)) {
        var t = Pa(this.year, this.month - 1)[1];
        if (!(this.day <= t))
          for (; this.day > t; ) {
            if (this.day -= t, ++this.month, this.month === 13 && (this.month = 1, ++this.year, this.year > bo))
              return;
            t = Pa(this.year, this.month - 1)[1];
          }
      }
    }, e.prototype.add = function(t, i) {
      var a = t.freq, r = t.interval, o = t.wkst, l = t.byhour, s = t.byminute, u = t.bysecond;
      switch (a) {
        case Z.YEARLY:
          return this.addYears(r);
        case Z.MONTHLY:
          return this.addMonths(r);
        case Z.WEEKLY:
          return this.addWeekly(r, o);
        case Z.DAILY:
          return this.addDaily(r);
        case Z.HOURLY:
          return this.addHours(r, i, l);
        case Z.MINUTELY:
          return this.addMinutes(r, i, l, s);
        case Z.SECONDLY:
          return this.addSeconds(r, i, l, s, u);
      }
    }, e;
  }(un)
);
function xo(n) {
  for (var e = [], t = Object.keys(n), i = 0, a = t; i < a.length; i++) {
    var r = a[i];
    ee(Z4, r) || e.push(r), vo(n[r]) && !Et(n[r]) && e.push(r);
  }
  if (e.length)
    throw new Error("Invalid options: " + e.join(", "));
  return Ee({}, n);
}
function k4(n) {
  var e = Ee(Ee({}, ji), xo(n));
  if (ae(e.byeaster) && (e.freq = L.YEARLY), !(ae(e.freq) && L.FREQUENCIES[e.freq]))
    throw new Error("Invalid frequency: ".concat(e.freq, " ").concat(n.freq));
  if (e.dtstart || (e.dtstart = new Date((/* @__PURE__ */ new Date()).setMilliseconds(0))), ae(e.wkst) ? De(e.wkst) || (e.wkst = e.wkst.weekday) : e.wkst = L.MO.weekday, ae(e.bysetpos)) {
    De(e.bysetpos) && (e.bysetpos = [e.bysetpos]);
    for (var t = 0; t < e.bysetpos.length; t++) {
      var i = e.bysetpos[t];
      if (i === 0 || !(i >= -366 && i <= 366))
        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
    }
  }
  if (!(e.byweekno || oe(e.byweekno) || oe(e.byyearday) || e.bymonthday || oe(e.bymonthday) || ae(e.byweekday) || ae(e.byeaster)))
    switch (e.freq) {
      case L.YEARLY:
        e.bymonth || (e.bymonth = e.dtstart.getUTCMonth() + 1), e.bymonthday = e.dtstart.getUTCDate();
        break;
      case L.MONTHLY:
        e.bymonthday = e.dtstart.getUTCDate();
        break;
      case L.WEEKLY:
        e.byweekday = [dt(e.dtstart)];
        break;
    }
  if (ae(e.bymonth) && !Te(e.bymonth) && (e.bymonth = [e.bymonth]), ae(e.byyearday) && !Te(e.byyearday) && De(e.byyearday) && (e.byyearday = [e.byyearday]), !ae(e.bymonthday))
    e.bymonthday = [], e.bynmonthday = [];
  else if (Te(e.bymonthday)) {
    for (var a = [], r = [], t = 0; t < e.bymonthday.length; t++) {
      var i = e.bymonthday[t];
      i > 0 ? a.push(i) : i < 0 && r.push(i);
    }
    e.bymonthday = a, e.bynmonthday = r;
  } else
    e.bymonthday < 0 ? (e.bynmonthday = [e.bymonthday], e.bymonthday = []) : (e.bynmonthday = [], e.bymonthday = [e.bymonthday]);
  if (ae(e.byweekno) && !Te(e.byweekno) && (e.byweekno = [e.byweekno]), !ae(e.byweekday))
    e.bynweekday = null;
  else if (De(e.byweekday))
    e.byweekday = [e.byweekday], e.bynweekday = null;
  else if (Ba(e.byweekday))
    e.byweekday = [ge.fromStr(e.byweekday).weekday], e.bynweekday = null;
  else if (e.byweekday instanceof ge)
    !e.byweekday.n || e.freq > L.MONTHLY ? (e.byweekday = [e.byweekday.weekday], e.bynweekday = null) : (e.bynweekday = [[e.byweekday.weekday, e.byweekday.n]], e.byweekday = null);
  else {
    for (var o = [], l = [], t = 0; t < e.byweekday.length; t++) {
      var s = e.byweekday[t];
      if (De(s)) {
        o.push(s);
        continue;
      } else if (Ba(s)) {
        o.push(ge.fromStr(s).weekday);
        continue;
      }
      !s.n || e.freq > L.MONTHLY ? o.push(s.weekday) : l.push([s.weekday, s.n]);
    }
    e.byweekday = oe(o) ? o : null, e.bynweekday = oe(l) ? l : null;
  }
  return ae(e.byhour) ? De(e.byhour) && (e.byhour = [e.byhour]) : e.byhour = e.freq < L.HOURLY ? [e.dtstart.getUTCHours()] : null, ae(e.byminute) ? De(e.byminute) && (e.byminute = [e.byminute]) : e.byminute = e.freq < L.MINUTELY ? [e.dtstart.getUTCMinutes()] : null, ae(e.bysecond) ? De(e.bysecond) && (e.bysecond = [e.bysecond]) : e.bysecond = e.freq < L.SECONDLY ? [e.dtstart.getUTCSeconds()] : null, { parsedOptions: e };
}
function E4(n) {
  var e = n.dtstart.getTime() % 1e3;
  if (!Hi(n.freq))
    return [];
  var t = [];
  return n.byhour.forEach(function(i) {
    n.byminute.forEach(function(a) {
      n.bysecond.forEach(function(r) {
        t.push(new un(i, a, r, e));
      });
    });
  }), t;
}
function ci(n) {
  var e = n.split(`
`).map(x4).filter(function(t) {
    return t !== null;
  });
  return Ee(Ee({}, e[0]), e[1]);
}
function cn(n) {
  var e = {}, t = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(n);
  if (!t)
    return e;
  var i = t[1], a = t[2];
  return i && (e.tzid = i), e.dtstart = Ui(a), e;
}
function x4(n) {
  if (n = n.replace(/^\s+|\s+$/, ""), !n.length)
    return null;
  var e = /^([A-Z]+?)[:;]/.exec(n.toUpperCase());
  if (!e)
    return Oa(n);
  var t = e[1];
  switch (t.toUpperCase()) {
    case "RRULE":
    case "EXRULE":
      return Oa(n);
    case "DTSTART":
      return cn(n);
    default:
      throw new Error("Unsupported RFC prop ".concat(t, " in ").concat(n));
  }
}
function Oa(n) {
  var e = n.replace(/^RRULE:/i, ""), t = cn(e), i = n.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
  return i.forEach(function(a) {
    var r = a.split("="), o = r[0], l = r[1];
    switch (o.toUpperCase()) {
      case "FREQ":
        t.freq = Z[l.toUpperCase()];
        break;
      case "WKST":
        t.wkst = we[l.toUpperCase()];
        break;
      case "COUNT":
      case "INTERVAL":
      case "BYSETPOS":
      case "BYMONTH":
      case "BYMONTHDAY":
      case "BYYEARDAY":
      case "BYWEEKNO":
      case "BYHOUR":
      case "BYMINUTE":
      case "BYSECOND":
        var s = S4(l), u = o.toLowerCase();
        t[u] = s;
        break;
      case "BYWEEKDAY":
      case "BYDAY":
        t.byweekday = C4(l);
        break;
      case "DTSTART":
      case "TZID":
        var c = cn(n);
        t.tzid = c.tzid, t.dtstart = c.dtstart;
        break;
      case "UNTIL":
        t.until = Ui(l);
        break;
      case "BYEASTER":
        t.byeaster = Number(l);
        break;
      default:
        throw new Error("Unknown RRULE property '" + o + "'");
    }
  }), t;
}
function S4(n) {
  if (n.indexOf(",") !== -1) {
    var e = n.split(",");
    return e.map(_a);
  }
  return _a(n);
}
function _a(n) {
  return /^[+-]?\d+$/.test(n) ? Number(n) : n;
}
function C4(n) {
  var e = n.split(",");
  return e.map(function(t) {
    if (t.length === 2)
      return we[t];
    var i = t.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
    if (!i || i.length < 3)
      throw new SyntaxError("Invalid weekday string: ".concat(t));
    var a = Number(i[1]), r = i[2], o = we[r].weekday;
    return new ge(o, a);
  });
}
var dn = (
  /** @class */
  function() {
    function n(e, t) {
      if (isNaN(e.getTime()))
        throw new RangeError("Invalid date passed to DateWithZone");
      this.date = e, this.tzid = t;
    }
    return Object.defineProperty(n.prototype, "isUTC", {
      get: function() {
        return !this.tzid || this.tzid.toUpperCase() === "UTC";
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.toString = function() {
      var e = Fi(this.date.getTime(), this.isUTC);
      return this.isUTC ? ":".concat(e) : ";TZID=".concat(this.tzid, ":").concat(e);
    }, n.prototype.getTime = function() {
      return this.date.getTime();
    }, n.prototype.rezonedDate = function() {
      return this.isUTC ? this.date : g4(this.date, this.tzid);
    }, n;
  }()
);
function di(n) {
  for (var e = [], t = "", i = Object.keys(n), a = Object.keys(ji), r = 0; r < i.length; r++)
    if (i[r] !== "tzid" && ee(a, i[r])) {
      var o = i[r].toUpperCase(), l = n[i[r]], s = "";
      if (!(!ae(l) || Te(l) && !l.length)) {
        switch (o) {
          case "FREQ":
            s = L.FREQUENCIES[n.freq];
            break;
          case "WKST":
            De(l) ? s = new ge(l).toString() : s = l.toString();
            break;
          case "BYWEEKDAY":
            o = "BYDAY", s = s4(l).map(function(g) {
              return g instanceof ge ? g : Te(g) ? new ge(g[0], g[1]) : new ge(g);
            }).toString();
            break;
          case "DTSTART":
            t = w4(l, n.tzid);
            break;
          case "UNTIL":
            s = Fi(l, !n.tzid);
            break;
          default:
            if (Te(l)) {
              for (var u = [], c = 0; c < l.length; c++)
                u[c] = String(l[c]);
              s = u.toString();
            } else
              s = String(l);
        }
        s && e.push([o, s]);
      }
    }
  var f = e.map(function(g) {
    var b = g[0], p = g[1];
    return "".concat(b, "=").concat(p.toString());
  }).join(";"), d = "";
  return f !== "" && (d = "RRULE:".concat(f)), [t, d].filter(function(g) {
    return !!g;
  }).join(`
`);
}
function w4(n, e) {
  return n ? "DTSTART" + new dn(new Date(n), e).toString() : "";
}
function $4(n, e) {
  return Array.isArray(n) ? !Array.isArray(e) || n.length !== e.length ? !1 : n.every(function(t, i) {
    return t.getTime() === e[i].getTime();
  }) : n instanceof Date ? e instanceof Date && n.getTime() === e.getTime() : n === e;
}
var B4 = (
  /** @class */
  function() {
    function n() {
      this.all = !1, this.before = [], this.after = [], this.between = [];
    }
    return n.prototype._cacheAdd = function(e, t, i) {
      t && (t = t instanceof Date ? li(t) : Ma(t)), e === "all" ? this.all = t : (i._value = t, this[e].push(i));
    }, n.prototype._cacheGet = function(e, t) {
      var i = !1, a = t ? Object.keys(t) : [], r = function(c) {
        for (var f = 0; f < a.length; f++) {
          var d = a[f];
          if (!$4(t[d], c[d]))
            return !0;
        }
        return !1;
      }, o = this[e];
      if (e === "all")
        i = this.all;
      else if (Te(o))
        for (var l = 0; l < o.length; l++) {
          var s = o[l];
          if (!(a.length && r(s))) {
            i = s._value;
            break;
          }
        }
      if (!i && this.all) {
        for (var u = new ct(e, t), l = 0; l < this.all.length && u.accept(this.all[l]); l++)
          ;
        i = u.getValue(), this._cacheAdd(e, i, t);
      }
      return Te(i) ? Ma(i) : i instanceof Date ? li(i) : i;
    }, n;
  }()
), P4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], K(1, 31), !0), K(2, 28), !0), K(3, 31), !0), K(4, 30), !0), K(5, 31), !0), K(6, 30), !0), K(7, 31), !0), K(8, 31), !0), K(9, 30), !0), K(10, 31), !0), K(11, 30), !0), K(12, 31), !0), K(1, 7), !0), M4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], K(1, 31), !0), K(2, 29), !0), K(3, 31), !0), K(4, 30), !0), K(5, 31), !0), K(6, 30), !0), K(7, 31), !0), K(8, 31), !0), K(9, 30), !0), K(10, 31), !0), K(11, 30), !0), K(12, 31), !0), K(1, 7), !0), D4 = Ue(1, 29), A4 = Ue(1, 30), Ke = Ue(1, 31), ue = Ue(1, 32), L4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], ue, !0), A4, !0), ue, !0), Ke, !0), ue, !0), Ke, !0), ue, !0), ue, !0), Ke, !0), ue, !0), Ke, !0), ue, !0), ue.slice(0, 7), !0), O4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], ue, !0), D4, !0), ue, !0), Ke, !0), ue, !0), Ke, !0), ue, !0), ue, !0), Ke, !0), ue, !0), Ke, !0), ue, !0), ue.slice(0, 7), !0), _4 = Ue(-28, 0), I4 = Ue(-29, 0), Ze = Ue(-30, 0), ce = Ue(-31, 0), R4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], ce, !0), I4, !0), ce, !0), Ze, !0), ce, !0), Ze, !0), ce, !0), ce, !0), Ze, !0), ce, !0), Ze, !0), ce, !0), ce.slice(0, 7), !0), N4 = M(M(M(M(M(M(M(M(M(M(M(M(M([], ce, !0), _4, !0), ce, !0), Ze, !0), ce, !0), Ze, !0), ce, !0), ce, !0), Ze, !0), ce, !0), Ze, !0), ce, !0), ce.slice(0, 7), !0), F4 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], U4 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], Ia = function() {
  for (var n = [], e = 0; e < 55; e++)
    n = n.concat(Ue(7));
  return n;
}();
function z4(n, e) {
  var t = tt(n, 1, 1), i = St(n) ? 366 : 365, a = St(n + 1) ? 366 : 365, r = si(t), o = dt(t), l = Ee(Ee({ yearlen: i, nextyearlen: a, yearordinal: r, yearweekday: o }, H4(n)), { wnomask: null });
  if (Le(e.byweekno))
    return l;
  l.wnomask = K(0, i + 7);
  var s, u, c = s = Ce(7 - o + e.wkst, 7);
  c >= 4 ? (c = 0, u = l.yearlen + Ce(o - e.wkst, 7)) : u = i - c;
  for (var f = Math.floor(u / 7), d = Ce(u, 7), g = Math.floor(f + d / 4), b = 0; b < e.byweekno.length; b++) {
    var p = e.byweekno[b];
    if (p < 0 && (p += g + 1), p > 0 && p <= g) {
      var h = void 0;
      p > 1 ? (h = c + (p - 1) * 7, c !== s && (h -= 7 - s)) : h = c;
      for (var E = 0; E < 7 && (l.wnomask[h] = 1, h++, l.wdaymask[h] !== e.wkst); E++)
        ;
    }
  }
  if (ee(e.byweekno, 1)) {
    var h = c + g * 7;
    if (c !== s && (h -= 7 - s), h < i)
      for (var b = 0; b < 7 && (l.wnomask[h] = 1, h += 1, l.wdaymask[h] !== e.wkst); b++)
        ;
  }
  if (c) {
    var B = void 0;
    if (ee(e.byweekno, -1))
      B = -1;
    else {
      var _ = dt(tt(n - 1, 1, 1)), D = Ce(7 - _.valueOf() + e.wkst, 7), I = St(n - 1) ? 366 : 365, F = void 0;
      D >= 4 ? (D = 0, F = I + Ce(_ - e.wkst, 7)) : F = i - c, B = Math.floor(52 + Ce(F, 7) / 4);
    }
    if (ee(e.byweekno, B))
      for (var h = 0; h < c; h++)
        l.wnomask[h] = 1;
  }
  return l;
}
function H4(n) {
  var e = St(n) ? 366 : 365, t = tt(n, 1, 1), i = dt(t);
  return e === 365 ? {
    mmask: P4,
    mdaymask: O4,
    nmdaymask: N4,
    wdaymask: Ia.slice(i),
    mrange: U4
  } : {
    mmask: M4,
    mdaymask: L4,
    nmdaymask: R4,
    wdaymask: Ia.slice(i),
    mrange: F4
  };
}
function j4(n, e, t, i, a, r) {
  var o = {
    lastyear: n,
    lastmonth: e,
    nwdaymask: []
  }, l = [];
  if (r.freq === L.YEARLY)
    if (Le(r.bymonth))
      l = [[0, t]];
    else
      for (var s = 0; s < r.bymonth.length; s++)
        e = r.bymonth[s], l.push(i.slice(e - 1, e + 1));
  else
    r.freq === L.MONTHLY && (l = [i.slice(e - 1, e + 1)]);
  if (Le(l))
    return o;
  o.nwdaymask = K(0, t);
  for (var s = 0; s < l.length; s++)
    for (var u = l[s], c = u[0], f = u[1] - 1, d = 0; d < r.bynweekday.length; d++) {
      var g = void 0, b = r.bynweekday[d], p = b[0], h = b[1];
      h < 0 ? (g = f + (h + 1) * 7, g -= Ce(a[g] - p, 7)) : (g = c + (h - 1) * 7, g += Ce(7 - a[g] + p, 7)), c <= g && g <= f && (o.nwdaymask[g] = 1);
    }
  return o;
}
function q4(n, e) {
  e === void 0 && (e = 0);
  var t = n % 19, i = Math.floor(n / 100), a = n % 100, r = Math.floor(i / 4), o = i % 4, l = Math.floor((i + 8) / 25), s = Math.floor((i - l + 1) / 3), u = Math.floor(19 * t + i - r - s + 15) % 30, c = Math.floor(a / 4), f = a % 4, d = Math.floor(32 + 2 * o + 2 * c - u - f) % 7, g = Math.floor((t + 11 * u + 22 * d) / 451), b = Math.floor((u + d - 7 * g + 114) / 31), p = (u + d - 7 * g + 114) % 31 + 1, h = Date.UTC(n, b - 1, p + e), E = Date.UTC(n, 0, 1);
  return [Math.ceil((h - E) / (1e3 * 60 * 60 * 24))];
}
var Y4 = (
  /** @class */
  function() {
    function n(e) {
      this.options = e;
    }
    return n.prototype.rebuild = function(e, t) {
      var i = this.options;
      if (e !== this.lastyear && (this.yearinfo = z4(e, i)), oe(i.bynweekday) && (t !== this.lastmonth || e !== this.lastyear)) {
        var a = this.yearinfo, r = a.yearlen, o = a.mrange, l = a.wdaymask;
        this.monthinfo = j4(e, t, r, o, l, i);
      }
      ae(i.byeaster) && (this.eastermask = q4(e, i.byeaster));
    }, Object.defineProperty(n.prototype, "lastyear", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastyear : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "lastmonth", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastmonth : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "yearlen", {
      get: function() {
        return this.yearinfo.yearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "yearordinal", {
      get: function() {
        return this.yearinfo.yearordinal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mrange", {
      get: function() {
        return this.yearinfo.mrange;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "wdaymask", {
      get: function() {
        return this.yearinfo.wdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mmask", {
      get: function() {
        return this.yearinfo.mmask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "wnomask", {
      get: function() {
        return this.yearinfo.wnomask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nwdaymask", {
      get: function() {
        return this.monthinfo ? this.monthinfo.nwdaymask : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nextyearlen", {
      get: function() {
        return this.yearinfo.nextyearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "mdaymask", {
      get: function() {
        return this.yearinfo.mdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "nmdaymask", {
      get: function() {
        return this.yearinfo.nmdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.ydayset = function() {
      return [Ue(this.yearlen), 0, this.yearlen];
    }, n.prototype.mdayset = function(e, t) {
      for (var i = this.mrange[t - 1], a = this.mrange[t], r = K(null, this.yearlen), o = i; o < a; o++)
        r[o] = o;
      return [r, i, a];
    }, n.prototype.wdayset = function(e, t, i) {
      for (var a = K(null, this.yearlen + 7), r = si(tt(e, t, i)) - this.yearordinal, o = r, l = 0; l < 7 && (a[r] = r, ++r, this.wdaymask[r] !== this.options.wkst); l++)
        ;
      return [a, o, r];
    }, n.prototype.ddayset = function(e, t, i) {
      var a = K(null, this.yearlen), r = si(tt(e, t, i)) - this.yearordinal;
      return a[r] = r, [a, r, r + 1];
    }, n.prototype.htimeset = function(e, t, i, a) {
      var r = this, o = [];
      return this.options.byminute.forEach(function(l) {
        o = o.concat(r.mtimeset(e, l, i, a));
      }), $t(o), o;
    }, n.prototype.mtimeset = function(e, t, i, a) {
      var r = this.options.bysecond.map(function(o) {
        return new un(e, t, o, a);
      });
      return $t(r), r;
    }, n.prototype.stimeset = function(e, t, i, a) {
      return [new un(e, t, i, a)];
    }, n.prototype.getdayset = function(e) {
      switch (e) {
        case Z.YEARLY:
          return this.ydayset.bind(this);
        case Z.MONTHLY:
          return this.mdayset.bind(this);
        case Z.WEEKLY:
          return this.wdayset.bind(this);
        case Z.DAILY:
          return this.ddayset.bind(this);
        default:
          return this.ddayset.bind(this);
      }
    }, n.prototype.gettimeset = function(e) {
      switch (e) {
        case Z.HOURLY:
          return this.htimeset.bind(this);
        case Z.MINUTELY:
          return this.mtimeset.bind(this);
        case Z.SECONDLY:
          return this.stimeset.bind(this);
      }
    }, n;
  }()
);
function V4(n, e, t, i, a, r) {
  for (var o = [], l = 0; l < n.length; l++) {
    var s = void 0, u = void 0, c = n[l];
    c < 0 ? (s = Math.floor(c / e.length), u = Ce(c, e.length)) : (s = Math.floor((c - 1) / e.length), u = Ce(c - 1, e.length));
    for (var f = [], d = t; d < i; d++) {
      var g = r[d];
      ae(g) && f.push(g);
    }
    var b = void 0;
    s < 0 ? b = f.slice(s)[0] : b = f[s];
    var p = e[u], h = To(a.yearordinal + b), E = ko(h, p);
    ee(o, E) || o.push(E);
  }
  return $t(o), o;
}
function So(n, e) {
  var t = e.dtstart, i = e.freq, a = e.interval, r = e.until, o = e.bysetpos, l = e.count;
  if (l === 0 || a === 0)
    return ze(n);
  var s = T4.fromDate(t), u = new Y4(e);
  u.rebuild(s.year, s.month);
  for (var c = K4(u, s, e); ; ) {
    var f = u.getdayset(i)(s.year, s.month, s.day), d = f[0], g = f[1], b = f[2], p = W4(d, g, b, u, e);
    if (oe(o))
      for (var h = V4(o, c, g, b, u, d), E = 0; E < h.length; E++) {
        var B = h[E];
        if (r && B > r)
          return ze(n);
        if (B >= t) {
          var _ = Ra(B, e);
          if (!n.accept(_) || l && (--l, !l))
            return ze(n);
        }
      }
    else
      for (var E = g; E < b; E++) {
        var D = d[E];
        if (ae(D))
          for (var I = To(u.yearordinal + D), F = 0; F < c.length; F++) {
            var j = c[F], B = ko(I, j);
            if (r && B > r)
              return ze(n);
            if (B >= t) {
              var _ = Ra(B, e);
              if (!n.accept(_) || l && (--l, !l))
                return ze(n);
            }
          }
      }
    if (e.interval === 0 || (s.add(e, p), s.year > bo))
      return ze(n);
    Hi(i) || (c = u.gettimeset(i)(s.hour, s.minute, s.second, 0)), u.rebuild(s.year, s.month);
  }
}
function G4(n, e, t) {
  var i = t.bymonth, a = t.byweekno, r = t.byweekday, o = t.byeaster, l = t.bymonthday, s = t.bynmonthday, u = t.byyearday;
  return oe(i) && !ee(i, n.mmask[e]) || oe(a) && !n.wnomask[e] || oe(r) && !ee(r, n.wdaymask[e]) || oe(n.nwdaymask) && !n.nwdaymask[e] || o !== null && !ee(n.eastermask, e) || (oe(l) || oe(s)) && !ee(l, n.mdaymask[e]) && !ee(s, n.nmdaymask[e]) || oe(u) && (e < n.yearlen && !ee(u, e + 1) && !ee(u, -n.yearlen + e) || e >= n.yearlen && !ee(u, e + 1 - n.yearlen) && !ee(u, -n.nextyearlen + e - n.yearlen));
}
function Ra(n, e) {
  return new dn(n, e.tzid).rezonedDate();
}
function ze(n) {
  return n.getValue();
}
function W4(n, e, t, i, a) {
  for (var r = !1, o = e; o < t; o++) {
    var l = n[o];
    r = G4(i, l, a), r && (n[l] = null);
  }
  return r;
}
function K4(n, e, t) {
  var i = t.freq, a = t.byhour, r = t.byminute, o = t.bysecond;
  return Hi(i) ? E4(t) : i >= L.HOURLY && oe(a) && !ee(a, e.hour) || i >= L.MINUTELY && oe(r) && !ee(r, e.minute) || i >= L.SECONDLY && oe(o) && !ee(o, e.second) ? [] : n.gettimeset(i)(e.hour, e.minute, e.second, e.millisecond);
}
var we = {
  MO: new ge(0),
  TU: new ge(1),
  WE: new ge(2),
  TH: new ge(3),
  FR: new ge(4),
  SA: new ge(5),
  SU: new ge(6)
}, ji = {
  freq: Z.YEARLY,
  dtstart: null,
  interval: 1,
  wkst: we.MO,
  count: null,
  until: null,
  tzid: null,
  bysetpos: null,
  bymonth: null,
  bymonthday: null,
  bynmonthday: null,
  byyearday: null,
  byweekno: null,
  byweekday: null,
  bynweekday: null,
  byhour: null,
  byminute: null,
  bysecond: null,
  byeaster: null
}, Z4 = Object.keys(ji), L = (
  /** @class */
  function() {
    function n(e, t) {
      e === void 0 && (e = {}), t === void 0 && (t = !1), this._cache = t ? null : new B4(), this.origOptions = xo(e);
      var i = k4(e).parsedOptions;
      this.options = i;
    }
    return n.parseText = function(e, t) {
      return Eo(e, t);
    }, n.fromText = function(e, t) {
      return b4(e, t);
    }, n.fromString = function(e) {
      return new n(n.parseString(e) || void 0);
    }, n.prototype._iter = function(e) {
      return So(e, this.options);
    }, n.prototype._cacheGet = function(e, t) {
      return this._cache ? this._cache._cacheGet(e, t) : !1;
    }, n.prototype._cacheAdd = function(e, t, i) {
      if (this._cache)
        return this._cache._cacheAdd(e, t, i);
    }, n.prototype.all = function(e) {
      if (e)
        return this._iter(new Aa("all", {}, e));
      var t = this._cacheGet("all");
      return t === !1 && (t = this._iter(new ct("all", {})), this._cacheAdd("all", t)), t;
    }, n.prototype.between = function(e, t, i, a) {
      if (i === void 0 && (i = !1), !Et(e) || !Et(t))
        throw new Error("Invalid date passed in to RRule.between");
      var r = {
        before: t,
        after: e,
        inc: i
      };
      if (a)
        return this._iter(new Aa("between", r, a));
      var o = this._cacheGet("between", r);
      return o === !1 && (o = this._iter(new ct("between", r)), this._cacheAdd("between", o, r)), o;
    }, n.prototype.before = function(e, t) {
      if (t === void 0 && (t = !1), !Et(e))
        throw new Error("Invalid date passed in to RRule.before");
      var i = { dt: e, inc: t }, a = this._cacheGet("before", i);
      return a === !1 && (a = this._iter(new ct("before", i)), this._cacheAdd("before", a, i)), a;
    }, n.prototype.after = function(e, t) {
      if (t === void 0 && (t = !1), !Et(e))
        throw new Error("Invalid date passed in to RRule.after");
      var i = { dt: e, inc: t }, a = this._cacheGet("after", i);
      return a === !1 && (a = this._iter(new ct("after", i)), this._cacheAdd("after", a, i)), a;
    }, n.prototype.count = function() {
      return this.all().length;
    }, n.prototype.toString = function() {
      return di(this.origOptions);
    }, n.prototype.toText = function(e, t, i) {
      return y4(this, e, t, i);
    }, n.prototype.isFullyConvertibleToText = function() {
      return v4(this);
    }, n.prototype.clone = function() {
      return new n(this.origOptions);
    }, n.FREQUENCIES = [
      "YEARLY",
      "MONTHLY",
      "WEEKLY",
      "DAILY",
      "HOURLY",
      "MINUTELY",
      "SECONDLY"
    ], n.YEARLY = Z.YEARLY, n.MONTHLY = Z.MONTHLY, n.WEEKLY = Z.WEEKLY, n.DAILY = Z.DAILY, n.HOURLY = Z.HOURLY, n.MINUTELY = Z.MINUTELY, n.SECONDLY = Z.SECONDLY, n.MO = we.MO, n.TU = we.TU, n.WE = we.WE, n.TH = we.TH, n.FR = we.FR, n.SA = we.SA, n.SU = we.SU, n.parseString = ci, n.optionsToString = di, n;
  }()
);
function J4(n, e, t, i, a, r) {
  var o = {}, l = n.accept;
  function s(d, g) {
    t.forEach(function(b) {
      b.between(d, g, !0).forEach(function(p) {
        o[Number(p)] = !0;
      });
    });
  }
  a.forEach(function(d) {
    var g = new dn(d, r).rezonedDate();
    o[Number(g)] = !0;
  }), n.accept = function(d) {
    var g = Number(d);
    return isNaN(g) ? l.call(this, d) : !o[g] && (s(new Date(g - 1), new Date(g + 1)), !o[g]) ? (o[g] = !0, l.call(this, d)) : !0;
  }, n.method === "between" && (s(n.args.after, n.args.before), n.accept = function(d) {
    var g = Number(d);
    return o[g] ? !0 : (o[g] = !0, l.call(this, d));
  });
  for (var u = 0; u < i.length; u++) {
    var c = new dn(i[u], r).rezonedDate();
    if (!n.accept(new Date(c.getTime())))
      break;
  }
  e.forEach(function(d) {
    So(n, d.options);
  });
  var f = n._result;
  switch ($t(f), n.method) {
    case "all":
    case "between":
      return f;
    case "before":
      return f.length && f[f.length - 1] || null;
    case "after":
    default:
      return f.length && f[0] || null;
  }
}
var Na = {
  dtstart: null,
  cache: !1,
  unfold: !1,
  forceset: !1,
  compatible: !1,
  tzid: null
};
function Q4(n, e) {
  var t = [], i = [], a = [], r = [], o = cn(n), l = o.dtstart, s = o.tzid, u = i8(n, e.unfold);
  return u.forEach(function(c) {
    var f;
    if (c) {
      var d = n8(c), g = d.name, b = d.parms, p = d.value;
      switch (g.toUpperCase()) {
        case "RRULE":
          if (b.length)
            throw new Error("unsupported RRULE parm: ".concat(b.join(",")));
          t.push(ci(c));
          break;
        case "RDATE":
          var h = (f = /RDATE(?:;TZID=([^:=]+))?/i.exec(c)) !== null && f !== void 0 ? f : [], E = h[1];
          E && !s && (s = E), i = i.concat(Ua(p, b));
          break;
        case "EXRULE":
          if (b.length)
            throw new Error("unsupported EXRULE parm: ".concat(b.join(",")));
          a.push(ci(p));
          break;
        case "EXDATE":
          r = r.concat(Ua(p, b));
          break;
        case "DTSTART":
          break;
        default:
          throw new Error("unsupported property: " + g);
      }
    }
  }), {
    dtstart: l,
    tzid: s,
    rrulevals: t,
    rdatevals: i,
    exrulevals: a,
    exdatevals: r
  };
}
function X4(n, e) {
  var t = Q4(n, e), i = t.rrulevals, a = t.rdatevals, r = t.exrulevals, o = t.exdatevals, l = t.dtstart, s = t.tzid, u = e.cache === !1;
  if (e.compatible && (e.forceset = !0, e.unfold = !0), e.forceset || i.length > 1 || a.length || r.length || o.length) {
    var c = new r8(u);
    return c.dtstart(l), c.tzid(s || void 0), i.forEach(function(d) {
      c.rrule(new L(qn(d, l, s), u));
    }), a.forEach(function(d) {
      c.rdate(d);
    }), r.forEach(function(d) {
      c.exrule(new L(qn(d, l, s), u));
    }), o.forEach(function(d) {
      c.exdate(d);
    }), e.compatible && e.dtstart && c.rdate(l), c;
  }
  var f = i[0] || {};
  return new L(qn(f, f.dtstart || e.dtstart || l, f.tzid || e.tzid || s), u);
}
function Fa(n, e) {
  return e === void 0 && (e = {}), X4(n, e8(e));
}
function qn(n, e, t) {
  return Ee(Ee({}, n), { dtstart: e, tzid: t });
}
function e8(n) {
  var e = [], t = Object.keys(n), i = Object.keys(Na);
  if (t.forEach(function(a) {
    ee(i, a) || e.push(a);
  }), e.length)
    throw new Error("Invalid options: " + e.join(", "));
  return Ee(Ee({}, Na), n);
}
function t8(n) {
  if (n.indexOf(":") === -1)
    return {
      name: "RRULE",
      value: n
    };
  var e = l4(n, ":", 1), t = e[0], i = e[1];
  return {
    name: t,
    value: i
  };
}
function n8(n) {
  var e = t8(n), t = e.name, i = e.value, a = t.split(";");
  if (!a)
    throw new Error("empty property name");
  return {
    name: a[0].toUpperCase(),
    parms: a.slice(1),
    value: i
  };
}
function i8(n, e) {
  if (e === void 0 && (e = !1), n = n && n.trim(), !n)
    throw new Error("Invalid empty string");
  if (!e)
    return n.split(/\s/);
  for (var t = n.split(`
`), i = 0; i < t.length; ) {
    var a = t[i] = t[i].replace(/\s+$/g, "");
    a ? i > 0 && a[0] === " " ? (t[i - 1] += a.slice(1), t.splice(i, 1)) : i += 1 : t.splice(i, 1);
  }
  return t;
}
function a8(n) {
  n.forEach(function(e) {
    if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(e))
      throw new Error("unsupported RDATE/EXDATE parm: " + e);
  });
}
function Ua(n, e) {
  return a8(e), n.split(",").map(function(t) {
    return Ui(t);
  });
}
function za(n) {
  var e = this;
  return function(t) {
    if (t !== void 0 && (e["_".concat(n)] = t), e["_".concat(n)] !== void 0)
      return e["_".concat(n)];
    for (var i = 0; i < e._rrule.length; i++) {
      var a = e._rrule[i].origOptions[n];
      if (a)
        return a;
    }
  };
}
var r8 = (
  /** @class */
  function(n) {
    zi(e, n);
    function e(t) {
      t === void 0 && (t = !1);
      var i = n.call(this, {}, t) || this;
      return i.dtstart = za.apply(i, ["dtstart"]), i.tzid = za.apply(i, ["tzid"]), i._rrule = [], i._rdate = [], i._exrule = [], i._exdate = [], i;
    }
    return e.prototype._iter = function(t) {
      return J4(t, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    }, e.prototype.rrule = function(t) {
      Ha(t, this._rrule);
    }, e.prototype.exrule = function(t) {
      Ha(t, this._exrule);
    }, e.prototype.rdate = function(t) {
      ja(t, this._rdate);
    }, e.prototype.exdate = function(t) {
      ja(t, this._exdate);
    }, e.prototype.rrules = function() {
      return this._rrule.map(function(t) {
        return Fa(t.toString());
      });
    }, e.prototype.exrules = function() {
      return this._exrule.map(function(t) {
        return Fa(t.toString());
      });
    }, e.prototype.rdates = function() {
      return this._rdate.map(function(t) {
        return new Date(t.getTime());
      });
    }, e.prototype.exdates = function() {
      return this._exdate.map(function(t) {
        return new Date(t.getTime());
      });
    }, e.prototype.valueOf = function() {
      var t = [];
      return !this._rrule.length && this._dtstart && (t = t.concat(di({ dtstart: this._dtstart }))), this._rrule.forEach(function(i) {
        t = t.concat(i.toString().split(`
`));
      }), this._exrule.forEach(function(i) {
        t = t.concat(i.toString().split(`
`).map(function(a) {
          return a.replace(/^RRULE:/, "EXRULE:");
        }).filter(function(a) {
          return !/^DTSTART/.test(a);
        }));
      }), this._rdate.length && t.push(qa("RDATE", this._rdate, this.tzid())), this._exdate.length && t.push(qa("EXDATE", this._exdate, this.tzid())), t;
    }, e.prototype.toString = function() {
      return this.valueOf().join(`
`);
    }, e.prototype.clone = function() {
      var t = new e(!!this._cache);
      return this._rrule.forEach(function(i) {
        return t.rrule(i.clone());
      }), this._exrule.forEach(function(i) {
        return t.exrule(i.clone());
      }), this._rdate.forEach(function(i) {
        return t.rdate(new Date(i.getTime()));
      }), this._exdate.forEach(function(i) {
        return t.exdate(new Date(i.getTime()));
      }), t;
    }, e;
  }(L)
);
function Ha(n, e) {
  if (!(n instanceof L))
    throw new TypeError(String(n) + " is not RRule instance");
  ee(e.map(String), String(n)) || e.push(n);
}
function ja(n, e) {
  if (!(n instanceof Date))
    throw new TypeError(String(n) + " is not Date instance");
  ee(e.map(Number), Number(n)) || (e.push(n), $t(e));
}
function qa(n, e, t) {
  var i = !t || t.toUpperCase() === "UTC", a = i ? "".concat(n, ":") : "".concat(n, ";TZID=").concat(t, ":"), r = e.map(function(o) {
    return Fi(o.valueOf(), i);
  }).join(",");
  return "".concat(a).concat(r);
}
const o8 = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class fn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || o8, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, i, a) {
    return a && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${i}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new fn(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new fn(this.logger, e);
  }
}
var Ie = new fn();
class Dn {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((i) => {
      this.observers[i] || (this.observers[i] = /* @__PURE__ */ new Map());
      const a = this.observers[i].get(t) || 0;
      this.observers[i].set(t, a + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      i[a - 1] = arguments[a];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [l, s] = o;
      for (let u = 0; u < s; u++)
        l(...i);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [l, s] = o;
      for (let u = 0; u < s; u++)
        l.apply(l, [e, ...i]);
    });
  }
}
function bt() {
  let n, e;
  const t = new Promise((i, a) => {
    n = i, e = a;
  });
  return t.resolve = n, t.reject = e, t;
}
function Ya(n) {
  return n == null ? "" : "" + n;
}
function s8(n, e, t) {
  n.forEach((i) => {
    e[i] && (t[i] = e[i]);
  });
}
const l8 = /###/g;
function Ct(n, e, t) {
  function i(l) {
    return l && l.indexOf("###") > -1 ? l.replace(l8, ".") : l;
  }
  function a() {
    return !n || typeof n == "string";
  }
  const r = typeof e != "string" ? e : e.split(".");
  let o = 0;
  for (; o < r.length - 1; ) {
    if (a())
      return {};
    const l = i(r[o]);
    !n[l] && t && (n[l] = new t()), Object.prototype.hasOwnProperty.call(n, l) ? n = n[l] : n = {}, ++o;
  }
  return a() ? {} : {
    obj: n,
    k: i(r[o])
  };
}
function Va(n, e, t) {
  const {
    obj: i,
    k: a
  } = Ct(n, e, Object);
  if (i !== void 0 || e.length === 1) {
    i[a] = t;
    return;
  }
  let r = e[e.length - 1], o = e.slice(0, e.length - 1), l = Ct(n, o, Object);
  for (; l.obj === void 0 && o.length; )
    r = `${o[o.length - 1]}.${r}`, o = o.slice(0, o.length - 1), l = Ct(n, o, Object), l && l.obj && typeof l.obj[`${l.k}.${r}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${r}`] = t;
}
function u8(n, e, t, i) {
  const {
    obj: a,
    k: r
  } = Ct(n, e, Object);
  a[r] = a[r] || [], i && (a[r] = a[r].concat(t)), i || a[r].push(t);
}
function gn(n, e) {
  const {
    obj: t,
    k: i
  } = Ct(n, e);
  if (t)
    return t[i];
}
function c8(n, e, t) {
  const i = gn(n, t);
  return i !== void 0 ? i : gn(e, t);
}
function Co(n, e, t) {
  for (const i in e)
    i !== "__proto__" && i !== "constructor" && (i in n ? typeof n[i] == "string" || n[i] instanceof String || typeof e[i] == "string" || e[i] instanceof String ? t && (n[i] = e[i]) : Co(n[i], e[i], t) : n[i] = e[i]);
  return n;
}
function rt(n) {
  return n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var d8 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function f8(n) {
  return typeof n == "string" ? n.replace(/[&<>"'\/]/g, (e) => d8[e]) : n;
}
class g8 {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const i = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, i), this.regExpQueue.push(e), i;
  }
}
const h8 = [" ", ",", "?", "!", ";"], m8 = new g8(20);
function p8(n, e, t) {
  e = e || "", t = t || "";
  const i = h8.filter((o) => e.indexOf(o) < 0 && t.indexOf(o) < 0);
  if (i.length === 0)
    return !0;
  const a = m8.getRegExp(`(${i.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let r = !a.test(n);
  if (!r) {
    const o = n.indexOf(t);
    o > 0 && !a.test(n.substring(0, o)) && (r = !0);
  }
  return r;
}
function fi(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n)
    return;
  if (n[e])
    return n[e];
  const i = e.split(t);
  let a = n;
  for (let r = 0; r < i.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, l = "";
    for (let s = r; s < i.length; ++s)
      if (s !== r && (l += t), l += i[s], o = a[l], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && s < i.length - 1)
          continue;
        r += s - r + 1;
        break;
      }
    a = o;
  }
  return a;
}
function hn(n) {
  return n && n.indexOf("_") > 0 ? n.replace("_", "-") : n;
}
class Ga extends Dn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const r = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    e.indexOf(".") > -1 ? l = e.split(".") : (l = [e, t], i && (Array.isArray(i) ? l.push(...i) : typeof i == "string" && r ? l.push(...i.split(r)) : l.push(i)));
    const s = gn(this.data, l);
    return !s && !t && !i && e.indexOf(".") > -1 && (e = l[0], t = l[1], i = l.slice(2).join(".")), s || !o || typeof i != "string" ? s : fi(this.data && this.data[e] && this.data[e][t], i, r);
  }
  addResource(e, t, i, a) {
    let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let l = [e, t];
    i && (l = l.concat(o ? i.split(o) : i)), e.indexOf(".") > -1 && (l = e.split("."), a = t, t = l[1]), this.addNamespaces(t), Va(this.data, l, a), r.silent || this.emit("added", e, t, i, a);
  }
  addResources(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const r in i)
      (typeof i[r] == "string" || Array.isArray(i[r])) && this.addResource(e, t, r, i[r], {
        silent: !0
      });
    a.silent || this.emit("added", e, t, i);
  }
  addResourceBundle(e, t, i, a, r) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, l = [e, t];
    e.indexOf(".") > -1 && (l = e.split("."), a = i, i = t, t = l[1]), this.addNamespaces(t);
    let s = gn(this.data, l) || {};
    o.skipCopy || (i = JSON.parse(JSON.stringify(i))), a ? Co(s, i, r) : s = {
      ...s,
      ...i
    }, Va(this.data, l, s), o.silent || this.emit("added", e, t, i);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((a) => t[a] && Object.keys(t[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var wo = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, i, a) {
    return n.forEach((r) => {
      this.processors[r] && (e = this.processors[r].process(e, t, i, a));
    }), e;
  }
};
const Wa = {};
class mn extends Dn {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), s8(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ie.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const i = this.resolve(e, t);
    return i && i.res !== void 0;
  }
  extractFromKey(e, t) {
    let i = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    i === void 0 && (i = ":");
    const a = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let r = t.ns || this.options.defaultNS || [];
    const o = i && e.indexOf(i) > -1, l = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !p8(e, i, a);
    if (o && !l) {
      const s = e.match(this.interpolator.nestingRegexp);
      if (s && s.length > 0)
        return {
          key: e,
          namespaces: r
        };
      const u = e.split(i);
      (i !== a || i === a && this.options.ns.indexOf(u[0]) > -1) && (r = u.shift()), e = u.join(a);
    }
    return typeof r == "string" && (r = [r]), {
      key: e,
      namespaces: r
    };
  }
  translate(e, t, i) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const a = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: l
    } = this.extractFromKey(e[e.length - 1], t), s = l[l.length - 1], u = t.lng || this.language, c = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (c) {
        const D = t.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${s}${D}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: u,
          usedNS: s,
          usedParams: this.getUsedParamsDetails(t)
        } : `${s}${D}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: u,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(t)
      } : o;
    }
    const f = this.resolve(e, t);
    let d = f && f.res;
    const g = f && f.usedKey || o, b = f && f.exactUsedKey || o, p = Object.prototype.toString.apply(d), h = ["[object Number]", "[object Function]", "[object RegExp]"], E = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, B = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (B && d && (typeof d != "string" && typeof d != "boolean" && typeof d != "number") && h.indexOf(p) < 0 && !(typeof E == "string" && Array.isArray(d))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const D = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(g, d, {
          ...t,
          ns: l
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (f.res = D, f.usedParams = this.getUsedParamsDetails(t), f) : D;
      }
      if (r) {
        const D = Array.isArray(d), I = D ? [] : {}, F = D ? b : g;
        for (const j in d)
          if (Object.prototype.hasOwnProperty.call(d, j)) {
            const W = `${F}${r}${j}`;
            I[j] = this.translate(W, {
              ...t,
              joinArrays: !1,
              ns: l
            }), I[j] === W && (I[j] = d[j]);
          }
        d = I;
      }
    } else if (B && typeof E == "string" && Array.isArray(d))
      d = d.join(E), d && (d = this.extendTranslation(d, e, t, i));
    else {
      let D = !1, I = !1;
      const F = t.count !== void 0 && typeof t.count != "string", j = mn.hasDefaultValue(t), W = F ? this.pluralResolver.getSuffix(u, t.count, t) : "", q = t.ordinal && F ? this.pluralResolver.getSuffix(u, t.count, {
        ordinal: !1
      }) : "", U = F && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), v = U && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${W}`] || t[`defaultValue${q}`] || t.defaultValue;
      !this.isValidLookup(d) && j && (D = !0, d = v), this.isValidLookup(d) || (I = !0, d = o);
      const S = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && I ? void 0 : d, x = j && v !== d && this.options.updateMissing;
      if (I || D || x) {
        if (this.logger.log(x ? "updateKey" : "missingKey", u, s, o, x ? v : d), r) {
          const w = this.resolve(o, {
            ...t,
            keySeparator: !1
          });
          w && w.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let m = [];
        const T = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && T && T[0])
          for (let w = 0; w < T.length; w++)
            m.push(T[w]);
        else
          this.options.saveMissingTo === "all" ? m = this.languageUtils.toResolveHierarchy(t.lng || this.language) : m.push(t.lng || this.language);
        const y = (w, A, R) => {
          const H = j && R !== d ? R : S;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(w, s, A, H, x, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(w, s, A, H, x, t), this.emit("missingKey", w, s, A, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && F ? m.forEach((w) => {
          const A = this.pluralResolver.getSuffixes(w, t);
          U && t[`defaultValue${this.options.pluralSeparator}zero`] && A.indexOf(`${this.options.pluralSeparator}zero`) < 0 && A.push(`${this.options.pluralSeparator}zero`), A.forEach((R) => {
            y([w], o + R, t[`defaultValue${R}`] || v);
          });
        }) : y(m, o, v));
      }
      d = this.extendTranslation(d, e, t, f, i), I && d === o && this.options.appendNamespaceToMissingKey && (d = `${s}:${o}`), (I || D) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${s}:${o}` : o, D ? d : void 0) : d = this.options.parseMissingKeyHandler(d));
    }
    return a ? (f.res = d, f.usedParams = this.getUsedParamsDetails(t), f) : d;
  }
  extendTranslation(e, t, i, a, r) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...i
      }, i.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!i.skipInterpolation) {
      i.interpolation && this.interpolator.init({
        ...i,
        interpolation: {
          ...this.options.interpolation,
          ...i.interpolation
        }
      });
      const u = typeof e == "string" && (i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (u) {
        const d = e.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let f = i.replace && typeof i.replace != "string" ? i.replace : i;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), e = this.interpolator.interpolate(e, f, i.lng || this.language, i), u) {
        const d = e.match(this.interpolator.nestingRegexp), g = d && d.length;
        c < g && (i.nest = !1);
      }
      !i.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (i.lng = a.usedLng), i.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var d = arguments.length, g = new Array(d), b = 0; b < d; b++)
          g[b] = arguments[b];
        return r && r[0] === g[0] && !i.context ? (o.logger.warn(`It seems you are nesting recursively key: ${g[0]} in key: ${t[0]}`), null) : o.translate(...g, t);
      }, i)), i.interpolation && this.interpolator.reset();
    }
    const l = i.postProcess || this.options.postProcess, s = typeof l == "string" ? [l] : l;
    return e != null && s && s.length && i.applyPostProcessor !== !1 && (e = wo.handle(s, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(i)
      },
      ...i
    } : i, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i, a, r, o, l;
    return typeof e == "string" && (e = [e]), e.forEach((s) => {
      if (this.isValidLookup(i))
        return;
      const u = this.extractFromKey(s, t), c = u.key;
      a = c;
      let f = u.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const d = t.count !== void 0 && typeof t.count != "string", g = d && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), b = t.context !== void 0 && (typeof t.context == "string" || typeof t.context == "number") && t.context !== "", p = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      f.forEach((h) => {
        this.isValidLookup(i) || (l = h, !Wa[`${p[0]}-${h}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(l) && (Wa[`${p[0]}-${h}`] = !0, this.logger.warn(`key "${a}" for languages "${p.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((E) => {
          if (this.isValidLookup(i))
            return;
          o = E;
          const B = [c];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(B, c, E, h, t);
          else {
            let D;
            d && (D = this.pluralResolver.getSuffix(E, t.count, t));
            const I = `${this.options.pluralSeparator}zero`, F = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (B.push(c + D), t.ordinal && D.indexOf(F) === 0 && B.push(c + D.replace(F, this.options.pluralSeparator)), g && B.push(c + I)), b) {
              const j = `${c}${this.options.contextSeparator}${t.context}`;
              B.push(j), d && (B.push(j + D), t.ordinal && D.indexOf(F) === 0 && B.push(j + D.replace(F, this.options.pluralSeparator)), g && B.push(j + I));
            }
          }
          let _;
          for (; _ = B.pop(); )
            this.isValidLookup(i) || (r = _, i = this.getResource(E, h, _, t));
        }));
      });
    }), {
      res: i,
      usedKey: a,
      exactUsedKey: r,
      usedLng: o,
      usedNS: l
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, i, a) : this.resourceStore.getResource(e, t, i, a);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], i = e.replace && typeof e.replace != "string";
    let a = i ? e.replace : e;
    if (i && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !i) {
      a = {
        ...a
      };
      for (const r of t)
        delete a[r];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const i in e)
      if (Object.prototype.hasOwnProperty.call(e, i) && t === i.substring(0, t.length) && e[i] !== void 0)
        return !0;
    return !1;
  }
}
function Yn(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
class Ka {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ie.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = hn(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = hn(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let i = e.split("-");
      return this.options.lowerCaseLng ? i = i.map((a) => a.toLowerCase()) : i.length === 2 ? (i[0] = i[0].toLowerCase(), i[1] = i[1].toUpperCase(), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = Yn(i[1].toLowerCase()))) : i.length === 3 && (i[0] = i[0].toLowerCase(), i[1].length === 2 && (i[1] = i[1].toUpperCase()), i[0] !== "sgn" && i[2].length === 2 && (i[2] = i[2].toUpperCase()), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = Yn(i[1].toLowerCase())), t.indexOf(i[2].toLowerCase()) > -1 && (i[2] = Yn(i[2].toLowerCase()))), i.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((i) => {
      if (t)
        return;
      const a = this.formatLanguageCode(i);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (t = a);
    }), !t && this.options.supportedLngs && e.forEach((i) => {
      if (t)
        return;
      const a = this.getLanguagePartFromCode(i);
      if (this.isSupportedCode(a))
        return t = a;
      t = this.options.supportedLngs.find((r) => {
        if (r === a)
          return r;
        if (!(r.indexOf("-") < 0 && a.indexOf("-") < 0) && (r.indexOf("-") > 0 && a.indexOf("-") < 0 && r.substring(0, r.indexOf("-")) === a || r.indexOf(a) === 0 && a.length > 1))
          return r;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), typeof e == "string" && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let i = e[t];
    return i || (i = e[this.getScriptPartFromCode(t)]), i || (i = e[this.formatLanguageCode(t)]), i || (i = e[this.getLanguagePartFromCode(t)]), i || (i = e.default), i || [];
  }
  toResolveHierarchy(e, t) {
    const i = this.getFallbackCodes(t || this.options.fallbackLng || [], e), a = [], r = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(e))) : typeof e == "string" && r(this.formatLanguageCode(e)), i.forEach((o) => {
      a.indexOf(o) < 0 && r(this.formatLanguageCode(o));
    }), a;
  }
}
let b8 = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], y8 = {
  1: function(n) {
    return +(n > 1);
  },
  2: function(n) {
    return +(n != 1);
  },
  3: function(n) {
    return 0;
  },
  4: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  5: function(n) {
    return n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
  },
  6: function(n) {
    return n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
  },
  7: function(n) {
    return n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  8: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3;
  },
  9: function(n) {
    return +(n >= 2);
  },
  10: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
  },
  11: function(n) {
    return n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3;
  },
  12: function(n) {
    return +(n % 10 != 1 || n % 100 == 11);
  },
  13: function(n) {
    return +(n !== 0);
  },
  14: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3;
  },
  15: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  16: function(n) {
    return n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2;
  },
  17: function(n) {
    return n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1;
  },
  18: function(n) {
    return n == 0 ? 0 : n == 1 ? 1 : 2;
  },
  19: function(n) {
    return n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;
  },
  20: function(n) {
    return n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;
  },
  21: function(n) {
    return n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0;
  },
  22: function(n) {
    return n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3;
  }
};
const v8 = ["v1", "v2", "v3"], T8 = ["v4"], Za = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function k8() {
  const n = {};
  return b8.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: y8[e.fc]
      };
    });
  }), n;
}
class E8 {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Ie.create("pluralResolver"), (!this.options.compatibilityJSON || T8.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = k8();
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(hn(e === "dev" ? "en" : e), {
          type: t.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return this.shouldUseIntlApi() ? i && i.resolvedOptions().pluralCategories.length > 1 : i && i.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, i).map((a) => `${t}${a}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return i ? this.shouldUseIntlApi() ? i.resolvedOptions().pluralCategories.sort((a, r) => Za[a] - Za[r]).map((a) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : i.numbers.map((a) => this.getSuffix(e, a, t)) : [];
  }
  getSuffix(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(e, i);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(t)}` : this.getSuffixRetroCompatible(a, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const i = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let a = e.numbers[i];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const r = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : r() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? r() : this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
  }
  shouldUseIntlApi() {
    return !v8.includes(this.options.compatibilityJSON);
  }
}
function Ja(n, e, t) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, r = c8(n, e, t);
  return !r && a && typeof t == "string" && (r = fi(n, t, i), r === void 0 && (r = fi(e, t, i))), r;
}
class x8 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ie.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: i,
      useRawValueToEscape: a,
      prefix: r,
      prefixEscaped: o,
      suffix: l,
      suffixEscaped: s,
      formatSeparator: u,
      unescapeSuffix: c,
      unescapePrefix: f,
      nestingPrefix: d,
      nestingPrefixEscaped: g,
      nestingSuffix: b,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: h,
      maxReplaces: E,
      alwaysFormat: B
    } = e.interpolation;
    this.escape = t !== void 0 ? t : f8, this.escapeValue = i !== void 0 ? i : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = r ? rt(r) : o || "{{", this.suffix = l ? rt(l) : s || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = d ? rt(d) : g || rt("$t("), this.nestingSuffix = b ? rt(b) : p || rt(")"), this.nestingOptionsSeparator = h || ",", this.maxReplaces = E || 1e3, this.alwaysFormat = B !== void 0 ? B : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, i) => t && t.source === i ? (t.lastIndex = 0, t) : new RegExp(i, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, i, a) {
    let r, o, l;
    const s = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function u(b) {
      return b.replace(/\$/g, "$$$$");
    }
    const c = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const B = Ja(t, s, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(B, void 0, i, {
          ...a,
          ...t,
          interpolationkey: b
        }) : B;
      }
      const p = b.split(this.formatSeparator), h = p.shift().trim(), E = p.join(this.formatSeparator).trim();
      return this.format(Ja(t, s, h, this.options.keySeparator, this.options.ignoreJSONStructure), E, i, {
        ...a,
        ...t,
        interpolationkey: h
      });
    };
    this.resetRegExp();
    const f = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => u(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? u(this.escape(b)) : u(b)
    }].forEach((b) => {
      for (l = 0; r = b.regex.exec(e); ) {
        const p = r[1].trim();
        if (o = c(p), o === void 0)
          if (typeof f == "function") {
            const E = f(e, r, a);
            o = typeof E == "string" ? E : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, p))
            o = "";
          else if (d) {
            o = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), o = "";
        else
          typeof o != "string" && !this.useRawValueToEscape && (o = Ya(o));
        const h = b.safeValue(o);
        if (e = e.replace(r[0], h), d ? (b.regex.lastIndex += o.length, b.regex.lastIndex -= r[0].length) : b.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, r, o;
    function l(s, u) {
      const c = this.nestingOptionsSeparator;
      if (s.indexOf(c) < 0)
        return s;
      const f = s.split(new RegExp(`${c}[ ]*{`));
      let d = `{${f[1]}`;
      s = f[0], d = this.interpolate(d, o);
      const g = d.match(/'/g), b = d.match(/"/g);
      (g && g.length % 2 === 0 && !b || b.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        o = JSON.parse(d), u && (o = {
          ...u,
          ...o
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${s}`, p), `${s}${c}${d}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, s;
    }
    for (; a = this.nestingRegexp.exec(e); ) {
      let s = [];
      o = {
        ...i
      }, o = o.replace && typeof o.replace != "string" ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let u = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const c = a[1].split(this.formatSeparator).map((f) => f.trim());
        a[1] = c.shift(), s = c, u = !0;
      }
      if (r = t(l.call(this, a[1].trim(), o), o), r && a[0] === e && typeof r != "string")
        return r;
      typeof r != "string" && (r = Ya(r)), r || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), r = ""), u && (r = s.reduce((c, f) => this.format(c, f, i.lng, {
        ...i,
        interpolationkey: a[1].trim()
      }), r.trim())), e = e.replace(a[0], r), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
function S8(n) {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const i = n.split("(");
    e = i[0].toLowerCase().trim();
    const a = i[1].substring(0, i[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? t.currency || (t.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? t.range || (t.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [l, ...s] = o.split(":"), u = s.join(":").trim().replace(/^'+|'+$/g, ""), c = l.trim();
        t[c] || (t[c] = u), u === "false" && (t[c] = !1), u === "true" && (t[c] = !0), isNaN(u) || (t[c] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}
function ot(n) {
  const e = {};
  return function(i, a, r) {
    const o = a + JSON.stringify(r);
    let l = e[o];
    return l || (l = n(hn(a), r), e[o] = l), l(i);
  };
}
class C8 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ie.create("formatter"), this.options = e, this.formats = {
      number: ot((t, i) => {
        const a = new Intl.NumberFormat(t, {
          ...i
        });
        return (r) => a.format(r);
      }),
      currency: ot((t, i) => {
        const a = new Intl.NumberFormat(t, {
          ...i,
          style: "currency"
        });
        return (r) => a.format(r);
      }),
      datetime: ot((t, i) => {
        const a = new Intl.DateTimeFormat(t, {
          ...i
        });
        return (r) => a.format(r);
      }),
      relativetime: ot((t, i) => {
        const a = new Intl.RelativeTimeFormat(t, {
          ...i
        });
        return (r) => a.format(r, i.range || "day");
      }),
      list: ot((t, i) => {
        const a = new Intl.ListFormat(t, {
          ...i
        });
        return (r) => a.format(r);
      })
    }, this.init(e);
  }
  init(e) {
    const i = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = i.formatSeparator ? i.formatSeparator : i.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = ot(t);
  }
  format(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return t.split(this.formatSeparator).reduce((l, s) => {
      const {
        formatName: u,
        formatOptions: c
      } = S8(s);
      if (this.formats[u]) {
        let f = l;
        try {
          const d = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, g = d.locale || d.lng || a.locale || a.lng || i;
          f = this.formats[u](l, g, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return l;
    }, e);
  }
}
function w8(n, e) {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
}
class $8 extends Dn {
  constructor(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = i, this.languageUtils = i.languageUtils, this.options = a, this.logger = Ie.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(i, a.backend, a);
  }
  queueLoad(e, t, i, a) {
    const r = {}, o = {}, l = {}, s = {};
    return e.forEach((u) => {
      let c = !0;
      t.forEach((f) => {
        const d = `${u}|${f}`;
        !i.reload && this.store.hasResourceBundle(u, f) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? o[d] === void 0 && (o[d] = !0) : (this.state[d] = 1, c = !1, o[d] === void 0 && (o[d] = !0), r[d] === void 0 && (r[d] = !0), s[f] === void 0 && (s[f] = !0)));
      }), c || (l[u] = !0);
    }), (Object.keys(r).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(s)
    };
  }
  loaded(e, t, i) {
    const a = e.split("|"), r = a[0], o = a[1];
    t && this.emit("failedLoading", r, o, t), i && this.store.addResourceBundle(r, o, i, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2;
    const l = {};
    this.queue.forEach((s) => {
      u8(s.loaded, [r], o), w8(s, e), t && s.errors.push(t), s.pendingCount === 0 && !s.done && (Object.keys(s.loaded).forEach((u) => {
        l[u] || (l[u] = {});
        const c = s.loaded[u];
        c.length && c.forEach((f) => {
          l[u][f] === void 0 && (l[u][f] = !0);
        });
      }), s.done = !0, s.errors.length ? s.callback(s.errors) : s.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((s) => !s.done);
  }
  read(e, t, i) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: i,
        tried: a,
        wait: r,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const l = (u, c) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (u && c && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, i, a + 1, r * 2, o);
        }, r);
        return;
      }
      o(u, c);
    }, s = this.backend[i].bind(this.backend);
    if (s.length === 2) {
      try {
        const u = s(e, t);
        u && typeof u.then == "function" ? u.then((c) => l(null, c)).catch(l) : l(null, u);
      } catch (u) {
        l(u);
      }
      return;
    }
    return s(e, t, l);
  }
  prepareLoading(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof t == "string" && (t = [t]);
    const r = this.queueLoad(e, t, i, a);
    if (!r.toLoad.length)
      return r.pending.length || a(), null;
    r.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, t, i) {
    this.prepareLoading(e, t, {}, i);
  }
  reload(e, t, i) {
    this.prepareLoading(e, t, {
      reload: !0
    }, i);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const i = e.split("|"), a = i[0], r = i[1];
    this.read(a, r, "read", void 0, void 0, (o, l) => {
      o && this.logger.warn(`${t}loading namespace ${r} for language ${a} failed`, o), !o && l && this.logger.log(`${t}loaded namespace ${r} for language ${a}`, l), this.loaded(e, o, l);
    });
  }
  saveMissing(e, t, i, a, r) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${i}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(i == null || i === "")) {
      if (this.backend && this.backend.create) {
        const s = {
          ...o,
          isUpdate: r
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let c;
            u.length === 5 ? c = u(e, t, i, a, s) : c = u(e, t, i, a), c && typeof c.then == "function" ? c.then((f) => l(null, f)).catch(l) : l(null, c);
          } catch (c) {
            l(c);
          }
        else
          u(e, t, i, a, l, s);
      }
      !e || !e[0] || this.store.addResource(e[0], t, i, a);
    }
  }
}
function Qa() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(e) {
      let t = {};
      if (typeof e[1] == "object" && (t = e[1]), typeof e[1] == "string" && (t.defaultValue = e[1]), typeof e[2] == "string" && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
        const i = e[3] || e[2];
        Object.keys(i).forEach((a) => {
          t[a] = i[a];
        });
      }
      return t;
    },
    interpolation: {
      escapeValue: !0,
      format: (n) => n,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function Xa(n) {
  return typeof n.ns == "string" && (n.ns = [n.ns]), typeof n.fallbackLng == "string" && (n.fallbackLng = [n.fallbackLng]), typeof n.fallbackNS == "string" && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n;
}
function Ht() {
}
function B8(n) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
}
class Bt extends Dn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Xa(e), this.services = {}, this.logger = Ie, this.modules = {
      external: []
    }, B8(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (i = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (typeof t.ns == "string" ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const a = Qa();
    this.options = {
      ...a,
      ...this.options,
      ...Xa(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    function r(c) {
      return c ? typeof c == "function" ? new c() : c : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Ie.init(r(this.modules.logger), this.options) : Ie.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = C8);
      const f = new Ka(this.options);
      this.store = new Ga(this.options.resources, this.options);
      const d = this.services;
      d.logger = Ie, d.resourceStore = this.store, d.languageUtils = f, d.pluralResolver = new E8(f, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (d.formatter = r(c), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new x8(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new $8(r(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(g) {
        for (var b = arguments.length, p = new Array(b > 1 ? b - 1 : 0), h = 1; h < b; h++)
          p[h - 1] = arguments[h];
        e.emit(g, ...p);
      }), this.modules.languageDetector && (d.languageDetector = r(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = r(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new mn(this.services, this.options), this.translator.on("*", function(g) {
        for (var b = arguments.length, p = new Array(b > 1 ? b - 1 : 0), h = 1; h < b; h++)
          p[h - 1] = arguments[h];
        e.emit(g, ...p);
      }), this.modules.external.forEach((g) => {
        g.init && g.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, i || (i = Ht), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments), e;
      };
    });
    const s = bt(), u = () => {
      const c = (f, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(d), i(f, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), s;
  }
  loadResources(e) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ht;
    const a = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (i = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return i();
      const r = [], o = (l) => {
        if (!l || l === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((u) => {
          u !== "cimode" && r.indexOf(u) < 0 && r.push(u);
        });
      };
      a ? o(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => o(s)), this.options.preload && this.options.preload.forEach((l) => o(l)), this.services.backendConnector.load(r, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), i(l);
      });
    } else
      i(null);
  }
  reloadResources(e, t, i) {
    const a = bt();
    return e || (e = this.languages), t || (t = this.options.ns), i || (i = Ht), this.services.backendConnector.reload(e, t, (r) => {
      a.resolve(), i(r);
    }), a;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && wo.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const i = this.languages[t];
        if (!(["cimode", "dev"].indexOf(i) > -1) && this.store.hasLanguageSomeTranslations(i)) {
          this.resolvedLanguage = i;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var i = this;
    this.isLanguageChangingTo = e;
    const a = bt();
    this.emit("languageChanging", e);
    const r = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, o = (s, u) => {
      u ? (r(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return i.t(...arguments);
      }), t && t(s, function() {
        return i.t(...arguments);
      });
    }, l = (s) => {
      !e && !s && this.services.languageDetector && (s = []);
      const u = typeof s == "string" ? s : this.services.languageUtils.getBestMatchFromCodes(s);
      u && (this.language || r(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (c) => {
        o(c, u);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(e), a;
  }
  getFixedT(e, t, i) {
    var a = this;
    const r = function(o, l) {
      let s;
      if (typeof l != "object") {
        for (var u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++)
          c[f - 2] = arguments[f];
        s = a.options.overloadTranslationOptionHandler([o, l].concat(c));
      } else
        s = {
          ...l
        };
      s.lng = s.lng || r.lng, s.lngs = s.lngs || r.lngs, s.ns = s.ns || r.ns, s.keyPrefix = s.keyPrefix || i || r.keyPrefix;
      const d = a.options.keySeparator || ".";
      let g;
      return s.keyPrefix && Array.isArray(o) ? g = o.map((b) => `${s.keyPrefix}${d}${b}`) : g = s.keyPrefix ? `${s.keyPrefix}${d}${o}` : o, a.t(g, s);
    };
    return typeof e == "string" ? r.lng = e : r.lngs = e, r.ns = t, r.keyPrefix = i, r;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const i = t.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (i.toLowerCase() === "cimode")
      return !0;
    const o = (l, s) => {
      const u = this.services.backendConnector.state[`${l}|${s}`];
      return u === -1 || u === 2;
    };
    if (t.precheck) {
      const l = t.precheck(this, o);
      if (l !== void 0)
        return l;
    }
    return !!(this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(i, e) && (!a || o(r, e)));
  }
  loadNamespaces(e, t) {
    const i = bt();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      i.resolve(), t && t(a);
    }), i) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const i = bt();
    typeof e == "string" && (e = [e]);
    const a = this.options.preload || [], r = e.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return r.length ? (this.options.preload = a.concat(r), this.loadResources((o) => {
      i.resolve(), t && t(o);
    }), i) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], i = this.services && this.services.languageUtils || new Ka(Qa());
    return t.indexOf(i.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Bt(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ht;
    const i = e.forkResourceStore;
    i && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, r = new Bt(a);
    return (e.debug !== void 0 || e.prefix !== void 0) && (r.logger = r.logger.clone(e)), ["store", "services", "language"].forEach((l) => {
      r[l] = this[l];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, i && (r.store = new Ga(this.store.data, a), r.services.resourceStore = r.store), r.translator = new mn(r.services, a), r.translator.on("*", function(l) {
      for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        u[c - 1] = arguments[c];
      r.emit(l, ...u);
    }), r.init(a, t), r.translator.options = a, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const qi = Bt.createInstance();
qi.createInstance = Bt.createInstance;
const $o = "No date selected", Bo = "Choose another time slot to reschedule your meeting", Po = "All day", Mo = "Today", Do = "{{count}} spots left", Ao = "Search", Lo = {
  sunday: "SUN",
  monday: "MON",
  tuesday: "TUE",
  wednesday: "WED",
  thursday: "THU",
  friday: "FRI",
  saturday: "SAT"
}, Oo = {
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
  day: "day",
  days: "days",
  week: "week",
  weeks: "weeks",
  month: "month",
  months: "months",
  year: "year",
  years: "years"
}, _o = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, Io = "Multiple options selected", Ro = "Please select at least one option", No = "Next", Fo = "{{date}}", Uo = "{{time}}", zo = "Name", Ho = "Enter your name", jo = "Email", qo = "Enter your email", Yo = "Guest email", Vo = "Enter guest email", Go = "Add guest", Wo = "Add another guest", Ko = "Back", Zo = "Book now", Jo = "Booking confirmed", Qo = "You'll receive an email confirmation soon.", Xo = "Booking sent", es = "You will receive an email once the booking is confirmed.", ts = "Booking rescheduled", ns = "Booking date and time", is = "Cancel booking", as = "Reschedule", rs = "Reject booking", os = "Confirm booking", ss = "Booking pending", ls = "Manage your booking below. The invitee will receive an email informing them of the request status.", us = "Your booking has been confirmed successfully", cs = "A confirmation email has been sent to", ds = "Cancel booking?", fs = "Your current timeslot will become available to others.", gs = "Reason for cancellation", hs = "Go back", ms = "Your booking has been cancelled successfully", ps = "A cancellation email has been sent to", bs = "the participants", ys = "Close", vs = "Closing", Ts = "{{field}} is required.", ks = "{{field}} has invalid format.", Es = "Create Booking", xs = "Get Availability", Ss = "Cancel Booking", Cs = "Reschedule Booking", ws = "Get UI Settings", $s = "Reject Booking", Bs = "Confirm Booking", Ps = "Something went wrong...", Ms = "Scheduling Component Error", Ds = "'sessionId' is required for private configs.", As = "If using public config either pass a configurationId or a combination of 'slug' and 'clientId'.", Ls = "Invalid timeslot!", Os = "The selected timeslot is invalid", _s = "Cancellation Error", Is = "Please provide a reason for cancellation.", Rs = "You cannot cancel the booking within {{minCancellationNotice}} minutes of the event", Ns = "Cancel booking form error", Fs = "Share Your Feedback", Us = "Providing us with your feedback and reporting errors helps us create a better experience for you.", zs = "Please give us a detailed description of the feature you’re commenting on, or where you’ve experienced an issue.", Hs = "Provide your feedback here", js = "Cancel", qs = "Submit", Ys = "Delete this scheduling page?", Vs = "Upon confirmation, this page and it’s connected scheduling links will be permanently deleted and deactivated. This action cannot be undone.", Gs = "Delete page", Ws = "Cancel", Ks = "Scheduler Editor", Zs = "All Scheduling Pages", Js = "Create and manage your Scheduling Pages.", Qs = "Create new", Xs = "Page title", el = "Duration", tl = "Loading", nl = "Required", il = "Optional", al = "Please wait while we fetch the scheduling pages", rl = "No scheduling pages found", ol = "Get started with creating your first scheduling page", sl = "Edit", ll = "Event info", ul = "Availability", cl = "Participants", dl = "Booking Options", fl = "Return to Calendar view", gl = "Booking Form", hl = "Communications", ml = "Page styles", pl = "Saving", bl = "Save changes", yl = "Create", vl = "day", Tl = "week", kl = "month", El = "year", xl = "minute", Sl = "hour", Cl = "Event communications", wl = "Set up automatic confirmation emails.", $l = "Unsaved changes", Bl = "Changes saved", Pl = "Please fix the form errors.", Ml = {
  bookingFormError: "Booking form error: ",
  bookingFormError_label: "Label is required for field of type {{type}}.",
  bookingFormError_option: "Empty option detected inside {{label}} of type {{type}}."
}, Dl = {
  previewButtonText: "Preview",
  copyLinkButtonText: "Copy link",
  deleteButtonText: "Delete"
}, Al = {
  headerTitle: "Participants",
  headerSubTitle: "Add people in your team or organization to join the event.",
  organizerAsParticipant: "Participant",
  organizer: "Organizer",
  participant: "Participant",
  addParticipant_first: "Add a participant",
  addParticipant_next: "Add another participant",
  tooltip: {
    includeOrganizer: "Include Organizer",
    includeOrganizerDesc: "The organizer (you) will be included in the round-robin rotation.",
    excludeOrganizer: "Exclude Organizer",
    excludeOrganizerDesc: "The organizer (you) will not be included in the round-robin rotation."
  },
  error: "Please add at least one participant"
}, Ll = {
  headerTitle: "Default open hours",
  headerSubTitle: "Set when you're regularly available for event bookings.",
  tooltip: {
    desc: "This is the default availability for participants who don’t have availability set on the Participants tab."
  },
  selectTimezone: "Select timezone",
  unavailable: "Unavailable",
  days: {
    SUN: "SUN",
    MON: "MON",
    TUE: "TUE",
    WED: "WED",
    THU: "THU",
    FRI: "FRI",
    SAT: "SAT"
  }
}, Ol = {
  errors: {
    invalid: "Invalid"
  }
}, _l = {
  headerTitle: "Calendar booking",
  headerSubTitle: "Select the calendar where you want to add event bookings.",
  tooltip: {
    desc: "The calendar will be used to create events."
  },
  selectOptionLabel: "Select an option",
  selectCalendarErrorMessage: "Please select a calendar"
}, Il = {
  dropdownLabel: "When a booking is confirmed",
  tooltip: {
    desc: "You can either display the default confirmation page or redirect users to your own confirmation page."
  },
  redirectOption_default: "Display default confirmation page",
  redirectOption_custom: "Redirect to custom URL"
}, Rl = {
  dropdownLabel: "When a booking is requested",
  tooltip: {
    desc: "Manually accept bookings allows you to review and either accept or decline each booking request"
  },
  bookingOption_booking: "Automatically accept bookings",
  bookingOption_organizerConfirmation: "Manually accept bookings"
}, Nl = {
  headerTitle: "Booking form",
  headerSubTitle: "Add custom fields to the booking form.",
  dropdownButtonText: "Add new field",
  addOption: "Add an option",
  allOptionsHeader: "ALL OPTIONS",
  fieldInTitleError: "This field is used in the event title and cannot be removed.",
  fieldInDescriptionError: "This field is used in the event description and cannot be removed.",
  label: "Label",
  defaultValue: "Default value",
  fieldType: {
    text: "Short text",
    multi_line_text: "Long text",
    email: "Email",
    phone_number: "Phone number",
    dropdown: "Dropdown",
    radio_button: "Radio button",
    checkbox: "Checkbox",
    date: "Date",
    metadata: "Metadata",
    multi_select: "Multi-select"
  },
  fieldLabel: {
    your_name: "Your name",
    your_email: "Your email",
    email: "Additional email",
    phone_number: "Phone number label",
    dropdown: "Dropdown label",
    text: "Short text label",
    multi_line_text: "Long text label",
    radio_button: "Radio button label",
    checkbox: "Checkbox label",
    date: "Date label",
    metadata: "Metadata label",
    multi_select: "Multi-select label"
  }
}, Fl = {
  headerTitle: "Buffer time",
  headerSubTitle: "Require empty buffer time before and after an event.",
  tooltip: {
    desc: "Scheduler does not book the buffer time."
  },
  beforeBufferLabel: "Before the event",
  afterBufferLabel: "After the event",
  minutesShort: "mins",
  previewHeader: "PREVIEW"
}, Ul = {
  calendarPickerLabel: "Select calendars that will be checked for availability",
  selectAtLeastOneCalendar: "Select at least one calendar."
}, zl = {
  cancellationPolicyLabel: "Cancellation policy message",
  tooltip: {
    desc: "Attendees receive this message if trying to cancel the event. Attendees are asked to provide a reason for cancellation."
  }
}, Hl = {
  headerTitle: "Booking confirmed{{organizerName}}",
  headerSubTitle: "Booking confirmation email",
  editButtonText: "Edit",
  error: {
    invalidImageUrl: "Invalid image URL."
  },
  confirmationEmail: {
    label: "Enable email notifications",
    tooltip: {
      desc: "Allow Nylas to send email notifications, including confirmation messages and event reminders.",
      language: "This language will be used for the email notifications to the organizers."
    },
    language: "Select language"
  },
  nylasBranding: {
    label: "Show Nylas branding",
    tooltip: {
      desc: "Uncheck this to hide the footer in the email communication."
    }
  },
  companyLogoUrl: {
    label: "Company logo URL",
    tooltip: {
      desc: "This logo appears in the booking confirmation email. The URL must be publicly accessible. The image will be scaled down to a max size of 200px x 100px."
    }
  },
  emailMessage: {
    header: "Email message",
    label: "Custom email title",
    tooltip: {
      desc: "An email title is a headline within the body of the email. This doesn't change the subject line."
    },
    additionalInfoLabel: "Additional info",
    additionalInfoTooltip: "Scheduler adds the content of the box to the email body.",
    additionalInfoPlaceholder: "Default body"
  },
  allHosts: "All host & guests",
  immediatelyUponBooking: "Immediately upon booking"
}, jl = {
  headerTitle: "Connected calendars",
  headerSubTitle: "Select the calendars to use for checking your availability.",
  tooltip: {
    desc: "Check availability across one or more calendars. If you select multiple calendars for a participant, the participant must be available across all of their calendars to be considered available."
  },
  participantCalendarTitle: "{{participantName}}'s connected calendars",
  selectAtLeastOneCalendar: "Please select at least one calendar for each participant."
}, ql = {
  headerTitle: "Custom booking flow"
}, Yl = {
  headerTitle: "Custom page slug",
  headerSubTitle: "Create a custom URL slug for this page.",
  eventSlugLabel: "Page URL slug",
  tooltip: {
    desc: "Provide a custom slug for your URL to help uniquely identify your page (letters, numbers, and hyphens only)"
  },
  copied: "Copied!"
}, Vl = {
  headerTitle: "Additional settings",
  headerSubTitle: "Booking settings for the event.",
  tooltip: {
    desc: "Customize your booking settings."
  },
  allowGuests: {
    label: "Allow guests to invite additional guests."
  },
  hideReschedule: {
    label: "Hide rescheduling option.",
    tooltip: {
      desc: "Hide the 'Reschedule' button in the booking confirmation and email notifications."
    }
  },
  hideCancel: {
    label: "Hide cancellation option.",
    tooltip: {
      desc: "Hide the 'Cancel' button in the booking confirmation and email notifications."
    }
  }
}, Gl = {
  headerTitle: "Event description",
  addAdditionalFields: {
    buttonText: "Auto-populate additional fields",
    tooltip: {
      desc: "Click this once you have added all the fields you want to include in the description. Important: Please leave the markers '--- Additional Fields ---' and '--- End Additional Fields ---' unchanged so that everything works correctly."
    }
  },
  tooltip: {
    desc: "The event description appears in the Scheduler Editor’s manager view and in the response payload when a booking is created."
  }
}, Wl = {
  headerTitle: "Event duration",
  error: {
    durationMustBeMultipleOf5: "Duration must be a multiple of 5",
    durationMustBeGreaterThan0: "Duration must be greater than 0"
  }
}, Kl = {
  headerTitle: "Event information"
}, Zl = {
  headerTitle: "Event limits"
}, Jl = {
  headerTitle: "Event meeting or location",
  tooltip: {
    desc: "Select a conferencing option or add a custom location."
  },
  conferenceOptions: {
    none: "None",
    zoom: "Zoom Meeting",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Custom location"
  }
}, Ql = {
  headerTitle: "Event title",
  helpText_start: "Create a dynamic templated event {{field}} by typing",
  helpText_end: "and selecting a template item.",
  title: "title",
  description: "description",
  tooltip: {
    desc: "For example, Interview with"
  },
  eventTitleRequired: "Event title is required",
  eventTitleTokenDescription: {
    invitee: "The name of the primary invitee.",
    inviteeEmail: "The email of the primary invitee.",
    duration: "The length in time of the event."
  }
}, Xl = {
  headerTitle: "Limit future bookings",
  tooltip: {
    desc: "The limit on how far in the future bookings can be made."
  }
}, eu = {
  headerTitle: "Minimum booking notice",
  tooltip: {
    desc: "The minimum amount of time in the future that a new booking can be made."
  }
}, tu = {
  headerTitle: "Minimum cancellation notice",
  tooltip: {
    desc: "The minimum amount of time required to cancel a booking."
  }
}, nu = {
  headerTitle: "Page name",
  headerSubTitle: "Set the Scheduling Page name.",
  pageNameError: "Please enter a page name",
  tooltip: {
    desc: "By default, Scheduling Pages use your user name as the Page name. The Page name is displayed in the top-left corner of the calendar view."
  }
}, iu = {
  headerTitle: "Page styling and customization"
}, au = {
  headerTitle: "Book to this calendar",
  headerSubTitle: "Select the calendar where you want to add event bookings.",
  participantBookingCalendarTitle: "{{participantName}}'s booking calendars",
  selectAtLeastOneCalendar: "Please select at least one calendar for each participant."
}, ru = {
  headerTitle: "Participant open hours",
  headerSubTitle: "If not set, the default open hours will be used to calculate availability for this participant.",
  participantOpenHoursTitle: "{{participantName}}'s open hours"
}, ou = {
  headerTitle: "Upcoming meeting{{organizerName}}",
  headerSubTitle: "Reminder before event",
  editButtonText: "Edit",
  recipientOptions_all: "All host & guests",
  recipientOptions_guest: "All event guests",
  recipientOptions_host: "Only event host",
  beforeTheEvent: "before the event",
  emailRecipients: {
    label: "Email recipients"
  },
  sendConfirmation: {
    label: "Send confirmation email when",
    tooltip: {
      desc: "The recipients will receive a reminder email at the specified time before the event."
    }
  },
  emailSubject: {
    label: "Email subject",
    placeholder: "Upcoming meeting{{organizerName}}"
  },
  reminderMinutesValidationError: "Please enter the reminder minutes in multiples of 5. Try ",
  newReminderButtonText: "New reminder"
}, su = {
  headerTitle: "Scheduling method",
  headerSubTitle: "Select a scheduling method for the event.",
  tooltip: {
    standard: {
      label: "Standard",
      desc: "Allows 1:1 bookings, or n:1 bookings with additional participants."
    },
    maxFairness: {
      label: "Round-Robin Maximize Fairness",
      desc: "Rotates through the list of participants you select, displaying the participant with the fewest recent bookings."
    },
    maxAvailability: {
      label: "Round-Robin Maximize Availability",
      desc: "Rotates through the list of participants you select, prioritizing participants with the fewest recent bookings, but making as many time-slots available as possible."
    }
  },
  schedulingMethodOptions_collective: "Standard booking",
  schedulingMethodOptions_maxFairness: "Round-Robin max Fairness",
  schedulingMethodOptions_maxAvailability: "Round-Robin max Availability"
}, lu = {
  minutesShort: "mins",
  lengthOfMeeting: "Length of the booking",
  headerTitle: "Time slot settings",
  timeslotInterval: {
    label: "Time slot interval."
  },
  timeslotRounding: {
    label: "Time slot rounding type",
    tooltip: {
      desc: "The interval at which time slots are displayed."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Interval rounding",
      desc: "Time slots will begin at times rounded to the interval value."
    },
    noRounding: {
      label: "Default",
      desc: "Time slots will be rounded to the nearest quarter-hour."
    }
  }
}, uu = {
  recurrenceOptions: {
    none: "Does not repeat",
    daily: "Daily",
    weekly: "Weekly every {{dayOfWeek}}",
    monthly: "Monthly on the {{dayOfMonth}}",
    monthOnDay: "Monthly on day {{date}}",
    yearly: "Annually on {{dateOfMonth}}",
    custom: "Custom"
  },
  recurrenceLabel: "Repeat this event",
  endDate: "End date",
  customRecurrence: {
    repeatEvery: "Repeat every",
    repeatOn: "Repeat on",
    ends: "Ends",
    endsOptions: {
      never: "Never",
      after: "After",
      on: "On"
    },
    occurrences: "occurrences"
  },
  dateTimeLabel: "Date and time",
  errors: {
    invalidTimeRange: "Invalid time range",
    startTimeSameAsEndTime: "Start time and end time cannot be the same",
    startTimeBeforeCurrentDate: "Start time cannot be in the past",
    invalid: "Invalid"
  }
}, cu = {
  headerTitle: "Invitees",
  headerSubTitle: "Set the maximum number of invitees for this event time slot.",
  tooltip: {
    desc: "The organizer and participants configured in the scheduling page are not counted as invitees."
  },
  attendees: "attendees"
}, du = {
  returnToAllSchedulingPages: "Return to all scheduling pages",
  createEventHeaderTitle: "Create an event",
  eventTypeHeaderTitle: "Event type",
  noEventTypesEnabled: "No event types enabled",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Allows 1:1 bookings"
    },
    collective: {
      label: "Collective",
      desc: "Allows n:1 bookings with additional participants"
    },
    maxFairness: {
      label: "Round-Robin Maximize Fairness",
      desc: "Rotates through the list of participants you select, displaying the participant with the fewest recent bookings."
    },
    maxAvailability: {
      label: "Round-Robin Maximize Availability",
      desc: "Rotates through the list of participants you select, prioritizing participants with the fewest recent bookings, but making as many time-slots available as possible."
    },
    group: {
      label: "Group / Class",
      desc: "These are events which generally have one organizer and multiple participants"
    }
  }
}, fu = "Page settings", gu = {
  createEventDetails: {
    headerTitle: "Event Details",
    closeButtonTooltip: "Close",
    cancelButton: "Cancel",
    createButton: "Create"
  },
  discardChanges: {
    headerTitle: "Discard unsaved changes?",
    cancelButton: "Cancel",
    discardButton: "Discard"
  },
  unsavedChanges: "Unsaved changes",
  editEventDetails: {
    headerTitle: "Event Details",
    closeButtonTooltip: "Close",
    deleteButton: "Delete",
    saveButton: "Save",
    pastEventTooltip: "This event is in the past and cannot be edited."
  },
  importEvent: {
    closeButtonTooltip: "Close",
    importButton: "Import",
    participantsLabel: "Participants"
  },
  deleteEvent: {
    closeButtonTooltip: "Close",
    deleting: "Deleting..."
  },
  editOptions: {
    headerTitle: "Actions",
    closeButtonTooltip: "Close",
    deleting: "Deleting...",
    import: "Import",
    edit: "Edit",
    deleteThis: "Delete this event only",
    deleteAll: "Delete all events"
  },
  updateOptions: {
    updateThis: "Update this event",
    updateAll: "Update all events",
    updateFuture: "Update all future occurrences"
  },
  deleteOptions: {
    deleteThis: "Delete this event",
    deleteFuture: "Delete this and all future occurrences",
    deleteAll: "Delete all events"
  }
}, P8 = {
  noDateSelected: $o,
  rescheduleTitle: Bo,
  allDay: Po,
  today: Mo,
  spotsLeft: Do,
  search: Ao,
  days: Lo,
  time: Oo,
  months: _o,
  multipleOptionsSelected: Io,
  selectAtLeastOneOption: Ro,
  nextButton: No,
  selectedDayAndYear: Fo,
  selectedTime: Uo,
  name: zo,
  namePlaceholder: Ho,
  email: jo,
  emailPlaceholder: qo,
  guestEmail: Yo,
  guestEmailPlaceholder: Vo,
  addGuest: Go,
  addAnotherGuest: Wo,
  backButton: Ko,
  bookNowButton: Zo,
  bookingConfirmed: Jo,
  bookingConfirmedDescription: Qo,
  bookingSent: Xo,
  bookingSentDescription: es,
  bookingRescheduled: ts,
  bookingDateAndTimeHeader: ns,
  cancelBookingButton: is,
  rescheduleBookingButton: as,
  rejectBookingButton: rs,
  confirmBookingButton: os,
  bookingPendingTitle: ss,
  bookingPendingnDescription: ls,
  confirmedEventCardTitle: us,
  confirmedEventCardDescription: cs,
  cancelBookingTitle: ds,
  cancelBookingMessage: fs,
  reasonForCancellation: gs,
  goBackButton: hs,
  bookingCancelledTitle: ms,
  bookingCancelledMessage: ps,
  bookingCancelledMessage_theParticipants: bs,
  closeButton: ys,
  closingButton: vs,
  fieldRequired: Ts,
  invalidInputFormat: ks,
  createBookingErrorTitle: Es,
  getAvailabilityErrorTitle: xs,
  cancelBookingErrorTitle: Ss,
  rescheduleBookingErrorTitle: Cs,
  getUISettingErrorTitle: ws,
  rejectBookingErrorTitle: $s,
  confirmBookingErrorTitle: Bs,
  genericErrorTitle: Ps,
  schedulingComponentErrorTitle: Ms,
  sessionIdRequiredErrorMessage: Ds,
  publicConfigErrorMessage: As,
  invalidTimeslotErrorTitle: Ls,
  invalidTimeslotErrorMessage: Os,
  cancellationErrorTitle: _s,
  cancellationErrorMessage: Is,
  minimumCancellationErrorMessage: Rs,
  cancelBokingFormError: Ns,
  feedbackFormTitle: Fs,
  feedbackFormDescription: Us,
  feedbackMessageLabel: zs,
  feedbackMessagePlaceholder: Hs,
  feedbackModalCloseButton: js,
  feedbackModalSubmitButton: qs,
  deleteSchedulingPageTitle: Ys,
  deleteSchedulingPageDescription: Vs,
  deleteSchedulingPageConfirmButton: Gs,
  deleteSchedulingPageCancelButton: Ws,
  schedulerEditorTitle: Ks,
  allSchedulingPages: Zs,
  createAndManageSchedulingPages: Js,
  createNewSchedulingPageButtonText: Qs,
  pageTitle: Xs,
  durationTitle: el,
  loading: tl,
  required: nl,
  optional: il,
  loadingPagesDescription: al,
  noSchedulingPages: rl,
  createFirstSchedulingPage: ol,
  editSchedulingPageButtonText: sl,
  eventInfoTab: ll,
  availabilityTab: ul,
  participantsTab: cl,
  bookingOptionsTab: dl,
  returnToCalendarView: fl,
  bookingFormTab: gl,
  communicationsTab: hl,
  pageStylesTab: ml,
  savingButtonText: pl,
  saveChangesButtonText: bl,
  createButtonText: yl,
  timePeriod_day: vl,
  timePeriod_week: Tl,
  timePeriod_month: kl,
  timePeriod_year: El,
  timeDuration_minute: xl,
  timeDuration_hour: Sl,
  eventCommunicationsTitle: Cl,
  eventCommunicationsDescription: wl,
  unsavedChangesLabel: $l,
  changesSavedLabel: Bl,
  fixFormErrors: Pl,
  nylasEditorTabs: Ml,
  nylasListConfigurations: Dl,
  nylasAdditionalParticipants: Al,
  nylasAvailabilityPicker: Ll,
  nylasTimeWindowPicker: Ol,
  nylasBookingCalendarPicker: _l,
  nylasBookingConfirmationRedirect: Il,
  nylasBookingConfirmationType: Rl,
  nylasBookingFormConfig: Nl,
  nylasBufferTime: Fl,
  nylasCalendarPicker: Ul,
  nylasCancellationPolicy: zl,
  nylasConfirmationEmail: Hl,
  nylasConnectedCalendars: jl,
  nylasCustomBookingFlow: ql,
  nylasCustomEventSlug: Yl,
  nylasCustomizeBookingSettings: Vl,
  nylasEventDescription: Gl,
  nylasEventDuration: Wl,
  nylasEventInfo: Kl,
  nylasEventLimits: Zl,
  nylasEventLocation: Jl,
  nylasEventTitle: Ql,
  nylasLimitFutureBookings: Xl,
  nylasMinBookingNotice: eu,
  nylasMinCancellationNotice: tu,
  nylasPageName: nu,
  nylasPageStyling: iu,
  nylasParticipantBookingCalendars: au,
  nylasParticipantCustomAvailability: ru,
  nylasReminderEmails: ou,
  nylasSchedulingMethod: su,
  nylasTimeslotInterval: lu,
  nylasEventTimeslot: uu,
  nylasEventCapacity: cu,
  nylasSelectEventType: du,
  pageSettingsButton: fu,
  nylasEventCalendar: gu
}, M8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: $o,
  rescheduleTitle: Bo,
  allDay: Po,
  today: Mo,
  spotsLeft: Do,
  search: Ao,
  days: Lo,
  time: Oo,
  months: _o,
  multipleOptionsSelected: Io,
  selectAtLeastOneOption: Ro,
  nextButton: No,
  selectedDayAndYear: Fo,
  selectedTime: Uo,
  name: zo,
  namePlaceholder: Ho,
  email: jo,
  emailPlaceholder: qo,
  guestEmail: Yo,
  guestEmailPlaceholder: Vo,
  addGuest: Go,
  addAnotherGuest: Wo,
  backButton: Ko,
  bookNowButton: Zo,
  bookingConfirmed: Jo,
  bookingConfirmedDescription: Qo,
  bookingSent: Xo,
  bookingSentDescription: es,
  bookingRescheduled: ts,
  bookingDateAndTimeHeader: ns,
  cancelBookingButton: is,
  rescheduleBookingButton: as,
  rejectBookingButton: rs,
  confirmBookingButton: os,
  bookingPendingTitle: ss,
  bookingPendingnDescription: ls,
  confirmedEventCardTitle: us,
  confirmedEventCardDescription: cs,
  cancelBookingTitle: ds,
  cancelBookingMessage: fs,
  reasonForCancellation: gs,
  goBackButton: hs,
  bookingCancelledTitle: ms,
  bookingCancelledMessage: ps,
  bookingCancelledMessage_theParticipants: bs,
  closeButton: ys,
  closingButton: vs,
  fieldRequired: Ts,
  invalidInputFormat: ks,
  createBookingErrorTitle: Es,
  getAvailabilityErrorTitle: xs,
  cancelBookingErrorTitle: Ss,
  rescheduleBookingErrorTitle: Cs,
  getUISettingErrorTitle: ws,
  rejectBookingErrorTitle: $s,
  confirmBookingErrorTitle: Bs,
  genericErrorTitle: Ps,
  schedulingComponentErrorTitle: Ms,
  sessionIdRequiredErrorMessage: Ds,
  publicConfigErrorMessage: As,
  invalidTimeslotErrorTitle: Ls,
  invalidTimeslotErrorMessage: Os,
  cancellationErrorTitle: _s,
  cancellationErrorMessage: Is,
  minimumCancellationErrorMessage: Rs,
  cancelBokingFormError: Ns,
  feedbackFormTitle: Fs,
  feedbackFormDescription: Us,
  feedbackMessageLabel: zs,
  feedbackMessagePlaceholder: Hs,
  feedbackModalCloseButton: js,
  feedbackModalSubmitButton: qs,
  deleteSchedulingPageTitle: Ys,
  deleteSchedulingPageDescription: Vs,
  deleteSchedulingPageConfirmButton: Gs,
  deleteSchedulingPageCancelButton: Ws,
  schedulerEditorTitle: Ks,
  allSchedulingPages: Zs,
  createAndManageSchedulingPages: Js,
  createNewSchedulingPageButtonText: Qs,
  pageTitle: Xs,
  durationTitle: el,
  loading: tl,
  required: nl,
  optional: il,
  loadingPagesDescription: al,
  noSchedulingPages: rl,
  createFirstSchedulingPage: ol,
  editSchedulingPageButtonText: sl,
  eventInfoTab: ll,
  availabilityTab: ul,
  participantsTab: cl,
  bookingOptionsTab: dl,
  returnToCalendarView: fl,
  bookingFormTab: gl,
  communicationsTab: hl,
  pageStylesTab: ml,
  savingButtonText: pl,
  saveChangesButtonText: bl,
  createButtonText: yl,
  timePeriod_day: vl,
  timePeriod_week: Tl,
  timePeriod_month: kl,
  timePeriod_year: El,
  timeDuration_minute: xl,
  timeDuration_hour: Sl,
  eventCommunicationsTitle: Cl,
  eventCommunicationsDescription: wl,
  unsavedChangesLabel: $l,
  changesSavedLabel: Bl,
  fixFormErrors: Pl,
  nylasEditorTabs: Ml,
  nylasListConfigurations: Dl,
  nylasAdditionalParticipants: Al,
  nylasAvailabilityPicker: Ll,
  nylasTimeWindowPicker: Ol,
  nylasBookingCalendarPicker: _l,
  nylasBookingConfirmationRedirect: Il,
  nylasBookingConfirmationType: Rl,
  nylasBookingFormConfig: Nl,
  nylasBufferTime: Fl,
  nylasCalendarPicker: Ul,
  nylasCancellationPolicy: zl,
  nylasConfirmationEmail: Hl,
  nylasConnectedCalendars: jl,
  nylasCustomBookingFlow: ql,
  nylasCustomEventSlug: Yl,
  nylasCustomizeBookingSettings: Vl,
  nylasEventDescription: Gl,
  nylasEventDuration: Wl,
  nylasEventInfo: Kl,
  nylasEventLimits: Zl,
  nylasEventLocation: Jl,
  nylasEventTitle: Ql,
  nylasLimitFutureBookings: Xl,
  nylasMinBookingNotice: eu,
  nylasMinCancellationNotice: tu,
  nylasPageName: nu,
  nylasPageStyling: iu,
  nylasParticipantBookingCalendars: au,
  nylasParticipantCustomAvailability: ru,
  nylasReminderEmails: ou,
  nylasSchedulingMethod: su,
  nylasTimeslotInterval: lu,
  nylasEventTimeslot: uu,
  nylasEventCapacity: cu,
  nylasSelectEventType: du,
  pageSettingsButton: fu,
  nylasEventCalendar: gu,
  default: P8
}), hu = "Aucune date sélectionnée", mu = "Choisissez un autre créneau horaire pour reprogrammer votre réunion", pu = "Toute la journée", bu = "Aujourd'hui", yu = "{{count}} places restantes", vu = "Rechercher", Tu = {
  sunday: "DIM",
  monday: "LUN",
  tuesday: "MAR",
  wednesday: "MER",
  thursday: "JEU",
  friday: "VEN",
  saturday: "SAM"
}, ku = {
  hour: "heure",
  hours: "heures",
  minute: "minute",
  minutes: "minutes",
  day: "jour",
  days: "jours",
  week: "semaine",
  weeks: "semaines",
  month: "mois",
  months: "mois",
  year: "année",
  years: "années"
}, Eu = {
  january: "Janvier",
  february: "Février",
  march: "Mars",
  april: "Avril",
  may: "Mai",
  june: "Juin",
  july: "Juillet",
  august: "Août",
  september: "Septembre",
  october: "Octobre",
  november: "Novembre",
  december: "Décembre"
}, xu = "Plusieurs options sélectionnées", Su = "Veuillez sélectionner au moins une option", Cu = "Suivant", wu = "{{date}}", $u = "{{time}}", Bu = "Nom", Pu = "Entrez votre nom", Mu = "E-mail", Du = "Entrer votre E-mail", Au = "E-mail invité", Lu = "Entrez l'adresse e-mail de l'invité", Ou = "Ajouter un invité", _u = "Ajouter un autre invité", Iu = "Retour", Ru = "Réservez maintenant", Nu = "Réservation confirmée", Fu = "Vous recevrez bientôt un e-mail de confirmation.", Uu = "Réservation envoyée", zu = "Vous recevrez un e-mail une fois la réservation confirmée.", Hu = "Réservation reprogrammée", ju = "Date et heure de la réservation", qu = "Annuler la réservation", Yu = "Replanifier", Vu = "Refuser la réservation", Gu = "Confirmer la réservation", Wu = "Réservation en attente", Ku = "Gérez votre réservation ci-dessous. L'invité recevra un e-mail l'informant du statut de la demande.", Zu = "Votre réservation a été confirmée avec succès", Ju = "Un e-mail de confirmation a été envoyé à", Qu = "Annuler la réservation?", Xu = "Votre créneau horaire actuel sera disponible pour les autres.", ec = "Raison de l'annulation", tc = "Retourner", nc = "Votre réservation a été annulée avec succès", ic = "Un e-mail d'annulation a été envoyé à", ac = "les participants", rc = "Fermer", oc = "Fermeture", sc = "{{field}} est requis.", lc = "{{field}} a un format invalide.", uc = "Créer une Réservation", cc = "Obtenir la Disponibilité", dc = "Annuler la Réservation", fc = "Reprogrammer la Réservation", gc = "Obtenir les Paramètres UI", hc = "Refuser la Réservation", mc = "Confirmer la Réservation", pc = "Quelque chose a mal tourné...", bc = "Erreur du composant de planification", yc = "'sessionId' est requis pour les configurations privées.", vc = "Si vous utilisez une configuration publique, passez soit un configurationId, soit une combinaison de 'slug' et 'clientId'.", Tc = "Créneau horaire invalide !", kc = "Le créneau horaire sélectionné est invalide", Ec = "Erreur d'annulation", xc = "Veuillez fournir une raison pour l'annulation.", Sc = "Vous ne pouvez pas annuler la réservation dans les {{minCancellationNotice}} minutes avant l'événement", Cc = "Erreur de formulaire d'annulation de réservation", wc = "Partagez vos commentaires", $c = "Nous fournir vos commentaires et signaler des erreurs nous aide à créer une meilleure expérience pour vous.", Bc = "Veuillez nous fournir une description détaillée de la fonctionnalité sur laquelle vous commentez ou du problème que vous avez rencontré.", Pc = "Saisissez vos commentaires ici", Mc = "Annuler", Dc = "Envoyer", Ac = "Supprimer cette page de planification?", Lc = "Après confirmation, cette page et ses liens de planification associés seront définitivement supprimés et désactivés. Cette action est irréversible.", Oc = "Supprimer la page", _c = "Annuler", Ic = "Éditeur de planification", Rc = "Toutes les pages de planification", Nc = "Créez et gérez vos pages de planification.", Fc = "Créer un nouveau", Uc = "Titre de la page", zc = "Durée", Hc = "Chargement", jc = "Requis", qc = "Facultatif", Yc = "Veuillez patienter pendant que nous récupérons les pages de planification", Vc = "Aucune page de planification trouvée", Gc = "Commencez par créer votre première page de planification", Wc = "Modifier", Kc = "Informations sur l'événement", Zc = "Disponibilité", Jc = "Participants", Qc = "Options de réservation", Xc = "Retour à la vue du calendrier", ed = "Formulaire de réservation", td = "Communications", nd = "Styles de page", id = "Enregistrement", ad = "Enregistrer les modifications", rd = "Créer", od = "jour", sd = "semaine", ld = "mois", ud = "année", cd = "minute", dd = "heure", fd = "Communications de l'événement", gd = "Configurez des e-mails de confirmation automatiques.", hd = "Modifications non enregistrées", md = "Modifications enregistrées", pd = "Veuillez corriger les erreurs du formulaire.", bd = {
  bookingFormError: "Erreur de formulaire de réservation: ",
  bookingFormError_label: "Étiquette requise pour le champ de type {{type}}.",
  bookingFormError_option: "Option vide détectée dans {{label}} de type {{type}}."
}, yd = {
  previewButtonText: "Aperçu",
  copyLinkButtonText: "Copier le lien",
  deleteButtonText: "Supprimer"
}, vd = {
  headerTitle: "Participants",
  headerSubTitle: "Ajoutez des personnes de votre équipe ou organisation pour participer à l'événement.",
  organizerAsParticipant: "Participant",
  organizer: "Organisateur",
  participant: "Participant",
  addParticipant_first: "Ajouter un participant",
  addParticipant_next: "Ajouter un autre participant",
  tooltip: {
    includeOrganizer: "Inclure l'organisateur",
    includeOrganizerDesc: "L'organisateur (vous) sera inclus dans la rotation.",
    excludeOrganizer: "Exclure l'organisateur",
    excludeOrganizerDesc: "L'organisateur (vous) ne sera pas inclus dans la rotation."
  },
  error: "Veuillez ajouter au moins un participant"
}, Td = {
  headerTitle: "Horaires d'ouverture par défaut",
  headerSubTitle: "Définissez vos disponibilités régulières pour les réservations d'événements.",
  tooltip: {
    desc: "Ce sont les disponibilités par défaut pour les participants qui n'ont pas défini de disponibilités dans l'onglet Participants."
  },
  selectTimezone: "Sélectionnez un fuseau horaire",
  unavailable: "Indisponible",
  days: {
    SUN: "DIM",
    MON: "LUN",
    TUE: "MAR",
    WED: "MER",
    THU: "JEU",
    FRI: "VEN",
    SAT: "SAM"
  }
}, kd = {
  errors: {
    invalid: "Invalide"
  }
}, Ed = {
  headerTitle: "Réservation de calendrier",
  headerSubTitle: "Sélectionnez le calendrier où vous souhaitez ajouter des réservations.",
  tooltip: {
    desc: "Le calendrier sera utilisé pour créer des événements."
  },
  selectOptionLabel: "Sélectionnez une option",
  selectCalendarErrorMessage: "Veuillez sélectionner un calendrier"
}, xd = {
  dropdownLabel: "Lorsque la réservation est confirmée",
  tooltip: {
    desc: "Vous pouvez afficher la page de confirmation par défaut ou rediriger les utilisateurs vers votre propre page de confirmation."
  },
  redirectOption_default: "Afficher la page de confirmation par défaut",
  redirectOption_custom: "Rediriger vers une URL personnalisée"
}, Sd = {
  dropdownLabel: "Lorsque la réservation est demandée",
  tooltip: {
    desc: "Accepter les réservations manuellement vous permet d'examiner et d'accepter ou de refuser chaque demande de réservation."
  },
  bookingOption_booking: "Accepter automatiquement les réservations",
  bookingOption_organizerConfirmation: "Accepter les réservations manuellement"
}, Cd = {
  headerTitle: "Formulaire de réservation",
  headerSubTitle: "Ajoutez des champs personnalisés au formulaire de réservation.",
  dropdownButtonText: "Ajouter un nouveau champ",
  addOption: "Ajouter une option",
  allOptionsHeader: "TOUTES LES OPTIONS",
  fieldInTitleError: "Ce champ est utilisé dans le titre de l'événement et ne peut pas être supprimé.",
  fieldInDescriptionError: "Ce champ est utilisé dans la description de l'événement et ne peut pas être supprimé.",
  label: "Étiquette",
  defaultValue: "Valeur par défaut",
  fieldType: {
    text: "Texte court",
    multi_line_text: "Texte long",
    email: "Email",
    phone_number: "Numéro de téléphone",
    dropdown: "Menu déroulant",
    radio_button: "Bouton radio",
    checkbox: "Case à cocher",
    date: "Date",
    metadata: "Métadonnées",
    multi_select: "Sélection multiple"
  },
  fieldLabel: {
    your_name: "Votre nom",
    your_email: "Votre e-mail",
    email: "E-mail supplémentaire",
    phone_number: "Étiquette du numéro de téléphone",
    dropdown: "Étiquette de menu déroulant",
    text: "Étiquette de texte court",
    multi_line_text: "Étiquette de texte long",
    radio_button: "Étiquette du bouton radio",
    checkbox: "Étiquette de case à cocher",
    date: "Étiquette de date",
    metadata: "Étiquette des métadonnées",
    multi_select: "Étiquette de sélection multiple"
  }
}, wd = {
  headerTitle: "Temps tampon",
  headerSubTitle: "Exigez un temps tampon avant et après un événement.",
  tooltip: {
    desc: "Le planificateur ne réservera pas le temps tampon."
  },
  beforeBufferLabel: "Avant l'événement",
  afterBufferLabel: "Après l'événement",
  minutesShort: "min",
  previewHeader: "APERÇU"
}, $d = {
  calendarPickerLabel: "Sélectionnez les calendriers à vérifier pour les disponibilités",
  selectAtLeastOneCalendar: "Veuillez sélectionner au moins un calendrier pour chaque participant."
}, Bd = {
  cancellationPolicyLabel: "Message de politique d'annulation",
  tooltip: {
    desc: "Les participants reçoivent ce message s'ils essaient d'annuler l'événement. Ils doivent fournir une raison pour l'annulation."
  }
}, Pd = {
  headerTitle: "Réservation confirmée{{organizerName}}",
  headerSubTitle: "E-mail de confirmation de réservation",
  editButtonText: "Modifier",
  error: {
    invalidImageUrl: "URL de l'image invalide."
  },
  confirmationEmail: {
    label: "Activer les notifications par e-mail",
    tooltip: {
      desc: "Autorisez Nylas à envoyer des notifications par e-mail, y compris des messages de confirmation et des rappels d'événements.",
      language: "Cette langue sera utilisée pour les notifications par e-mail aux organisateurs."
    },
    language: "Sélectionner la langue"
  },
  nylasBranding: {
    label: "Afficher la marque Nylas",
    tooltip: {
      desc: "Décochez cette option pour masquer le pied de page dans la communication par e-mail."
    }
  },
  companyLogoUrl: {
    label: "URL du logo de l'entreprise",
    tooltip: {
      desc: "Ce logo apparaît dans l'e-mail de confirmation de réservation. L'URL doit être accessible publiquement. L'image sera redimensionnée à une taille maximale de 200px x 100px."
    }
  },
  emailMessage: {
    header: "Message e-mail",
    label: "Titre personnalisé de l'e-mail",
    tooltip: {
      desc: "Un titre d'e-mail est une en-tête dans le corps de l'e-mail. Cela ne modifie pas la ligne d'objet."
    },
    additionalInfoLabel: "Informations supplémentaires",
    additionalInfoTooltip: "Le planificateur ajoute le contenu de cette case au corps de l'e-mail.",
    additionalInfoPlaceholder: "Texte par défaut"
  },
  allHosts: "Tous les hôtes et invités",
  immediatelyUponBooking: "Immédiatement après la réservation"
}, Md = {
  headerTitle: "Calendriers connectés",
  headerSubTitle: "Sélectionnez les calendriers à utiliser pour vérifier votre disponibilité.",
  tooltip: {
    desc: "Vérifiez la disponibilité sur un ou plusieurs calendriers. Si vous sélectionnez plusieurs calendriers pour un participant, celui-ci doit être disponible sur tous ses calendriers pour être considéré comme disponible."
  },
  participantCalendarTitle: "Calendriers connectés de {{participantName}}",
  selectAtLeastOneCalendar: "Veuillez sélectionner au moins un calendrier pour chaque participant."
}, Dd = {
  headerTitle: "Flux de réservation personnalisé"
}, Ad = {
  headerTitle: "Slug personnalisé de page",
  headerSubTitle: "Créez un slug d'URL personnalisé pour cette page.",
  eventSlugLabel: "Slug d'URL de la page",
  tooltip: {
    desc: "Fournissez un slug personnalisé pour votre URL afin d'identifier de manière unique votre page (lettres, chiffres et tirets uniquement)."
  },
  copied: "Copié !"
}, Ld = {
  headerTitle: "Paramètres supplémentaires",
  headerSubTitle: "Paramètres de réservation pour l'événement.",
  tooltip: {
    desc: "Personnalisez vos paramètres de réservation."
  },
  allowGuests: {
    label: "Autoriser les invités à inviter d'autres invités."
  },
  hideReschedule: {
    label: "Masquer l'option de reprogrammation.",
    tooltip: {
      desc: "Masquer le bouton 'Reprogrammer' dans la confirmation de réservation et les notifications par e-mail."
    }
  },
  hideCancel: {
    label: "Masquer l'option d'annulation",
    tooltip: {
      desc: "Masquer le bouton 'Annuler' dans la confirmation de réservation et les notifications par e-mail."
    }
  }
}, Od = {
  headerTitle: "Description de l'événement",
  addAdditionalFields: {
    buttonText: "Remplir automatiquement les champs supplémentaires",
    tooltip: {
      desc: "Cliquez ici une fois que vous avez ajouté tous les champs que vous souhaitez inclure dans la description. Important : Veuillez ne pas modifier les marqueurs '--- Additional Fields ---' et '--- End Additional Fields ---' pour assurer le bon fonctionnement."
    }
  },
  tooltip: {
    desc: "La description de l'événement apparaît dans la vue gestionnaire de l'éditeur de planification et dans la réponse lors de la création d'une réservation."
  }
}, _d = {
  headerTitle: "Durée de l'événement",
  error: {
    durationMustBeMultipleOf5: "La durée doit être un multiple de 5",
    durationMustBeGreaterThan0: "La durée doit être supérieure à 0"
  }
}, Id = {
  headerTitle: "Informations sur l'événement"
}, Rd = {
  headerTitle: "Limites de l'événement"
}, Nd = {
  headerTitle: "Lieu ou réunion de l'événement",
  tooltip: {
    desc: "Sélectionnez une option de conférence ou ajoutez un lieu personnalisé."
  },
  conferenceOptions: {
    none: "Aucun",
    zoom: "Réunion Zoom",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Emplacement personnalisé"
  }
}, Fd = {
  headerTitle: "Titre de l'événement",
  helpText_start: "Créez un événement dynamique basé sur un modèle {{field}} en tapant",
  helpText_end: "et en sélectionnant un élément de modèle.",
  title: "titre",
  description: "description",
  tooltip: {
    desc: "Par exemple : Entretien avec"
  },
  eventTitleRequired: "Le titre de l'événement est requis",
  eventTitleTokenDescription: {
    invitee: "Le nom du participant principal.",
    inviteeEmail: "L'adresse e-mail du participant principal.",
    duration: "La durée de l'événement."
  }
}, Ud = {
  headerTitle: "Limiter les réservations futures",
  tooltip: {
    desc: "La limite pour déterminer jusqu'où dans le futur les réservations peuvent être effectuées."
  }
}, zd = {
  headerTitle: "Préavis minimal pour les réservations",
  tooltip: {
    desc: "Le délai minimal à l'avance pour effectuer une nouvelle réservation."
  }
}, Hd = {
  headerTitle: "Préavis minimal d'annulation",
  tooltip: {
    desc: "Le délai minimal nécessaire pour annuler une réservation."
  }
}, jd = {
  headerTitle: "Nom de la page",
  headerSubTitle: "Définissez le nom de la page de planification.",
  pageNameError: "Veuillez entrer un nom de page",
  tooltip: {
    desc: "Par défaut, les pages de planification utilisent votre nom d'utilisateur comme nom de page. Le nom de la page est affiché dans le coin supérieur gauche de la vue du calendrier."
  }
}, qd = {
  headerTitle: "Personnalisation et style de la page"
}, Yd = {
  headerTitle: "Réserver sur ce calendrier",
  headerSubTitle: "Sélectionnez le calendrier où vous souhaitez ajouter des réservations d'événements.",
  participantBookingCalendarTitle: "Calendriers de réservation de {{participantName}}",
  selectAtLeastOneCalendar: "Veuillez sélectionner au moins un calendrier pour chaque participant."
}, Vd = {
  headerTitle: "Horaires d'ouverture des participants",
  headerSubTitle: "Si ce n'est pas défini, les horaires d'ouverture par défaut seront utilisés pour calculer la disponibilité de ce participant.",
  participantOpenHoursTitle: "Horaires d'ouverture de {{participantName}}"
}, Gd = {
  headerTitle: "Prochaine réunion {{organizerName}}",
  headerSubTitle: "Rappel avant l'événement",
  editButtonText: "Modifier",
  recipientOptions_all: "Tous les hôtes et invités",
  recipientOptions_guest: "Tous les invités de l'événement",
  recipientOptions_host: "Uniquement l'hôte de l'événement",
  beforeTheEvent: "avant l'événement",
  emailRecipients: {
    label: "Destinataires de l'e-mail"
  },
  sendConfirmation: {
    label: "Envoyer un e-mail de confirmation lorsque",
    tooltip: {
      desc: "Les destinataires recevront un e-mail de rappel au moment spécifié avant l'événement."
    }
  },
  emailSubject: {
    label: "Objet de l'e-mail",
    placeholder: "Prochaine réunion {{organizerName}}"
  },
  reminderMinutesValidationError: "Veuillez entrer les minutes du rappel par multiples de 5. Essayez ",
  newReminderButtonText: "Nouveau rappel"
}, Wd = {
  headerTitle: "Méthode de planification",
  headerSubTitle: "Sélectionnez une méthode de planification pour l'événement.",
  tooltip: {
    standard: {
      label: "Standard",
      desc: "Permet des réservations 1:1 ou n:1 avec des participants supplémentaires."
    },
    maxFairness: {
      label: "Tour de rôle - Maximiser l'équité",
      desc: "Fait tourner la liste des participants que vous sélectionnez, en affichant le participant avec le moins de réservations récentes."
    },
    maxAvailability: {
      label: "Tour de rôle - Maximiser la disponibilité",
      desc: "Fait tourner la liste des participants que vous sélectionnez, en priorisant ceux ayant le moins de réservations récentes tout en rendant autant de créneaux horaires disponibles que possible."
    }
  },
  schedulingMethodOptions_collective: "Réservation standard",
  schedulingMethodOptions_maxFairness: "Tour de rôle - Maximiser l'équité",
  schedulingMethodOptions_maxAvailability: "Tour de rôle - Maximiser la disponibilité"
}, Kd = {
  minutesShort: "min",
  lengthOfMeeting: "Durée de la réunion",
  headerTitle: "Paramètres des créneaux horaires",
  timeslotInterval: {
    label: "Intervalle des créneaux horaires."
  },
  timeslotRounding: {
    label: "Type d'arrondi des créneaux horaires",
    tooltip: {
      desc: "L'intervalle auquel les créneaux horaires sont affichés."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Arrondi d'intervalle",
      desc: "Les créneaux horaires commenceront à des heures arrondies à la valeur de l'intervalle."
    },
    noRounding: {
      label: "Par défaut",
      desc: "Les créneaux horaires seront arrondis au quart d'heure le plus proche."
    }
  }
}, Zd = {
  recurrenceOptions: {
    none: "Ne se répète pas",
    daily: "Quotidien",
    weekly: "Hebdomadaire chaque {{dayOfWeek}}",
    monthly: "Mensuel le {{dayOfMonth}}",
    monthOnDay: "Mensuel le jour {{date}}",
    yearly: "Annuel le {{dateOfMonth}}",
    custom: "Personnalisé"
  },
  recurrenceLabel: "Répéter cet événement",
  endDate: "Date de fin",
  customRecurrence: {
    repeatEvery: "Répéter tous les",
    repeatOn: "Répéter le",
    ends: "Se termine",
    endsOptions: {
      never: "Jamais",
      after: "Après",
      on: "Le"
    },
    occurrences: "occurrences"
  },
  dateTimeLabel: "Date et heure",
  errors: {
    invalidTimeRange: "Plage de temps invalide",
    startTimeSameAsEndTime: "L'heure de début et l'heure de fin ne peuvent pas être identiques",
    startTimeBeforeCurrentDate: "L'heure de début ne peut pas être dans le passé",
    invalid: "Invalide"
  }
}, Jd = {
  headerTitle: "Invités",
  headerSubTitle: "Définissez le nombre maximum d'invités pour ce créneau horaire de l'événement.",
  tooltip: {
    desc: "L'organisateur et les participants configurés sur la page de planification ne sont pas comptés comme invités."
  },
  attendees: "invités"
}, Qd = {
  returnToAllSchedulingPages: "Retour à toutes les pages de planification",
  createEventHeaderTitle: "Créer un événement",
  eventTypeHeaderTitle: "Type d'événement",
  noEventTypesEnabled: "Aucun type d'événement activé",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Permet des réservations 1:1"
    },
    collective: {
      label: "Réservation standard",
      desc: "Permet des réservations n:1 avec des participants supplémentaires"
    },
    maxFairness: {
      label: "Tour de rôle - Maximiser l'équité",
      desc: "Fait tourner la liste des participants que vous sélectionnez, en affichant le participant avec le moins de réservations récentes."
    },
    maxAvailability: {
      label: "Tour de rôle - Maximiser la disponibilité",
      desc: "Fait tourner la liste des participants que vous sélectionnez, en priorisant ceux ayant le moins de réservations récentes tout en rendant autant de créneaux horaires disponibles que possible."
    },
    group: {
      label: "Événement de groupe / classe",
      desc: "Ces événements ont généralement un organisateur et plusieurs participants."
    }
  }
}, Xd = "Paramètres de la page", ef = {
  createEventDetails: {
    headerTitle: "Détails de l'événement",
    closeButtonTooltip: "Fermer",
    cancelButton: "Annuler",
    createButton: "Créer"
  },
  discardChanges: {
    headerTitle: "Voulez-vous vraiment annuler les modifications non enregistrées ?",
    cancelButton: "Annuler",
    discardButton: "Descartar"
  },
  unsavedChanges: "Modifications non enregistrées",
  editEventDetails: {
    headerTitle: "Détails de l'événement",
    closeButtonTooltip: "Fermer",
    deleteButton: "Supprimer",
    saveButton: "Enregistrer",
    pastEventTooltip: "Cet événement est passé et ne peut pas être modifié."
  },
  importEvent: {
    closeButtonTooltip: "Fermer",
    importButton: "Importer",
    participantsLabel: "Participants"
  },
  deleteEvent: {
    closeButtonTooltip: "Fermer",
    deleting: "Suppression..."
  },
  editOptions: {
    headerTitle: "Actions",
    closeButtonTooltip: "Fermer",
    deleting: "Suppression...",
    import: "Importer",
    edit: "Modifier",
    deleteThis: "Supprimer cet événement",
    deleteAll: "Supprimer tous les événements"
  },
  updateOptions: {
    updateThis: "Mettre à jour cet événement",
    updateAll: "Mettre à jour tous les événements",
    updateFuture: "Mettre à jour tous les futurs événements"
  },
  deleteOptions: {
    deleteThis: "Supprimer",
    deleteFuture: "Supprimer et tous les futurs événements",
    deleteAll: "Supprimer tous les événements"
  }
}, D8 = {
  noDateSelected: hu,
  rescheduleTitle: mu,
  allDay: pu,
  today: bu,
  spotsLeft: yu,
  search: vu,
  days: Tu,
  time: ku,
  months: Eu,
  multipleOptionsSelected: xu,
  selectAtLeastOneOption: Su,
  nextButton: Cu,
  selectedDayAndYear: wu,
  selectedTime: $u,
  name: Bu,
  namePlaceholder: Pu,
  email: Mu,
  emailPlaceholder: Du,
  guestEmail: Au,
  guestEmailPlaceholder: Lu,
  addGuest: Ou,
  addAnotherGuest: _u,
  backButton: Iu,
  bookNowButton: Ru,
  bookingConfirmed: Nu,
  bookingConfirmedDescription: Fu,
  bookingSent: Uu,
  bookingSentDescription: zu,
  bookingRescheduled: Hu,
  bookingDateAndTimeHeader: ju,
  cancelBookingButton: qu,
  rescheduleBookingButton: Yu,
  rejectBookingButton: Vu,
  confirmBookingButton: Gu,
  bookingPendingTitle: Wu,
  bookingPendingnDescription: Ku,
  confirmedEventCardTitle: Zu,
  confirmedEventCardDescription: Ju,
  cancelBookingTitle: Qu,
  cancelBookingMessage: Xu,
  reasonForCancellation: ec,
  goBackButton: tc,
  bookingCancelledTitle: nc,
  bookingCancelledMessage: ic,
  bookingCancelledMessage_theParticipants: ac,
  closeButton: rc,
  closingButton: oc,
  fieldRequired: sc,
  invalidInputFormat: lc,
  createBookingErrorTitle: uc,
  getAvailabilityErrorTitle: cc,
  cancelBookingErrorTitle: dc,
  rescheduleBookingErrorTitle: fc,
  getUISettingErrorTitle: gc,
  rejectBookingErrorTitle: hc,
  confirmBookingErrorTitle: mc,
  genericErrorTitle: pc,
  schedulingComponentErrorTitle: bc,
  sessionIdRequiredErrorMessage: yc,
  publicConfigErrorMessage: vc,
  invalidTimeslotErrorTitle: Tc,
  invalidTimeslotErrorMessage: kc,
  cancellationErrorTitle: Ec,
  cancellationErrorMessage: xc,
  minimumCancellationErrorMessage: Sc,
  cancelBokingFormError: Cc,
  feedbackFormTitle: wc,
  feedbackFormDescription: $c,
  feedbackMessageLabel: Bc,
  feedbackMessagePlaceholder: Pc,
  feedbackModalCloseButton: Mc,
  feedbackModalSubmitButton: Dc,
  deleteSchedulingPageTitle: Ac,
  deleteSchedulingPageDescription: Lc,
  deleteSchedulingPageConfirmButton: Oc,
  deleteSchedulingPageCancelButton: _c,
  schedulerEditorTitle: Ic,
  allSchedulingPages: Rc,
  createAndManageSchedulingPages: Nc,
  createNewSchedulingPageButtonText: Fc,
  pageTitle: Uc,
  durationTitle: zc,
  loading: Hc,
  required: jc,
  optional: qc,
  loadingPagesDescription: Yc,
  noSchedulingPages: Vc,
  createFirstSchedulingPage: Gc,
  editSchedulingPageButtonText: Wc,
  eventInfoTab: Kc,
  availabilityTab: Zc,
  participantsTab: Jc,
  bookingOptionsTab: Qc,
  returnToCalendarView: Xc,
  bookingFormTab: ed,
  communicationsTab: td,
  pageStylesTab: nd,
  savingButtonText: id,
  saveChangesButtonText: ad,
  createButtonText: rd,
  timePeriod_day: od,
  timePeriod_week: sd,
  timePeriod_month: ld,
  timePeriod_year: ud,
  timeDuration_minute: cd,
  timeDuration_hour: dd,
  eventCommunicationsTitle: fd,
  eventCommunicationsDescription: gd,
  unsavedChangesLabel: hd,
  changesSavedLabel: md,
  fixFormErrors: pd,
  nylasEditorTabs: bd,
  nylasListConfigurations: yd,
  nylasAdditionalParticipants: vd,
  nylasAvailabilityPicker: Td,
  nylasTimeWindowPicker: kd,
  nylasBookingCalendarPicker: Ed,
  nylasBookingConfirmationRedirect: xd,
  nylasBookingConfirmationType: Sd,
  nylasBookingFormConfig: Cd,
  nylasBufferTime: wd,
  nylasCalendarPicker: $d,
  nylasCancellationPolicy: Bd,
  nylasConfirmationEmail: Pd,
  nylasConnectedCalendars: Md,
  nylasCustomBookingFlow: Dd,
  nylasCustomEventSlug: Ad,
  nylasCustomizeBookingSettings: Ld,
  nylasEventDescription: Od,
  nylasEventDuration: _d,
  nylasEventInfo: Id,
  nylasEventLimits: Rd,
  nylasEventLocation: Nd,
  nylasEventTitle: Fd,
  nylasLimitFutureBookings: Ud,
  nylasMinBookingNotice: zd,
  nylasMinCancellationNotice: Hd,
  nylasPageName: jd,
  nylasPageStyling: qd,
  nylasParticipantBookingCalendars: Yd,
  nylasParticipantCustomAvailability: Vd,
  nylasReminderEmails: Gd,
  nylasSchedulingMethod: Wd,
  nylasTimeslotInterval: Kd,
  nylasEventTimeslot: Zd,
  nylasEventCapacity: Jd,
  nylasSelectEventType: Qd,
  pageSettingsButton: Xd,
  nylasEventCalendar: ef
}, A8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: hu,
  rescheduleTitle: mu,
  allDay: pu,
  today: bu,
  spotsLeft: yu,
  search: vu,
  days: Tu,
  time: ku,
  months: Eu,
  multipleOptionsSelected: xu,
  selectAtLeastOneOption: Su,
  nextButton: Cu,
  selectedDayAndYear: wu,
  selectedTime: $u,
  name: Bu,
  namePlaceholder: Pu,
  email: Mu,
  emailPlaceholder: Du,
  guestEmail: Au,
  guestEmailPlaceholder: Lu,
  addGuest: Ou,
  addAnotherGuest: _u,
  backButton: Iu,
  bookNowButton: Ru,
  bookingConfirmed: Nu,
  bookingConfirmedDescription: Fu,
  bookingSent: Uu,
  bookingSentDescription: zu,
  bookingRescheduled: Hu,
  bookingDateAndTimeHeader: ju,
  cancelBookingButton: qu,
  rescheduleBookingButton: Yu,
  rejectBookingButton: Vu,
  confirmBookingButton: Gu,
  bookingPendingTitle: Wu,
  bookingPendingnDescription: Ku,
  confirmedEventCardTitle: Zu,
  confirmedEventCardDescription: Ju,
  cancelBookingTitle: Qu,
  cancelBookingMessage: Xu,
  reasonForCancellation: ec,
  goBackButton: tc,
  bookingCancelledTitle: nc,
  bookingCancelledMessage: ic,
  bookingCancelledMessage_theParticipants: ac,
  closeButton: rc,
  closingButton: oc,
  fieldRequired: sc,
  invalidInputFormat: lc,
  createBookingErrorTitle: uc,
  getAvailabilityErrorTitle: cc,
  cancelBookingErrorTitle: dc,
  rescheduleBookingErrorTitle: fc,
  getUISettingErrorTitle: gc,
  rejectBookingErrorTitle: hc,
  confirmBookingErrorTitle: mc,
  genericErrorTitle: pc,
  schedulingComponentErrorTitle: bc,
  sessionIdRequiredErrorMessage: yc,
  publicConfigErrorMessage: vc,
  invalidTimeslotErrorTitle: Tc,
  invalidTimeslotErrorMessage: kc,
  cancellationErrorTitle: Ec,
  cancellationErrorMessage: xc,
  minimumCancellationErrorMessage: Sc,
  cancelBokingFormError: Cc,
  feedbackFormTitle: wc,
  feedbackFormDescription: $c,
  feedbackMessageLabel: Bc,
  feedbackMessagePlaceholder: Pc,
  feedbackModalCloseButton: Mc,
  feedbackModalSubmitButton: Dc,
  deleteSchedulingPageTitle: Ac,
  deleteSchedulingPageDescription: Lc,
  deleteSchedulingPageConfirmButton: Oc,
  deleteSchedulingPageCancelButton: _c,
  schedulerEditorTitle: Ic,
  allSchedulingPages: Rc,
  createAndManageSchedulingPages: Nc,
  createNewSchedulingPageButtonText: Fc,
  pageTitle: Uc,
  durationTitle: zc,
  loading: Hc,
  required: jc,
  optional: qc,
  loadingPagesDescription: Yc,
  noSchedulingPages: Vc,
  createFirstSchedulingPage: Gc,
  editSchedulingPageButtonText: Wc,
  eventInfoTab: Kc,
  availabilityTab: Zc,
  participantsTab: Jc,
  bookingOptionsTab: Qc,
  returnToCalendarView: Xc,
  bookingFormTab: ed,
  communicationsTab: td,
  pageStylesTab: nd,
  savingButtonText: id,
  saveChangesButtonText: ad,
  createButtonText: rd,
  timePeriod_day: od,
  timePeriod_week: sd,
  timePeriod_month: ld,
  timePeriod_year: ud,
  timeDuration_minute: cd,
  timeDuration_hour: dd,
  eventCommunicationsTitle: fd,
  eventCommunicationsDescription: gd,
  unsavedChangesLabel: hd,
  changesSavedLabel: md,
  fixFormErrors: pd,
  nylasEditorTabs: bd,
  nylasListConfigurations: yd,
  nylasAdditionalParticipants: vd,
  nylasAvailabilityPicker: Td,
  nylasTimeWindowPicker: kd,
  nylasBookingCalendarPicker: Ed,
  nylasBookingConfirmationRedirect: xd,
  nylasBookingConfirmationType: Sd,
  nylasBookingFormConfig: Cd,
  nylasBufferTime: wd,
  nylasCalendarPicker: $d,
  nylasCancellationPolicy: Bd,
  nylasConfirmationEmail: Pd,
  nylasConnectedCalendars: Md,
  nylasCustomBookingFlow: Dd,
  nylasCustomEventSlug: Ad,
  nylasCustomizeBookingSettings: Ld,
  nylasEventDescription: Od,
  nylasEventDuration: _d,
  nylasEventInfo: Id,
  nylasEventLimits: Rd,
  nylasEventLocation: Nd,
  nylasEventTitle: Fd,
  nylasLimitFutureBookings: Ud,
  nylasMinBookingNotice: zd,
  nylasMinCancellationNotice: Hd,
  nylasPageName: jd,
  nylasPageStyling: qd,
  nylasParticipantBookingCalendars: Yd,
  nylasParticipantCustomAvailability: Vd,
  nylasReminderEmails: Gd,
  nylasSchedulingMethod: Wd,
  nylasTimeslotInterval: Kd,
  nylasEventTimeslot: Zd,
  nylasEventCapacity: Jd,
  nylasSelectEventType: Qd,
  pageSettingsButton: Xd,
  nylasEventCalendar: ef,
  default: D8
}), tf = "No has seleccionado ninguna fecha", nf = "Elige otro horario para reprogramar tu reunión", af = "Todo el día", rf = "Hoy", of = "{{count}} plazas libres", sf = "Buscar", lf = {
  sunday: "DOM",
  monday: "LUN",
  tuesday: "MAR",
  wednesday: "MIÉ",
  thursday: "JUE",
  friday: "VIE",
  saturday: "SÁB"
}, uf = {
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos",
  day: "día",
  days: "días",
  week: "semana",
  weeks: "semanas",
  month: "mes",
  months: "meses",
  year: "año",
  years: "años"
}, cf = {
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre"
}, df = "Múltiples opciones seleccionadas", ff = "Por favor, seleccione al menos una opción", gf = "Siguiente", hf = "{{date}}", mf = "{{time}}", pf = "Nombre", bf = "Introduce tu nombre", yf = "Correo electrónico", vf = "Introduce tu correo electrónico", Tf = "Correo electrónico del invitado", kf = "Introduce el correo electrónico del invitado", Ef = "Añadir invitado", xf = "Añadir otro invitado", Sf = "Atrás", Cf = "Reservar ahora", wf = "Reserva confirmada", $f = "Recibirás una confirmación por correo electrónico pronto.", Bf = "Reserva enviada", Pf = "Recibirás un correo electrónico una vez que se confirme la reserva.", Mf = "Reserva reprogramada", Df = "Fecha y hora de la reserva", Af = "Cancelar reserva", Lf = "Reprogramar", Of = "Rechazar reserva", _f = "Confirmar reserva", If = "Reserva pendiente", Rf = "Gestiona tu reserva a continuación. El invitado recibirá un correo electrónico informándole del estado de la solicitud.", Nf = "Tu reserva ha sido confirmada con éxito", Ff = "Se ha enviado un correo de confirmación a", Uf = "¿Cancelar reserva?", zf = "Su horario actual estará disponible para otros.", Hf = "Motivo de la cancelación", jf = "Regresar", qf = "Su reserva ha sido cancelada con éxito", Yf = "Se ha enviado un correo electrónico de cancelación a", Vf = "los participantes", Gf = "Cerrar", Wf = "Cerrando", Kf = "{{field}} es obligatorio.", Zf = "{{field}} tiene un formato no válido.", Jf = "Crear Reserva", Qf = "Obtener Disponibilidad", Xf = "Cancelar Reserva", eg = "Reprogramar Reserva", tg = "Obtener Configuraciones de UI", ng = "Rechazar Reserva", ig = "Confirmar Reserva", ag = "Algo salió mal...", rg = "Error en el componente de programación", og = "'sessionId' es necesario para configuraciones privadas.", sg = "Si se usa una configuración pública, pase una configurationId o una combinación de 'slug' y 'clientId'.", lg = "¡Intervalo de tiempo no válido!", ug = "El intervalo de tiempo seleccionado no es válido", cg = "Error de Cancelación", dg = "Por favor, indique el motivo de la cancelación.", fg = "No puede cancelar la reserva dentro de los {{minCancellationNotice}} minutos del evento", gg = "Error en el formulario de cancelación de la reserva", hg = "Comparta su opinión", mg = "Proporcionarnos su opinión y reportar errores nos ayuda a crear una mejor experiencia para usted.", pg = "Por favor, proporcione una descripción detallada de la función sobre la que está comentando o dónde ha experimentado un problema.", bg = "Proporcione su opinión aquí", yg = "Cancelar", vg = "Enviar", Tg = "¿Eliminar esta página de programación?", kg = "Al confirmar, esta página y sus enlaces de programación conectados serán eliminados y desactivados permanentemente. Esta acción no se puede deshacer.", Eg = "Eliminar página", xg = "Cancelar", Sg = "Editor de programación", Cg = "Todas las páginas de programación", wg = "Crea y gestiona tus páginas de programación.", $g = "Crear nuevo", Bg = "Título de la página", Pg = "Duración", Mg = "Cargando", Dg = "Requerido", Ag = "Opcional", Lg = "Por favor, espera mientras cargamos las páginas de programación", Og = "No se encontraron páginas de programación", _g = "Comienza creando tu primera página de programación", Ig = "Editar", Rg = "Información del evento", Ng = "Disponibilidad", Fg = "Participantes", Ug = "Opciones de reserva", zg = "Volver a la vista de calendario", Hg = "Formulario de reserva", jg = "Comunicaciones", qg = "Estilos de página", Yg = "Guardando", Vg = "Guardar cambios", Gg = "Crear", Wg = "día", Kg = "semana", Zg = "mes", Jg = "año", Qg = "minuto", Xg = "hora", eh = "Comunicaciones del evento", th = "Configura correos electrónicos de confirmación automáticos.", nh = "Cambios no guardados", ih = "Cambios guardados", ah = "Por favor, corrija los errores del formulario.", rh = {
  bookingFormError: "Error en el formulario de reserva: ",
  bookingFormError_label: "Etiqueta requerida para el campo de tipo {{type}}.",
  bookingFormError_option: "Opción vacía detectada dentro de {{label}} de tipo {{type}}."
}, oh = {
  previewButtonText: "Vista previa",
  copyLinkButtonText: "Copiar enlace",
  deleteButtonText: "Eliminar"
}, sh = {
  headerTitle: "Participantes",
  headerSubTitle: "Agregue personas de su equipo u organización para unirse al evento.",
  organizerAsParticipant: "Participante",
  organizer: "Organizador",
  participant: "Participante",
  addParticipant_first: "Agregar un participante",
  addParticipant_next: "Agregar otro participante",
  tooltip: {
    includeOrganizer: "Incluir organizador",
    includeOrganizerDesc: "El organizador (usted) será incluido en la rotación de turnos.",
    excludeOrganizer: "Excluir organizador",
    excludeOrganizerDesc: "El organizador (usted) no será incluido en la rotación de turnos."
  },
  error: "Por favor, agregue al menos un participante"
}, lh = {
  headerTitle: "Horario abierto predeterminado",
  headerSubTitle: "Establezca cuándo está disponible regularmente para reservas de eventos.",
  tooltip: {
    desc: "Esta es la disponibilidad predeterminada para los participantes que no tienen disponibilidad configurada en la pestaña de Participantes."
  },
  selectTimezone: "Seleccionar zona horaria",
  unavailable: "No disponible",
  days: {
    SUN: "DOM",
    MON: "LUN",
    TUE: "MAR",
    WED: "MIÉ",
    THU: "JUE",
    FRI: "VIE",
    SAT: "SÁB"
  }
}, uh = {
  errors: {
    invalid: "Inválido"
  }
}, ch = {
  headerTitle: "Reserva de calendario",
  headerSubTitle: "Seleccione el calendario donde desea agregar reservas de eventos.",
  tooltip: {
    desc: "El calendario se usará para crear eventos."
  },
  selectOptionLabel: "Seleccionar una opción",
  selectCalendarErrorMessage: "Por favor seleccione un calendario"
}, dh = {
  dropdownLabel: "Cuando se confirma una reserva",
  tooltip: {
    desc: "Puede mostrar la página de confirmación predeterminada o redirigir a los usuarios a su propia página de confirmación."
  },
  redirectOption_default: "Mostrar página de confirmación predeterminada",
  redirectOption_custom: "Redirigir a una URL personalizada"
}, fh = {
  dropdownLabel: "Cuando se solicita una reserva",
  tooltip: {
    desc: "Aceptar reservas manualmente le permite revisar y aceptar o rechazar cada solicitud de reserva."
  },
  bookingOption_booking: "Aceptar reservas automáticamente",
  bookingOption_organizerConfirmation: "Aceptar reservas manualmente"
}, gh = {
  headerTitle: "Formulario de reserva",
  headerSubTitle: "Agregue campos personalizados al formulario de reserva.",
  dropdownButtonText: "Agregar nuevo campo",
  addOption: "Agregar una opción",
  allOptionsHeader: "TODAS LAS OPCIONES",
  fieldInTitleError: "Este campo se utiliza en el título del evento y no se puede eliminar.",
  fieldInDescriptionError: "Este campo se utiliza en la descripción del evento y no se puede eliminar.",
  label: "Etiqueta",
  defaultValue: "Valor predeterminado",
  fieldType: {
    text: "Texto corto",
    multi_line_text: "Texto largo",
    email: "Correo electrónico",
    phone_number: "Número de teléfono",
    dropdown: "Desplegable",
    radio_button: "Botón de opción",
    checkbox: "Casilla de verificación",
    date: "Fecha",
    metadata: "Metadatos",
    multi_select: "Selección múltiple"
  },
  fieldLabel: {
    your_name: "Tu nombre",
    your_email: "Tu correo electrónico",
    email: "Correo electrónico adicional",
    phone_number: "Etiqueta de número de teléfono",
    dropdown: "Etiqueta de menú desplegable",
    text: "Etiqueta de texto corto",
    multi_line_text: "Etiqueta de texto largo",
    radio_button: "Etiqueta de botón de opción",
    checkbox: "Etiqueta de casilla de verificación",
    date: "Etiqueta de fecha",
    metadata: "Etiqueta de metadatos",
    multi_select: "Etiqueta de selección múltiple"
  }
}, hh = {
  headerTitle: "Tiempo de buffer",
  headerSubTitle: "Requiere tiempo de buffer vacío antes y después de un evento.",
  tooltip: {
    desc: "El planificador no reserva el tiempo de buffer."
  },
  beforeBufferLabel: "Antes del evento",
  afterBufferLabel: "Después del evento",
  minutesShort: "mins",
  previewHeader: "PREVISUALIZAR"
}, mh = {
  calendarPickerLabel: "Seleccione los calendarios que se verificarán para la disponibilidad",
  selectAtLeastOneCalendar: "Por favor, seleccione al menos un calendario para cada participante."
}, ph = {
  cancellationPolicyLabel: "Mensaje de política de cancelación",
  tooltip: {
    desc: "Los asistentes reciben este mensaje si intentan cancelar el evento. Se les pide que proporcionen una razón para la cancelación."
  }
}, bh = {
  headerTitle: "Reserva confirmada{{organizerName}}",
  headerSubTitle: "Correo de confirmación de reserva",
  editButtonText: "Editar",
  error: {
    invalidImageUrl: "URL de imagen no válida."
  },
  confirmationEmail: {
    label: "Habilitar notificaciones por correo electrónico",
    tooltip: {
      desc: "Permita que Nylas envíe notificaciones por correo electrónico, incluidos mensajes de confirmación y recordatorios de eventos.",
      language: "Esta idioma se usará para las notificaciones por correo electrónico a los organizadores."
    },
    language: "Seleccionar idioma"
  },
  nylasBranding: {
    label: "Mostrar la marca de Nylas",
    tooltip: {
      desc: "Desmarque esta opción para ocultar el pie de página en la comunicación por correo electrónico."
    }
  },
  companyLogoUrl: {
    label: "URL del logo de la empresa",
    tooltip: {
      desc: "Este logo aparece en el correo de confirmación de reserva. La URL debe ser accesible públicamente. La imagen se reducirá a un tamaño máximo de 200px x 100px."
    }
  },
  emailMessage: {
    header: "Mensaje de correo",
    label: "Título personalizado del correo",
    tooltip: {
      desc: "Un título de correo es un encabezado dentro del cuerpo del correo. Esto no cambia la línea de asunto."
    },
    additionalInfoLabel: "Información adicional",
    additionalInfoTooltip: "El planificador agrega el contenido de este cuadro al cuerpo del correo.",
    additionalInfoPlaceholder: "Cuerpo predeterminado"
  },
  allHosts: "Todos los anfitriones e invitados",
  immediatelyUponBooking: "Inmediatamente después de la reserva"
}, yh = {
  headerTitle: "Calendarios conectados",
  headerSubTitle: "Seleccione los calendarios que se utilizarán para verificar su disponibilidad.",
  tooltip: {
    desc: "Verifique la disponibilidad en uno o más calendarios. Si selecciona varios calendarios para un participante, el participante debe estar disponible en todos sus calendarios para considerarse disponible."
  },
  participantCalendarTitle: "Calendarios conectados de {{participantName}}",
  selectAtLeastOneCalendar: "Por favor, seleccione al menos un calendario para cada participante."
}, vh = {
  headerTitle: "Flujo de reserva personalizado"
}, Th = {
  headerTitle: "Slug personalizado de la página",
  headerSubTitle: "Crea un slug de URL personalizado para esta página.",
  eventSlugLabel: "Slug de URL de la página",
  tooltip: {
    desc: "Proporcione un slug personalizado para su URL que identifique de manera única su página (solo letras, números y guiones)."
  },
  copied: "¡Copiado!"
}, kh = {
  headerTitle: "Configuraciones adicionales",
  headerSubTitle: "Configuraciones de reserva para el evento.",
  tooltip: {
    desc: "Personalice sus configuraciones de reserva."
  },
  allowGuests: {
    label: "Permitir que los invitados inviten a otros invitados."
  },
  hideReschedule: {
    label: "Ocultar opción de reprogramación.",
    tooltip: {
      desc: "Ocultar el botón 'Reprogramar' en la confirmación de reserva y las notificaciones por correo electrónico."
    }
  },
  hideCancel: {
    label: "Ocultar opción de cancelación",
    tooltip: {
      desc: "Ocultar el botón 'Cancelar' en la confirmación de reserva y las notificaciones por correo electrónico."
    }
  }
}, Eh = {
  headerTitle: "Descripción del evento",
  addAdditionalFields: {
    buttonText: "Auto-completar campos adicionales",
    tooltip: {
      desc: "Haga clic en esto una vez que haya agregado todos los campos que desea incluir en la descripción. Importante: Por favor, no modifique los marcadores '--- Additional Fields ---' y '--- End Additional Fields ---' para asegurar que todo funcione correctamente."
    }
  },
  tooltip: {
    desc: "La descripción del evento aparece en la vista del administrador del Editor de Programación y en la respuesta cuando se crea una reserva."
  }
}, xh = {
  headerTitle: "Duración del evento",
  error: {
    durationMustBeMultipleOf5: "La duración debe ser un múltiplo de 5",
    durationMustBeGreaterThan0: "La duración debe ser mayor que 0"
  }
}, Sh = {
  headerTitle: "Información del evento"
}, Ch = {
  headerTitle: "Límites del evento"
}, wh = {
  headerTitle: "Ubicación o reunión del evento",
  tooltip: {
    desc: "Seleccione una opción de conferencia o agregue una ubicación personalizada."
  },
  conferenceOptions: {
    none: "Ninguno",
    zoom: "Reunión de Zoom",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Ubicación personalizada"
  }
}, $h = {
  headerTitle: "Título del evento",
  helpText_start: "Crea un evento dinámico con plantilla {{field}} escribiendo",
  helpText_end: "y seleccionando un elemento de plantilla.",
  title: "título",
  description: "descripción",
  tooltip: {
    desc: "Por ejemplo, Entrevista con"
  },
  eventTitleRequired: "El título del evento es obligatorio",
  eventTitleTokenDescription: {
    invitee: "El nombre del invitado principal.",
    inviteeEmail: "La dirección de correo electrónico del invitado principal.",
    duration: "La duración del evento."
  }
}, Bh = {
  headerTitle: "Limitar reservas futuras",
  tooltip: {
    desc: "El límite de cuán lejos en el futuro se pueden hacer las reservas."
  }
}, Ph = {
  headerTitle: "Aviso mínimo de reserva",
  tooltip: {
    desc: "La cantidad mínima de tiempo en el futuro en que se puede realizar una nueva reserva."
  }
}, Mh = {
  headerTitle: "Aviso mínimo de cancelación",
  tooltip: {
    desc: "La cantidad mínima de tiempo requerida para cancelar una reserva."
  }
}, Dh = {
  headerTitle: "Nombre de la página",
  headerSubTitle: "Establezca el nombre de la página de programación.",
  pageNameError: "Por favor, ingrese un nombre de página",
  tooltip: {
    desc: "Por defecto, las páginas de programación utilizan su nombre de usuario como nombre de la página. El nombre de la página se muestra en la esquina superior izquierda de la vista del calendario."
  }
}, Ah = {
  headerTitle: "Estilo y personalización de la página"
}, Lh = {
  headerTitle: "Reservar en este calendario",
  headerSubTitle: "Seleccione el calendario donde desea agregar reservas de eventos.",
  participantBookingCalendarTitle: "Calendarios de reserva de {{participantName}}",
  selectAtLeastOneCalendar: "Por favor, seleccione al menos un calendario para cada participante."
}, Oh = {
  headerTitle: "Horario de apertura del participante",
  headerSubTitle: "Si no se establece, se utilizarán las horas de apertura predeterminadas para calcular la disponibilidad de este participante.",
  participantOpenHoursTitle: "Horario de apertura de {{participantName}}"
}, _h = {
  headerTitle: "Próxima reunión {{organizerName}}",
  headerSubTitle: "Recordatorio antes del evento",
  editButtonText: "Editar",
  recipientOptions_all: "Todos los anfitriones e invitados",
  recipientOptions_guest: "Todos los invitados al evento",
  recipientOptions_host: "Solo el anfitrión del evento",
  beforeTheEvent: "antes del evento",
  emailRecipients: {
    label: "Destinatarios del correo electrónico"
  },
  sendConfirmation: {
    label: "Enviar correo de confirmación cuando",
    tooltip: {
      desc: "Los destinatarios recibirán un correo de recordatorio en el tiempo especificado antes del evento."
    }
  },
  emailSubject: {
    label: "Asunto del correo",
    placeholder: "Próxima reunión {{organizerName}}"
  },
  reminderMinutesValidationError: "Por favor, ingrese los minutos del recordatorio en múltiplos de 5. Intente ",
  newReminderButtonText: "Nuevo recordatorio"
}, Ih = {
  headerTitle: "Método de programación",
  headerSubTitle: "Seleccione un método de programación para el evento.",
  tooltip: {
    standard: {
      label: "Estándar",
      desc: "Permite reservas 1:1 o n:1 con participantes adicionales."
    },
    maxFairness: {
      label: "Rotación - Maximizar equidad",
      desc: "Rota por la lista de participantes que selecciona, mostrando al participante con menos reservas recientes."
    },
    maxAvailability: {
      label: "Rotación - Maximizar disponibilidad",
      desc: "Rota por la lista de participantes que selecciona, priorizando a los participantes con menos reservas recientes, pero haciendo la mayor cantidad de franjas horarias disponibles."
    }
  },
  schedulingMethodOptions_collective: "Reserva estándar",
  schedulingMethodOptions_maxFairness: "Rotación - Máxima equidad",
  schedulingMethodOptions_maxAvailability: "Rotación - Máxima disponibilidad"
}, Rh = {
  minutesShort: "mins",
  lengthOfMeeting: "Duración de la reunión",
  headerTitle: "Configuración de intervalos de tiempo",
  timeslotInterval: {
    label: "Intervalo de tiempo."
  },
  timeslotRounding: {
    label: "Tipo de redondeo de intervalo",
    tooltip: {
      desc: "El intervalo en el que se muestran los intervalos de tiempo."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Redondeo de intervalos",
      desc: "Los intervalos de tiempo comenzarán en horarios redondeados al valor del intervalo."
    },
    noRounding: {
      label: "Predeterminado",
      desc: "Los intervalos de tiempo se redondearán al cuarto de hora más cercano."
    }
  }
}, Nh = {
  recurrenceOptions: {
    none: "No se repite",
    daily: "Diario",
    weekly: "Semanalmente cada {{dayOfWeek}}",
    monthly: "Mensualmente el {{dayOfMonth}}",
    monthOnDay: "Mensualmente el día {{date}}",
    yearly: "Anualmente el {{dateOfMonth}}",
    custom: "Personalizado"
  },
  recurrenceLabel: "Repetir este evento",
  endDate: "Fecha de finalización",
  customRecurrence: {
    repeatEvery: "Repetir cada",
    repeatOn: "Repetir el",
    ends: "Termina",
    endsOptions: {
      never: "Nunca",
      after: "Después",
      on: "En"
    },
    occurrences: "ocurrencias"
  },
  dateTimeLabel: "Fecha y hora",
  errors: {
    invalidTimeRange: "Rango de tiempo inválido",
    startTimeSameAsEndTime: "La hora de inicio y la hora de finalización no pueden ser iguales",
    startTimeBeforeCurrentDate: "La hora de inicio no puede ser en el pasado",
    invalid: "Inválido"
  }
}, Fh = {
  headerTitle: "Invitados",
  headerSubTitle: "Establezca el número máximo de invitados para este intervalo de tiempo del evento.",
  tooltip: {
    desc: "El organizador y los participantes configurados en la página de programación no se cuentan como invitados."
  },
  attendees: "invitados"
}, Uh = {
  returnToAllSchedulingPages: "Volver a todas las páginas de programación",
  createEventHeaderTitle: "Crear un evento",
  eventTypeHeaderTitle: "Tipo de evento",
  noEventTypesEnabled: "No hay tipos de evento habilitados",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Permite reservas 1:1"
    },
    collective: {
      label: "Reserva estándar",
      desc: "Permite reservas n:1 con participantes adicionales"
    },
    maxFairness: {
      label: "Rotación - Maximizar equidad",
      desc: "Rota por la lista de participantes que selecciona, mostrando al participante con menos reservas recientes."
    },
    maxAvailability: {
      label: "Rotación - Maximizar disponibilidad",
      desc: "Rota por la lista de participantes que selecciona, priorizando a los participantes con menos reservas recientes, pero haciendo la mayor cantidad de franjas horarias disponibles."
    },
    group: {
      label: "Evento de grupo / clase",
      desc: "Estos son eventos que generalmente tienen un organizador y varios participantes"
    }
  }
}, zh = "Configuración de la página", Hh = {
  createEventDetails: {
    headerTitle: "Detalles del evento",
    closeButtonTooltip: "Cerrar",
    cancelButton: "Cancelar",
    createButton: "Crear"
  },
  discardChanges: {
    headerTitle: "¿Desea descartar los cambios no guardados?",
    cancelButton: "Cancelar",
    discardButton: "Descartar"
  },
  unsavedChanges: "Cambios no guardados",
  editEventDetails: {
    headerTitle: "Detalles del evento",
    closeButtonTooltip: "Cerrar",
    deleteButton: "Eliminar",
    saveButton: "Guardar",
    pastEventTooltip: "Este evento es pasado y no puede ser editado."
  },
  importEvent: {
    closeButtonTooltip: "Cerrar",
    importButton: "Importar",
    participantsLabel: "Participantes"
  },
  deleteEvent: {
    closeButtonTooltip: "Cerrar",
    deleting: "Eliminando..."
  },
  editOptions: {
    headerTitle: "Acciones",
    closeButtonTooltip: "Cerrar",
    deleting: "Eliminando...",
    import: "Importar",
    edit: "Editar",
    deleteThis: "Eliminar este evento",
    deleteAll: "Eliminar todos los eventos"
  },
  updateOptions: {
    updateThis: "Actualizar este evento",
    updateAll: "Actualizar todos los eventos",
    updateFuture: "Actualizar todos los futuros eventos"
  },
  deleteOptions: {
    deleteThis: "Eliminar",
    deleteFuture: "Eliminar y todos los futuros eventos",
    deleteAll: "Eliminar todos los eventos"
  }
}, L8 = {
  noDateSelected: tf,
  rescheduleTitle: nf,
  allDay: af,
  today: rf,
  spotsLeft: of,
  search: sf,
  days: lf,
  time: uf,
  months: cf,
  multipleOptionsSelected: df,
  selectAtLeastOneOption: ff,
  nextButton: gf,
  selectedDayAndYear: hf,
  selectedTime: mf,
  name: pf,
  namePlaceholder: bf,
  email: yf,
  emailPlaceholder: vf,
  guestEmail: Tf,
  guestEmailPlaceholder: kf,
  addGuest: Ef,
  addAnotherGuest: xf,
  backButton: Sf,
  bookNowButton: Cf,
  bookingConfirmed: wf,
  bookingConfirmedDescription: $f,
  bookingSent: Bf,
  bookingSentDescription: Pf,
  bookingRescheduled: Mf,
  bookingDateAndTimeHeader: Df,
  cancelBookingButton: Af,
  rescheduleBookingButton: Lf,
  rejectBookingButton: Of,
  confirmBookingButton: _f,
  bookingPendingTitle: If,
  bookingPendingnDescription: Rf,
  confirmedEventCardTitle: Nf,
  confirmedEventCardDescription: Ff,
  cancelBookingTitle: Uf,
  cancelBookingMessage: zf,
  reasonForCancellation: Hf,
  goBackButton: jf,
  bookingCancelledTitle: qf,
  bookingCancelledMessage: Yf,
  bookingCancelledMessage_theParticipants: Vf,
  closeButton: Gf,
  closingButton: Wf,
  fieldRequired: Kf,
  invalidInputFormat: Zf,
  createBookingErrorTitle: Jf,
  getAvailabilityErrorTitle: Qf,
  cancelBookingErrorTitle: Xf,
  rescheduleBookingErrorTitle: eg,
  getUISettingErrorTitle: tg,
  rejectBookingErrorTitle: ng,
  confirmBookingErrorTitle: ig,
  genericErrorTitle: ag,
  schedulingComponentErrorTitle: rg,
  sessionIdRequiredErrorMessage: og,
  publicConfigErrorMessage: sg,
  invalidTimeslotErrorTitle: lg,
  invalidTimeslotErrorMessage: ug,
  cancellationErrorTitle: cg,
  cancellationErrorMessage: dg,
  minimumCancellationErrorMessage: fg,
  cancelBokingFormError: gg,
  feedbackFormTitle: hg,
  feedbackFormDescription: mg,
  feedbackMessageLabel: pg,
  feedbackMessagePlaceholder: bg,
  feedbackModalCloseButton: yg,
  feedbackModalSubmitButton: vg,
  deleteSchedulingPageTitle: Tg,
  deleteSchedulingPageDescription: kg,
  deleteSchedulingPageConfirmButton: Eg,
  deleteSchedulingPageCancelButton: xg,
  schedulerEditorTitle: Sg,
  allSchedulingPages: Cg,
  createAndManageSchedulingPages: wg,
  createNewSchedulingPageButtonText: $g,
  pageTitle: Bg,
  durationTitle: Pg,
  loading: Mg,
  required: Dg,
  optional: Ag,
  loadingPagesDescription: Lg,
  noSchedulingPages: Og,
  createFirstSchedulingPage: _g,
  editSchedulingPageButtonText: Ig,
  eventInfoTab: Rg,
  availabilityTab: Ng,
  participantsTab: Fg,
  bookingOptionsTab: Ug,
  returnToCalendarView: zg,
  bookingFormTab: Hg,
  communicationsTab: jg,
  pageStylesTab: qg,
  savingButtonText: Yg,
  saveChangesButtonText: Vg,
  createButtonText: Gg,
  timePeriod_day: Wg,
  timePeriod_week: Kg,
  timePeriod_month: Zg,
  timePeriod_year: Jg,
  timeDuration_minute: Qg,
  timeDuration_hour: Xg,
  eventCommunicationsTitle: eh,
  eventCommunicationsDescription: th,
  unsavedChangesLabel: nh,
  changesSavedLabel: ih,
  fixFormErrors: ah,
  nylasEditorTabs: rh,
  nylasListConfigurations: oh,
  nylasAdditionalParticipants: sh,
  nylasAvailabilityPicker: lh,
  nylasTimeWindowPicker: uh,
  nylasBookingCalendarPicker: ch,
  nylasBookingConfirmationRedirect: dh,
  nylasBookingConfirmationType: fh,
  nylasBookingFormConfig: gh,
  nylasBufferTime: hh,
  nylasCalendarPicker: mh,
  nylasCancellationPolicy: ph,
  nylasConfirmationEmail: bh,
  nylasConnectedCalendars: yh,
  nylasCustomBookingFlow: vh,
  nylasCustomEventSlug: Th,
  nylasCustomizeBookingSettings: kh,
  nylasEventDescription: Eh,
  nylasEventDuration: xh,
  nylasEventInfo: Sh,
  nylasEventLimits: Ch,
  nylasEventLocation: wh,
  nylasEventTitle: $h,
  nylasLimitFutureBookings: Bh,
  nylasMinBookingNotice: Ph,
  nylasMinCancellationNotice: Mh,
  nylasPageName: Dh,
  nylasPageStyling: Ah,
  nylasParticipantBookingCalendars: Lh,
  nylasParticipantCustomAvailability: Oh,
  nylasReminderEmails: _h,
  nylasSchedulingMethod: Ih,
  nylasTimeslotInterval: Rh,
  nylasEventTimeslot: Nh,
  nylasEventCapacity: Fh,
  nylasSelectEventType: Uh,
  pageSettingsButton: zh,
  nylasEventCalendar: Hh
}, O8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: tf,
  rescheduleTitle: nf,
  allDay: af,
  today: rf,
  spotsLeft: of,
  search: sf,
  days: lf,
  time: uf,
  months: cf,
  multipleOptionsSelected: df,
  selectAtLeastOneOption: ff,
  nextButton: gf,
  selectedDayAndYear: hf,
  selectedTime: mf,
  name: pf,
  namePlaceholder: bf,
  email: yf,
  emailPlaceholder: vf,
  guestEmail: Tf,
  guestEmailPlaceholder: kf,
  addGuest: Ef,
  addAnotherGuest: xf,
  backButton: Sf,
  bookNowButton: Cf,
  bookingConfirmed: wf,
  bookingConfirmedDescription: $f,
  bookingSent: Bf,
  bookingSentDescription: Pf,
  bookingRescheduled: Mf,
  bookingDateAndTimeHeader: Df,
  cancelBookingButton: Af,
  rescheduleBookingButton: Lf,
  rejectBookingButton: Of,
  confirmBookingButton: _f,
  bookingPendingTitle: If,
  bookingPendingnDescription: Rf,
  confirmedEventCardTitle: Nf,
  confirmedEventCardDescription: Ff,
  cancelBookingTitle: Uf,
  cancelBookingMessage: zf,
  reasonForCancellation: Hf,
  goBackButton: jf,
  bookingCancelledTitle: qf,
  bookingCancelledMessage: Yf,
  bookingCancelledMessage_theParticipants: Vf,
  closeButton: Gf,
  closingButton: Wf,
  fieldRequired: Kf,
  invalidInputFormat: Zf,
  createBookingErrorTitle: Jf,
  getAvailabilityErrorTitle: Qf,
  cancelBookingErrorTitle: Xf,
  rescheduleBookingErrorTitle: eg,
  getUISettingErrorTitle: tg,
  rejectBookingErrorTitle: ng,
  confirmBookingErrorTitle: ig,
  genericErrorTitle: ag,
  schedulingComponentErrorTitle: rg,
  sessionIdRequiredErrorMessage: og,
  publicConfigErrorMessage: sg,
  invalidTimeslotErrorTitle: lg,
  invalidTimeslotErrorMessage: ug,
  cancellationErrorTitle: cg,
  cancellationErrorMessage: dg,
  minimumCancellationErrorMessage: fg,
  cancelBokingFormError: gg,
  feedbackFormTitle: hg,
  feedbackFormDescription: mg,
  feedbackMessageLabel: pg,
  feedbackMessagePlaceholder: bg,
  feedbackModalCloseButton: yg,
  feedbackModalSubmitButton: vg,
  deleteSchedulingPageTitle: Tg,
  deleteSchedulingPageDescription: kg,
  deleteSchedulingPageConfirmButton: Eg,
  deleteSchedulingPageCancelButton: xg,
  schedulerEditorTitle: Sg,
  allSchedulingPages: Cg,
  createAndManageSchedulingPages: wg,
  createNewSchedulingPageButtonText: $g,
  pageTitle: Bg,
  durationTitle: Pg,
  loading: Mg,
  required: Dg,
  optional: Ag,
  loadingPagesDescription: Lg,
  noSchedulingPages: Og,
  createFirstSchedulingPage: _g,
  editSchedulingPageButtonText: Ig,
  eventInfoTab: Rg,
  availabilityTab: Ng,
  participantsTab: Fg,
  bookingOptionsTab: Ug,
  returnToCalendarView: zg,
  bookingFormTab: Hg,
  communicationsTab: jg,
  pageStylesTab: qg,
  savingButtonText: Yg,
  saveChangesButtonText: Vg,
  createButtonText: Gg,
  timePeriod_day: Wg,
  timePeriod_week: Kg,
  timePeriod_month: Zg,
  timePeriod_year: Jg,
  timeDuration_minute: Qg,
  timeDuration_hour: Xg,
  eventCommunicationsTitle: eh,
  eventCommunicationsDescription: th,
  unsavedChangesLabel: nh,
  changesSavedLabel: ih,
  fixFormErrors: ah,
  nylasEditorTabs: rh,
  nylasListConfigurations: oh,
  nylasAdditionalParticipants: sh,
  nylasAvailabilityPicker: lh,
  nylasTimeWindowPicker: uh,
  nylasBookingCalendarPicker: ch,
  nylasBookingConfirmationRedirect: dh,
  nylasBookingConfirmationType: fh,
  nylasBookingFormConfig: gh,
  nylasBufferTime: hh,
  nylasCalendarPicker: mh,
  nylasCancellationPolicy: ph,
  nylasConfirmationEmail: bh,
  nylasConnectedCalendars: yh,
  nylasCustomBookingFlow: vh,
  nylasCustomEventSlug: Th,
  nylasCustomizeBookingSettings: kh,
  nylasEventDescription: Eh,
  nylasEventDuration: xh,
  nylasEventInfo: Sh,
  nylasEventLimits: Ch,
  nylasEventLocation: wh,
  nylasEventTitle: $h,
  nylasLimitFutureBookings: Bh,
  nylasMinBookingNotice: Ph,
  nylasMinCancellationNotice: Mh,
  nylasPageName: Dh,
  nylasPageStyling: Ah,
  nylasParticipantBookingCalendars: Lh,
  nylasParticipantCustomAvailability: Oh,
  nylasReminderEmails: _h,
  nylasSchedulingMethod: Ih,
  nylasTimeslotInterval: Rh,
  nylasEventTimeslot: Nh,
  nylasEventCapacity: Fh,
  nylasSelectEventType: Uh,
  pageSettingsButton: zh,
  nylasEventCalendar: Hh,
  default: L8
}), jh = "日付が選択されていません", qh = "別の時間を選択してください", Yh = "全天", Vh = "今日", Gh = "{{count}} スポット残り", Wh = "検索", Kh = {
  sunday: "日",
  monday: "月",
  tuesday: "火",
  wednesday: "水",
  thursday: "木",
  friday: "金",
  saturday: "土"
}, Zh = {
  hour: "時間",
  hours: "時間",
  minute: "分",
  minutes: "分",
  day: "日",
  days: "日",
  week: "週",
  weeks: "週",
  month: "月",
  months: "月",
  year: "年",
  years: "年"
}, Jh = {
  january: "1月",
  february: "2月",
  march: "3月",
  april: "4月",
  may: "5月",
  june: "6月",
  july: "7月",
  august: "8月",
  september: "9月",
  october: "10月",
  november: "11月",
  december: "12月"
}, Qh = "複数のオプションが選択されています", Xh = "少なくとも1つのオプションを選択してください", em = "次", tm = "{{date}}", nm = "{{time}}", im = "名前", am = "名前を入力してください", rm = "メールアドレス", om = "メールアドレスを入力してください", sm = "ゲストのメールアドレス", lm = "ゲストのメールアドレスを入力してください", um = "ゲストを追加", cm = "他のゲストを追加", dm = "戻る", fm = "今すぐ予約", gm = "予約が確認されました", hm = "間もなくメールで確認が届きます。", mm = "予約が送信されました", pm = "予約が確認され次第、メールをお送りします。", bm = "予約が再予定されました", ym = "予約の日付と時間", vm = "予約をキャンセル", Tm = "再調整", km = "予約を拒否", Em = "予約を確認", xm = "予約保留中", Sm = "以下で予約を管理します。招待者にはリクエストステータスを知らせるメールが届きます。", Cm = "予約が正常に確認されました", wm = "確認メールが送信されました", $m = "予約をキャンセルしますか？", Bm = "現在の時間枠は他の人に利用可能になります。", Pm = "キャンセルの理由", Mm = "戻る", Dm = "予約が正常にキャンセルされました", Am = "キャンセルメールが送信されました", Lm = "参加者に送信されました", Om = "閉じる", _m = "閉じる", Im = "{{field}} は必須です.", Rm = "{{field}} の形式が無効です.", Nm = "予約作成", Fm = "空き状況を取得", Um = "予約をキャンセル", zm = "予約の再スケジュール", Hm = "UI設定を取得", jm = "予約を拒否", qm = "予約を確認", Ym = "何かがうまくいかなかった...", Vm = "スケジューリングコンポーネントエラー", Gm = "プライベート構成には 'sessionId' が必要です。", Wm = "公開設定を使用する場合は、configurationId または 'slug' と 'clientId' の組み合わせを渡します。", Km = "無効な時間帯！", Zm = "選択された時間帯は無効です", Jm = "キャンセルエラー", Qm = "キャンセルの理由を入力してください。", Xm = "イベントの{{minCancellationNotice}}分前には予約をキャンセルできません", ep = "予約キャンセルフォームエラー", tp = "フィードバックを共有する", np = "フィードバックを提供し、エラーを報告することで、より良い体験を提供するためのサポートになります。", ip = "コメントしている機能や問題が発生した箇所の詳細な説明をお願いします。", ap = "ここにフィードバックを記入してください", rp = "キャンセル", op = "送信", sp = "このスケジューリングページを削除しますか？", lp = "確認すると、このページと接続されているスケジュールリンクは完全に削除および無効化されます。この操作は元に戻せません。", up = "ページを削除", cp = "キャンセル", dp = "スケジューラーエディター", fp = "すべてのスケジュールページ", gp = "スケジュールページを作成して管理します。", hp = "新規作成", mp = "ページタイトル", pp = "期間", bp = "読み込み中", yp = "必須", vp = "任意", Tp = "スケジュールページを取得しています。お待ちください。", kp = "スケジュールページが見つかりません", Ep = "最初のスケジュールページを作成して始めましょう", xp = "編集", Sp = "イベント情報", Cp = "利用可能時間", wp = "参加者", $p = "予約オプション", Bp = "カレンダーに戻る", Pp = "予約フォーム", Mp = "通信", Dp = "ページスタイル", Ap = "保存中", Lp = "変更を保存", Op = "作成", _p = "日", Ip = "週", Rp = "月", Np = "年", Fp = "分", Up = "時間", zp = "イベント通信", Hp = "自動確認メールを設定します。", jp = "未保存の変更", qp = "変更が保存されました", Yp = "フォームエラーを修正してください。", Vp = {
  bookingFormError: "予約フォームエラー：",
  bookingFormError_label: "{{type}} タイプのフィールドにはラベルが必要です。",
  bookingFormError_option: "{{label}} の {{type}} タイプの空のオプションが検出されました。"
}, Gp = {
  previewButtonText: "プレビュー",
  copyLinkButtonText: "リンクをコピー",
  deleteButtonText: "削除"
}, Wp = {
  headerTitle: "参加者",
  headerSubTitle: "チームや組織のメンバーをイベントに追加します。",
  organizerAsParticipant: "参加者",
  organizer: "主催者",
  participant: "参加者",
  addParticipant_first: "参加者を追加",
  addParticipant_next: "別の参加者を追加",
  tooltip: {
    includeOrganizer: "主催者を含む",
    includeOrganizerDesc: "主催者（あなた）はローテーションに含まれます。",
    excludeOrganizer: "主催者を除外する",
    excludeOrganizerDesc: "主催者（あなた）はローテーションに含まれません。"
  },
  error: "少なくとも1人の参加者を追加してください"
}, Kp = {
  headerTitle: "デフォルトの空き時間",
  headerSubTitle: "イベント予約のための通常の空き時間を設定します。",
  tooltip: {
    desc: "これは、参加者タブで空き時間が設定されていない参加者のデフォルトの可用性です。"
  },
  selectTimezone: "タイムゾーンを選択",
  unavailable: "利用不可",
  days: {
    SUN: "日",
    MON: "月",
    TUE: "火",
    WED: "水",
    THU: "木",
    FRI: "金",
    SAT: "土"
  }
}, Zp = {
  errors: {
    invalid: "無効"
  }
}, Jp = {
  headerTitle: "カレンダー予約",
  headerSubTitle: "イベント予約を追加するカレンダーを選択します。",
  tooltip: {
    desc: "カレンダーはイベントを作成するために使用されます。"
  },
  selectOptionLabel: "オプションを選択",
  selectCalendarErrorMessage: "カレンダーを選択してください"
}, Qp = {
  dropdownLabel: "予約が確定した場合",
  tooltip: {
    desc: "デフォルトの確認ページを表示するか、独自の確認ページにリダイレクトできます。"
  },
  redirectOption_default: "デフォルトの確認ページを表示",
  redirectOption_custom: "カスタムURLにリダイレクト"
}, Xp = {
  dropdownLabel: "予約がリクエストされた場合",
  tooltip: {
    desc: "手動で予約を承認すると、各予約リクエストを確認して承認または拒否できます。"
  },
  bookingOption_booking: "予約を自動的に承認",
  bookingOption_organizerConfirmation: "予約を手動で承認"
}, e0 = {
  headerTitle: "予約フォーム",
  headerSubTitle: "予約フォームにカスタムフィールドを追加します。",
  dropdownButtonText: "新しいフィールドを追加",
  addOption: "オプションを追加",
  allOptionsHeader: "すべてのオプション",
  fieldInTitleError: "このフィールドはイベントのタイトルで使用されているため、削除できません。",
  fieldInDescriptionError: "このフィールドはイベントの説明で使用されているため、削除できません。",
  label: "ラベル",
  defaultValue: "デフォルト値",
  fieldType: {
    text: "短いテキスト",
    multi_line_text: "長いテキスト",
    email: "メール",
    phone_number: "電話番号",
    dropdown: "ドロップダウン",
    radio_button: "ラジオボタン",
    checkbox: "チェックボックス",
    date: "日付",
    metadata: "メタデータ",
    multi_select: "マルチセレクト"
  },
  fieldLabel: {
    your_name: "あなたの名前",
    your_email: "あなたのメール",
    email: "追加のメール",
    phone_number: "電話番号ラベル",
    dropdown: "ドロップダウンラベル",
    text: "短いテキストラベル",
    multi_line_text: "長いテキストラベル",
    radio_button: "ラジオボタンラベル",
    checkbox: "チェックボックスラベル",
    date: "日付ラベル",
    metadata: "メタデータラベル",
    multi_select: "マルチセレクトラベル"
  }
}, t0 = {
  headerTitle: "バッファ時間",
  headerSubTitle: "イベントの前後に空き時間を確保します。",
  tooltip: {
    desc: "スケジューラーはバッファ時間を予約しません。"
  },
  beforeBufferLabel: "イベントの前",
  afterBufferLabel: "イベントの後",
  minutesShort: "分",
  previewHeader: "プレビュー"
}, n0 = {
  calendarPickerLabel: "可用性を確認するカレンダーを選択",
  selectAtLeastOneCalendar: "少なくとも1つのカレンダーを選択してください。"
}, i0 = {
  cancellationPolicyLabel: "キャンセルポリシーメッセージ",
  tooltip: {
    desc: "イベントをキャンセルしようとした場合、参加者にはこのメッセージが表示されます。キャンセルの理由を提供するよう求められます。"
  }
}, a0 = {
  headerTitle: "予約が確認されました{{organizerName}}",
  headerSubTitle: "予約確認メール",
  editButtonText: "編集",
  error: {
    invalidImageUrl: "無効な画像URLです。"
  },
  confirmationEmail: {
    label: "メール通知を有効にする",
    tooltip: {
      desc: "Nylasが確認メッセージやイベントリマインダーを含むメール通知を送信できるようにします。",
      language: "この言語は、主催者に対するメール通知に使用されます。"
    },
    language: "言語を選択"
  },
  nylasBranding: {
    label: "Nylasのブランディングを表示",
    tooltip: {
      desc: "メールのフッターを非表示にするには、このチェックを外してください。"
    }
  },
  companyLogoUrl: {
    label: "会社ロゴURL",
    tooltip: {
      desc: "このロゴは予約確認メールに表示されます。URLは公開可能である必要があります。画像は最大サイズ200px x 100pxに縮小されます。"
    }
  },
  emailMessage: {
    header: "メールメッセージ",
    label: "カスタムメールタイトル",
    tooltip: {
      desc: "メールタイトルは、メール本文内の見出しです。これは件名を変更しません。"
    },
    additionalInfoLabel: "追加情報",
    additionalInfoTooltip: "スケジューラーは、このボックスの内容をメール本文に追加します。",
    additionalInfoPlaceholder: "デフォルト本文"
  },
  allHosts: "すべてのホストとゲスト",
  immediatelyUponBooking: "予約後すぐに"
}, r0 = {
  headerTitle: "接続されたカレンダー",
  headerSubTitle: "利用可能性を確認するために使用するカレンダーを選択します。",
  tooltip: {
    desc: "1つ以上のカレンダーで利用可能性を確認します。参加者に複数のカレンダーを選択した場合、すべてのカレンダーで利用可能である必要があります。"
  },
  participantCalendarTitle: "{{participantName}}の接続されたカレンダー",
  selectAtLeastOneCalendar: "少なくとも1つのカレンダーを選択してください。"
}, o0 = {
  headerTitle: "カスタム予約フロー"
}, s0 = {
  headerTitle: "カスタムページスラッグ",
  headerSubTitle: "このページのカスタムURLスラッグを作成します。",
  eventSlugLabel: "ページURLスラッグ",
  tooltip: {
    desc: "URLにカスタムスラッグを指定して、ページを一意に識別します（文字、数字、ハイフンのみ）。"
  },
  copied: "コピーしました！"
}, l0 = {
  headerTitle: "追加設定",
  headerSubTitle: "イベントの予約設定。",
  tooltip: {
    desc: "予約設定をカスタマイズします。"
  },
  allowGuests: {
    label: "ゲストが追加のゲストを招待することを許可します。"
  },
  hideReschedule: {
    label: "再スケジュールオプションを非表示",
    tooltip: {
      desc: "予約確認とメール通知で「再スケジュール」ボタンを非表示にします。"
    }
  },
  hideCancel: {
    label: "キャンセルオプションを非表示",
    tooltip: {
      desc: "予約確認とメール通知で「キャンセル」ボタンを非表示にします。"
    }
  }
}, u0 = {
  headerTitle: "イベントの説明",
  addAdditionalFields: {
    buttonText: "追加フィールドを自動入力",
    tooltip: {
      desc: "説明に含めたいすべてのフィールドを追加した後、これをクリックしてください。重要：すべてが正しく機能するために、'--- Additional Fields ---'と'--- End Additional Fields ---'のマーカーは変更しないでください。"
    }
  },
  tooltip: {
    desc: "イベントの説明はスケジューラーエディターの管理ビューに表示され、予約が作成されたときのレスポンスペイロードにも含まれます。"
  }
}, c0 = {
  headerTitle: "イベントの期間",
  error: {
    durationMustBeMultipleOf5: "期間は5の倍数でなければなりません",
    durationMustBeGreaterThan0: "期間は0より大きくなければなりません"
  }
}, d0 = {
  headerTitle: "イベント情報"
}, f0 = {
  headerTitle: "イベントの制限"
}, g0 = {
  headerTitle: "イベントの会場または会議",
  tooltip: {
    desc: "会議オプションを選択するか、カスタムロケーションを追加します。"
  },
  conferenceOptions: {
    none: "なし",
    zoom: "Zoomミーティング",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "カスタムの場所"
  }
}, h0 = {
  headerTitle: "イベントタイトル",
  helpText_start: "入力して動的なテンプレートイベント {{field}} を作成します",
  helpText_end: "およびテンプレート項目を選択。",
  title: "タイトル",
  description: "説明",
  tooltip: {
    desc: "例: インタビュー（候補者）"
  },
  eventTitleRequired: "イベントタイトルは必須です",
  eventTitleTokenDescription: {
    invitee: "主催者の名前",
    inviteeEmail: "主催者のメールアドレス",
    duration: "イベントの長さ"
  }
}, m0 = {
  headerTitle: "今後の予約を制限する",
  tooltip: {
    desc: "予約を未来にどれだけ作成できるかの制限です。"
  }
}, p0 = {
  headerTitle: "最小予約通知",
  tooltip: {
    desc: "新しい予約を行うために必要な、未来にある最小の時間猶予です。"
  }
}, b0 = {
  headerTitle: "最小キャンセル通知",
  tooltip: {
    desc: "予約をキャンセルするために必要な最小の時間です。"
  }
}, y0 = {
  headerTitle: "ページ名",
  headerSubTitle: "スケジュールページの名前を設定してください。",
  pageNameError: "ページ名を入力してください",
  tooltip: {
    desc: "デフォルトでは、スケジュールページはあなたのユーザー名をページ名として使用します。ページ名はカレンダー表示の左上に表示されます。"
  }
}, v0 = {
  headerTitle: "ページのスタイリングとカスタマイズ"
}, T0 = {
  headerTitle: "このカレンダーへの予約",
  headerSubTitle: "イベントの予約を追加するカレンダーを選択してください。",
  participantBookingCalendarTitle: "{{participantName}} の予約カレンダー",
  selectAtLeastOneCalendar: "少なくとも1つのカレンダーを選択してください。"
}, k0 = {
  headerTitle: "参加者の利用可能時間",
  headerSubTitle: "設定されていない場合、標準の営業時間が参加者の利用可能時間を計算するために使用されます。",
  participantOpenHoursTitle: "{{participantName}} の営業時間"
}, E0 = {
  headerTitle: "今後の会議 {{organizerName}}",
  headerSubTitle: "イベント前のリマインダー",
  editButtonText: "編集",
  recipientOptions_all: "すべてのホストとゲスト",
  recipientOptions_guest: "イベントのすべてのゲスト",
  recipientOptions_host: "イベントホストのみ",
  beforeTheEvent: "イベント前",
  emailRecipients: {
    label: "メール受信者"
  },
  sendConfirmation: {
    label: "以下の場合に確認メールを送信",
    tooltip: {
      desc: "受信者は、指定されたイベント前の時刻にリマインダーメールを受け取ります。"
    }
  },
  emailSubject: {
    label: "メールの件名",
    placeholder: "今後の会議 {{organizerName}}"
  },
  reminderMinutesValidationError: "リマインダーの分数を5の倍数で入力してください。試してください: ",
  newReminderButtonText: "新しいリマインダー"
}, x0 = {
  headerTitle: "スケジューリング方法",
  headerSubTitle: "イベントのスケジューリング方法を選択してください。",
  tooltip: {
    standard: {
      label: "標準",
      desc: "1対1の予約または追加参加者を含むn対1の予約を許可します。"
    },
    maxFairness: {
      label: "ラウンドロビン - 最大の公平性",
      desc: "選択された参加者のリストを順に処理し、直近の予約が最も少ない参加者を表示します。"
    },
    maxAvailability: {
      label: "ラウンドロビン - 最大の利用可能性",
      desc: "選択された参加者のリストを順に処理し、予約が最も少ない参加者を優先しながら、できるだけ多くの時間枠を利用可能にします。"
    }
  },
  schedulingMethodOptions_collective: "標準予約",
  schedulingMethodOptions_maxFairness: "ラウンドロビン - 最大の公平性",
  schedulingMethodOptions_maxAvailability: "ラウンドロビン - 最大の利用可能性"
}, S0 = {
  minutesShort: "分",
  lengthOfMeeting: "会議の長さ",
  headerTitle: "時間枠設定",
  timeslotInterval: {
    label: "時間枠の間隔。"
  },
  timeslotRounding: {
    label: "時間枠の丸めタイプ",
    tooltip: {
      desc: "時間枠が表示される間隔。"
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "間隔の丸め",
      desc: "時間枠は間隔値に丸められた時刻から始まります。"
    },
    noRounding: {
      label: "デフォルト",
      desc: "時間枠は最も近い15分単位に丸められます。"
    }
  }
}, C0 = {
  recurrenceOptions: {
    none: "繰り返しません",
    daily: "毎日",
    weekly: "{{dayOfWeek}}ごとに毎週",
    monthly: "毎月{{dayOfMonth}}",
    monthOnDay: "毎月{{date}}の日",
    yearly: "毎年{{dateOfMonth}}",
    custom: "カスタム"
  },
  recurrenceLabel: "このイベントを繰り返す",
  endDate: "終了日",
  customRecurrence: {
    repeatEvery: "毎回繰り返す",
    repeatOn: "繰り返す日",
    ends: "終了",
    endsOptions: {
      never: "終了しない",
      after: "後",
      on: "終了日"
    },
    occurrences: "回数"
  },
  dateTimeLabel: "日時",
  errors: {
    invalidTimeRange: "時間範囲が無効です",
    startTimeSameAsEndTime: "開始時間と終了時間は同じにできません",
    startTimeBeforeCurrentDate: "開始時間は過去にできません",
    invalid: "無効"
  }
}, w0 = {
  headerTitle: "招待者",
  headerSubTitle: "このイベントのタイムスロットの最大招待者数を設定します。",
  tooltip: {
    desc: "スケジュールページで設定された主催者および参加者は招待者としてカウントされません。"
  },
  attendees: "招待者"
}, $0 = {
  returnToAllSchedulingPages: "すべてのスケジュールページに戻る",
  createEventHeaderTitle: "イベントを作成する",
  eventTypeHeaderTitle: "イベントの種類",
  noEventTypesEnabled: "イベントの種類が有効化されていません",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "1対1の予約を許可します。"
    },
    collective: {
      label: "標準予約",
      desc: "追加の参加者を含むn対1の予約を許可します。"
    },
    maxFairness: {
      label: "ラウンドロビン-最大の公平性",
      desc: "選択された参加者のリストを順に処理し、直近の予約が最も少ない参加者を表示します。"
    },
    maxAvailability: {
      label: "ラウンドロビン-最大の利用可能性",
      desc: "選択された参加者のリストを順に処理し、予約が最も少ない参加者を優先しながら、できるだけ多くの時間枠を利用可能にします。"
    },
    group: {
      label: "グループ/クラス",
      desc: "これらは通常、1つの主催者と複数の参加者を持つイベントです。"
    }
  }
}, B0 = "ページの設定", P0 = {
  createEventDetails: {
    headerTitle: "イベントの詳細",
    closeButtonTooltip: "閉じる",
    cancelButton: "キャンセル",
    createButton: "作成"
  },
  discardChanges: {
    headerTitle: "変更を破棄しますか？",
    cancelButton: "キャンセル",
    discardButton: "破棄"
  },
  unsavedChanges: "未保存の変更",
  editEventDetails: {
    headerTitle: "イベントの詳細",
    closeButtonTooltip: "閉じる",
    deleteButton: "削除",
    saveButton: "保存",
    pastEventTooltip: "このイベントは過去にあり、編集できません。"
  },
  importEvent: {
    closeButtonTooltip: "閉じる",
    importButton: "インポート",
    participantsLabel: "参加者"
  },
  deleteEvent: {
    closeButtonTooltip: "閉じる",
    deleting: "削除中..."
  },
  editOptions: {
    headerTitle: "アクション",
    closeButtonTooltip: "閉じる",
    deleting: "削除中...",
    import: "インポート",
    edit: "編集",
    deleteThis: "このイベントを削除",
    deleteAll: "すべてのイベントを削除"
  },
  updateOptions: {
    updateThis: "このイベントを更新",
    updateAll: "すべてのイベントを更新",
    updateFuture: "すべての将来のイベントを更新"
  },
  deleteOptions: {
    deleteThis: "削除",
    deleteFuture: "このイベントとすべての将来のイベントを削除",
    deleteAll: "すべてのイベントを削除"
  }
}, _8 = {
  noDateSelected: jh,
  rescheduleTitle: qh,
  allDay: Yh,
  today: Vh,
  spotsLeft: Gh,
  search: Wh,
  days: Kh,
  time: Zh,
  months: Jh,
  multipleOptionsSelected: Qh,
  selectAtLeastOneOption: Xh,
  nextButton: em,
  selectedDayAndYear: tm,
  selectedTime: nm,
  name: im,
  namePlaceholder: am,
  email: rm,
  emailPlaceholder: om,
  guestEmail: sm,
  guestEmailPlaceholder: lm,
  addGuest: um,
  addAnotherGuest: cm,
  backButton: dm,
  bookNowButton: fm,
  bookingConfirmed: gm,
  bookingConfirmedDescription: hm,
  bookingSent: mm,
  bookingSentDescription: pm,
  bookingRescheduled: bm,
  bookingDateAndTimeHeader: ym,
  cancelBookingButton: vm,
  rescheduleBookingButton: Tm,
  rejectBookingButton: km,
  confirmBookingButton: Em,
  bookingPendingTitle: xm,
  bookingPendingnDescription: Sm,
  confirmedEventCardTitle: Cm,
  confirmedEventCardDescription: wm,
  cancelBookingTitle: $m,
  cancelBookingMessage: Bm,
  reasonForCancellation: Pm,
  goBackButton: Mm,
  bookingCancelledTitle: Dm,
  bookingCancelledMessage: Am,
  bookingCancelledMessage_theParticipants: Lm,
  closeButton: Om,
  closingButton: _m,
  fieldRequired: Im,
  invalidInputFormat: Rm,
  createBookingErrorTitle: Nm,
  getAvailabilityErrorTitle: Fm,
  cancelBookingErrorTitle: Um,
  rescheduleBookingErrorTitle: zm,
  getUISettingErrorTitle: Hm,
  rejectBookingErrorTitle: jm,
  confirmBookingErrorTitle: qm,
  genericErrorTitle: Ym,
  schedulingComponentErrorTitle: Vm,
  sessionIdRequiredErrorMessage: Gm,
  publicConfigErrorMessage: Wm,
  invalidTimeslotErrorTitle: Km,
  invalidTimeslotErrorMessage: Zm,
  cancellationErrorTitle: Jm,
  cancellationErrorMessage: Qm,
  minimumCancellationErrorMessage: Xm,
  cancelBokingFormError: ep,
  feedbackFormTitle: tp,
  feedbackFormDescription: np,
  feedbackMessageLabel: ip,
  feedbackMessagePlaceholder: ap,
  feedbackModalCloseButton: rp,
  feedbackModalSubmitButton: op,
  deleteSchedulingPageTitle: sp,
  deleteSchedulingPageDescription: lp,
  deleteSchedulingPageConfirmButton: up,
  deleteSchedulingPageCancelButton: cp,
  schedulerEditorTitle: dp,
  allSchedulingPages: fp,
  createAndManageSchedulingPages: gp,
  createNewSchedulingPageButtonText: hp,
  pageTitle: mp,
  durationTitle: pp,
  loading: bp,
  required: yp,
  optional: vp,
  loadingPagesDescription: Tp,
  noSchedulingPages: kp,
  createFirstSchedulingPage: Ep,
  editSchedulingPageButtonText: xp,
  eventInfoTab: Sp,
  availabilityTab: Cp,
  participantsTab: wp,
  bookingOptionsTab: $p,
  returnToCalendarView: Bp,
  bookingFormTab: Pp,
  communicationsTab: Mp,
  pageStylesTab: Dp,
  savingButtonText: Ap,
  saveChangesButtonText: Lp,
  createButtonText: Op,
  timePeriod_day: _p,
  timePeriod_week: Ip,
  timePeriod_month: Rp,
  timePeriod_year: Np,
  timeDuration_minute: Fp,
  timeDuration_hour: Up,
  eventCommunicationsTitle: zp,
  eventCommunicationsDescription: Hp,
  unsavedChangesLabel: jp,
  changesSavedLabel: qp,
  fixFormErrors: Yp,
  nylasEditorTabs: Vp,
  nylasListConfigurations: Gp,
  nylasAdditionalParticipants: Wp,
  nylasAvailabilityPicker: Kp,
  nylasTimeWindowPicker: Zp,
  nylasBookingCalendarPicker: Jp,
  nylasBookingConfirmationRedirect: Qp,
  nylasBookingConfirmationType: Xp,
  nylasBookingFormConfig: e0,
  nylasBufferTime: t0,
  nylasCalendarPicker: n0,
  nylasCancellationPolicy: i0,
  nylasConfirmationEmail: a0,
  nylasConnectedCalendars: r0,
  nylasCustomBookingFlow: o0,
  nylasCustomEventSlug: s0,
  nylasCustomizeBookingSettings: l0,
  nylasEventDescription: u0,
  nylasEventDuration: c0,
  nylasEventInfo: d0,
  nylasEventLimits: f0,
  nylasEventLocation: g0,
  nylasEventTitle: h0,
  nylasLimitFutureBookings: m0,
  nylasMinBookingNotice: p0,
  nylasMinCancellationNotice: b0,
  nylasPageName: y0,
  nylasPageStyling: v0,
  nylasParticipantBookingCalendars: T0,
  nylasParticipantCustomAvailability: k0,
  nylasReminderEmails: E0,
  nylasSchedulingMethod: x0,
  nylasTimeslotInterval: S0,
  nylasEventTimeslot: C0,
  nylasEventCapacity: w0,
  nylasSelectEventType: $0,
  pageSettingsButton: B0,
  nylasEventCalendar: P0
}, I8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: jh,
  rescheduleTitle: qh,
  allDay: Yh,
  today: Vh,
  spotsLeft: Gh,
  search: Wh,
  days: Kh,
  time: Zh,
  months: Jh,
  multipleOptionsSelected: Qh,
  selectAtLeastOneOption: Xh,
  nextButton: em,
  selectedDayAndYear: tm,
  selectedTime: nm,
  name: im,
  namePlaceholder: am,
  email: rm,
  emailPlaceholder: om,
  guestEmail: sm,
  guestEmailPlaceholder: lm,
  addGuest: um,
  addAnotherGuest: cm,
  backButton: dm,
  bookNowButton: fm,
  bookingConfirmed: gm,
  bookingConfirmedDescription: hm,
  bookingSent: mm,
  bookingSentDescription: pm,
  bookingRescheduled: bm,
  bookingDateAndTimeHeader: ym,
  cancelBookingButton: vm,
  rescheduleBookingButton: Tm,
  rejectBookingButton: km,
  confirmBookingButton: Em,
  bookingPendingTitle: xm,
  bookingPendingnDescription: Sm,
  confirmedEventCardTitle: Cm,
  confirmedEventCardDescription: wm,
  cancelBookingTitle: $m,
  cancelBookingMessage: Bm,
  reasonForCancellation: Pm,
  goBackButton: Mm,
  bookingCancelledTitle: Dm,
  bookingCancelledMessage: Am,
  bookingCancelledMessage_theParticipants: Lm,
  closeButton: Om,
  closingButton: _m,
  fieldRequired: Im,
  invalidInputFormat: Rm,
  createBookingErrorTitle: Nm,
  getAvailabilityErrorTitle: Fm,
  cancelBookingErrorTitle: Um,
  rescheduleBookingErrorTitle: zm,
  getUISettingErrorTitle: Hm,
  rejectBookingErrorTitle: jm,
  confirmBookingErrorTitle: qm,
  genericErrorTitle: Ym,
  schedulingComponentErrorTitle: Vm,
  sessionIdRequiredErrorMessage: Gm,
  publicConfigErrorMessage: Wm,
  invalidTimeslotErrorTitle: Km,
  invalidTimeslotErrorMessage: Zm,
  cancellationErrorTitle: Jm,
  cancellationErrorMessage: Qm,
  minimumCancellationErrorMessage: Xm,
  cancelBokingFormError: ep,
  feedbackFormTitle: tp,
  feedbackFormDescription: np,
  feedbackMessageLabel: ip,
  feedbackMessagePlaceholder: ap,
  feedbackModalCloseButton: rp,
  feedbackModalSubmitButton: op,
  deleteSchedulingPageTitle: sp,
  deleteSchedulingPageDescription: lp,
  deleteSchedulingPageConfirmButton: up,
  deleteSchedulingPageCancelButton: cp,
  schedulerEditorTitle: dp,
  allSchedulingPages: fp,
  createAndManageSchedulingPages: gp,
  createNewSchedulingPageButtonText: hp,
  pageTitle: mp,
  durationTitle: pp,
  loading: bp,
  required: yp,
  optional: vp,
  loadingPagesDescription: Tp,
  noSchedulingPages: kp,
  createFirstSchedulingPage: Ep,
  editSchedulingPageButtonText: xp,
  eventInfoTab: Sp,
  availabilityTab: Cp,
  participantsTab: wp,
  bookingOptionsTab: $p,
  returnToCalendarView: Bp,
  bookingFormTab: Pp,
  communicationsTab: Mp,
  pageStylesTab: Dp,
  savingButtonText: Ap,
  saveChangesButtonText: Lp,
  createButtonText: Op,
  timePeriod_day: _p,
  timePeriod_week: Ip,
  timePeriod_month: Rp,
  timePeriod_year: Np,
  timeDuration_minute: Fp,
  timeDuration_hour: Up,
  eventCommunicationsTitle: zp,
  eventCommunicationsDescription: Hp,
  unsavedChangesLabel: jp,
  changesSavedLabel: qp,
  fixFormErrors: Yp,
  nylasEditorTabs: Vp,
  nylasListConfigurations: Gp,
  nylasAdditionalParticipants: Wp,
  nylasAvailabilityPicker: Kp,
  nylasTimeWindowPicker: Zp,
  nylasBookingCalendarPicker: Jp,
  nylasBookingConfirmationRedirect: Qp,
  nylasBookingConfirmationType: Xp,
  nylasBookingFormConfig: e0,
  nylasBufferTime: t0,
  nylasCalendarPicker: n0,
  nylasCancellationPolicy: i0,
  nylasConfirmationEmail: a0,
  nylasConnectedCalendars: r0,
  nylasCustomBookingFlow: o0,
  nylasCustomEventSlug: s0,
  nylasCustomizeBookingSettings: l0,
  nylasEventDescription: u0,
  nylasEventDuration: c0,
  nylasEventInfo: d0,
  nylasEventLimits: f0,
  nylasEventLocation: g0,
  nylasEventTitle: h0,
  nylasLimitFutureBookings: m0,
  nylasMinBookingNotice: p0,
  nylasMinCancellationNotice: b0,
  nylasPageName: y0,
  nylasPageStyling: v0,
  nylasParticipantBookingCalendars: T0,
  nylasParticipantCustomAvailability: k0,
  nylasReminderEmails: E0,
  nylasSchedulingMethod: x0,
  nylasTimeslotInterval: S0,
  nylasEventTimeslot: C0,
  nylasEventCapacity: w0,
  nylasSelectEventType: $0,
  pageSettingsButton: B0,
  nylasEventCalendar: P0,
  default: _8
}), M0 = "Kein Datum ausgewählt", D0 = "Wählen Sie einen anderen Zeitpunkt, um Ihr Meeting neu zu planen", A0 = "Ganzer Tag", L0 = "Heute", O0 = "{{count}} Plätze frei", _0 = "Suchen", I0 = {
  sunday: "SO",
  monday: "MO",
  tuesday: "DI",
  wednesday: "MI",
  thursday: "DO",
  friday: "FR",
  saturday: "SA"
}, R0 = {
  hour: "Stunde",
  hours: "Stunden",
  minute: "Minute",
  minutes: "Minuten",
  day: "Tag",
  days: "Tage",
  week: "Woche",
  weeks: "Wochen",
  month: "Monat",
  months: "Monate",
  year: "Jahr",
  years: "Jahre"
}, N0 = {
  january: "Januar",
  february: "Februar",
  march: "März",
  april: "April",
  may: "Mai",
  june: "Juni",
  july: "Juli",
  august: "August",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "Dezember"
}, F0 = "Mehrere Optionen ausgewählt", U0 = "Bitte wählen Sie mindestens eine Option", z0 = "Weiter", H0 = "{{date}}", j0 = "{{time}}", q0 = "Name", Y0 = "Geben Sie Ihren Namen ein", V0 = "E-Mail", G0 = "Geben Sie Ihre E-Mail-Adresse ein", W0 = "Gast E-Mail", K0 = "Geben Sie die E-Mail-Adresse des Gastes ein", Z0 = "Gast hinzufügen", J0 = "Weiteren Gast hinzufügen", Q0 = "Zurück", X0 = "Jetzt buchen", eb = "Buchung bestätigt", tb = "Sie erhalten in Kürze eine E-Mail-Bestätigung.", nb = "Buchung gesendet", ib = "Sie erhalten eine E-Mail, sobald die Buchung bestätigt ist.", ab = "Buchung umgebucht", rb = "Buchungsdatum und -zeit", ob = "Buchung stornieren", sb = "Umplanen", lb = "Buchung ablehnen", ub = "Buchung bestätigen", cb = "Buchung ausstehend", db = "Verwalten Sie Ihre Buchung unten. Der Eingeladene erhält eine E-Mail mit dem Status der Anfrage.", fb = "Ihre Buchung wurde erfolgreich bestätigt", gb = "Eine Bestätigungs-E-Mail wurde gesendet an", hb = "Buchung stornieren?", mb = "Ihr aktueller Zeitraum wird für andere verfügbar.", pb = "Grund für die Stornierung", bb = "Zurück", yb = "Ihre Buchung wurde erfolgreich storniert", vb = "Eine Stornierungs-E-Mail wurde an", Tb = "die Teilnehmer versendet", kb = "Schließen", Eb = "Schließen", xb = "{{field}} ist erforderlich.", Sb = "{{field}} hat ein ungültiges Format.", Cb = "Buchung Erstellen", wb = "Verfügbarkeit Ermitteln", $b = "Buchung Stornieren", Bb = "Buchung Verschieben", Pb = "UI-Einstellungen Abrufen", Mb = "Buchung Ablehnen", Db = "Buchung Bestätigen", Ab = "Etwas ist schief gelaufen...", Lb = "Fehler im Planungskomponent", Ob = "'sessionId' ist für private Konfigurationen erforderlich.", _b = "Bei Verwendung einer öffentlichen Konfiguration geben Sie entweder eine Konfigurations-ID oder eine Kombination aus 'slug' und 'clientId' an.", Ib = "Ungültiges Zeitfenster!", Rb = "Das ausgewählte Zeitfenster ist ungültig", Nb = "Stornierungsfehler", Fb = "Bitte geben Sie einen Grund für die Stornierung an.", Ub = "Sie können die Buchung nicht innerhalb von {{minCancellationNotice}} Minuten vor der Veranstaltung stornieren", zb = "Fehler im Stornierungsformular", Hb = "Teilen Sie Ihr Feedback", jb = "Indem Sie uns Ihr Feedback geben und Fehler melden, helfen Sie uns, eine bessere Erfahrung für Sie zu schaffen.", qb = "Bitte geben Sie uns eine detaillierte Beschreibung der Funktion, über die Sie kommentieren, oder wo Sie ein Problem festgestellt haben.", Yb = "Geben Sie hier Ihr Feedback ein", Vb = "Annuleren", Gb = "Absenden", Wb = "Diese Terminseite löschen?", Kb = "Nach Bestätigung werden diese Seite und die damit verbundenen Terminplanungslinks dauerhaft gelöscht und deaktiviert. Diese Aktion kann nicht rückgängig gemacht werden.", Zb = "Seite löschen", Jb = "Abbrechen", Qb = "Planungseditor", Xb = "Alle Planungsseiten", e1 = "Erstellen und verwalten Sie Ihre Planungsseiten.", t1 = "Neu erstellen", n1 = "Seitentitel", i1 = "Dauer", a1 = "Wird geladen", r1 = "Erforderlich", o1 = "Optional", s1 = "Bitte warten Sie, während wir die Planungsseiten abrufen", l1 = "Keine Planungsseiten gefunden", u1 = "Erstellen Sie Ihre erste Planungsseite", c1 = "Bearbeiten", d1 = "Veranstaltungsinfo", f1 = "Verfügbarkeit", g1 = "Teilnehmer", h1 = "Buchungsoptionen", m1 = "Zurück zur Kalenderansicht", p1 = "Buchungsformular", b1 = "Kommunikationen", y1 = "Seitenstile", v1 = "Speichern", T1 = "Änderungen speichern", k1 = "Erstellen", E1 = "Tag", x1 = "Woche", S1 = "Monat", C1 = "Jahr", w1 = "Minute", $1 = "Stunde", B1 = "Veranstaltungskommunikation", P1 = "Richten Sie automatische Bestätigungs-E-Mails ein.", M1 = "Ungespeicherte Änderungen", D1 = "Änderungen gespeichert", A1 = "Bitte korrigieren Sie die Formularfehler.", L1 = {
  bookingFormError: "Buchungsformularfehler: ",
  bookingFormError_label: "Bezeichnung ist erforderlich für das Feld des Typs {{type}}.",
  bookingFormError_option: "Leere Option innerhalb von {{label}} des Typs {{type}} erkannt."
}, O1 = {
  previewButtonText: "Vorschau",
  copyLinkButtonText: "Link kopieren",
  deleteButtonText: "Löschen"
}, _1 = {
  headerTitle: "Teilnehmer",
  headerSubTitle: "Fügen Sie Personen aus Ihrem Team oder Ihrer Organisation hinzu, um an der Veranstaltung teilzunehmen.",
  organizerAsParticipant: "Teilnehmer",
  organizer: "Organisator",
  participant: "Teilnehmer",
  addParticipant_first: "Einen Teilnehmer hinzufügen",
  addParticipant_next: "Einen weiteren Teilnehmer hinzufügen",
  tooltip: {
    includeOrganizer: "Organisator einschließen",
    includeOrganizerDesc: "Der Organisator (Sie) wird in die Rundlauf-Rotation einbezogen.",
    excludeOrganizer: "Organisator ausschließen",
    excludeOrganizerDesc: "Der Organisator (Sie) wird nicht in die Rundlauf-Rotation einbezogen."
  },
  error: "Bitte fügen Sie mindestens einen Teilnehmer hinzu"
}, I1 = {
  headerTitle: "Standard-Öffnungszeiten",
  headerSubTitle: "Legen Sie fest, wann Sie regelmäßig für Buchungen verfügbar sind.",
  tooltip: {
    desc: "Dies ist die Standardverfügbarkeit für Teilnehmer, die keine Verfügbarkeit auf der Teilnehmer-Registerkarte festgelegt haben."
  },
  selectTimezone: "Zeitzone auswählen",
  unavailable: "Nicht verfügbar",
  days: {
    SUN: "SO",
    MON: "MO",
    TUE: "DI",
    WED: "MI",
    THU: "DO",
    FRI: "FR",
    SAT: "SA"
  }
}, R1 = {
  errors: {
    invalid: "Ungültig"
  }
}, N1 = {
  headerTitle: "Kalenderbuchung",
  headerSubTitle: "Wählen Sie den Kalender aus, in dem Sie Buchungen hinzufügen möchten.",
  tooltip: {
    desc: "Der Kalender wird verwendet, um Ereignisse zu erstellen."
  },
  selectOptionLabel: "Eine Option auswählen",
  selectCalendarErrorMessage: "Bitte wählen Sie einen Kalender"
}, F1 = {
  dropdownLabel: "Wenn eine Buchung bestätigt wird",
  tooltip: {
    desc: "Sie können entweder die Standard-Bestätigungsseite anzeigen oder Benutzer auf Ihre eigene Bestätigungsseite umleiten."
  },
  redirectOption_default: "Standard-Bestätigungsseite anzeigen",
  redirectOption_custom: "Zu einer benutzerdefinierten URL umleiten"
}, U1 = {
  dropdownLabel: "Wenn eine Buchung angefordert wird",
  tooltip: {
    desc: "Das manuelle Akzeptieren von Buchungen ermöglicht es Ihnen, jede Buchungsanfrage zu überprüfen und entweder zu akzeptieren oder abzulehnen."
  },
  bookingOption_booking: "Buchungen automatisch akzeptieren",
  bookingOption_organizerConfirmation: "Buchungen manuell akzeptieren"
}, z1 = {
  headerTitle: "Buchungsformular",
  headerSubTitle: "Fügen Sie benutzerdefinierte Felder zum Buchungsformular hinzu.",
  dropdownButtonText: "Neues Feld hinzufügen",
  addOption: "Option hinzufügen",
  allOptionsHeader: "ALLE OPTIONEN",
  fieldInTitleError: "Dieses Feld wird im Veranstaltungstitel verwendet und kann nicht entfernt werden.",
  fieldInDescriptionError: "Dieses Feld wird in der Veranstaltungsbeschreibung verwendet und kann nicht entfernt werden.",
  label: "Bezeichnung",
  defaultValue: "Standardwert",
  fieldType: {
    text: "Kurzer Text",
    multi_line_text: "Langer Text",
    email: "E-Mail",
    phone_number: "Telefonnummer",
    dropdown: "Auswahlmenü",
    radio_button: "Optionsfeld",
    checkbox: "Kontrollkästchen",
    date: "Datum",
    metadata: "Metadaten",
    multi_select: "Mehrfachauswahl"
  },
  fieldLabel: {
    your_name: "Ihr Name",
    your_email: "Ihre E-Mail",
    email: "Zusätzliche E-Mail",
    phone_number: "Telefonnummernbezeichnung",
    dropdown: "Dropdown-Bezeichnung",
    text: "Kurztextbezeichnung",
    multi_line_text: "Langtextbezeichnung",
    radio_button: "Radiobutton-Beschriftung",
    checkbox: "Checkbox-Beschriftung",
    date: "Datumsbezeichnung",
    metadata: "Metadatenbezeichnung",
    multi_select: "Mehrfachauswahl-Bezeichnung"
  }
}, H1 = {
  headerTitle: "Pufferzeit",
  headerSubTitle: "Erfordert leere Pufferzeit vor und nach einem Ereignis.",
  tooltip: {
    desc: "Der Planer bucht die Pufferzeit nicht."
  },
  beforeBufferLabel: "Vor dem Ereignis",
  afterBufferLabel: "Nach dem Ereignis",
  minutesShort: "Min",
  previewHeader: "VORSCHAU"
}, j1 = {
  calendarPickerLabel: "Wählen Sie die Kalender aus, die auf Verfügbarkeit überprüft werden sollen",
  selectAtLeastOneCalendar: "Bitte wählen Sie mindestens einen Kalender für jeden Teilnehmer."
}, q1 = {
  cancellationPolicyLabel: "Nachricht zur Stornierungsrichtlinie",
  tooltip: {
    desc: "Teilnehmer erhalten diese Nachricht, wenn sie versuchen, das Ereignis abzusagen. Sie werden gebeten, einen Grund für die Stornierung anzugeben."
  }
}, Y1 = {
  headerTitle: "Buchung bestätigt{{organizerName}}",
  headerSubTitle: "Buchungsbestätigungs-E-Mail",
  editButtonText: "Bearbeiten",
  error: {
    invalidImageUrl: "Ungültige Bild-URL."
  },
  confirmationEmail: {
    label: "E-Mail-Benachrichtigungen aktivieren",
    tooltip: {
      desc: "Erlauben Sie Nylas, E-Mail-Benachrichtigungen zu senden, einschließlich Bestätigungsnachrichten und Veranstaltungserinnerungen.",
      language: "Diese Sprache wird für die E-Mail-Benachrichtigungen an die Organisatoren verwendet."
    },
    language: "Sprache auswählen"
  },
  nylasBranding: {
    label: "Nylas-Branding anzeigen",
    tooltip: {
      desc: "Deaktivieren Sie diese Option, um die Fußzeile in der E-Mail-Kommunikation auszublenden."
    }
  },
  companyLogoUrl: {
    label: "Firmenlogo-URL",
    tooltip: {
      desc: "Dieses Logo erscheint in der Buchungsbestätigungs-E-Mail. Die URL muss öffentlich zugänglich sein. Das Bild wird auf eine maximale Größe von 200px x 100px skaliert."
    }
  },
  emailMessage: {
    header: "E-Mail-Nachricht",
    label: "Benutzerdefinierter E-Mail-Titel",
    tooltip: {
      desc: "Ein E-Mail-Titel ist eine Überschrift innerhalb des E-Mail-Textes. Dies ändert nicht die Betreffzeile."
    },
    additionalInfoLabel: "Zusätzliche Informationen",
    additionalInfoTooltip: "Der Planer fügt den Inhalt dieses Felds in den E-Mail-Text ein.",
    additionalInfoPlaceholder: "Standardtext"
  },
  allHosts: "Alle Gastgeber und Gäste",
  immediatelyUponBooking: "Unmittelbar nach der Buchung"
}, V1 = {
  headerTitle: "Verknüpfte Kalender",
  headerSubTitle: "Wählen Sie die Kalender aus, die für die Verfügbarkeitsprüfung verwendet werden sollen.",
  tooltip: {
    desc: "Überprüfen Sie die Verfügbarkeit in einem oder mehreren Kalendern. Wenn Sie mehrere Kalender für einen Teilnehmer auswählen, muss der Teilnehmer in all seinen Kalendern verfügbar sein, um als verfügbar zu gelten."
  },
  participantCalendarTitle: "Verknüpfte Kalender von {{participantName}}",
  selectAtLeastOneCalendar: "Bitte wählen Sie mindestens einen Kalender für jeden Teilnehmer."
}, G1 = {
  headerTitle: "Benutzerdefinierter Buchungsablauf"
}, W1 = {
  headerTitle: "Benutzerdefinierter Seiten-Slug",
  headerSubTitle: "Erstellen Sie einen benutzerdefinierten URL-Slug für diese Seite.",
  eventSlugLabel: "Seiten-URL-Slug",
  tooltip: {
    desc: "Geben Sie einen benutzerdefinierten Slug für Ihre URL an, um Ihre Seite eindeutig zu identifizieren (nur Buchstaben, Zahlen und Bindestriche)."
  },
  copied: "Kopiert!"
}, K1 = {
  headerTitle: "Zusätzliche Einstellungen",
  headerSubTitle: "Buchungseinstellungen für das Ereignis.",
  tooltip: {
    desc: "Passen Sie Ihre Buchungseinstellungen an."
  },
  allowGuests: {
    label: "Gästen erlauben, zusätzliche Gäste einzuladen."
  },
  hideReschedule: {
    label: "Option zur Neuplanung ausblenden.",
    tooltip: {
      desc: "Blenden Sie die Schaltfläche 'Neu planen' in der Buchungsbestätigung und in E-Mail-Benachrichtigungen aus."
    }
  },
  hideCancel: {
    label: "Option zur Stornierung ausblenden",
    tooltip: {
      desc: "Blenden Sie die Schaltfläche 'Stornieren' in der Buchungsbestätigung und in E-Mail-Benachrichtigungen aus."
    }
  }
}, Z1 = {
  headerTitle: "Ereignisbeschreibung",
  addAdditionalFields: {
    buttonText: "Zusätzliche Felder automatisch ausfüllen",
    tooltip: {
      desc: "Klicken Sie hier, nachdem Sie alle Felder hinzugefügt haben, die Sie in die Beschreibung aufnehmen möchten. Wichtig: Bitte lassen Sie die Markierungen '--- Additional Fields ---' und '--- End Additional Fields ---' unverändert, damit alles korrekt funktioniert."
    }
  },
  tooltip: {
    desc: "Die Ereignisbeschreibung erscheint in der Ansicht des Planungseditors und in der Antwort, wenn eine Buchung erstellt wird."
  }
}, J1 = {
  headerTitle: "Ereignisdauer",
  error: {
    durationMustBeMultipleOf5: "Die Dauer muss ein Vielfaches von 5 sein",
    durationMustBeGreaterThan0: "Die Dauer muss größer als 0 sein"
  }
}, Q1 = {
  headerTitle: "Ereignisinformationen"
}, X1 = {
  headerTitle: "Ereignisbeschränkungen"
}, ey = {
  headerTitle: "Veranstaltungsort oder -besprechung",
  tooltip: {
    desc: "Wählen Sie eine Konferenzoption oder fügen Sie einen benutzerdefinierten Standort hinzu."
  },
  conferenceOptions: {
    none: "Keiner",
    zoom: "Zoom-Meeting",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Individueller Standort"
  }
}, ty = {
  headerTitle: "Ereignistitel",
  helpText_start: "Erstellen Sie ein dynamisches, vorlagenbasiertes Ereignis {{field}}, indem Sie eingeben",
  helpText_end: "und ein Vorlagenelement auswählen.",
  title: "Titel",
  description: "Beschreibung",
  tooltip: {
    desc: "Zum Beispiel: Interview mit"
  },
  eventTitleRequired: "Ereignistitel ist erforderlich",
  eventTitleTokenDescription: {
    invitee: "Der Name des Haupteinladungsbenutzers.",
    inviteeEmail: "Die E-Mail-Adresse des Haupteinladungsbenutzers.",
    duration: "Die Dauer des Ereignisses."
  }
}, ny = {
  headerTitle: "Zukünftige Buchungen begrenzen",
  tooltip: {
    desc: "Die Begrenzung, wie weit in die Zukunft Buchungen vorgenommen werden können."
  }
}, iy = {
  headerTitle: "Mindestbuchungsfrist",
  tooltip: {
    desc: "Die minimale Zeit im Voraus, die für eine neue Buchung erforderlich ist."
  }
}, ay = {
  headerTitle: "Mindestkündigungsfrist",
  tooltip: {
    desc: "Die minimale Zeit, die benötigt wird, um eine Buchung zu stornieren."
  }
}, ry = {
  headerTitle: "Seitenname",
  headerSubTitle: "Legen Sie den Namen der Planungsseite fest.",
  pageNameError: "Bitte geben Sie einen Seitennamen ein",
  tooltip: {
    desc: "Standardmäßig verwenden Planungsseiten Ihren Benutzernamen als Seitennamen. Der Seitenname wird oben links in der Kalenderansicht angezeigt."
  }
}, oy = {
  headerTitle: "Seitengestaltung und -anpassung"
}, sy = {
  headerTitle: "In diesem Kalender buchen",
  headerSubTitle: "Wählen Sie den Kalender aus, in dem Sie Veranstaltungsbuchungen hinzufügen möchten.",
  participantBookingCalendarTitle: "{{participantName}}s Buchungskalender",
  selectAtLeastOneCalendar: "Bitte wählen Sie mindestens einen Kalender für jeden Teilnehmer."
}, ly = {
  headerTitle: "Öffnungszeiten des Teilnehmers",
  headerSubTitle: "Wenn nicht festgelegt, werden die Standardöffnungszeiten verwendet, um die Verfügbarkeit dieses Teilnehmers zu berechnen.",
  participantOpenHoursTitle: "{{participantName}}s Öffnungszeiten"
}, uy = {
  headerTitle: "Nächstes Meeting {{organizerName}}",
  headerSubTitle: "Erinnerung vor dem Event",
  editButtonText: "Bearbeiten",
  recipientOptions_all: "Alle Gastgeber und Gäste",
  recipientOptions_guest: "Alle Eventgäste",
  recipientOptions_host: "Nur Event-Gastgeber",
  beforeTheEvent: "vor dem Event",
  emailRecipients: {
    label: "E-Mail-Empfänger"
  },
  sendConfirmation: {
    label: "Bestätigungsmail senden, wenn",
    tooltip: {
      desc: "Die Empfänger erhalten eine Erinnerungsmail zur angegebenen Zeit vor dem Event."
    }
  },
  emailSubject: {
    label: "Betreff der E-Mail",
    placeholder: "Nächstes Meeting {{organizerName}}"
  },
  reminderMinutesValidationError: "Bitte geben Sie die Erinnerungsminuten in Vielfachen von 5 ein. Versuchen Sie es mit ",
  newReminderButtonText: "Neue Erinnerung"
}, cy = {
  headerTitle: "Planungsmethode",
  headerSubTitle: "Wählen Sie eine Planungsmethode für das Event aus.",
  tooltip: {
    standard: {
      label: "Standard",
      desc: "Ermöglicht 1:1-Buchungen oder n:1-Buchungen mit zusätzlichen Teilnehmern."
    },
    maxFairness: {
      label: "Rundlauf - Maximale Fairness",
      desc: "Rotiert durch die Liste der ausgewählten Teilnehmer und zeigt den Teilnehmer mit den wenigsten Buchungen an."
    },
    maxAvailability: {
      label: "Rundlauf - Maximale Verfügbarkeit",
      desc: "Rotiert durch die Liste der ausgewählten Teilnehmer und priorisiert diejenigen mit den wenigsten Buchungen, bietet jedoch so viele Zeitslots wie möglich an."
    }
  },
  schedulingMethodOptions_collective: "Standardbuchung",
  schedulingMethodOptions_maxFairness: "Rundlauf - Maximale Fairness",
  schedulingMethodOptions_maxAvailability: "Rundlauf - Maximale Verfügbarkeit"
}, dy = {
  minutesShort: "Mins",
  lengthOfMeeting: "Dauer Der Buchung",
  headerTitle: "Zeitfenster-Einstellungen",
  timeslotInterval: {
    label: "Zeitfenster-Intervall."
  },
  timeslotRounding: {
    label: "Zeitfenster-Rundungstyp",
    tooltip: {
      desc: "Das Intervall, in dem Zeitfenster angezeigt werden."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Intervall-Rundung",
      desc: "Zeitfenster beginnen zu Zeiten, die auf den Intervallwert gerundet sind."
    },
    noRounding: {
      label: "Standard",
      desc: "Zeitfenster werden auf die nächste Viertelstunde gerundet."
    }
  }
}, fy = {
  recurrenceOptions: {
    none: "Wiederholt sich nicht",
    daily: "Täglich",
    weekly: "Wöchentlich jeden {{dayOfWeek}}",
    monthly: "Monatlich am {{dayOfMonth}}",
    monthOnDay: "Monatlich am Tag {{date}}",
    yearly: "Jährlich am {{dateOfMonth}}",
    custom: "Benutzerdefiniert"
  },
  recurrenceLabel: "Wiederhole dieses Ereignis",
  endDate: "Enddatum",
  customRecurrence: {
    repeatEvery: "Wiederhole alle",
    repeatOn: "Wiederhole am",
    ends: "Endet",
    endsOptions: {
      never: "Nie",
      after: "Nach",
      on: "Am"
    },
    occurrences: "Vorkommen"
  },
  dateTimeLabel: "Datum und Uhrzeit",
  errors: {
    invalidTimeRange: "Ungültige Zeitspanne",
    startTimeSameAsEndTime: "Startzeit und Endzeit können nicht gleich sein",
    startTimeBeforeCurrentDate: "Startzeit kann nicht in der Vergangenheit liegen",
    invalid: "Ungültig"
  }
}, gy = {
  headerTitle: "Teilnehmer",
  headerSubTitle: "Legen Sie die maximale Anzahl von Teilnehmern für diesen Ereignis-Zeitblock fest.",
  tooltip: {
    desc: "Der Organisator und die auf der Planungsseite konfigurierten Teilnehmer werden nicht als Teilnehmer gezählt."
  },
  attendees: "Teilnehmer"
}, hy = {
  returnToAllSchedulingPages: "Zurück zur Planungsseite",
  createEventHeaderTitle: "Ereignis erstellen",
  eventTypeHeaderTitle: "Ereignisart",
  noEventTypesEnabled: "Keine Ereignisarten aktiviert",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Erlaubt 1:1-Buchungen"
    },
    collective: {
      label: "Standardbuchung",
      desc: "Erlaubt n:1-Buchungen mit zusätzlichen Teilnehmern"
    },
    maxFairness: {
      label: "Rundlauf-Rotation - Maximale Fairness",
      desc: "Rotiert durch die Liste der ausgewählten Teilnehmer und zeigt den Teilnehmer mit den wenigsten Buchungen an."
    },
    maxAvailability: {
      label: "Rundlauf-Rotation - Maximale Verfügbarkeit",
      desc: "Rotiert durch die Liste der ausgewählten Teilnehmer und priorisiert diejenigen mit den wenigsten Buchungen, bietet jedoch so viele Zeitslots wie möglich an."
    },
    group: {
      label: "Gruppenbuchung",
      desc: "Diese sind Ereignisse, die in der Regel einen Organisator und mehrere Teilnehmer haben."
    }
  }
}, my = "Seiteneinstellungen", py = {
  createEventDetails: {
    headerTitle: "Ereignisdetails",
    closeButtonTooltip: "Schließen",
    cancelButton: "Abbrechen",
    createButton: "Erstellen"
  },
  discardChanges: {
    headerTitle: "Nicht gespeicherte Änderungen verwerfen?",
    cancelButton: "Abbrechen",
    discardButton: "Entfernen"
  },
  unsavedChanges: "Ungespeicherte Änderungen",
  editEventDetails: {
    headerTitle: "Ereignisdetails",
    closeButtonTooltip: "Schließen",
    deleteButton: "Löschen",
    saveButton: "Speichern",
    pastEventTooltip: "Dieses Ereignis ist in der Vergangenheit und kann nicht bearbeitet werden."
  },
  importEvent: {
    closeButtonTooltip: "Schließen",
    importButton: "Importieren",
    participantsLabel: "Teilnehmer"
  },
  deleteEvent: {
    closeButtonTooltip: "Schließen",
    deleting: "Löschen..."
  },
  editOptions: {
    headerTitle: "Aktionen",
    closeButtonTooltip: "Schließen",
    deleting: "Löschen...",
    import: "Importieren",
    edit: "Bearbeiten",
    deleteThis: "Dieses Ereignis nur löschen",
    deleteAll: "Alle Ereignisse löschen"
  },
  updateOptions: {
    updateThis: "Aktualisieren",
    updateAll: "Alle Ereignisse aktualisieren",
    updateFuture: "Alle zukünftigen Vorkommen aktualisieren"
  },
  deleteOptions: {
    deleteThis: "Löschen",
    deleteFuture: "Löschen und alle zukünftigen Vorkommen",
    deleteAll: "Alle Ereignisse löschen"
  }
}, R8 = {
  noDateSelected: M0,
  rescheduleTitle: D0,
  allDay: A0,
  today: L0,
  spotsLeft: O0,
  search: _0,
  days: I0,
  time: R0,
  months: N0,
  multipleOptionsSelected: F0,
  selectAtLeastOneOption: U0,
  nextButton: z0,
  selectedDayAndYear: H0,
  selectedTime: j0,
  name: q0,
  namePlaceholder: Y0,
  email: V0,
  emailPlaceholder: G0,
  guestEmail: W0,
  guestEmailPlaceholder: K0,
  addGuest: Z0,
  addAnotherGuest: J0,
  backButton: Q0,
  bookNowButton: X0,
  bookingConfirmed: eb,
  bookingConfirmedDescription: tb,
  bookingSent: nb,
  bookingSentDescription: ib,
  bookingRescheduled: ab,
  bookingDateAndTimeHeader: rb,
  cancelBookingButton: ob,
  rescheduleBookingButton: sb,
  rejectBookingButton: lb,
  confirmBookingButton: ub,
  bookingPendingTitle: cb,
  bookingPendingnDescription: db,
  confirmedEventCardTitle: fb,
  confirmedEventCardDescription: gb,
  cancelBookingTitle: hb,
  cancelBookingMessage: mb,
  reasonForCancellation: pb,
  goBackButton: bb,
  bookingCancelledTitle: yb,
  bookingCancelledMessage: vb,
  bookingCancelledMessage_theParticipants: Tb,
  closeButton: kb,
  closingButton: Eb,
  fieldRequired: xb,
  invalidInputFormat: Sb,
  createBookingErrorTitle: Cb,
  getAvailabilityErrorTitle: wb,
  cancelBookingErrorTitle: $b,
  rescheduleBookingErrorTitle: Bb,
  getUISettingErrorTitle: Pb,
  rejectBookingErrorTitle: Mb,
  confirmBookingErrorTitle: Db,
  genericErrorTitle: Ab,
  schedulingComponentErrorTitle: Lb,
  sessionIdRequiredErrorMessage: Ob,
  publicConfigErrorMessage: _b,
  invalidTimeslotErrorTitle: Ib,
  invalidTimeslotErrorMessage: Rb,
  cancellationErrorTitle: Nb,
  cancellationErrorMessage: Fb,
  minimumCancellationErrorMessage: Ub,
  cancelBokingFormError: zb,
  feedbackFormTitle: Hb,
  feedbackFormDescription: jb,
  feedbackMessageLabel: qb,
  feedbackMessagePlaceholder: Yb,
  feedbackModalCloseButton: Vb,
  feedbackModalSubmitButton: Gb,
  deleteSchedulingPageTitle: Wb,
  deleteSchedulingPageDescription: Kb,
  deleteSchedulingPageConfirmButton: Zb,
  deleteSchedulingPageCancelButton: Jb,
  schedulerEditorTitle: Qb,
  allSchedulingPages: Xb,
  createAndManageSchedulingPages: e1,
  createNewSchedulingPageButtonText: t1,
  pageTitle: n1,
  durationTitle: i1,
  loading: a1,
  required: r1,
  optional: o1,
  loadingPagesDescription: s1,
  noSchedulingPages: l1,
  createFirstSchedulingPage: u1,
  editSchedulingPageButtonText: c1,
  eventInfoTab: d1,
  availabilityTab: f1,
  participantsTab: g1,
  bookingOptionsTab: h1,
  returnToCalendarView: m1,
  bookingFormTab: p1,
  communicationsTab: b1,
  pageStylesTab: y1,
  savingButtonText: v1,
  saveChangesButtonText: T1,
  createButtonText: k1,
  timePeriod_day: E1,
  timePeriod_week: x1,
  timePeriod_month: S1,
  timePeriod_year: C1,
  timeDuration_minute: w1,
  timeDuration_hour: $1,
  eventCommunicationsTitle: B1,
  eventCommunicationsDescription: P1,
  unsavedChangesLabel: M1,
  changesSavedLabel: D1,
  fixFormErrors: A1,
  nylasEditorTabs: L1,
  nylasListConfigurations: O1,
  nylasAdditionalParticipants: _1,
  nylasAvailabilityPicker: I1,
  nylasTimeWindowPicker: R1,
  nylasBookingCalendarPicker: N1,
  nylasBookingConfirmationRedirect: F1,
  nylasBookingConfirmationType: U1,
  nylasBookingFormConfig: z1,
  nylasBufferTime: H1,
  nylasCalendarPicker: j1,
  nylasCancellationPolicy: q1,
  nylasConfirmationEmail: Y1,
  nylasConnectedCalendars: V1,
  nylasCustomBookingFlow: G1,
  nylasCustomEventSlug: W1,
  nylasCustomizeBookingSettings: K1,
  nylasEventDescription: Z1,
  nylasEventDuration: J1,
  nylasEventInfo: Q1,
  nylasEventLimits: X1,
  nylasEventLocation: ey,
  nylasEventTitle: ty,
  nylasLimitFutureBookings: ny,
  nylasMinBookingNotice: iy,
  nylasMinCancellationNotice: ay,
  nylasPageName: ry,
  nylasPageStyling: oy,
  nylasParticipantBookingCalendars: sy,
  nylasParticipantCustomAvailability: ly,
  nylasReminderEmails: uy,
  nylasSchedulingMethod: cy,
  nylasTimeslotInterval: dy,
  nylasEventTimeslot: fy,
  nylasEventCapacity: gy,
  nylasSelectEventType: hy,
  pageSettingsButton: my,
  nylasEventCalendar: py
}, N8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: M0,
  rescheduleTitle: D0,
  allDay: A0,
  today: L0,
  spotsLeft: O0,
  search: _0,
  days: I0,
  time: R0,
  months: N0,
  multipleOptionsSelected: F0,
  selectAtLeastOneOption: U0,
  nextButton: z0,
  selectedDayAndYear: H0,
  selectedTime: j0,
  name: q0,
  namePlaceholder: Y0,
  email: V0,
  emailPlaceholder: G0,
  guestEmail: W0,
  guestEmailPlaceholder: K0,
  addGuest: Z0,
  addAnotherGuest: J0,
  backButton: Q0,
  bookNowButton: X0,
  bookingConfirmed: eb,
  bookingConfirmedDescription: tb,
  bookingSent: nb,
  bookingSentDescription: ib,
  bookingRescheduled: ab,
  bookingDateAndTimeHeader: rb,
  cancelBookingButton: ob,
  rescheduleBookingButton: sb,
  rejectBookingButton: lb,
  confirmBookingButton: ub,
  bookingPendingTitle: cb,
  bookingPendingnDescription: db,
  confirmedEventCardTitle: fb,
  confirmedEventCardDescription: gb,
  cancelBookingTitle: hb,
  cancelBookingMessage: mb,
  reasonForCancellation: pb,
  goBackButton: bb,
  bookingCancelledTitle: yb,
  bookingCancelledMessage: vb,
  bookingCancelledMessage_theParticipants: Tb,
  closeButton: kb,
  closingButton: Eb,
  fieldRequired: xb,
  invalidInputFormat: Sb,
  createBookingErrorTitle: Cb,
  getAvailabilityErrorTitle: wb,
  cancelBookingErrorTitle: $b,
  rescheduleBookingErrorTitle: Bb,
  getUISettingErrorTitle: Pb,
  rejectBookingErrorTitle: Mb,
  confirmBookingErrorTitle: Db,
  genericErrorTitle: Ab,
  schedulingComponentErrorTitle: Lb,
  sessionIdRequiredErrorMessage: Ob,
  publicConfigErrorMessage: _b,
  invalidTimeslotErrorTitle: Ib,
  invalidTimeslotErrorMessage: Rb,
  cancellationErrorTitle: Nb,
  cancellationErrorMessage: Fb,
  minimumCancellationErrorMessage: Ub,
  cancelBokingFormError: zb,
  feedbackFormTitle: Hb,
  feedbackFormDescription: jb,
  feedbackMessageLabel: qb,
  feedbackMessagePlaceholder: Yb,
  feedbackModalCloseButton: Vb,
  feedbackModalSubmitButton: Gb,
  deleteSchedulingPageTitle: Wb,
  deleteSchedulingPageDescription: Kb,
  deleteSchedulingPageConfirmButton: Zb,
  deleteSchedulingPageCancelButton: Jb,
  schedulerEditorTitle: Qb,
  allSchedulingPages: Xb,
  createAndManageSchedulingPages: e1,
  createNewSchedulingPageButtonText: t1,
  pageTitle: n1,
  durationTitle: i1,
  loading: a1,
  required: r1,
  optional: o1,
  loadingPagesDescription: s1,
  noSchedulingPages: l1,
  createFirstSchedulingPage: u1,
  editSchedulingPageButtonText: c1,
  eventInfoTab: d1,
  availabilityTab: f1,
  participantsTab: g1,
  bookingOptionsTab: h1,
  returnToCalendarView: m1,
  bookingFormTab: p1,
  communicationsTab: b1,
  pageStylesTab: y1,
  savingButtonText: v1,
  saveChangesButtonText: T1,
  createButtonText: k1,
  timePeriod_day: E1,
  timePeriod_week: x1,
  timePeriod_month: S1,
  timePeriod_year: C1,
  timeDuration_minute: w1,
  timeDuration_hour: $1,
  eventCommunicationsTitle: B1,
  eventCommunicationsDescription: P1,
  unsavedChangesLabel: M1,
  changesSavedLabel: D1,
  fixFormErrors: A1,
  nylasEditorTabs: L1,
  nylasListConfigurations: O1,
  nylasAdditionalParticipants: _1,
  nylasAvailabilityPicker: I1,
  nylasTimeWindowPicker: R1,
  nylasBookingCalendarPicker: N1,
  nylasBookingConfirmationRedirect: F1,
  nylasBookingConfirmationType: U1,
  nylasBookingFormConfig: z1,
  nylasBufferTime: H1,
  nylasCalendarPicker: j1,
  nylasCancellationPolicy: q1,
  nylasConfirmationEmail: Y1,
  nylasConnectedCalendars: V1,
  nylasCustomBookingFlow: G1,
  nylasCustomEventSlug: W1,
  nylasCustomizeBookingSettings: K1,
  nylasEventDescription: Z1,
  nylasEventDuration: J1,
  nylasEventInfo: Q1,
  nylasEventLimits: X1,
  nylasEventLocation: ey,
  nylasEventTitle: ty,
  nylasLimitFutureBookings: ny,
  nylasMinBookingNotice: iy,
  nylasMinCancellationNotice: ay,
  nylasPageName: ry,
  nylasPageStyling: oy,
  nylasParticipantBookingCalendars: sy,
  nylasParticipantCustomAvailability: ly,
  nylasReminderEmails: uy,
  nylasSchedulingMethod: cy,
  nylasTimeslotInterval: dy,
  nylasEventTimeslot: fy,
  nylasEventCapacity: gy,
  nylasSelectEventType: hy,
  pageSettingsButton: my,
  nylasEventCalendar: py,
  default: R8
}), by = "Ingen dag vald", yy = "Välj en annan tid för att boka om din tid", vy = "Alla dagar", Ty = "Idag", ky = "{{count}} platser kvar", Ey = "Sök", xy = {
  sunday: "SÖN",
  monday: "MÅN",
  tuesday: "TIS",
  wednesday: "ONS",
  thursday: "TOR",
  friday: "FRE",
  saturday: "LÖR"
}, Sy = {
  hour: "timme",
  hours: "timmar",
  minute: "minut",
  minutes: "minuter",
  day: "dag",
  days: "dagar",
  week: "vecka",
  weeks: "veckor",
  month: "månad",
  months: "månader",
  year: "år",
  years: "år"
}, Cy = {
  january: "Januari",
  february: "Februari",
  march: "Mars",
  april: "April",
  may: "Maj",
  june: "Juni",
  july: "Juli",
  august: "Augusti",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "December"
}, wy = "Flera val", $y = "Vänligen välj minst ett alternativ", By = "Nästa", Py = "{{date}}", My = "{{time}}", Dy = "Namn", Ay = "Ange ditt namn", Ly = "E-post", Oy = "Ange din e-postadress", _y = "Gästens e-post", Iy = "Ange gästens e-postadress", Ry = "Lägg till gäst", Ny = "Lägg till en gäst till", Fy = "Tillbaka", Uy = "Boka nu", zy = "Bokning bekräftad", Hy = "Du kommer snart att få en bekräftelse via e-post.", jy = "Bokning skickad", qy = "Du kommer att få ett e-mail när bokningen är bekräftad.", Yy = "Bokning ombokad", Vy = "Bokningsdatum och tid", Gy = "Avboka bokning", Wy = "Omboka", Ky = "Avvisa bokning", Zy = "Bekräfta bokning", Jy = "Bokning pågår", Qy = "Hantera din bokning nedan. Inbjudna kommer att få ett e-postmeddelande om begärans status.", Xy = "Din bokning har bekräftats framgångsrikt", ev = "Ett bekräftelsemail har skickats till", tv = "Avboka bokning?", nv = "Din nuvarande tidslucka kommer att bli tillgänglig för andra.", iv = "Anledning till avbokning", av = "Gå tillbaka", rv = "Din bokning har avbokats framgångsrikt", ov = "Ett avbokningsmejl har skickats till", sv = "deltagarna", lv = "Stäng", uv = "Stänger", cv = "{{field}} är obligatoriskt.", dv = "{{field}} har ogiltigt format.", fv = "Skapa Bokning", gv = "Hämta Tillgänglighet", hv = "Avboka Bokning", mv = "Omboka Bokning", pv = "Hämta UI-inställningar", bv = "Avvisa Bokning", yv = "Bekräfta Bokning", vv = "Något gick fel...", Tv = "Schemaläggningskomponentfel", kv = "'sessionId' krävs för privata konfigurationer.", Ev = "Om du använder offentlig konfiguration anger du antingen en konfigurations-ID eller en kombination av 'slug' och 'clientId'.", xv = "Ogiltig tidslucka!", Sv = "Den valda tidsluckan är ogiltig", Cv = "Avbokningsfel", wv = "Vänligen ange en anledning till avbokningen.", $v = "Du kan inte avboka bokningen inom {{minCancellationNotice}} minuter före evenemanget", Bv = "Fel i avbokningsformuläret", Pv = "Dela din feedback", Mv = "Att ge oss din feedback och rapportera fel hjälper oss att skapa en bättre upplevelse för dig.", Dv = "Ge oss en detaljerad beskrivning av funktionen du kommenterar eller där du har upplevt ett problem.", Av = "Ge din feedback här", Lv = "Avbryt", Ov = "Skicka", _v = "Ta bort denna schemaläggningssida?", Iv = "Efter bekräftelse kommer denna sida och dess anslutna schemaläggningslänkar att raderas och inaktiveras permanent. Denna åtgärd kan inte ångras.", Rv = "Ta bort sida", Nv = "Avbryt", Fv = "Schemaläggningsredigerare", Uv = "Alla schemaläggningssidor", zv = "Skapa och hantera dina schemaläggningssidor.", Hv = "Skapa ny", jv = "Sidrubrik", qv = "Varaktighet", Yv = "Laddar", Vv = "Obligatorisk", Gv = "Valfritt", Wv = "Vänta medan vi hämtar schemaläggningssidorna", Kv = "Inga schemaläggningssidor hittades", Zv = "Kom igång genom att skapa din första schemaläggningssida", Jv = "Redigera", Qv = "Händelseinfo", Xv = "Tillgänglighet", e2 = "Deltagare", t2 = "Bokningsalternativ", n2 = "Tillbaka till kalender", i2 = "Bokningsformulär", a2 = "Kommunikation", r2 = "Sidstilar", o2 = "Sparar", s2 = "Spara ändringar", l2 = "Skapa", u2 = "dag", c2 = "vecka", d2 = "månad", f2 = "år", g2 = "minut", h2 = "timme", m2 = "Evenemangskommunikation", p2 = "Ställ in automatiska bekräftelsemejl.", b2 = "Osparade ändringar", y2 = "Ändringar sparade", v2 = "Vänligen korrigera formulärfelet.", T2 = {
  bookingFormError: "Bokningsformulärfelet: ",
  bookingFormError_label: "Etikett krävs för fältet av typ {{type}}.",
  bookingFormError_option: "Tomt alternativ identifierat inom {{label}} av typ {{type}}."
}, k2 = {
  previewButtonText: "Förhandsgranska",
  copyLinkButtonText: "Kopiera länk",
  deleteButtonText: "Ta bort"
}, E2 = {
  headerTitle: "Deltagare",
  headerSubTitle: "Lägg till personer i ditt team eller organisation för att delta i evenemanget.",
  organizerAsParticipant: "Deltagare",
  organizer: "Arrangör",
  participant: "Deltagare",
  addParticipant_first: "Lägg till en deltagare",
  addParticipant_next: "Lägg till en annan deltagare",
  tooltip: {
    includeOrganizer: "Inkludera arrangör",
    includeOrganizerDesc: "Arrangören (du) kommer att inkluderas i rotationsschemat.",
    excludeOrganizer: "Exkludera arrangör",
    excludeOrganizerDesc: "Arrangören (du) kommer inte att inkluderas i rotationsschemat."
  },
  error: "Vänligen lägg till minst en deltagare"
}, x2 = {
  headerTitle: "Standard öppettider",
  headerSubTitle: "Ange när du regelbundet är tillgänglig för bokningar.",
  tooltip: {
    desc: "Detta är standardtillgängligheten för deltagare som inte har angett tillgänglighet på deltagarfliken."
  },
  selectTimezone: "Välj tidszon",
  unavailable: "Inte tillgänglig",
  days: {
    SUN: "SÖN",
    MON: "MÅN",
    TUE: "TIS",
    WED: "ONS",
    THU: "TOR",
    FRI: "FRE",
    SAT: "LÖR"
  },
  errors: {
    invalid: "Ogiltigt"
  }
}, S2 = {
  headerTitle: "Kalenderbokning",
  headerSubTitle: "Välj kalendern där du vill lägga till bokningar.",
  tooltip: {
    desc: "Kalendern används för att skapa händelser."
  },
  selectOptionLabel: "Välj ett alternativ",
  selectCalendarErrorMessage: "Vänligen välj en kalender"
}, C2 = {
  dropdownLabel: "När en bokning har bekräftats",
  tooltip: {
    desc: "Du kan antingen visa standardsidan för bekräftelse eller omdirigera användare till din egen bekräftelsesida."
  },
  redirectOption_default: "Visa standardsidan för bekräftelse",
  redirectOption_custom: "Omdirigera till anpassad URL"
}, w2 = {
  dropdownLabel: "När en bokning begärs",
  tooltip: {
    desc: "Manuell godkännande av bokningar låter dig granska och antingen acceptera eller neka varje bokningsförfrågan."
  },
  bookingOption_booking: "Godkänn bokningar automatiskt",
  bookingOption_organizerConfirmation: "Godkänn bokningar manuellt"
}, $2 = {
  headerTitle: "Bokningsformulär",
  headerSubTitle: "Lägg till anpassade fält i bokningsformuläret.",
  dropdownButtonText: "Lägg till nytt fält",
  addOption: "Lägg till ett alternativ",
  allOptionsHeader: "ALLA ALTERNATIV",
  fieldInTitleError: "Detta fält används i evenemangstiteln och kan inte tas bort.",
  fieldInDescriptionError: "Detta fält används i evenemangsbeskrivningen och kan inte tas bort.",
  label: "Etikett",
  defaultValue: "Standardvärde",
  fieldType: {
    text: "Kort text",
    multi_line_text: "Lång text",
    email: "E-post",
    phone_number: "Telefonnummer",
    dropdown: "Rullgardinsmeny",
    radio_button: "Radioknapp",
    checkbox: "Kryssruta",
    date: "Datum",
    metadata: "Metadata",
    multi_select: "Flera urval"
  },
  fieldLabel: {
    your_name: "Ditt namn",
    your_email: "Din e-post",
    email: "Ytterligare e-post",
    phone_number: "Telefonnummer etikett",
    dropdown: "Rullgardinsmeny etikett",
    text: "Kort text etikett",
    multi_line_text: "Lång text etikett",
    radio_button: "Radioknapp etikett",
    checkbox: "Kryssruta etikett",
    date: "Datum etikett",
    metadata: "Metadata etikett",
    multi_select: "Flera urval etikett"
  }
}, B2 = {
  headerTitle: "Buffertid",
  headerSubTitle: "Kräver tom buffertid före och efter ett evenemang.",
  tooltip: {
    desc: "Schemaläggaren bokar inte bufferttiden."
  },
  beforeBufferLabel: "Före evenemanget",
  afterBufferLabel: "Efter evenemanget",
  minutesShort: "min",
  previewHeader: "FÖRHANDSVISNING"
}, P2 = {
  calendarPickerLabel: "Välj kalendrar som ska kontrolleras för tillgänglighet",
  selectAtLeastOneCalendar: "Vänligen välj minst en kalender för varje deltagare."
}, M2 = {
  cancellationPolicyLabel: "Meddelande om avbokningspolicy",
  tooltip: {
    desc: "Deltagarna får detta meddelande om de försöker avboka evenemanget. De ombeds ange en anledning till avbokningen."
  }
}, D2 = {
  headerTitle: "Bokning bekräftad{{organizerName}}",
  headerSubTitle: "Bekräftelsemail för bokning",
  editButtonText: "Redigera",
  error: {
    invalidImageUrl: "Ogiltig bild-URL."
  },
  confirmationEmail: {
    label: "Aktivera e-postmeddelanden",
    tooltip: {
      desc: "Tillåt Nylas att skicka e-postmeddelanden, inklusive bekräftelsemeddelanden och påminnelser om evenemang.",
      language: "Denna språk kommer att användas för e-postmeddelanden till arrangörerna."
    },
    language: "Välj språk"
  },
  nylasBranding: {
    label: "Visa Nylas-varumärke",
    tooltip: {
      desc: "Avmarkera detta för att dölja sidfoten i e-postkommunikationen."
    }
  },
  companyLogoUrl: {
    label: "Företagslogotyp-URL",
    tooltip: {
      desc: "Denna logotyp visas i bokningsbekräftelsemail. URL:en måste vara offentligt tillgänglig. Bilden kommer att skalas ner till en maximal storlek på 200px x 100px."
    }
  },
  emailMessage: {
    header: "E-postmeddelande",
    label: "Anpassad e-posttitel",
    tooltip: {
      desc: "En e-posttitel är en rubrik i e-postens innehåll. Detta ändrar inte ämnesraden."
    },
    additionalInfoLabel: "Ytterligare information",
    additionalInfoTooltip: "Schemaläggaren lägger till innehållet i rutan till e-postens innehåll.",
    additionalInfoPlaceholder: "Standardtext"
  },
  allHosts: "Alla värdar och gäster",
  immediatelyUponBooking: "Omedelbart efter bokning"
}, A2 = {
  headerTitle: "Anslutna kalendrar",
  headerSubTitle: "Välj kalendrarna som ska användas för att kontrollera din tillgänglighet.",
  tooltip: {
    desc: "Kontrollera tillgänglighet i en eller flera kalendrar. Om du väljer flera kalendrar för en deltagare måste deltagaren vara tillgänglig i alla sina kalendrar för att anses vara tillgänglig."
  },
  participantCalendarTitle: "{{participantName}}s anslutna kalendrar",
  selectAtLeastOneCalendar: "Vänligen välj minst en kalender för varje deltagare."
}, L2 = {
  headerTitle: "Anpassat bokningsflöde"
}, O2 = {
  headerTitle: "Anpassad sidlänk",
  headerSubTitle: "Skapa en anpassad URL-länk för denna sida.",
  eventSlugLabel: "Sidlänk för URL",
  tooltip: {
    desc: "Ange en anpassad länk för din URL för att unikt identifiera din sida (endast bokstäver, siffror och bindestreck)."
  },
  copied: "Kopierad!"
}, _2 = {
  headerTitle: "Ytterligare inställningar",
  headerSubTitle: "Bokningsinställningar för evenemanget.",
  tooltip: {
    desc: "Anpassa dina bokningsinställningar."
  },
  allowGuests: {
    label: "Tillåt gäster att bjuda in ytterligare gäster."
  },
  hideReschedule: {
    label: "Dölj alternativ för ombokning.",
    tooltip: {
      desc: "Dölj knappen 'Omboka' i bokningsbekräftelsen och e-postaviseringar."
    }
  },
  hideCancel: {
    label: "Dölj alternativ för avbokning",
    tooltip: {
      desc: "Dölj knappen 'Avboka' i bokningsbekräftelsen och e-postaviseringar."
    }
  }
}, I2 = {
  headerTitle: "Evenemangsbeskrivning",
  addAdditionalFields: {
    buttonText: "Fyll i ytterligare fält automatiskt",
    tooltip: {
      desc: "Klicka på detta när du har lagt till alla fält du vill inkludera i beskrivningen. Viktigt: Vänligen ändra inte markeringarna '--- Additional Fields ---' och '--- End Additional Fields ---' för att säkerställa att allt fungerar korrekt."
    }
  },
  tooltip: {
    desc: "Evenemangsbeskrivningen visas i schemaläggarens redigeringsvy och i svarspayloaden när en bokning skapas."
  }
}, R2 = {
  headerTitle: "Evenemangets varaktighet",
  error: {
    durationMustBeMultipleOf5: "Varaktigheten måste vara en multipel av 5",
    durationMustBeGreaterThan0: "Varaktigheten måste vara större än 0"
  }
}, N2 = {
  headerTitle: "Evenemangsinformation"
}, F2 = {
  headerTitle: "Begränsningar för evenemanget"
}, U2 = {
  headerTitle: "Evenemangsmöte eller plats",
  tooltip: {
    desc: "Välj ett konferensalternativ eller lägg till en anpassad plats."
  },
  conferenceOptions: {
    none: "Ingen",
    zoom: "Zoom-möte",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Anpassad plats"
  }
}, z2 = {
  headerTitle: "Evenemangets titel",
  helpText_start: "Skapa ett dynamiskt mallbaserat event {{field}} genom att skriva",
  helpText_end: "och välja ett mallobjekt.",
  title: "titel",
  description: "beskrivning",
  tooltip: {
    desc: "Till exempel: Intervju med"
  },
  eventTitleRequired: "Evenemangets titel är obligatorisk",
  eventTitleTokenDescription: {
    invitee: "Namnet på huvudinbjudan.",
    inviteeEmail: "E-postadressen för huvudinbjudan.",
    duration: "Varaktigheten för evenemanget."
  }
}, H2 = {
  headerTitle: "Begränsa framtida bokningar",
  tooltip: {
    desc: "Gränsen för hur långt in i framtiden bokningar kan göras."
  }
}, j2 = {
  headerTitle: "Minsta bokningsnotis",
  tooltip: {
    desc: "Den minsta tidsramen i framtiden som en ny bokning kan göras."
  }
}, q2 = {
  headerTitle: "Minsta avbokningsnotis",
  tooltip: {
    desc: "Den minsta tidsramen som krävs för att avboka en bokning."
  }
}, Y2 = {
  headerTitle: "Sidnamn",
  headerSubTitle: "Ange namnet på schemaläggningssidan.",
  pageNameError: "Ange ett sidnamn",
  tooltip: {
    desc: "Som standard använder schemaläggningssidor ditt användarnamn som sidnamn. Sidnamnet visas i det övre vänstra hörnet av kalendervyn."
  }
}, V2 = {
  headerTitle: "Sidstil och anpassning"
}, G2 = {
  headerTitle: "Boka till denna kalender",
  headerSubTitle: "Välj kalendern där du vill lägga till bokningar.",
  participantBookingCalendarTitle: "{{participantName}}s bokningskalendrar",
  selectAtLeastOneCalendar: "Vänligen välj minst en kalender för varje deltagare."
}, W2 = {
  headerTitle: "Deltagares öppettider",
  headerSubTitle: "Om inte inställt används standardöppettiderna för att beräkna deltagarens tillgänglighet.",
  participantOpenHoursTitle: "{{participantName}}s öppettider"
}, K2 = {
  headerTitle: "Kommande möte {{organizerName}}",
  headerSubTitle: "Påminnelse före händelsen",
  editButtonText: "Redigera",
  recipientOptions_all: "Alla värdar och gäster",
  recipientOptions_guest: "Alla gäster på evenemanget",
  recipientOptions_host: "Endast värd för evenemanget",
  beforeTheEvent: "före evenemanget",
  emailRecipients: {
    label: "E-postmottagare"
  },
  sendConfirmation: {
    label: "Skicka bekräftelsemail när",
    tooltip: {
      desc: "Mottagarna kommer att få ett påminnelsemail vid den angivna tiden före evenemanget."
    }
  },
  emailSubject: {
    label: "E-postämne",
    placeholder: "Kommande möte {{organizerName}}"
  },
  reminderMinutesValidationError: "Ange påminnelseminuter i multiplar av 5. Försök ",
  newReminderButtonText: "Ny påminnelse"
}, Z2 = {
  headerTitle: "Schemaläggningsmetod",
  headerSubTitle: "Välj en schemaläggningsmetod för evenemanget.",
  tooltip: {
    standard: {
      label: "Standard",
      desc: "Tillåter 1:1-bokningar eller n:1-bokningar med ytterligare deltagare."
    },
    maxFairness: {
      label: "Rundgång - Maximera rättvisa",
      desc: "Rotera genom deltagarlistan och visa deltagaren med minst bokningar."
    },
    maxAvailability: {
      label: "Rundgång - Maximera tillgänglighet",
      desc: "Rotera genom deltagarlistan och prioritera deltagare med minst bokningar, samtidigt som så många tidsslotar som möjligt görs tillgängliga."
    }
  },
  schedulingMethodOptions_collective: "Standardbokning",
  schedulingMethodOptions_maxFairness: "Rundgång - Max rättvisa",
  schedulingMethodOptions_maxAvailability: "Rundgång - Max tillgänglighet"
}, J2 = {
  minutesShort: "min",
  lengthOfMeeting: "Möteslängd",
  headerTitle: "Inställningar för tidsluckor",
  timeslotInterval: {
    label: "Intervall för tidsluckor."
  },
  timeslotRounding: {
    label: "Typ av avrundning för tidsluckor",
    tooltip: {
      desc: "Intervall vid vilket tidsluckor visas."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Avrundning av intervall",
      desc: "Tidsluckor börjar vid tider som avrundas till intervallvärdet."
    },
    noRounding: {
      label: "Standard",
      desc: "Tidsluckor avrundas till närmaste kvart."
    }
  }
}, Q2 = {
  recurrenceOptions: {
    none: "Upprepas inte",
    daily: "Dagligen",
    weekly: "Varje vecka på {{dayOfWeek}}",
    monthly: "Månadsvis den {{dayOfMonth}}",
    monthOnDay: "Månadsvis den {{date}}",
    yearly: "Årligen den {{dateOfMonth}}",
    custom: "Anpassad"
  },
  recurrenceLabel: "Upprepa denna händelse",
  endDate: "Slutdatum",
  customRecurrence: {
    repeatEvery: "Upprepa varje",
    repeatOn: "Upprepa på",
    ends: "Slutar",
    endsOptions: {
      never: "Aldrig",
      after: "Efter",
      on: "På"
    },
    occurrences: "förekomster"
  },
  dateTimeLabel: "Datum och tid",
  errors: {
    invalidTimeRange: "Ogiltig tidsperiod",
    startTimeSameAsEndTime: "Starttid och sluttid kan inte vara samma",
    startTimeBeforeCurrentDate: "Starttid kan inte vara i det passade",
    invalid: "Ogiltigt"
  }
}, X2 = {
  headerTitle: "Deltagare",
  headerSubTitle: "Ställ in det maximala antalet deltagare för denna tidslucka.",
  tooltip: {
    desc: "Arrangören och deltagarna som är konfigurerade på schemaläggningssidan räknas inte som deltagare."
  },
  attendees: "deltagare"
}, eT = {
  returnToAllSchedulingPages: "Tillbaka till alla schemaläggningssidor",
  createEventHeaderTitle: "Skapa ett evenemang",
  eventTypeHeaderTitle: "Evenemangstyp",
  noEventTypesEnabled: "Inga evenemangstyper aktiverade",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Tillåter 1:1-bokningar."
    },
    collective: {
      label: "Standardbokning",
      desc: "Tillåter n:1-bokningar med ytterligare deltagare."
    },
    maxFairness: {
      label: "Rundgång - Maximera rättvisa",
      desc: "Rotera genom deltagarlistan och visa deltagaren med minst bokningar."
    },
    maxAvailability: {
      label: "Rundgång - Maximera tillgänglighet",
      desc: "Rotera genom deltagarlistan och prioritera deltagare med minst bokningar, samtidigt som så många tidsslotar som möjligt görs tillgängliga."
    },
    group: {
      label: "Grupp / Klass",
      desc: "Dessa är evenemang som vanligtvis har en arrangör och flera deltagare."
    }
  }
}, tT = "Sidinställningar", nT = {
  createEventDetails: {
    headerTitle: "Evenemangsinformation",
    closeButtonTooltip: "Stäng",
    cancelButton: "Avbryt",
    createButton: "Skapa"
  },
  discardChanges: {
    headerTitle: "Vill du verkligen avbryta ändringarna?",
    cancelButton: "Avbryt",
    discardButton: "Avbryt"
  },
  unsavedChanges: "Osparade ändringar",
  editEventDetails: {
    headerTitle: "Evenemangsinformation",
    closeButtonTooltip: "Stäng",
    deleteButton: "Ta bort",
    saveButton: "Spara",
    pastEventTooltip: "Detta evenemang är i det passade och kan inte redigeras."
  },
  importEvent: {
    closeButtonTooltip: "Stäng",
    importButton: "Importera",
    participantsLabel: "Deltagare"
  },
  deleteEvent: {
    closeButtonTooltip: "Stäng",
    deleting: "Tar bort..."
  },
  editOptions: {
    headerTitle: "Alternativ",
    closeButtonTooltip: "Stäng",
    deleting: "Tar bort...",
    import: "Importera",
    edit: "Redigera",
    deleteThis: "Ta bort detta evenemang",
    deleteAll: "Ta bort alla evenemang"
  },
  updateOptions: {
    updateThis: "Uppdatera detta evenemang",
    updateAll: "Uppdatera alla evenemang",
    updateFuture: "Uppdatera alla framtida evenemang"
  },
  deleteOptions: {
    deleteThis: "Ta bort",
    deleteFuture: "Ta bort detta och alla framtida evenemang",
    deleteAll: "Ta bort alla evenemang"
  }
}, F8 = {
  noDateSelected: by,
  rescheduleTitle: yy,
  allDay: vy,
  today: Ty,
  spotsLeft: ky,
  search: Ey,
  days: xy,
  time: Sy,
  months: Cy,
  multipleOptionsSelected: wy,
  selectAtLeastOneOption: $y,
  nextButton: By,
  selectedDayAndYear: Py,
  selectedTime: My,
  name: Dy,
  namePlaceholder: Ay,
  email: Ly,
  emailPlaceholder: Oy,
  guestEmail: _y,
  guestEmailPlaceholder: Iy,
  addGuest: Ry,
  addAnotherGuest: Ny,
  backButton: Fy,
  bookNowButton: Uy,
  bookingConfirmed: zy,
  bookingConfirmedDescription: Hy,
  bookingSent: jy,
  bookingSentDescription: qy,
  bookingRescheduled: Yy,
  bookingDateAndTimeHeader: Vy,
  cancelBookingButton: Gy,
  rescheduleBookingButton: Wy,
  rejectBookingButton: Ky,
  confirmBookingButton: Zy,
  bookingPendingTitle: Jy,
  bookingPendingnDescription: Qy,
  confirmedEventCardTitle: Xy,
  confirmedEventCardDescription: ev,
  cancelBookingTitle: tv,
  cancelBookingMessage: nv,
  reasonForCancellation: iv,
  goBackButton: av,
  bookingCancelledTitle: rv,
  bookingCancelledMessage: ov,
  bookingCancelledMessage_theParticipants: sv,
  closeButton: lv,
  closingButton: uv,
  fieldRequired: cv,
  invalidInputFormat: dv,
  createBookingErrorTitle: fv,
  getAvailabilityErrorTitle: gv,
  cancelBookingErrorTitle: hv,
  rescheduleBookingErrorTitle: mv,
  getUISettingErrorTitle: pv,
  rejectBookingErrorTitle: bv,
  confirmBookingErrorTitle: yv,
  genericErrorTitle: vv,
  schedulingComponentErrorTitle: Tv,
  sessionIdRequiredErrorMessage: kv,
  publicConfigErrorMessage: Ev,
  invalidTimeslotErrorTitle: xv,
  invalidTimeslotErrorMessage: Sv,
  cancellationErrorTitle: Cv,
  cancellationErrorMessage: wv,
  minimumCancellationErrorMessage: $v,
  cancelBokingFormError: Bv,
  feedbackFormTitle: Pv,
  feedbackFormDescription: Mv,
  feedbackMessageLabel: Dv,
  feedbackMessagePlaceholder: Av,
  feedbackModalCloseButton: Lv,
  feedbackModalSubmitButton: Ov,
  deleteSchedulingPageTitle: _v,
  deleteSchedulingPageDescription: Iv,
  deleteSchedulingPageConfirmButton: Rv,
  deleteSchedulingPageCancelButton: Nv,
  schedulerEditorTitle: Fv,
  allSchedulingPages: Uv,
  createAndManageSchedulingPages: zv,
  createNewSchedulingPageButtonText: Hv,
  pageTitle: jv,
  durationTitle: qv,
  loading: Yv,
  required: Vv,
  optional: Gv,
  loadingPagesDescription: Wv,
  noSchedulingPages: Kv,
  createFirstSchedulingPage: Zv,
  editSchedulingPageButtonText: Jv,
  eventInfoTab: Qv,
  availabilityTab: Xv,
  participantsTab: e2,
  bookingOptionsTab: t2,
  returnToCalendarView: n2,
  bookingFormTab: i2,
  communicationsTab: a2,
  pageStylesTab: r2,
  savingButtonText: o2,
  saveChangesButtonText: s2,
  createButtonText: l2,
  timePeriod_day: u2,
  timePeriod_week: c2,
  timePeriod_month: d2,
  timePeriod_year: f2,
  timeDuration_minute: g2,
  timeDuration_hour: h2,
  eventCommunicationsTitle: m2,
  eventCommunicationsDescription: p2,
  unsavedChangesLabel: b2,
  changesSavedLabel: y2,
  fixFormErrors: v2,
  nylasEditorTabs: T2,
  nylasListConfigurations: k2,
  nylasAdditionalParticipants: E2,
  nylasAvailabilityPicker: x2,
  nylasBookingCalendarPicker: S2,
  nylasBookingConfirmationRedirect: C2,
  nylasBookingConfirmationType: w2,
  nylasBookingFormConfig: $2,
  nylasBufferTime: B2,
  nylasCalendarPicker: P2,
  nylasCancellationPolicy: M2,
  nylasConfirmationEmail: D2,
  nylasConnectedCalendars: A2,
  nylasCustomBookingFlow: L2,
  nylasCustomEventSlug: O2,
  nylasCustomizeBookingSettings: _2,
  nylasEventDescription: I2,
  nylasEventDuration: R2,
  nylasEventInfo: N2,
  nylasEventLimits: F2,
  nylasEventLocation: U2,
  nylasEventTitle: z2,
  nylasLimitFutureBookings: H2,
  nylasMinBookingNotice: j2,
  nylasMinCancellationNotice: q2,
  nylasPageName: Y2,
  nylasPageStyling: V2,
  nylasParticipantBookingCalendars: G2,
  nylasParticipantCustomAvailability: W2,
  nylasReminderEmails: K2,
  nylasSchedulingMethod: Z2,
  nylasTimeslotInterval: J2,
  nylasEventTimeslot: Q2,
  nylasEventCapacity: X2,
  nylasSelectEventType: eT,
  pageSettingsButton: tT,
  nylasEventCalendar: nT
}, U8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: by,
  rescheduleTitle: yy,
  allDay: vy,
  today: Ty,
  spotsLeft: ky,
  search: Ey,
  days: xy,
  time: Sy,
  months: Cy,
  multipleOptionsSelected: wy,
  selectAtLeastOneOption: $y,
  nextButton: By,
  selectedDayAndYear: Py,
  selectedTime: My,
  name: Dy,
  namePlaceholder: Ay,
  email: Ly,
  emailPlaceholder: Oy,
  guestEmail: _y,
  guestEmailPlaceholder: Iy,
  addGuest: Ry,
  addAnotherGuest: Ny,
  backButton: Fy,
  bookNowButton: Uy,
  bookingConfirmed: zy,
  bookingConfirmedDescription: Hy,
  bookingSent: jy,
  bookingSentDescription: qy,
  bookingRescheduled: Yy,
  bookingDateAndTimeHeader: Vy,
  cancelBookingButton: Gy,
  rescheduleBookingButton: Wy,
  rejectBookingButton: Ky,
  confirmBookingButton: Zy,
  bookingPendingTitle: Jy,
  bookingPendingnDescription: Qy,
  confirmedEventCardTitle: Xy,
  confirmedEventCardDescription: ev,
  cancelBookingTitle: tv,
  cancelBookingMessage: nv,
  reasonForCancellation: iv,
  goBackButton: av,
  bookingCancelledTitle: rv,
  bookingCancelledMessage: ov,
  bookingCancelledMessage_theParticipants: sv,
  closeButton: lv,
  closingButton: uv,
  fieldRequired: cv,
  invalidInputFormat: dv,
  createBookingErrorTitle: fv,
  getAvailabilityErrorTitle: gv,
  cancelBookingErrorTitle: hv,
  rescheduleBookingErrorTitle: mv,
  getUISettingErrorTitle: pv,
  rejectBookingErrorTitle: bv,
  confirmBookingErrorTitle: yv,
  genericErrorTitle: vv,
  schedulingComponentErrorTitle: Tv,
  sessionIdRequiredErrorMessage: kv,
  publicConfigErrorMessage: Ev,
  invalidTimeslotErrorTitle: xv,
  invalidTimeslotErrorMessage: Sv,
  cancellationErrorTitle: Cv,
  cancellationErrorMessage: wv,
  minimumCancellationErrorMessage: $v,
  cancelBokingFormError: Bv,
  feedbackFormTitle: Pv,
  feedbackFormDescription: Mv,
  feedbackMessageLabel: Dv,
  feedbackMessagePlaceholder: Av,
  feedbackModalCloseButton: Lv,
  feedbackModalSubmitButton: Ov,
  deleteSchedulingPageTitle: _v,
  deleteSchedulingPageDescription: Iv,
  deleteSchedulingPageConfirmButton: Rv,
  deleteSchedulingPageCancelButton: Nv,
  schedulerEditorTitle: Fv,
  allSchedulingPages: Uv,
  createAndManageSchedulingPages: zv,
  createNewSchedulingPageButtonText: Hv,
  pageTitle: jv,
  durationTitle: qv,
  loading: Yv,
  required: Vv,
  optional: Gv,
  loadingPagesDescription: Wv,
  noSchedulingPages: Kv,
  createFirstSchedulingPage: Zv,
  editSchedulingPageButtonText: Jv,
  eventInfoTab: Qv,
  availabilityTab: Xv,
  participantsTab: e2,
  bookingOptionsTab: t2,
  returnToCalendarView: n2,
  bookingFormTab: i2,
  communicationsTab: a2,
  pageStylesTab: r2,
  savingButtonText: o2,
  saveChangesButtonText: s2,
  createButtonText: l2,
  timePeriod_day: u2,
  timePeriod_week: c2,
  timePeriod_month: d2,
  timePeriod_year: f2,
  timeDuration_minute: g2,
  timeDuration_hour: h2,
  eventCommunicationsTitle: m2,
  eventCommunicationsDescription: p2,
  unsavedChangesLabel: b2,
  changesSavedLabel: y2,
  fixFormErrors: v2,
  nylasEditorTabs: T2,
  nylasListConfigurations: k2,
  nylasAdditionalParticipants: E2,
  nylasAvailabilityPicker: x2,
  nylasBookingCalendarPicker: S2,
  nylasBookingConfirmationRedirect: C2,
  nylasBookingConfirmationType: w2,
  nylasBookingFormConfig: $2,
  nylasBufferTime: B2,
  nylasCalendarPicker: P2,
  nylasCancellationPolicy: M2,
  nylasConfirmationEmail: D2,
  nylasConnectedCalendars: A2,
  nylasCustomBookingFlow: L2,
  nylasCustomEventSlug: O2,
  nylasCustomizeBookingSettings: _2,
  nylasEventDescription: I2,
  nylasEventDuration: R2,
  nylasEventInfo: N2,
  nylasEventLimits: F2,
  nylasEventLocation: U2,
  nylasEventTitle: z2,
  nylasLimitFutureBookings: H2,
  nylasMinBookingNotice: j2,
  nylasMinCancellationNotice: q2,
  nylasPageName: Y2,
  nylasPageStyling: V2,
  nylasParticipantBookingCalendars: G2,
  nylasParticipantCustomAvailability: W2,
  nylasReminderEmails: K2,
  nylasSchedulingMethod: Z2,
  nylasTimeslotInterval: J2,
  nylasEventTimeslot: Q2,
  nylasEventCapacity: X2,
  nylasSelectEventType: eT,
  pageSettingsButton: tT,
  nylasEventCalendar: nT,
  default: F8
}), iT = "请选择日期", aT = "选择另一个时间段重新安排您的会议", rT = "全天", oT = "今天", sT = "{{count}} 剩余", lT = "搜索", uT = {
  sunday: "周日",
  monday: "周一",
  tuesday: "周二",
  wednesday: "周三",
  thursday: "周四",
  friday: "周五",
  saturday: "周六"
}, cT = {
  hour: "小时",
  hours: "小时",
  minute: "分钟",
  minutes: "分钟",
  day: "天",
  days: "天",
  week: "周",
  weeks: "周",
  month: "月",
  months: "月",
  year: "年",
  years: "年"
}, dT = {
  january: "一月",
  february: "二月",
  march: "三月",
  april: "四月",
  may: "五月",
  june: "六月",
  july: "七月",
  august: "八月",
  september: "九月",
  october: "十月",
  november: "十一月",
  december: "十二月"
}, fT = "多个选项已选择", gT = "请至少选择一个选项", hT = "下一个", mT = "{{date}}", pT = "{{time}}", bT = "姓名", yT = "输入你的名字", vT = "电子邮件", TT = "输入你的电子邮件", kT = "客人的电子邮件", ET = "输入客人的电子邮件", xT = "添加客人", ST = "添加另一个客人", CT = "返回", wT = "立即预订", $T = "预订已确认", BT = "您将很快收到一封确认电子邮件。", PT = "预订已发送", MT = "预订确认后，您将收到一封电子邮件。", DT = "预订已重新安排", AT = "预订日期和时间", LT = "取消预订", OT = "重新安排", _T = "拒绝预订", IT = "确认预订", RT = "预订待处理", NT = "在下方管理您的预订。受邀者将收到一封电子邮件，通知他们请求状态。", FT = "您的预订已成功确认", UT = "确认邮件已发送至", zT = "取消预订？", HT = "您当前的时间段将对其他人开放。", jT = "取消原因", qT = "返回", YT = "您的预订已成功取消", VT = "取消邮件已发送至", GT = "参与者", WT = "关闭", KT = "关闭", ZT = "{{field}} 是必需的.", JT = "{{field}} 格式无效.", QT = "创建预订", XT = "获取可用性", ek = "取消预订", tk = "重新安排预订", nk = "获取UI设置", ik = "拒绝预订", ak = "确认预订", rk = "出了点问题...", ok = "调度组件错误", sk = "私有配置需要 'sessionId'。", lk = "如果使用公共配置，请传递 configurationId 或 'slug' 和 'clientId' 的组合。", uk = "无效的时间段！", ck = "所选时间段无效", dk = "取消错误", fk = "请提供取消的原因。", gk = "您不能在活动开始前的{{minCancellationNotice}}分钟内取消预订", hk = "取消预订表单错误", mk = "分享您的反馈", pk = "为我们提供反馈并报告错误有助于为您创造更好的体验。", bk = "请详细描述您正在评论的功能或遇到问题的地方。", yk = "在此处提供您的反馈", vk = "取消", Tk = "提交", kk = "删除此日程安排页面？", Ek = "确认后，此页面及其关联的日程安排链接将被永久删除并停用。此操作无法撤消。", xk = "删除页面", Sk = "取消", Ck = "日程编辑器", wk = "所有日程页面", $k = "创建和管理您的日程页面。", Bk = "创建新的", Pk = "页面标题", Mk = "持续时间", Dk = "加载中", Ak = "必需", Lk = "可选", Ok = "请稍候，我们正在获取日程页面", _k = "未找到日程页面", Ik = "从创建第一个日程页面开始", Rk = "编辑", Nk = "事件信息", Fk = "可用性", Uk = "参与者", zk = "预订选项", Hk = "返回日历视图", jk = "预订表格", qk = "通讯", Yk = "页面样式", Vk = "保存中", Gk = "保存更改", Wk = "创建", Kk = "天", Zk = "周", Jk = "月", Qk = "年", Xk = "分钟", e3 = "小时", t3 = "活动通信", n3 = "设置自动确认电子邮件。", i3 = "未保存的更改", a3 = "更改已保存", r3 = "请修复表单错误。", o3 = {
  bookingFormError: "预订表单错误：",
  bookingFormError_label: "{{type}} 类型的字段需要标签。",
  bookingFormError_option: "{{label}} 类型的 {{type}} 字段中检测到空选项。"
}, s3 = {
  previewButtonText: "预览",
  copyLinkButtonText: "复制链接",
  deleteButtonText: "删除"
}, l3 = {
  headerTitle: "参与者",
  headerSubTitle: "添加您的团队或组织中的人员加入活动。",
  organizerAsParticipant: "参与者",
  organizer: "组织者",
  participant: "参与者",
  addParticipant_first: "添加参与者",
  addParticipant_next: "添加另一位参与者",
  tooltip: {
    includeOrganizer: "包括组织者",
    includeOrganizerDesc: "组织者（您）将包含在轮换中。",
    excludeOrganizer: "排除组织者",
    excludeOrganizerDesc: "组织者（您）将不包含在轮换中。"
  },
  error: "请至少添加一个参与者"
}, u3 = {
  headerTitle: "默认开放时间",
  headerSubTitle: "设置您定期可用于活动预订的时间。",
  tooltip: {
    desc: "这是为未在参与者选项卡上设置可用性的参与者提供的默认可用时间。"
  },
  selectTimezone: "选择时区",
  unavailable: "不可用",
  days: {
    SUN: "周日",
    MON: "周一",
    TUE: "周二",
    WED: "周三",
    THU: "周四",
    FRI: "周五",
    SAT: "周六"
  },
  errors: {
    invalid: "无效"
  }
}, c3 = {
  headerTitle: "日历预订",
  headerSubTitle: "选择您希望添加活动预订的日历。",
  tooltip: {
    desc: "日历将用于创建事件。"
  },
  selectOptionLabel: "选择一个选项",
  selectCalendarErrorMessage: "请选择一个日历"
}, d3 = {
  dropdownLabel: "预订确认时",
  tooltip: {
    desc: "您可以显示默认确认页面或将用户重定向到您自己的确认页面。"
  },
  redirectOption_default: "显示默认确认页面",
  redirectOption_custom: "重定向到自定义 URL"
}, f3 = {
  dropdownLabel: "预订请求时",
  tooltip: {
    desc: "手动接受预订允许您审核并接受或拒绝每个预订请求。"
  },
  bookingOption_booking: "自动接受预订",
  bookingOption_organizerConfirmation: "手动接受预订"
}, g3 = {
  headerTitle: "预订表格",
  headerSubTitle: "向预订表格添加自定义字段。",
  dropdownButtonText: "添加新字段",
  addOption: "添加选项",
  allOptionsHeader: "所有选项",
  fieldInTitleError: "该字段用于事件标题，无法删除。",
  fieldInDescriptionError: "该字段用于事件描述，无法删除。",
  label: "标签",
  defaultValue: "默认值",
  fieldType: {
    text: "短文本",
    multi_line_text: "长文本",
    email: "电子邮件",
    phone_number: "电话号码",
    dropdown: "下拉菜单",
    radio_button: "单选按钮",
    checkbox: "复选框",
    date: "日期",
    metadata: "元数据",
    multi_select: "多选"
  },
  fieldLabel: {
    your_name: "您的姓名",
    your_email: "您的邮箱",
    email: "额外的邮箱",
    phone_number: "电话号码标签",
    dropdown: "下拉菜单标签",
    text: "短文本标签",
    multi_line_text: "长文本标签",
    radio_button: "单选按钮标签",
    checkbox: "复选框标签",
    date: "日期标签",
    metadata: "元数据标签",
    multi_select: "多选标签"
  }
}, h3 = {
  headerTitle: "缓冲时间",
  headerSubTitle: "要求在活动之前和之后的空闲缓冲时间。",
  tooltip: {
    desc: "调度器不会预订缓冲时间。"
  },
  beforeBufferLabel: "活动前",
  afterBufferLabel: "活动后",
  minutesShort: "分钟",
  previewHeader: "预览"
}, m3 = {
  calendarPickerLabel: "选择要检查可用性的日历",
  selectAtLeastOneCalendar: "请为每个参与者至少选择一个日历。"
}, p3 = {
  cancellationPolicyLabel: "取消政策信息",
  tooltip: {
    desc: "如果试图取消活动，参与者将收到此消息。参与者需要提供取消原因。"
  }
}, b3 = {
  headerTitle: "预订已确认{{organizerName}}",
  headerSubTitle: "预订确认电子邮件",
  editButtonText: "编辑",
  error: {
    invalidImageUrl: "无效的图像 URL。"
  },
  confirmationEmail: {
    label: "启用电子邮件通知",
    tooltip: {
      desc: "允许 Nylas 发送电子邮件通知，包括确认消息和事件提醒。",
      language: "此语言将用于向组织者发送电子邮件通知。"
    },
    language: "选择语言"
  },
  nylasBranding: {
    label: "显示 Nylas 品牌",
    tooltip: {
      desc: "取消选中此选项以在电子邮件中隐藏页脚。"
    }
  },
  companyLogoUrl: {
    label: "公司标志 URL",
    tooltip: {
      desc: "此标志将出现在预订确认电子邮件中。URL 必须可公开访问。图像将缩小至最大尺寸 200px x 100px。"
    }
  },
  emailMessage: {
    header: "电子邮件信息",
    label: "自定义电子邮件标题",
    tooltip: {
      desc: "电子邮件标题是电子邮件正文中的标题。这不会更改主题行。"
    },
    additionalInfoLabel: "附加信息",
    additionalInfoTooltip: "调度器会将此框的内容添加到电子邮件正文中。",
    additionalInfoPlaceholder: "默认正文"
  },
  allHosts: "所有主办方和来宾",
  immediatelyUponBooking: "预订后立即"
}, y3 = {
  headerTitle: "已连接的日历",
  headerSubTitle: "选择用于检查您可用性的日历。",
  tooltip: {
    desc: "检查一个或多个日历的可用性。如果为参与者选择了多个日历，则参与者必须在其所有日历上可用才能被视为可用。"
  },
  participantCalendarTitle: "{{participantName}}的已连接日历",
  selectAtLeastOneCalendar: "请为每个参与者至少选择一个日历。"
}, v3 = {
  headerTitle: "自定义预订流程"
}, T3 = {
  headerTitle: "自定义页面短链接",
  headerSubTitle: "为此页面创建自定义 URL 短链接。",
  eventSlugLabel: "页面 URL 短链接",
  tooltip: {
    desc: "为您的 URL 提供一个自定义短链接，以帮助唯一标识您的页面（仅限字母、数字和连字符）。"
  },
  copied: "已复制！"
}, k3 = {
  headerTitle: "附加设置",
  headerSubTitle: "活动的预订设置。",
  tooltip: {
    desc: "自定义您的预订设置。"
  },
  allowGuests: {
    label: "允许客人邀请其他客人。"
  },
  hideReschedule: {
    label: "隐藏重新安排选项。",
    tooltip: {
      desc: "隐藏预订确认和电子邮件通知中的“重新安排”按钮。"
    }
  },
  hideCancel: {
    label: "隐藏取消选项",
    tooltip: {
      desc: "隐藏预订确认和电子邮件通知中的“取消”按钮。"
    }
  }
}, E3 = {
  headerTitle: "活动描述",
  addAdditionalFields: {
    buttonText: "自动填充其他字段",
    tooltip: {
      desc: "添加完所有您想包含在描述中的字段后点击此处。重要提示：请不要修改'--- Additional Fields ---'和'--- End Additional Fields ---'标记，以确保一切正常运行。"
    }
  },
  tooltip: {
    desc: "活动描述显示在调度器编辑器的管理视图中，并在创建预订时包含在响应中。"
  }
}, x3 = {
  headerTitle: "活动持续时间",
  error: {
    durationMustBeMultipleOf5: "持续时间必须是5的倍数",
    durationMustBeGreaterThan0: "持续时间必须大于0"
  }
}, S3 = {
  headerTitle: "活动信息"
}, C3 = {
  headerTitle: "活动限制"
}, w3 = {
  headerTitle: "活动会议或地点",
  tooltip: {
    desc: "选择一个会议选项或添加一个自定义地点。"
  },
  conferenceOptions: {
    none: "无",
    zoom: "Zoom会议",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "自定义位置"
  }
}, $3 = {
  headerTitle: "活动标题",
  helpText_start: "通过输入创建动态模板事件 {{field}}",
  helpText_end: "并选择模板项创建动态模板活动标题。",
  title: "标题",
  description: "描述",
  tooltip: {
    desc: "例如，与...面试"
  },
  eventTitleRequired: "活动标题是必需的",
  eventTitleTokenDescription: {
    invitee: "主催者の名前",
    inviteeEmail: "主催者のメールアドレス",
    duration: "イベントの長さ"
  }
}, B3 = {
  headerTitle: "限制未来预订",
  tooltip: {
    desc: "限制可以进行预订的未来时间范围。"
  }
}, P3 = {
  headerTitle: "最小预订通知时间",
  tooltip: {
    desc: "可以进行新预订的最短时间。"
  }
}, M3 = {
  headerTitle: "最小取消通知时间",
  tooltip: {
    desc: "取消预订所需的最短时间。"
  }
}, D3 = {
  headerTitle: "页面名称",
  headerSubTitle: "设置日程安排页面的名称。",
  pageNameError: "请输入页面名称",
  tooltip: {
    desc: "默认情况下，日程安排页面使用您的用户名作为页面名称。页面名称显示在日历视图的左上角。"
  }
}, A3 = {
  headerTitle: "页面样式和自定义"
}, L3 = {
  headerTitle: "预订到此日历",
  headerSubTitle: "选择您希望添加活动预订的日历。",
  participantBookingCalendarTitle: "{{participantName}}的预订日历",
  selectAtLeastOneCalendar: "请为每个参与者至少选择一个日历。"
}, O3 = {
  headerTitle: "参与者开放时间",
  headerSubTitle: "如果未设置，将使用默认开放时间来计算该参与者的可用性。",
  participantOpenHoursTitle: "{{participantName}}的开放时间"
}, _3 = {
  headerTitle: "即将举行的会议 {{organizerName}}",
  headerSubTitle: "活动前的提醒",
  editButtonText: "编辑",
  recipientOptions_all: "所有主办方和来宾",
  recipientOptions_guest: "所有活动来宾",
  recipientOptions_host: "仅活动主办方",
  beforeTheEvent: "活动前",
  emailRecipients: {
    label: "电子邮件接收者"
  },
  sendConfirmation: {
    label: "在以下时间发送确认电子邮件",
    tooltip: {
      desc: "接收者将在活动前的指定时间收到提醒邮件。"
    }
  },
  emailSubject: {
    label: "电子邮件主题",
    placeholder: "即将举行的会议 {{organizerName}}"
  },
  reminderMinutesValidationError: "请以5的倍数输入提醒时间（分钟）。尝试 ",
  newReminderButtonText: "新提醒"
}, I3 = {
  headerTitle: "日程安排方法",
  headerSubTitle: "为活动选择一种日程安排方法。",
  tooltip: {
    standard: {
      label: "标准",
      desc: "允许 1:1 预订或包含额外参与者的 n:1 预订。"
    },
    maxFairness: {
      label: "轮询 - 最大公平性",
      desc: "在所选参与者列表中轮询，显示最近预订最少的参与者。"
    },
    maxAvailability: {
      label: "轮询 - 最大可用性",
      desc: "在所选参与者列表中轮询，优先显示最近预订最少的参与者，并尽可能多地提供时间段。"
    }
  },
  schedulingMethodOptions_collective: "标准预订",
  schedulingMethodOptions_maxFairness: "轮询 - 最大公平性",
  schedulingMethodOptions_maxAvailability: "轮询 - 最大可用性"
}, R3 = {
  minutesShort: "分钟",
  lengthOfMeeting: "会议长度",
  headerTitle: "时间段设置",
  timeslotInterval: {
    label: "时间段间隔。"
  },
  timeslotRounding: {
    label: "时间段舍入类型",
    tooltip: {
      desc: "显示时间段的间隔。"
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "间隔舍入",
      desc: "时间段将从舍入到间隔值的时间开始。"
    },
    noRounding: {
      label: "默认",
      desc: "时间段将舍入到最近的15分钟。"
    }
  }
}, N3 = {
  recurrenceOptions: {
    none: "不重复",
    daily: "每天",
    weekly: "每周 {{dayOfWeek}}",
    monthly: "每月 {{dayOfMonth}}",
    monthOnDay: "每月第 {{date}} 天",
    yearly: "每年 {{dateOfMonth}}",
    custom: "自定义"
  },
  recurrenceLabel: "重复此活动",
  endDate: "结束日期",
  customRecurrence: {
    repeatEvery: "每次重复",
    repeatOn: "重复日期",
    ends: "结束",
    endsOptions: {
      never: "从不",
      after: "之后",
      on: "日期"
    },
    occurrences: "次"
  },
  dateTimeLabel: "日期和时间",
  errors: {
    invalidTimeRange: "无效的时间范围",
    startTimeSameAsEndTime: "开始时间和结束时间不能相同",
    startTimeBeforeCurrentDate: "开始时间不能在当前日期之前",
    invalid: "无效"
  }
}, F3 = {
  headerTitle: "受邀者",
  headerSubTitle: "设置此时间段的最大受邀者数量。",
  tooltip: {
    desc: "在计划页面中配置的组织者和参与者不计为受邀者。"
  },
  attendees: "受邀者"
}, U3 = {
  returnToAllSchedulingPages: "返回所有日程安排页面",
  createEventHeaderTitle: "创建活动",
  eventTypeHeaderTitle: "活动类型",
  noEventTypesEnabled: "没有活动类型启用",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "允许 1:1 预订。"
    },
    collective: {
      label: "标准预订",
      desc: "允许 n:1 预订，包括额外参与者。"
    },
    maxFairness: {
      label: "轮询 - 最大公平性",
      desc: "轮询所选参与者列表，显示最近预订最少的参与者。"
    },
    maxAvailability: {
      label: "轮询 - 最大可用性",
      desc: "轮询所选参与者列表，优先显示最近预订最少的参与者，但尽可能多地提供时间段。"
    },
    group: {
      label: "组/班级",
      desc: "这些是通常具有一个组织者和多个参与者的活动。"
    }
  }
}, z3 = "页面设置", H3 = {
  createEventDetails: {
    headerTitle: "事件详情",
    closeButtonTooltip: "关闭",
    cancelButton: "取消",
    createButton: "创建"
  },
  discardChanges: {
    headerTitle: "确定要放弃未保存的更改吗？",
    cancelButton: "取消",
    discardButton: "放弃"
  },
  unsavedChanges: "未保存的更改",
  editEventDetails: {
    headerTitle: "事件详情",
    closeButtonTooltip: "关闭",
    deleteButton: "删除",
    saveButton: "保存",
    pastEventTooltip: "此事件已过去，无法编辑。"
  },
  importEvent: {
    closeButtonTooltip: "关闭",
    importButton: "导入",
    participantsLabel: "参与者"
  },
  deleteEvent: {
    closeButtonTooltip: "关闭",
    deleting: "删除中..."
  },
  editOptions: {
    headerTitle: "选项",
    closeButtonTooltip: "关闭",
    deleting: "删除中...",
    import: "导入",
    edit: "编辑",
    deleteThis: "删除此事件",
    deleteAll: "删除所有事件"
  },
  updateOptions: {
    updateThis: "更新此事件",
    updateAll: "更新所有事件",
    updateFuture: "更新所有未来事件"
  },
  deleteOptions: {
    deleteThis: "删除",
    deleteFuture: "删除此事件和所有未来事件",
    deleteAll: "删除所有事件"
  }
}, z8 = {
  noDateSelected: iT,
  rescheduleTitle: aT,
  allDay: rT,
  today: oT,
  spotsLeft: sT,
  search: lT,
  days: uT,
  time: cT,
  months: dT,
  multipleOptionsSelected: fT,
  selectAtLeastOneOption: gT,
  nextButton: hT,
  selectedDayAndYear: mT,
  selectedTime: pT,
  name: bT,
  namePlaceholder: yT,
  email: vT,
  emailPlaceholder: TT,
  guestEmail: kT,
  guestEmailPlaceholder: ET,
  addGuest: xT,
  addAnotherGuest: ST,
  backButton: CT,
  bookNowButton: wT,
  bookingConfirmed: $T,
  bookingConfirmedDescription: BT,
  bookingSent: PT,
  bookingSentDescription: MT,
  bookingRescheduled: DT,
  bookingDateAndTimeHeader: AT,
  cancelBookingButton: LT,
  rescheduleBookingButton: OT,
  rejectBookingButton: _T,
  confirmBookingButton: IT,
  bookingPendingTitle: RT,
  bookingPendingnDescription: NT,
  confirmedEventCardTitle: FT,
  confirmedEventCardDescription: UT,
  cancelBookingTitle: zT,
  cancelBookingMessage: HT,
  reasonForCancellation: jT,
  goBackButton: qT,
  bookingCancelledTitle: YT,
  bookingCancelledMessage: VT,
  bookingCancelledMessage_theParticipants: GT,
  closeButton: WT,
  closingButton: KT,
  fieldRequired: ZT,
  invalidInputFormat: JT,
  createBookingErrorTitle: QT,
  getAvailabilityErrorTitle: XT,
  cancelBookingErrorTitle: ek,
  rescheduleBookingErrorTitle: tk,
  getUISettingErrorTitle: nk,
  rejectBookingErrorTitle: ik,
  confirmBookingErrorTitle: ak,
  genericErrorTitle: rk,
  schedulingComponentErrorTitle: ok,
  sessionIdRequiredErrorMessage: sk,
  publicConfigErrorMessage: lk,
  invalidTimeslotErrorTitle: uk,
  invalidTimeslotErrorMessage: ck,
  cancellationErrorTitle: dk,
  cancellationErrorMessage: fk,
  minimumCancellationErrorMessage: gk,
  cancelBokingFormError: hk,
  feedbackFormTitle: mk,
  feedbackFormDescription: pk,
  feedbackMessageLabel: bk,
  feedbackMessagePlaceholder: yk,
  feedbackModalCloseButton: vk,
  feedbackModalSubmitButton: Tk,
  deleteSchedulingPageTitle: kk,
  deleteSchedulingPageDescription: Ek,
  deleteSchedulingPageConfirmButton: xk,
  deleteSchedulingPageCancelButton: Sk,
  schedulerEditorTitle: Ck,
  allSchedulingPages: wk,
  createAndManageSchedulingPages: $k,
  createNewSchedulingPageButtonText: Bk,
  pageTitle: Pk,
  durationTitle: Mk,
  loading: Dk,
  required: Ak,
  optional: Lk,
  loadingPagesDescription: Ok,
  noSchedulingPages: _k,
  createFirstSchedulingPage: Ik,
  editSchedulingPageButtonText: Rk,
  eventInfoTab: Nk,
  availabilityTab: Fk,
  participantsTab: Uk,
  bookingOptionsTab: zk,
  returnToCalendarView: Hk,
  bookingFormTab: jk,
  communicationsTab: qk,
  pageStylesTab: Yk,
  savingButtonText: Vk,
  saveChangesButtonText: Gk,
  createButtonText: Wk,
  timePeriod_day: Kk,
  timePeriod_week: Zk,
  timePeriod_month: Jk,
  timePeriod_year: Qk,
  timeDuration_minute: Xk,
  timeDuration_hour: e3,
  eventCommunicationsTitle: t3,
  eventCommunicationsDescription: n3,
  unsavedChangesLabel: i3,
  changesSavedLabel: a3,
  fixFormErrors: r3,
  nylasEditorTabs: o3,
  nylasListConfigurations: s3,
  nylasAdditionalParticipants: l3,
  nylasAvailabilityPicker: u3,
  nylasBookingCalendarPicker: c3,
  nylasBookingConfirmationRedirect: d3,
  nylasBookingConfirmationType: f3,
  nylasBookingFormConfig: g3,
  nylasBufferTime: h3,
  nylasCalendarPicker: m3,
  nylasCancellationPolicy: p3,
  nylasConfirmationEmail: b3,
  nylasConnectedCalendars: y3,
  nylasCustomBookingFlow: v3,
  nylasCustomEventSlug: T3,
  nylasCustomizeBookingSettings: k3,
  nylasEventDescription: E3,
  nylasEventDuration: x3,
  nylasEventInfo: S3,
  nylasEventLimits: C3,
  nylasEventLocation: w3,
  nylasEventTitle: $3,
  nylasLimitFutureBookings: B3,
  nylasMinBookingNotice: P3,
  nylasMinCancellationNotice: M3,
  nylasPageName: D3,
  nylasPageStyling: A3,
  nylasParticipantBookingCalendars: L3,
  nylasParticipantCustomAvailability: O3,
  nylasReminderEmails: _3,
  nylasSchedulingMethod: I3,
  nylasTimeslotInterval: R3,
  nylasEventTimeslot: N3,
  nylasEventCapacity: F3,
  nylasSelectEventType: U3,
  pageSettingsButton: z3,
  nylasEventCalendar: H3
}, H8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: iT,
  rescheduleTitle: aT,
  allDay: rT,
  today: oT,
  spotsLeft: sT,
  search: lT,
  days: uT,
  time: cT,
  months: dT,
  multipleOptionsSelected: fT,
  selectAtLeastOneOption: gT,
  nextButton: hT,
  selectedDayAndYear: mT,
  selectedTime: pT,
  name: bT,
  namePlaceholder: yT,
  email: vT,
  emailPlaceholder: TT,
  guestEmail: kT,
  guestEmailPlaceholder: ET,
  addGuest: xT,
  addAnotherGuest: ST,
  backButton: CT,
  bookNowButton: wT,
  bookingConfirmed: $T,
  bookingConfirmedDescription: BT,
  bookingSent: PT,
  bookingSentDescription: MT,
  bookingRescheduled: DT,
  bookingDateAndTimeHeader: AT,
  cancelBookingButton: LT,
  rescheduleBookingButton: OT,
  rejectBookingButton: _T,
  confirmBookingButton: IT,
  bookingPendingTitle: RT,
  bookingPendingnDescription: NT,
  confirmedEventCardTitle: FT,
  confirmedEventCardDescription: UT,
  cancelBookingTitle: zT,
  cancelBookingMessage: HT,
  reasonForCancellation: jT,
  goBackButton: qT,
  bookingCancelledTitle: YT,
  bookingCancelledMessage: VT,
  bookingCancelledMessage_theParticipants: GT,
  closeButton: WT,
  closingButton: KT,
  fieldRequired: ZT,
  invalidInputFormat: JT,
  createBookingErrorTitle: QT,
  getAvailabilityErrorTitle: XT,
  cancelBookingErrorTitle: ek,
  rescheduleBookingErrorTitle: tk,
  getUISettingErrorTitle: nk,
  rejectBookingErrorTitle: ik,
  confirmBookingErrorTitle: ak,
  genericErrorTitle: rk,
  schedulingComponentErrorTitle: ok,
  sessionIdRequiredErrorMessage: sk,
  publicConfigErrorMessage: lk,
  invalidTimeslotErrorTitle: uk,
  invalidTimeslotErrorMessage: ck,
  cancellationErrorTitle: dk,
  cancellationErrorMessage: fk,
  minimumCancellationErrorMessage: gk,
  cancelBokingFormError: hk,
  feedbackFormTitle: mk,
  feedbackFormDescription: pk,
  feedbackMessageLabel: bk,
  feedbackMessagePlaceholder: yk,
  feedbackModalCloseButton: vk,
  feedbackModalSubmitButton: Tk,
  deleteSchedulingPageTitle: kk,
  deleteSchedulingPageDescription: Ek,
  deleteSchedulingPageConfirmButton: xk,
  deleteSchedulingPageCancelButton: Sk,
  schedulerEditorTitle: Ck,
  allSchedulingPages: wk,
  createAndManageSchedulingPages: $k,
  createNewSchedulingPageButtonText: Bk,
  pageTitle: Pk,
  durationTitle: Mk,
  loading: Dk,
  required: Ak,
  optional: Lk,
  loadingPagesDescription: Ok,
  noSchedulingPages: _k,
  createFirstSchedulingPage: Ik,
  editSchedulingPageButtonText: Rk,
  eventInfoTab: Nk,
  availabilityTab: Fk,
  participantsTab: Uk,
  bookingOptionsTab: zk,
  returnToCalendarView: Hk,
  bookingFormTab: jk,
  communicationsTab: qk,
  pageStylesTab: Yk,
  savingButtonText: Vk,
  saveChangesButtonText: Gk,
  createButtonText: Wk,
  timePeriod_day: Kk,
  timePeriod_week: Zk,
  timePeriod_month: Jk,
  timePeriod_year: Qk,
  timeDuration_minute: Xk,
  timeDuration_hour: e3,
  eventCommunicationsTitle: t3,
  eventCommunicationsDescription: n3,
  unsavedChangesLabel: i3,
  changesSavedLabel: a3,
  fixFormErrors: r3,
  nylasEditorTabs: o3,
  nylasListConfigurations: s3,
  nylasAdditionalParticipants: l3,
  nylasAvailabilityPicker: u3,
  nylasBookingCalendarPicker: c3,
  nylasBookingConfirmationRedirect: d3,
  nylasBookingConfirmationType: f3,
  nylasBookingFormConfig: g3,
  nylasBufferTime: h3,
  nylasCalendarPicker: m3,
  nylasCancellationPolicy: p3,
  nylasConfirmationEmail: b3,
  nylasConnectedCalendars: y3,
  nylasCustomBookingFlow: v3,
  nylasCustomEventSlug: T3,
  nylasCustomizeBookingSettings: k3,
  nylasEventDescription: E3,
  nylasEventDuration: x3,
  nylasEventInfo: S3,
  nylasEventLimits: C3,
  nylasEventLocation: w3,
  nylasEventTitle: $3,
  nylasLimitFutureBookings: B3,
  nylasMinBookingNotice: P3,
  nylasMinCancellationNotice: M3,
  nylasPageName: D3,
  nylasPageStyling: A3,
  nylasParticipantBookingCalendars: L3,
  nylasParticipantCustomAvailability: O3,
  nylasReminderEmails: _3,
  nylasSchedulingMethod: I3,
  nylasTimeslotInterval: R3,
  nylasEventTimeslot: N3,
  nylasEventCapacity: F3,
  nylasSelectEventType: U3,
  pageSettingsButton: z3,
  nylasEventCalendar: H3,
  default: z8
}), j3 = "Geen datum geselecteerd", q3 = "Kies een ander tijdslot om je afspraak te verzetten", Y3 = "Alle dag", V3 = "Vandaag", G3 = "{{count}} plaatsen over", W3 = "Zoeken", K3 = {
  sunday: "ZO",
  monday: "MA",
  tuesday: "DI",
  wednesday: "WO",
  thursday: "DO",
  friday: "VR",
  saturday: "ZA"
}, Z3 = {
  hour: "uur",
  hours: "uren",
  minute: "minuut",
  minutes: "minuten",
  day: "dag",
  days: "dagen",
  week: "week",
  weeks: "weken",
  month: "maand",
  months: "maanden",
  year: "jaar",
  years: "jaren"
}, J3 = {
  january: "Januari",
  february: "Februari",
  march: "Maart",
  april: "April",
  may: "Mei",
  june: "Juni",
  july: "Juli",
  august: "Augustus",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "December"
}, Q3 = "Meerdere opties geselecteerd", X3 = "Selecteer minstens één optie", eE = "Volgende", tE = "{{date}}", nE = "{{time}}", iE = "Naam", aE = "Voer je naam in", rE = "E-mail", oE = "Voer je e-mail in", sE = "E-mail van gast", lE = "Voer het e-mailadres van de gast in", uE = "Gast toevoegen", cE = "Nog een gast toevoegen", dE = "Terug", fE = "Boek nu", gE = "Boeking bevestigd", hE = "U ontvangt binnenkort een e-mailbevestiging.", mE = "Boeking verzonden", pE = "U ontvangt een e-mail zodra de boeking is bevestigd.", bE = "Boeking verplaatst", yE = "Boekingsdatum en -tijd", vE = "Boeking annuleren", TE = "Herplannen", kE = "Boeking afwijzen", EE = "Boeking bevestigen", xE = "Boeking in afwachting", SE = "Beheer uw boeking hieronder. De genodigde ontvangt een e-mail over de status van de aanvraag.", CE = "Uw boeking is succesvol bevestigd", wE = "Een bevestigingsmail is verzonden naar", $E = "Boeking annuleren?", BE = "Uw huidige tijdslot zal beschikbaar worden voor anderen.", PE = "Reden voor annulering", ME = "Ga terug", DE = "Uw boeking is succesvol geannuleerd", AE = "Er is een annuleringsmail verzonden naar", LE = "deelnemers", OE = "Sluiten", _E = "Sluiten", IE = "{{field}} is vereist.", RE = "{{field}} heeft een ongeldig formaat.", NE = "Boeking Maken", FE = "Beschikbaarheid Opvragen", UE = "Boeking Annuleren", zE = "Boeking Wijzigen", HE = "UI-instellingen Ophalen", jE = "Boeking Afwijzen", qE = "Boeking Bevestigen", YE = "Er is iets misgegaan...", VE = "Geen sessie-ID!", GE = "Fout in planningscomponent", WE = "'sessionId' is vereist voor privéconfiguraties.", KE = "Als u een openbare configuratie gebruikt, geeft u een configurationId of een combinatie van 'slug' en 'clientId' door.", ZE = "Het geselecteerde tijdslot is ongeldig", JE = "Annuleringsfout", QE = "Geef een reden op voor de annulering.", XE = "U kunt de boeking niet annuleren binnen {{minCancellationNotice}} minuten voor het evenement", ex = "Fout in het annuleringsformulier", tx = "Deel uw feedback", nx = "Door ons uw feedback te geven en fouten te melden, helpt u ons een betere ervaring voor u te creëren.", ix = "Geef ons een gedetailleerde beschrijving van de functie waarover u commentaar geeft of waar u een probleem heeft ondervonden.", ax = "Geef hier uw feedback", rx = "Sluiten", ox = "Verzenden", sx = "Deze planningspagina verwijderen?", lx = "Na bevestiging worden deze pagina en de gekoppelde planningslinks permanent verwijderd en gedeactiveerd. Deze actie kan niet ongedaan worden gemaakt.", ux = "Pagina verwijderen", cx = "Annuleren", dx = "Planner Editor", fx = "Alle planningspagina's", gx = "Maak en beheer uw planningspagina's.", hx = "Nieuwe maken", mx = "Paginatitel", px = "Duur", bx = "Bezig met laden", yx = "Vereist", vx = "Optioneel", Tx = "Even geduld terwijl we de planningspagina's ophalen", kx = "Geen planningspagina's gevonden", Ex = "Begin met het maken van uw eerste planningspagina", xx = "Bewerken", Sx = "Evenementinfo", Cx = "Beschikbaarheid", wx = "Deelnemers", $x = "Boekingsopties", Bx = "Terug naar de kalenderweergave", Px = "Boekingsformulier", Mx = "Communicatie", Dx = "Paginastijlen", Ax = "Opslaan", Lx = "Wijzigingen opslaan", Ox = "Aanmaken", _x = "dag", Ix = "week", Rx = "maand", Nx = "jaar", Fx = "minuut", Ux = "uur", zx = "Evenementcommunicatie", Hx = "Stel automatische bevestigingsmails in.", jx = "Niet-opgeslagen wijzigingen", qx = "Wijzigingen opgeslagen", Yx = "Corrigeer de formulierfouten.", Vx = {
  bookingFormError: "Boekingsformulierfout: ",
  bookingFormError_label: "Label is vereist voor het veld van type {{type}}.",
  bookingFormError_option: "Lege optie gedetecteerd binnen {{label}} van type {{type}}."
}, Gx = {
  previewButtonText: "Voorbeeld",
  copyLinkButtonText: "Kopieer link",
  deleteButtonText: "Verwijderen"
}, Wx = {
  headerTitle: "Deelnemers",
  headerSubTitle: "Voeg mensen van uw team of organisatie toe aan het evenement.",
  organizerAsParticipant: "Deelnemer",
  organizer: "Organisator",
  participant: "Deelnemer",
  addParticipant_first: "Een deelnemer toevoegen",
  addParticipant_next: "Nog een deelnemer toevoegen",
  tooltip: {
    includeOrganizer: "Organisator opnemen",
    includeOrganizerDesc: "De organisator (u) wordt opgenomen in de beurtrolrotatie.",
    excludeOrganizer: "Organisator uitsluiten",
    excludeOrganizerDesc: "De organisator (u) wordt niet opgenomen in de beurtrolrotatie."
  },
  error: "Voeg minstens één deelnemer toe"
}, Kx = {
  headerTitle: "Standaard openingstijden",
  headerSubTitle: "Stel in wanneer u regelmatig beschikbaar bent voor boekingen.",
  tooltip: {
    desc: "Dit is de standaard beschikbaarheid voor deelnemers die geen beschikbaarheid hebben ingesteld op het tabblad Deelnemers."
  },
  selectTimezone: "Selecteer tijdzone",
  unavailable: "Niet beschikbaar",
  days: {
    SUN: "ZON",
    MON: "MAA",
    TUE: "DIN",
    WED: "WOE",
    THU: "DON",
    FRI: "VRIJ",
    SAT: "ZAT"
  },
  errors: {
    invalid: "Ongeldig"
  }
}, Zx = {
  headerTitle: "Kalender boeken",
  headerSubTitle: "Selecteer de kalender waarin u boekingen wilt toevoegen.",
  tooltip: {
    desc: "De kalender wordt gebruikt om evenementen te maken."
  },
  selectOptionLabel: "Selecteer een optie",
  selectCalendarErrorMessage: "Selecteer een kalender"
}, Jx = {
  dropdownLabel: "Wanneer een boeking wordt bevestigd",
  tooltip: {
    desc: "U kunt de standaard bevestigingspagina weergeven of gebruikers omleiden naar uw eigen bevestigingspagina."
  },
  redirectOption_default: "Standaard bevestigingspagina weergeven",
  redirectOption_custom: "Omleiden naar aangepaste URL"
}, Qx = {
  dropdownLabel: "Wanneer een boeking wordt aangevraagd",
  tooltip: {
    desc: "Handmatig accepteren van boekingen stelt u in staat om elke boekingsaanvraag te beoordelen en te accepteren of te weigeren."
  },
  bookingOption_booking: "Boekingen automatisch accepteren",
  bookingOption_organizerConfirmation: "Boekingen handmatig accepteren"
}, Xx = {
  headerTitle: "Boekingsformulier",
  headerSubTitle: "Voeg aangepaste velden toe aan het boekingsformulier.",
  dropdownButtonText: "Nieuw veld toevoegen",
  addOption: "Optie toevoegen",
  allOptionsHeader: "ALLE OPTIES",
  fieldInTitleError: "Dit veld wordt gebruikt in de evenementtitel en kan niet worden verwijderd.",
  fieldInDescriptionError: "Dit veld wordt gebruikt in de evenementbeschrijving en kan niet worden verwijderd.",
  label: "Label",
  defaultValue: "Standaardwaarde",
  fieldType: {
    text: "Korte tekst",
    multi_line_text: "Lange tekst",
    email: "E-mail",
    phone_number: "Telefoonnummer",
    dropdown: "Keuzelijst",
    radio_button: "Radioknop",
    checkbox: "Selectievakje",
    date: "Datum",
    metadata: "Metadata",
    multi_select: "Meervoudige selectie"
  },
  fieldLabel: {
    your_name: "Uw naam",
    your_email: "Uw e-mail",
    email: "Aanvullende e-mail",
    phone_number: "Telefoonnummer label",
    dropdown: "Dropdown label",
    text: "Korte tekst label",
    multi_line_text: "Lange tekst label",
    radio_button: "Radioknop label",
    checkbox: "Selectievakje label",
    date: "Datum label",
    metadata: "Metadata label",
    multi_select: "Meervoudige selectie label"
  }
}, eS = {
  headerTitle: "Buffertijd",
  headerSubTitle: "Vereist lege buffertijd vóór en na een evenement.",
  tooltip: {
    desc: "De planner boekt de buffertijd niet."
  },
  beforeBufferLabel: "Voor het evenement",
  afterBufferLabel: "Na het evenement",
  minutesShort: "min",
  previewHeader: "VOORBEELD"
}, tS = {
  calendarPickerLabel: "Selecteer agenda's die worden gecontroleerd op beschikbaarheid",
  selectAtLeastOneCalendar: "Selecteer minstens één agenda voor elke deelnemer."
}, nS = {
  cancellationPolicyLabel: "Annuleringsbeleid bericht",
  tooltip: {
    desc: "Deelnemers ontvangen dit bericht als ze proberen het evenement te annuleren. Ze worden gevraagd een reden voor annulering op te geven."
  }
}, iS = {
  headerTitle: "Boeking bevestigd{{organizerName}}",
  headerSubTitle: "Bevestigingsmail voor boeking",
  editButtonText: "Bewerken",
  error: {
    invalidImageUrl: "Ongeldige afbeelding URL."
  },
  confirmationEmail: {
    label: "E-mailmeldingen inschakelen",
    tooltip: {
      desc: "Sta Nylas toe e-mailmeldingen te verzenden, inclusief bevestigingsberichten en evenementherinneringen.",
      language: "Deze taal wordt gebruikt voor e-mailmeldingen aan de organisatoren."
    },
    language: "Taal selecteren"
  },
  nylasBranding: {
    label: "Nylas-branding tonen",
    tooltip: {
      desc: "Schakel dit uit om de voettekst in de e-mailcommunicatie te verbergen."
    }
  },
  companyLogoUrl: {
    label: "Bedrijfslogo-URL",
    tooltip: {
      desc: "Dit logo verschijnt in de bevestigingsmail voor boeking. De URL moet openbaar toegankelijk zijn. De afbeelding wordt verkleind tot een maximale grootte van 200px x 100px."
    }
  },
  emailMessage: {
    header: "E-mailbericht",
    label: "Aangepaste e-mailtitel",
    tooltip: {
      desc: "Een e-mailtitel is een kop in de e-mailtekst. Dit wijzigt de onderwerpregel niet."
    },
    additionalInfoLabel: "Aanvullende informatie",
    additionalInfoTooltip: "De planner voegt de inhoud van dit veld toe aan de e-mailtekst.",
    additionalInfoPlaceholder: "Standaardtekst"
  },
  allHosts: "Alle hosts en gasten",
  immediatelyUponBooking: "Direct na boeking"
}, aS = {
  headerTitle: "Verbonden agenda's",
  headerSubTitle: "Selecteer de agenda's die worden gebruikt om uw beschikbaarheid te controleren.",
  tooltip: {
    desc: "Controleer beschikbaarheid in een of meer agenda's. Als u meerdere agenda's voor een deelnemer selecteert, moet de deelnemer in al zijn agenda's beschikbaar zijn om als beschikbaar te worden beschouwd."
  },
  participantCalendarTitle: "Verbonden agenda's van {{participantName}}",
  selectAtLeastOneCalendar: "Selecteer minstens één agenda voor elke deelnemer."
}, rS = {
  headerTitle: "Aangepaste boekingsflow"
}, oS = {
  headerTitle: "Aangepaste pagina slug",
  headerSubTitle: "Maak een aangepaste URL-slug voor deze pagina.",
  eventSlugLabel: "Pagina-URL-slug",
  tooltip: {
    desc: "Geef een aangepaste slug op voor uw URL om uw pagina uniek te identificeren (alleen letters, cijfers en streepjes)."
  },
  copied: "Gekopieerd!"
}, sS = {
  headerTitle: "Aanvullende instellingen",
  headerSubTitle: "Boekingsinstellingen voor het evenement.",
  tooltip: {
    desc: "Pas uw boekingsinstellingen aan."
  },
  allowGuests: {
    label: "Sta gasten toe om extra gasten uit te nodigen."
  },
  hideReschedule: {
    label: "Optie voor herplanning verbergen.",
    tooltip: {
      desc: "Verberg de knop 'Herplannen' in de boekingsbevestiging en e-mailmeldingen."
    }
  },
  hideCancel: {
    label: "Optie voor annuleren verbergen",
    tooltip: {
      desc: "Verberg de knop 'Annuleren' in de boekingsbevestiging en e-mailmeldingen."
    }
  }
}, lS = {
  headerTitle: "Eventbeschrijving",
  addAdditionalFields: {
    buttonText: "Extra velden automatisch invullen",
    tooltip: {
      desc: "Klik hierop nadat u alle velden heeft toegevoegd die u in de beschrijving wilt opnemen. Belangrijk: Laat de markeringen '--- Additional Fields ---' en '--- End Additional Fields ---' ongewijzigd om ervoor te zorgen dat alles correct werkt."
    }
  },
  tooltip: {
    desc: "De eventbeschrijving wordt weergegeven in de beheerweergave van de planner en in het antwoord als een boeking wordt gemaakt."
  }
}, uS = {
  headerTitle: "Duur van het evenement",
  error: {
    durationMustBeMultipleOf5: "De duur moet een veelvoud van 5 zijn",
    durationMustBeGreaterThan0: "De duur moet groter zijn dan 0"
  }
}, cS = {
  headerTitle: "Eventinformatie"
}, dS = {
  headerTitle: "Eventlimieten"
}, fS = {
  headerTitle: "Evenementlocatie of vergadering",
  tooltip: {
    desc: "Kies een conferentieoptie of voeg een aangepaste locatie toe."
  },
  conferenceOptions: {
    none: "Geen",
    zoom: "Zoom-vergadering",
    google: "Google Meet",
    microsoft: "Microsoft Teams",
    custom: "Aangepaste locatie"
  }
}, gS = {
  headerTitle: "Eventtitel",
  helpText_start: "Maak een dynamische gebeurtenis met sjabloon {{field}} door te typen",
  helpText_end: "en een template-item te selecteren.",
  title: "titel",
  description: "beschrijving",
  tooltip: {
    desc: "Bijvoorbeeld: Interview met"
  },
  eventTitleRequired: "Eventtitel is vereist",
  eventTitleTokenDescription: {
    invitee: "De naam van de hoofdinzijer.",
    inviteeEmail: "De e-mailadres van de hoofdinzijer.",
    duration: "De duur van het evenement."
  }
}, hS = {
  headerTitle: "Beperk toekomstige boekingen",
  tooltip: {
    desc: "De limiet voor hoe ver in de toekomst boekingen kunnen worden gemaakt."
  }
}, mS = {
  headerTitle: "Minimale boekingsmelding",
  tooltip: {
    desc: "De minimale hoeveelheid tijd in de toekomst waarin een nieuwe boeking kan worden gemaakt."
  }
}, pS = {
  headerTitle: "Minimale annuleringsmelding",
  tooltip: {
    desc: "De minimale hoeveelheid tijd die nodig is om een boeking te annuleren."
  }
}, bS = {
  headerTitle: "Paginanaam",
  headerSubTitle: "Stel de naam van de planningspagina in.",
  pageNameError: "Voer een paginanaam in",
  tooltip: {
    desc: "Standaard gebruiken planningspagina's uw gebruikersnaam als paginanaam. De paginanaam wordt weergegeven in de linkerbovenhoek van de kalenderweergave."
  }
}, yS = {
  headerTitle: "Pagina-opmaak en -aanpassing"
}, vS = {
  headerTitle: "Boeken naar deze agenda",
  headerSubTitle: "Selecteer de agenda waarin u boekingen voor evenementen wilt toevoegen.",
  participantBookingCalendarTitle: "{{participantName}}'s boekingsagenda's",
  selectAtLeastOneCalendar: "Selecteer minstens één agenda voor elke deelnemer."
}, TS = {
  headerTitle: "Beschikbaarheid van deelnemer",
  headerSubTitle: "Als deze niet is ingesteld, worden de standaard openingstijden gebruikt om de beschikbaarheid voor deze deelnemer te berekenen.",
  participantOpenHoursTitle: "{{participantName}}'s openingstijden"
}, kS = {
  headerTitle: "Komende vergadering {{organizerName}}",
  headerSubTitle: "Herinnering vóór evenement",
  editButtonText: "Bewerken",
  recipientOptions_all: "Alle hosts en gasten",
  recipientOptions_guest: "Alle gasten van het evenement",
  recipientOptions_host: "Alleen evenementhost",
  beforeTheEvent: "voor het evenement",
  emailRecipients: {
    label: "E-mailontvangers"
  },
  sendConfirmation: {
    label: "Stuur een bevestigingsmail wanneer",
    tooltip: {
      desc: "De ontvangers ontvangen een herinneringsmail op het opgegeven tijdstip vóór het evenement."
    }
  },
  emailSubject: {
    label: "Onderwerp van de e-mail",
    placeholder: "Komende vergadering {{organizerName}}"
  },
  reminderMinutesValidationError: "Voer de herinneringsminuten in veelvouden van 5 in. Probeer ",
  newReminderButtonText: "Nieuwe herinnering"
}, ES = {
  headerTitle: "Planningsmethode",
  headerSubTitle: "Selecteer een planningsmethode voor het evenement.",
  tooltip: {
    standard: {
      label: "Standaard",
      desc: "Staat 1:1 boekingen of n:1 boekingen toe met extra deelnemers."
    },
    maxFairness: {
      label: "Rondgang - Maximale eerlijkheid",
      desc: "Doorloopt de lijst met geselecteerde deelnemers en toont de deelnemer met de minste recente boekingen."
    },
    maxAvailability: {
      label: "Rondgang - Maximale beschikbaarheid",
      desc: "Doorloopt de lijst met geselecteerde deelnemers, prioriteert deelnemers met de minste boekingen, maar maakt zoveel mogelijk tijdslots beschikbaar."
    }
  },
  schedulingMethodOptions_collective: "Standaard boeking",
  schedulingMethodOptions_maxFairness: "Rondgang - Maximale eerlijkheid",
  schedulingMethodOptions_maxAvailability: "Rondgang - Maximale beschikbaarheid"
}, xS = {
  minutesShort: "min",
  lengthOfMeeting: "Lengte van de vergadering",
  headerTitle: "Tijdslotinstellingen",
  timeslotInterval: {
    label: "Tijdslotinterval."
  },
  timeslotRounding: {
    label: "Type tijdslotafronding",
    tooltip: {
      desc: "Het interval waarop tijdslots worden weergegeven."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "Intervalafronding",
      desc: "Tijdslots beginnen op tijden die zijn afgerond op de intervalwaarde."
    },
    noRounding: {
      label: "Standaard",
      desc: "Tijdslots worden afgerond op het dichtstbijzijnde kwartier."
    }
  }
}, SS = {
  recurrenceOptions: {
    none: "Herhaalt niet",
    daily: "Dagelijks",
    weekly: "Wekelijks elke {{dayOfWeek}}",
    monthly: "Maandelijks op {{dayOfMonth}}",
    monthOnDay: "Maandelijks op dag {{date}}",
    yearly: "Jaarlijks op {{dateOfMonth}}",
    custom: "Aangepast"
  },
  recurrenceLabel: "Herhaal dit evenement",
  endDate: "Einddatum",
  customRecurrence: {
    repeatEvery: "Herhaal elke",
    repeatOn: "Herhaal op",
    ends: "Eindigt",
    endsOptions: {
      never: "Nooit",
      after: "Na",
      on: "Op"
    },
    occurrences: "keer"
  },
  dateTimeLabel: "Datum en tijd",
  errors: {
    invalidTimeRange: "Ongeldige tijdsperiode",
    startTimeSameAsEndTime: "Starttijd en eindtijd kunnen niet dezelfde zijn",
    startTimeBeforeCurrentDate: "Starttijd kan niet in het verleden liggen",
    invalid: "Ongeldig"
  }
}, CS = {
  headerTitle: "Genodigden",
  headerSubTitle: "Stel het maximale aantal genodigden in voor dit tijdslot van het evenement.",
  tooltip: {
    desc: "De organisator en deelnemers die zijn geconfigureerd op de planningspagina worden niet als genodigden geteld."
  },
  attendees: "genodigden"
}, wS = {
  returnToAllSchedulingPages: "Terug naar alle planningspagina's",
  createEventHeaderTitle: "Evenement maken",
  eventTypeHeaderTitle: "Evenementtype",
  noEventTypesEnabled: "Geen evenementtypen ingeschakeld",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "Staat 1:1 boekingen toe."
    },
    collective: {
      label: "Standaard boeking",
      desc: "Staat n:1 boekingen toe met extra deelnemers."
    },
    maxFairness: {
      label: "Rondgang - Maximale eerlijkheid",
      desc: "Doorloopt de lijst met geselecteerde deelnemers en toont de deelnemer met de minste recente boekingen."
    },
    maxAvailability: {
      label: "Rondgang - Maximale beschikbaarheid",
      desc: "Doorloopt de lijst met geselecteerde deelnemers, prioriteert deelnemers met de minste boekingen, maar maakt zoveel mogelijk tijdslots beschikbaar."
    },
    group: {
      label: "Groep / Klasse",
      desc: "Dit zijn evenementen die meestal één organisator en meerdere deelnemers hebben."
    }
  }
}, $S = "Pagina-instellingen", BS = {
  createEventDetails: {
    headerTitle: "Evenementdetails",
    closeButtonTooltip: "Sluiten",
    cancelButton: "Annuleren",
    createButton: "Maken"
  },
  discardChanges: {
    headerTitle: "Wilt u de wijzigingen annuleren?",
    cancelButton: "Annuleren",
    discardButton: "Annuleren"
  },
  unsavedChanges: "Ongewijzigde wijzigingen",
  editEventDetails: {
    headerTitle: "Evenementdetails",
    closeButtonTooltip: "Sluiten",
    deleteButton: "Verwijderen",
    saveButton: "Opslaan",
    pastEventTooltip: "Dit evenement is in het verleden en kan niet worden gewijzigd."
  },
  importEvent: {
    closeButtonTooltip: "Sluiten",
    importButton: "Importeren",
    participantsLabel: "Deelnemers"
  },
  deleteEvent: {
    closeButtonTooltip: "Sluiten",
    deleting: "Verwijderen..."
  },
  editOptions: {
    headerTitle: "Opties",
    closeButtonTooltip: "Sluiten",
    deleting: "Verwijderen...",
    import: "Importeren",
    edit: "Bewerken",
    deleteThis: "Dit evenement verwijderen",
    deleteAll: "Alle evenementen verwijderen"
  },
  updateOptions: {
    updateThis: "Dit evenement bijwerken",
    updateAll: "Alle evenementen bijwerken",
    updateFuture: "Alle toekomstige evenementen bijwerken"
  },
  deleteOptions: {
    deleteThis: "Verwijderen",
    deleteFuture: "Dit evenement en alle toekomstige evenementen verwijderen",
    deleteAll: "Alle evenementen verwijderen"
  }
}, j8 = {
  noDateSelected: j3,
  rescheduleTitle: q3,
  allDay: Y3,
  today: V3,
  spotsLeft: G3,
  search: W3,
  days: K3,
  time: Z3,
  months: J3,
  multipleOptionsSelected: Q3,
  selectAtLeastOneOption: X3,
  nextButton: eE,
  selectedDayAndYear: tE,
  selectedTime: nE,
  name: iE,
  namePlaceholder: aE,
  email: rE,
  emailPlaceholder: oE,
  guestEmail: sE,
  guestEmailPlaceholder: lE,
  addGuest: uE,
  addAnotherGuest: cE,
  backButton: dE,
  bookNowButton: fE,
  bookingConfirmed: gE,
  bookingConfirmedDescription: hE,
  bookingSent: mE,
  bookingSentDescription: pE,
  bookingRescheduled: bE,
  bookingDateAndTimeHeader: yE,
  cancelBookingButton: vE,
  rescheduleBookingButton: TE,
  rejectBookingButton: kE,
  confirmBookingButton: EE,
  bookingPendingTitle: xE,
  bookingPendingnDescription: SE,
  confirmedEventCardTitle: CE,
  confirmedEventCardDescription: wE,
  cancelBookingTitle: $E,
  cancelBookingMessage: BE,
  reasonForCancellation: PE,
  goBackButton: ME,
  bookingCancelledTitle: DE,
  bookingCancelledMessage: AE,
  bookingCancelledMessage_theParticipants: LE,
  closeButton: OE,
  closingButton: _E,
  fieldRequired: IE,
  invalidInputFormat: RE,
  createBookingErrorTitle: NE,
  getAvailabilityErrorTitle: FE,
  cancelBookingErrorTitle: UE,
  rescheduleBookingErrorTitle: zE,
  getUISettingErrorTitle: HE,
  rejectBookingErrorTitle: jE,
  confirmBookingErrorTitle: qE,
  genericErrorTitle: YE,
  noSessionIdErrorTitle: VE,
  schedulingComponentErrorTitle: GE,
  sessionIdRequiredErrorMessage: WE,
  publicConfigErrorMessage: KE,
  invalidTimeslotErrorMessage: ZE,
  cancellationErrorTitle: JE,
  cancellationErrorMessage: QE,
  minimumCancellationErrorMessage: XE,
  cancelBokingFormError: ex,
  feedbackFormTitle: tx,
  feedbackFormDescription: nx,
  feedbackMessageLabel: ix,
  feedbackMessagePlaceholder: ax,
  feedbackModalCloseButton: rx,
  feedbackModalSubmitButton: ox,
  deleteSchedulingPageTitle: sx,
  deleteSchedulingPageDescription: lx,
  deleteSchedulingPageConfirmButton: ux,
  deleteSchedulingPageCancelButton: cx,
  schedulerEditorTitle: dx,
  allSchedulingPages: fx,
  createAndManageSchedulingPages: gx,
  createNewSchedulingPageButtonText: hx,
  pageTitle: mx,
  durationTitle: px,
  loading: bx,
  required: yx,
  optional: vx,
  loadingPagesDescription: Tx,
  noSchedulingPages: kx,
  createFirstSchedulingPage: Ex,
  editSchedulingPageButtonText: xx,
  eventInfoTab: Sx,
  availabilityTab: Cx,
  participantsTab: wx,
  bookingOptionsTab: $x,
  returnToCalendarView: Bx,
  bookingFormTab: Px,
  communicationsTab: Mx,
  pageStylesTab: Dx,
  savingButtonText: Ax,
  saveChangesButtonText: Lx,
  createButtonText: Ox,
  timePeriod_day: _x,
  timePeriod_week: Ix,
  timePeriod_month: Rx,
  timePeriod_year: Nx,
  timeDuration_minute: Fx,
  timeDuration_hour: Ux,
  eventCommunicationsTitle: zx,
  eventCommunicationsDescription: Hx,
  unsavedChangesLabel: jx,
  changesSavedLabel: qx,
  fixFormErrors: Yx,
  nylasEditorTabs: Vx,
  nylasListConfigurations: Gx,
  nylasAdditionalParticipants: Wx,
  nylasAvailabilityPicker: Kx,
  nylasBookingCalendarPicker: Zx,
  nylasBookingConfirmationRedirect: Jx,
  nylasBookingConfirmationType: Qx,
  nylasBookingFormConfig: Xx,
  nylasBufferTime: eS,
  nylasCalendarPicker: tS,
  nylasCancellationPolicy: nS,
  nylasConfirmationEmail: iS,
  nylasConnectedCalendars: aS,
  nylasCustomBookingFlow: rS,
  nylasCustomEventSlug: oS,
  nylasCustomizeBookingSettings: sS,
  nylasEventDescription: lS,
  nylasEventDuration: uS,
  nylasEventInfo: cS,
  nylasEventLimits: dS,
  nylasEventLocation: fS,
  nylasEventTitle: gS,
  nylasLimitFutureBookings: hS,
  nylasMinBookingNotice: mS,
  nylasMinCancellationNotice: pS,
  nylasPageName: bS,
  nylasPageStyling: yS,
  nylasParticipantBookingCalendars: vS,
  nylasParticipantCustomAvailability: TS,
  nylasReminderEmails: kS,
  nylasSchedulingMethod: ES,
  nylasTimeslotInterval: xS,
  nylasEventTimeslot: SS,
  nylasEventCapacity: CS,
  nylasSelectEventType: wS,
  pageSettingsButton: $S,
  nylasEventCalendar: BS
}, q8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: j3,
  rescheduleTitle: q3,
  allDay: Y3,
  today: V3,
  spotsLeft: G3,
  search: W3,
  days: K3,
  time: Z3,
  months: J3,
  multipleOptionsSelected: Q3,
  selectAtLeastOneOption: X3,
  nextButton: eE,
  selectedDayAndYear: tE,
  selectedTime: nE,
  name: iE,
  namePlaceholder: aE,
  email: rE,
  emailPlaceholder: oE,
  guestEmail: sE,
  guestEmailPlaceholder: lE,
  addGuest: uE,
  addAnotherGuest: cE,
  backButton: dE,
  bookNowButton: fE,
  bookingConfirmed: gE,
  bookingConfirmedDescription: hE,
  bookingSent: mE,
  bookingSentDescription: pE,
  bookingRescheduled: bE,
  bookingDateAndTimeHeader: yE,
  cancelBookingButton: vE,
  rescheduleBookingButton: TE,
  rejectBookingButton: kE,
  confirmBookingButton: EE,
  bookingPendingTitle: xE,
  bookingPendingnDescription: SE,
  confirmedEventCardTitle: CE,
  confirmedEventCardDescription: wE,
  cancelBookingTitle: $E,
  cancelBookingMessage: BE,
  reasonForCancellation: PE,
  goBackButton: ME,
  bookingCancelledTitle: DE,
  bookingCancelledMessage: AE,
  bookingCancelledMessage_theParticipants: LE,
  closeButton: OE,
  closingButton: _E,
  fieldRequired: IE,
  invalidInputFormat: RE,
  createBookingErrorTitle: NE,
  getAvailabilityErrorTitle: FE,
  cancelBookingErrorTitle: UE,
  rescheduleBookingErrorTitle: zE,
  getUISettingErrorTitle: HE,
  rejectBookingErrorTitle: jE,
  confirmBookingErrorTitle: qE,
  genericErrorTitle: YE,
  noSessionIdErrorTitle: VE,
  schedulingComponentErrorTitle: GE,
  sessionIdRequiredErrorMessage: WE,
  publicConfigErrorMessage: KE,
  invalidTimeslotErrorMessage: ZE,
  cancellationErrorTitle: JE,
  cancellationErrorMessage: QE,
  minimumCancellationErrorMessage: XE,
  cancelBokingFormError: ex,
  feedbackFormTitle: tx,
  feedbackFormDescription: nx,
  feedbackMessageLabel: ix,
  feedbackMessagePlaceholder: ax,
  feedbackModalCloseButton: rx,
  feedbackModalSubmitButton: ox,
  deleteSchedulingPageTitle: sx,
  deleteSchedulingPageDescription: lx,
  deleteSchedulingPageConfirmButton: ux,
  deleteSchedulingPageCancelButton: cx,
  schedulerEditorTitle: dx,
  allSchedulingPages: fx,
  createAndManageSchedulingPages: gx,
  createNewSchedulingPageButtonText: hx,
  pageTitle: mx,
  durationTitle: px,
  loading: bx,
  required: yx,
  optional: vx,
  loadingPagesDescription: Tx,
  noSchedulingPages: kx,
  createFirstSchedulingPage: Ex,
  editSchedulingPageButtonText: xx,
  eventInfoTab: Sx,
  availabilityTab: Cx,
  participantsTab: wx,
  bookingOptionsTab: $x,
  returnToCalendarView: Bx,
  bookingFormTab: Px,
  communicationsTab: Mx,
  pageStylesTab: Dx,
  savingButtonText: Ax,
  saveChangesButtonText: Lx,
  createButtonText: Ox,
  timePeriod_day: _x,
  timePeriod_week: Ix,
  timePeriod_month: Rx,
  timePeriod_year: Nx,
  timeDuration_minute: Fx,
  timeDuration_hour: Ux,
  eventCommunicationsTitle: zx,
  eventCommunicationsDescription: Hx,
  unsavedChangesLabel: jx,
  changesSavedLabel: qx,
  fixFormErrors: Yx,
  nylasEditorTabs: Vx,
  nylasListConfigurations: Gx,
  nylasAdditionalParticipants: Wx,
  nylasAvailabilityPicker: Kx,
  nylasBookingCalendarPicker: Zx,
  nylasBookingConfirmationRedirect: Jx,
  nylasBookingConfirmationType: Qx,
  nylasBookingFormConfig: Xx,
  nylasBufferTime: eS,
  nylasCalendarPicker: tS,
  nylasCancellationPolicy: nS,
  nylasConfirmationEmail: iS,
  nylasConnectedCalendars: aS,
  nylasCustomBookingFlow: rS,
  nylasCustomEventSlug: oS,
  nylasCustomizeBookingSettings: sS,
  nylasEventDescription: lS,
  nylasEventDuration: uS,
  nylasEventInfo: cS,
  nylasEventLimits: dS,
  nylasEventLocation: fS,
  nylasEventTitle: gS,
  nylasLimitFutureBookings: hS,
  nylasMinBookingNotice: mS,
  nylasMinCancellationNotice: pS,
  nylasPageName: bS,
  nylasPageStyling: yS,
  nylasParticipantBookingCalendars: vS,
  nylasParticipantCustomAvailability: TS,
  nylasReminderEmails: kS,
  nylasSchedulingMethod: ES,
  nylasTimeslotInterval: xS,
  nylasEventTimeslot: SS,
  nylasEventCapacity: CS,
  nylasSelectEventType: wS,
  pageSettingsButton: $S,
  nylasEventCalendar: BS,
  default: j8
}), PS = "날짜가 선택되지 않았습니다", MS = "회의 일정을 변경할 다른 시간대를 선택하세요", DS = "온 날", AS = "오늘", LS = "{{count}} 스포트 남음", OS = "검색", _S = {
  sunday: "일",
  monday: "월",
  tuesday: "화",
  wednesday: "수",
  thursday: "목",
  friday: "금",
  saturday: "토"
}, IS = {
  hour: "시간",
  hours: "시간",
  minute: "분",
  minutes: "분",
  day: "일",
  days: "일",
  week: "주",
  weeks: "주",
  month: "월",
  months: "월",
  year: "년",
  years: "년"
}, RS = {
  january: "1월",
  february: "2월",
  march: "3월",
  april: "4월",
  may: "5월",
  june: "6월",
  july: "7월",
  august: "8월",
  september: "9월",
  october: "10월",
  november: "11월",
  december: "12월"
}, NS = "여러 옵션이 선택되었습니다", FS = "최소 하나의 옵션을 선택하세요", US = "다음", zS = "{{date}}", HS = "{{time}}", jS = "이름", qS = "이름을 입력하세요", YS = "이메일", VS = "이메일을 입력하세요", GS = "게스트 이메일", WS = "게스트 이메일을 입력하세요", KS = "게스트 추가", ZS = "다른 게스트 추가", JS = "뒤로", QS = "지금 예약", XS = "예약이 확인되었습니다", eC = "곧 이메일 확인을 받게 됩니다.", tC = "예약이 전송되었습니다", nC = "예약이 확인되면 이메일을 받게 됩니다.", iC = "예약이 재조정되었습니다", aC = "예약 날짜 및 시간", rC = "예약 취소", oC = "재조정", sC = "예약 거부", lC = "예약 확인", uC = "예약 대기 중", cC = "아래에서 예약을 관리하세요. 초대한 사람은 요청 상태를 알려주는 이메일을 받게 됩니다.", dC = "예약이 성공적으로 확인되었습니다", fC = "확인 이메일이 전송되었습니다:", gC = "예약을 취소하시겠습니까?", hC = "현재 시간대는 다른 사람이 이용할 수 있게 됩니다.", mC = "취소 사유", pC = "뒤로가기", bC = "예약이 성공적으로 취소되었습니다", yC = "취소 이메일이 전송되었습니다:", vC = "참여자에게 전송되었습니다", TC = "닫기", kC = "닫는 중", EC = "{{field}}은(는) 필수 항목입니다.", xC = "{{field}}의 형식이 올바르지 않습니다.", SC = "예약 생성", CC = "가능 여부 가져오기", wC = "예약 취소", $C = "예약 재조정", BC = "UI 설정 가져오기", PC = "예약 거부", MC = "예약 확인", DC = "문제가 발생했습니다", AC = "스케줄링 구성 요소 오류", LC = "비공개 구성에 'sessionId'가 필요합니다.", OC = "공개 구성을 사용하는 경우 configurationId 또는 'slug'와 'clientId'의 조합을 전달하십시오.", _C = "잘못된 시간대!", IC = "선택한 시간대가 유효하지 않습니다", RC = "취소 오류", NC = "취소 사유를 제공해주세요.", FC = "이벤트 {{minCancellationNotice}}분 이내에는 예약을 취소할 수 없습니다", UC = "예약 취소 양식 오류", zC = "피드백 공유", HC = "피드백을 제공하고 오류를 보고해주시면 더 나은 경험을 만드는 데 도움이 됩니다.", jC = "댓글을 남기고 싶은 기능에 대한 상세한 설명이나 문제가 발생한 부분을 알려주세요.", qC = "여기에 피드백을 제공하세요", YC = "취소", VC = "제출", GC = "이 스케줄링 페이지를 삭제하시겠습니까?", WC = "확인하면 이 페이지와 연결된 모든 스케줄링 링크가 영구적으로 삭제되고 비활성화됩니다. 이 작업은 되돌릴 수 없습니다.", KC = "페이지 삭제", ZC = "취소", JC = "스케줄러 편집기", QC = "모든 스케줄링 페이지", XC = "스케줄링 페이지를 생성하고 관리하세요.", ew = "새로 만들기", tw = "페이지 제목", nw = "기간", iw = "로딩 중", aw = "필수", rw = "선택 사항", ow = "스케줄링 페이지를 가져오는 중입니다. 잠시만 기다려 주세요.", sw = "스케줄링 페이지가 없습니다", lw = "첫 번째 스케줄링 페이지 생성을 시작하세요", uw = "편집", cw = "이벤트 정보", dw = "가능 여부", fw = "참여자", gw = "예약 옵션", hw = "캘린더로 돌아가기", mw = "예약 양식", pw = "커뮤니케이션", bw = "페이지 스타일", yw = "저장 중", vw = "변경 사항 저장", Tw = "생성", kw = "일", Ew = "주", xw = "월", Sw = "년", Cw = "분", ww = "시간", $w = "이벤트 커뮤니케이션", Bw = "자동 확인 이메일을 설정하세요.", Pw = "저장되지 않은 변경 사항", Mw = "변경 사항 저장됨", Dw = "폼 오류를 수정하세요.", Aw = {
  bookingFormError: "예약 폼 오류: ",
  bookingFormError_label: "{{type}} 타입의 필드에는 라벨이 필요합니다.",
  bookingFormError_option: "{{label}} 타입의 {{type}} 타입의 빈 옵션이 발견되었습니다."
}, Lw = {
  previewButtonText: "미리보기",
  copyLinkButtonText: "링크 복사",
  deleteButtonText: "삭제"
}, Ow = {
  headerTitle: "참여자",
  headerSubTitle: "팀이나 조직의 사람들을 추가하여 이벤트에 참여시키세요.",
  organizerAsParticipant: "참여자",
  organizer: "주최자",
  participant: "참여자",
  addParticipant_first: "참여자 추가",
  addParticipant_next: "다른 참여자 추가",
  tooltip: {
    includeOrganizer: "주최자 포함",
    includeOrganizerDesc: "주최자(당신)가 라운드 로빈 순환에 포함됩니다.",
    excludeOrganizer: "주최자 제외",
    excludeOrganizerDesc: "주최자(당신)가 라운드 로빈 순환에 포함되지 않습니다."
  },
  error: "최소 한 명의 참여자를 추가하세요"
}, _w = {
  headerTitle: "기본 영업 시간",
  headerSubTitle: "정기적으로 이벤트 예약이 가능한 시간을 설정하세요.",
  tooltip: {
    desc: "참여자가 '참여자' 탭에서 가능 여부를 설정하지 않은 경우 기본 가능 여부입니다."
  },
  selectTimezone: "시간대 선택",
  unavailable: "불가능",
  days: {
    SUN: "일",
    MON: "월",
    TUE: "화",
    WED: "수",
    THU: "목",
    FRI: "금",
    SAT: "토"
  },
  errors: {
    invalid: "유효하지 않음"
  }
}, Iw = {
  headerTitle: "캘린더 예약",
  headerSubTitle: "이벤트 예약을 추가할 캘린더를 선택하세요.",
  tooltip: {
    desc: "캘린더는 이벤트를 생성하는 데 사용됩니다."
  },
  selectOptionLabel: "옵션 선택",
  selectCalendarErrorMessage: "캘린더를 선택해주세요"
}, Rw = {
  dropdownLabel: "예약이 확인될 때",
  tooltip: {
    desc: "기본 확인 페이지를 표시하거나 사용자의 확인 페이지로 리디렉션할 수 있습니다."
  },
  redirectOption_default: "기본 확인 페이지 표시",
  redirectOption_custom: "사용자 지정 URL로 리디렉션"
}, Nw = {
  dropdownLabel: "예약이 요청될 때",
  tooltip: {
    desc: "수동으로 예약을 승인하면 각 예약 요청을 검토하고 승인 또는 거부할 수 있습니다."
  },
  bookingOption_booking: "자동으로 예약 승인",
  bookingOption_organizerConfirmation: "수동으로 예약 승인"
}, Fw = {
  headerTitle: "예약 양식",
  headerSubTitle: "예약 양식에 사용자 지정 필드를 추가하세요.",
  dropdownButtonText: "새 필드 추가",
  addOption: "옵션 추가",
  allOptionsHeader: "모든 옵션",
  fieldInTitleError: "이 필드는 이벤트 제목에 사용되며 제거할 수 없습니다.",
  fieldInDescriptionError: "이 필드는 이벤트 설명에 사용되며 제거할 수 없습니다.",
  label: "라벨",
  defaultValue: "기본값",
  fieldType: {
    text: "짧은 텍스트",
    multi_line_text: "긴 텍스트",
    email: "이메일",
    phone_number: "전화번호",
    dropdown: "드롭다운",
    radio_button: "라디오 버튼",
    checkbox: "체크박스",
    date: "날짜",
    metadata: "메타데이터",
    multi_select: "다중 선택"
  },
  fieldLabel: {
    your_name: "이름",
    your_email: "이메일",
    email: "추가 이메일",
    phone_number: "전화번호 레이블",
    dropdown: "드롭다운 레이블",
    text: "짧은 텍스트 레이블",
    multi_line_text: "긴 텍스트 레이블",
    radio_button: "라디오 버튼 레이블",
    checkbox: "체크박스 레이블",
    date: "날짜 레이블",
    metadata: "메타데이터 레이블",
    multi_select: "다중 선택 레이블"
  }
}, Uw = {
  headerTitle: "버퍼 시간",
  headerSubTitle: "이벤트 전후에 빈 버퍼 시간을 요구하세요.",
  tooltip: {
    desc: "스케줄러는 버퍼 시간을 예약하지 않습니다."
  },
  beforeBufferLabel: "이벤트 전",
  afterBufferLabel: "이벤트 후",
  minutesShort: "분",
  previewHeader: "미리보기"
}, zw = {
  calendarPickerLabel: "가능 여부를 확인할 캘린더 선택",
  selectAtLeastOneCalendar: "각 참여자에 대해 최소 하나의 캘린더를 선택하세요."
}, Hw = {
  cancellationPolicyLabel: "취소 정책 메시지",
  tooltip: {
    desc: "참석자가 이벤트를 취소하려고 할 때 이 메시지를 받습니다. 참석자에게 취소 사유를 제공하도록 요청합니다."
  }
}, jw = {
  headerTitle: "예약 확인{{organizerName}}",
  headerSubTitle: "예약 확인 이메일",
  editButtonText: "편집",
  error: {
    invalidImageUrl: "이미지 URL이 유효하지 않습니다."
  },
  confirmationEmail: {
    label: "이메일 알림 활성화",
    tooltip: {
      desc: "Nylas가 확인 메시지와 이벤트 알림을 포함한 이메일 알림을 보낼 수 있도록 허용합니다.",
      language: "이 언어는 주최자에 대한 이메일 알림에 사용됩니다."
    },
    language: "언어 선택"
  },
  nylasBranding: {
    label: "Nylas 브랜딩 표시",
    tooltip: {
      desc: "이메일 커뮤니케이션의 바닥글을 숨기려면 선택을 해제하세요."
    }
  },
  companyLogoUrl: {
    label: "회사 로고 URL",
    tooltip: {
      desc: "이 로고는 예약 확인 이메일에 표시됩니다. URL은 공개적으로 접근 가능해야 합니다. 이미지는 최대 크기인 200px x 100px로 축소됩니다."
    }
  },
  emailMessage: {
    header: "이메일 메시지",
    label: "사용자 지정 이메일 제목",
    tooltip: {
      desc: "이메일 제목은 이메일 본문의 헤드라인입니다. 제목 줄은 변경되지 않습니다."
    },
    additionalInfoLabel: "추가 정보",
    additionalInfoTooltip: "스케줄러가 상자의 내용을 이메일 본문에 추가합니다.",
    additionalInfoPlaceholder: "기본 본문"
  },
  allHosts: "모든 호스트 및 게스트",
  immediatelyUponBooking: "예약 즉시"
}, qw = {
  headerTitle: "연결된 캘린더",
  headerSubTitle: "가능 여부 확인에 사용할 캘린더를 선택하세요.",
  tooltip: {
    desc: "하나 이상의 캘린더에서 가능 여부를 확인하세요. 참여자에 대해 여러 캘린더를 선택하면, 참여자가 모든 캘린더에서 가능해야 사용 가능으로 간주됩니다."
  },
  participantCalendarTitle: "{{participantName}}의 연결된 캘린더",
  selectAtLeastOneCalendar: "각 참여자에 대해 최소 하나의 캘린더를 선택하세요."
}, Yw = {
  headerTitle: "맞춤 예약 흐름"
}, Vw = {
  headerTitle: "사용자 정의 페이지 슬러그",
  headerSubTitle: "이 페이지에 대한 사용자 정의 URL 슬러그를 만드세요.",
  eventSlugLabel: "페이지 URL 슬러그",
  tooltip: {
    desc: "URL에 대한 사용자 정의 슬러그를 제공하여 페이지를 고유하게 식별하세요 (문자, 숫자, 하이픈만 사용 가능)."
  },
  copied: "복사됨!"
}, Gw = {
  headerTitle: "추가 설정",
  headerSubTitle: "이벤트 예약 설정.",
  tooltip: {
    desc: "예약 설정을 사용자 지정하세요."
  },
  allowGuests: {
    label: "게스트가 추가 게스트를 초대할 수 있도록 허용"
  },
  hideReschedule: {
    label: "예약 재조정 옵션 숨기기",
    tooltip: {
      desc: "예약 확인 및 이메일 알림에서 '재조정' 버튼을 숨깁니다."
    }
  },
  hideCancel: {
    label: "취소 옵션 숨기기",
    tooltip: {
      desc: "예약 확인 및 이메일 알림에서 '취소' 버튼을 숨깁니다."
    }
  }
}, Ww = {
  headerTitle: "이벤트 설명",
  addAdditionalFields: {
    buttonText: "추가 필드 자동 채우기",
    tooltip: {
      desc: "설명에 포함하려는 모든 필드를 추가한 후 이 버튼을 클릭하세요. 중요: 모든 기능이 올바르게 작동하도록 '--- Additional Fields ---'와 '--- End Additional Fields ---' 표시를 수정하지 마세요."
    }
  },
  tooltip: {
    desc: "이벤트 설명은 스케줄러 편집기의 관리자 보기 및 예약 생성 시 응답 페이로드에 표시됩니다."
  }
}, Kw = {
  headerTitle: "이벤트 기간",
  error: {
    durationMustBeMultipleOf5: "기간은 5의 배수여야 합니다",
    durationMustBeGreaterThan0: "기간은 0보다 크거나 같아야 합니다"
  }
}, Zw = {
  headerTitle: "이벤트 정보"
}, Jw = {
  headerTitle: "이벤트 제한"
}, Qw = {
  headerTitle: "이벤트 회의 또는 위치",
  tooltip: {
    desc: "회의 옵션을 선택하거나 맞춤 위치를 추가하세요."
  },
  conferenceOptions: {
    none: "없음",
    zoom: "줌 미팅",
    google: "구글 미트",
    microsoft: "마이크로소프트 팀즈",
    custom: "사용자 지정 위치"
  }
}, Xw = {
  headerTitle: "이벤트 제목",
  helpText_start: "다이나믹 템플릿 이벤트 {{field}}을(를) 생성하려면 입력하세요",
  helpText_end: "및 템플릿 항목을 선택하세요.",
  title: "제목",
  description: "설명",
  tooltip: {
    desc: "예: 인터뷰 with"
  },
  eventTitleRequired: "이벤트 제목은 필수입니다",
  eventTitleTokenDescription: {
    invitee: "주최자의 이름",
    inviteeEmail: "주최자의 이메일",
    duration: "이벤트의 기간"
  }
}, e6 = {
  headerTitle: "미래 예약 제한",
  tooltip: {
    desc: "예약을 할 수 있는 미래의 최대 기간."
  }
}, t6 = {
  headerTitle: "최소 예약 공지",
  tooltip: {
    desc: "새 예약을 할 수 있는 최소 시간."
  }
}, n6 = {
  headerTitle: "최소 취소 공지",
  tooltip: {
    desc: "예약을 취소하는 데 필요한 최소 시간."
  }
}, i6 = {
  headerTitle: "페이지 이름",
  headerSubTitle: "스케줄링 페이지 이름을 설정하세요.",
  pageNameError: "페이지 이름을 입력하세요",
  tooltip: {
    desc: "기본적으로 스케줄링 페이지는 사용자 이름을 페이지 이름으로 사용합니다. 페이지 이름은 캘린더 보기의 왼쪽 상단에 표시됩니다."
  }
}, a6 = {
  headerTitle: "페이지 스타일 및 맞춤화"
}, r6 = {
  headerTitle: "이 캘린더에 예약",
  headerSubTitle: "이벤트 예약을 추가할 캘린더를 선택하세요.",
  participantBookingCalendarTitle: "{{participantName}}의 예약 캘린더",
  selectAtLeastOneCalendar: "각 참여자에 대해 최소 하나의 캘린더를 선택하세요."
}, o6 = {
  headerTitle: "참여자 영업 시간",
  headerSubTitle: "설정되지 않은 경우 기본 영업 시간이 이 참여자의 가능 여부 계산에 사용됩니다.",
  participantOpenHoursTitle: "{{participantName}}의 영업 시간"
}, s6 = {
  headerTitle: "다가오는 회의{{organizerName}}",
  headerSubTitle: "이벤트 전 알림",
  editButtonText: "편집",
  recipientOptions_all: "모든 호스트 및 게스트",
  recipientOptions_guest: "모든 이벤트 게스트",
  recipientOptions_host: "이벤트 호스트만",
  beforeTheEvent: "이벤트 전",
  emailRecipients: {
    label: "이메일 수신자"
  },
  sendConfirmation: {
    label: "예약 시 확인 이메일 전송",
    tooltip: {
      desc: "수신자는 이벤트 전 지정된 시간에 알림 이메일을 받게 됩니다."
    }
  },
  emailSubject: {
    label: "이메일 제목",
    placeholder: "다가오는 회의{{organizerName}}"
  },
  reminderMinutesValidationError: "리마인더 분을 5의 배수로 입력하세요. 시도해보세요 ",
  newReminderButtonText: "새 알림"
}, l6 = {
  headerTitle: "스케줄링 방법",
  headerSubTitle: "이벤트의 스케줄링 방법을 선택하세요.",
  tooltip: {
    standard: {
      label: "표준",
      desc: "1:1 예약 또는 추가 참여자가 있는 n:1 예약을 허용합니다."
    },
    maxFairness: {
      label: "라운드 로빈 공정성 최대화",
      desc: "선택한 참여자 목록을 순환하며 최근 예약이 가장 적은 참여자를 표시합니다."
    },
    maxAvailability: {
      label: "라운드 로빈 가능성 최대화",
      desc: "선택한 참여자 목록을 순환하며 최근 예약이 가장 적은 참여자를 우선시하지만 가능한 많은 시간대를 제공합니다."
    }
  },
  schedulingMethodOptions_collective: "표준 예약",
  schedulingMethodOptions_maxFairness: "라운드 로빈 공정성 최대화",
  schedulingMethodOptions_maxAvailability: "라운드 로빈 가능성 최대화"
}, u6 = {
  minutesShort: "분",
  lengthOfMeeting: "회의 시간",
  headerTitle: "시간대 설정",
  timeslotInterval: {
    label: "시간대 간격"
  },
  timeslotRounding: {
    label: "시간대 반올림 유형",
    tooltip: {
      desc: "시간대가 표시되는 간격."
    }
  },
  timeslotRoundingOptions: {
    rounding: {
      label: "간격 반올림",
      desc: "시간대는 간격 값으로 반올림된 시간에서 시작됩니다."
    },
    noRounding: {
      label: "기본값",
      desc: "시간대는 가장 가까운 15분 단위로 반올림됩니다."
    }
  }
}, c6 = {
  recurrenceOptions: {
    none: "반복하지 않음",
    daily: "매일",
    weekly: "매주 {{dayOfWeek}}",
    monthly: "매월 {{dayOfMonth}}",
    monthOnDay: "매월 {{date}}일에",
    yearly: "매년 {{dateOfMonth}}",
    custom: "사용자 정의"
  },
  recurrenceLabel: "이 이벤트 반복",
  endDate: "종료 날짜",
  customRecurrence: {
    repeatEvery: "반복 주기",
    repeatOn: "반복 날짜",
    ends: "종료",
    endsOptions: {
      never: "안함",
      after: "후",
      on: "날짜"
    },
    occurrences: "횟수"
  },
  dateTimeLabel: "날짜 및 시간",
  errors: {
    invalidTimeRange: "시간 범위가 유효하지 않습니다",
    startTimeSameAsEndTime: "시작 시간과 종료 시간은 같을 수 없습니다",
    startTimeBeforeCurrentDate: "시작 시간은 과거일 수 없습니다",
    invalid: "유효하지 않음"
  }
}, d6 = {
  headerTitle: "초대자",
  headerSubTitle: "이 이벤트 시간 슬롯의 최대 초대자 수를 설정하세요.",
  tooltip: {
    desc: "일정 페이지에서 구성된 주최자 및 참가자는 초대자로 계산되지 않습니다."
  },
  attendees: "참석자"
}, f6 = {
  returnToAllSchedulingPages: "모든 스케줄링 페이지로 돌아가기",
  createEventHeaderTitle: "이벤트 만들기",
  eventTypeHeaderTitle: "이벤트 유형",
  noEventTypesEnabled: "이벤트 유형이 활성화되지 않았습니다.",
  eventTypeOptions: {
    oneOnOne: {
      label: "1:1",
      desc: "1:1 예약을 허용합니다."
    },
    collective: {
      label: "표준 예약",
      desc: "추가 참여자가 있는 n:1 예약을 허용합니다."
    },
    maxFairness: {
      label: "라운드 로빈 공정성 최대화",
      desc: "선택한 참여자 목록을 순환하며 최근 예약이 가장 적은 참여자를 표시합니다."
    },
    maxAvailability: {
      label: "라운드 로빈 가능성 최대화",
      desc: "선택한 참여자 목록을 순환하며 최근 예약이 가장 적은 참여자를 우선시하지만 가능한 많은 시간대를 제공합니다."
    },
    group: {
      label: "그룹/클래스",
      desc: "이 이벤트는 일반적으로 하나의 주최자와 여러 참여자를 가지고 있습니다."
    }
  }
}, g6 = "페이지 설정", h6 = {
  createEventDetails: {
    headerTitle: "이벤트 세부 정보",
    closeButtonTooltip: "닫기",
    cancelButton: "취소",
    createButton: "만들기"
  },
  discardChanges: {
    headerTitle: "변경 사항을 취소하시겠습니까?",
    cancelButton: "취소",
    discardButton: "취소"
  },
  unsavedChanges: "변경 사항이 저장되지 않았습니다",
  editEventDetails: {
    headerTitle: "이벤트 세부 정보",
    closeButtonTooltip: "닫기",
    deleteButton: "삭제",
    saveButton: "저장",
    pastEventTooltip: "이 이벤트는 과거이며 편집할 수 없습니다."
  },
  importEvent: {
    closeButtonTooltip: "닫기",
    importButton: "가져오기",
    participantsLabel: "참여자"
  },
  deleteEvent: {
    closeButtonTooltip: "닫기",
    deleting: "삭제 중..."
  },
  editOptions: {
    headerTitle: "옵션",
    closeButtonTooltip: "닫기",
    deleting: "삭제 중...",
    import: "가져오기",
    edit: "편집",
    deleteThis: "이 이벤트 삭제",
    deleteAll: "모든 이벤트 삭제"
  },
  updateOptions: {
    updateThis: "이 이벤트 업데이트",
    updateAll: "모든 이벤트 업데이트",
    updateFuture: "모든 미래 이벤트 업데이트"
  },
  deleteOptions: {
    deleteThis: "삭제",
    deleteFuture: "이 이벤트와 모든 미래 이벤트 삭제",
    deleteAll: "모든 이벤트 삭제"
  }
}, Y8 = {
  noDateSelected: PS,
  rescheduleTitle: MS,
  allDay: DS,
  today: AS,
  spotsLeft: LS,
  search: OS,
  days: _S,
  time: IS,
  months: RS,
  multipleOptionsSelected: NS,
  selectAtLeastOneOption: FS,
  nextButton: US,
  selectedDayAndYear: zS,
  selectedTime: HS,
  name: jS,
  namePlaceholder: qS,
  email: YS,
  emailPlaceholder: VS,
  guestEmail: GS,
  guestEmailPlaceholder: WS,
  addGuest: KS,
  addAnotherGuest: ZS,
  backButton: JS,
  bookNowButton: QS,
  bookingConfirmed: XS,
  bookingConfirmedDescription: eC,
  bookingSent: tC,
  bookingSentDescription: nC,
  bookingRescheduled: iC,
  bookingDateAndTimeHeader: aC,
  cancelBookingButton: rC,
  rescheduleBookingButton: oC,
  rejectBookingButton: sC,
  confirmBookingButton: lC,
  bookingPendingTitle: uC,
  bookingPendingnDescription: cC,
  confirmedEventCardTitle: dC,
  confirmedEventCardDescription: fC,
  cancelBookingTitle: gC,
  cancelBookingMessage: hC,
  reasonForCancellation: mC,
  goBackButton: pC,
  bookingCancelledTitle: bC,
  bookingCancelledMessage: yC,
  bookingCancelledMessage_theParticipants: vC,
  closeButton: TC,
  closingButton: kC,
  fieldRequired: EC,
  invalidInputFormat: xC,
  createBookingErrorTitle: SC,
  getAvailabilityErrorTitle: CC,
  cancelBookingErrorTitle: wC,
  rescheduleBookingErrorTitle: $C,
  getUISettingErrorTitle: BC,
  rejectBookingErrorTitle: PC,
  confirmBookingErrorTitle: MC,
  genericErrorTitle: DC,
  schedulingComponentErrorTitle: AC,
  sessionIdRequiredErrorMessage: LC,
  publicConfigErrorMessage: OC,
  invalidTimeslotErrorTitle: _C,
  invalidTimeslotErrorMessage: IC,
  cancellationErrorTitle: RC,
  cancellationErrorMessage: NC,
  minimumCancellationErrorMessage: FC,
  cancelBokingFormError: UC,
  feedbackFormTitle: zC,
  feedbackFormDescription: HC,
  feedbackMessageLabel: jC,
  feedbackMessagePlaceholder: qC,
  feedbackModalCloseButton: YC,
  feedbackModalSubmitButton: VC,
  deleteSchedulingPageTitle: GC,
  deleteSchedulingPageDescription: WC,
  deleteSchedulingPageConfirmButton: KC,
  deleteSchedulingPageCancelButton: ZC,
  schedulerEditorTitle: JC,
  allSchedulingPages: QC,
  createAndManageSchedulingPages: XC,
  createNewSchedulingPageButtonText: ew,
  pageTitle: tw,
  durationTitle: nw,
  loading: iw,
  required: aw,
  optional: rw,
  loadingPagesDescription: ow,
  noSchedulingPages: sw,
  createFirstSchedulingPage: lw,
  editSchedulingPageButtonText: uw,
  eventInfoTab: cw,
  availabilityTab: dw,
  participantsTab: fw,
  bookingOptionsTab: gw,
  returnToCalendarView: hw,
  bookingFormTab: mw,
  communicationsTab: pw,
  pageStylesTab: bw,
  savingButtonText: yw,
  saveChangesButtonText: vw,
  createButtonText: Tw,
  timePeriod_day: kw,
  timePeriod_week: Ew,
  timePeriod_month: xw,
  timePeriod_year: Sw,
  timeDuration_minute: Cw,
  timeDuration_hour: ww,
  eventCommunicationsTitle: $w,
  eventCommunicationsDescription: Bw,
  unsavedChangesLabel: Pw,
  changesSavedLabel: Mw,
  fixFormErrors: Dw,
  nylasEditorTabs: Aw,
  nylasListConfigurations: Lw,
  nylasAdditionalParticipants: Ow,
  nylasAvailabilityPicker: _w,
  nylasBookingCalendarPicker: Iw,
  nylasBookingConfirmationRedirect: Rw,
  nylasBookingConfirmationType: Nw,
  nylasBookingFormConfig: Fw,
  nylasBufferTime: Uw,
  nylasCalendarPicker: zw,
  nylasCancellationPolicy: Hw,
  nylasConfirmationEmail: jw,
  nylasConnectedCalendars: qw,
  nylasCustomBookingFlow: Yw,
  nylasCustomEventSlug: Vw,
  nylasCustomizeBookingSettings: Gw,
  nylasEventDescription: Ww,
  nylasEventDuration: Kw,
  nylasEventInfo: Zw,
  nylasEventLimits: Jw,
  nylasEventLocation: Qw,
  nylasEventTitle: Xw,
  nylasLimitFutureBookings: e6,
  nylasMinBookingNotice: t6,
  nylasMinCancellationNotice: n6,
  nylasPageName: i6,
  nylasPageStyling: a6,
  nylasParticipantBookingCalendars: r6,
  nylasParticipantCustomAvailability: o6,
  nylasReminderEmails: s6,
  nylasSchedulingMethod: l6,
  nylasTimeslotInterval: u6,
  nylasEventTimeslot: c6,
  nylasEventCapacity: d6,
  nylasSelectEventType: f6,
  pageSettingsButton: g6,
  nylasEventCalendar: h6
}, V8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  noDateSelected: PS,
  rescheduleTitle: MS,
  allDay: DS,
  today: AS,
  spotsLeft: LS,
  search: OS,
  days: _S,
  time: IS,
  months: RS,
  multipleOptionsSelected: NS,
  selectAtLeastOneOption: FS,
  nextButton: US,
  selectedDayAndYear: zS,
  selectedTime: HS,
  name: jS,
  namePlaceholder: qS,
  email: YS,
  emailPlaceholder: VS,
  guestEmail: GS,
  guestEmailPlaceholder: WS,
  addGuest: KS,
  addAnotherGuest: ZS,
  backButton: JS,
  bookNowButton: QS,
  bookingConfirmed: XS,
  bookingConfirmedDescription: eC,
  bookingSent: tC,
  bookingSentDescription: nC,
  bookingRescheduled: iC,
  bookingDateAndTimeHeader: aC,
  cancelBookingButton: rC,
  rescheduleBookingButton: oC,
  rejectBookingButton: sC,
  confirmBookingButton: lC,
  bookingPendingTitle: uC,
  bookingPendingnDescription: cC,
  confirmedEventCardTitle: dC,
  confirmedEventCardDescription: fC,
  cancelBookingTitle: gC,
  cancelBookingMessage: hC,
  reasonForCancellation: mC,
  goBackButton: pC,
  bookingCancelledTitle: bC,
  bookingCancelledMessage: yC,
  bookingCancelledMessage_theParticipants: vC,
  closeButton: TC,
  closingButton: kC,
  fieldRequired: EC,
  invalidInputFormat: xC,
  createBookingErrorTitle: SC,
  getAvailabilityErrorTitle: CC,
  cancelBookingErrorTitle: wC,
  rescheduleBookingErrorTitle: $C,
  getUISettingErrorTitle: BC,
  rejectBookingErrorTitle: PC,
  confirmBookingErrorTitle: MC,
  genericErrorTitle: DC,
  schedulingComponentErrorTitle: AC,
  sessionIdRequiredErrorMessage: LC,
  publicConfigErrorMessage: OC,
  invalidTimeslotErrorTitle: _C,
  invalidTimeslotErrorMessage: IC,
  cancellationErrorTitle: RC,
  cancellationErrorMessage: NC,
  minimumCancellationErrorMessage: FC,
  cancelBokingFormError: UC,
  feedbackFormTitle: zC,
  feedbackFormDescription: HC,
  feedbackMessageLabel: jC,
  feedbackMessagePlaceholder: qC,
  feedbackModalCloseButton: YC,
  feedbackModalSubmitButton: VC,
  deleteSchedulingPageTitle: GC,
  deleteSchedulingPageDescription: WC,
  deleteSchedulingPageConfirmButton: KC,
  deleteSchedulingPageCancelButton: ZC,
  schedulerEditorTitle: JC,
  allSchedulingPages: QC,
  createAndManageSchedulingPages: XC,
  createNewSchedulingPageButtonText: ew,
  pageTitle: tw,
  durationTitle: nw,
  loading: iw,
  required: aw,
  optional: rw,
  loadingPagesDescription: ow,
  noSchedulingPages: sw,
  createFirstSchedulingPage: lw,
  editSchedulingPageButtonText: uw,
  eventInfoTab: cw,
  availabilityTab: dw,
  participantsTab: fw,
  bookingOptionsTab: gw,
  returnToCalendarView: hw,
  bookingFormTab: mw,
  communicationsTab: pw,
  pageStylesTab: bw,
  savingButtonText: yw,
  saveChangesButtonText: vw,
  createButtonText: Tw,
  timePeriod_day: kw,
  timePeriod_week: Ew,
  timePeriod_month: xw,
  timePeriod_year: Sw,
  timeDuration_minute: Cw,
  timeDuration_hour: ww,
  eventCommunicationsTitle: $w,
  eventCommunicationsDescription: Bw,
  unsavedChangesLabel: Pw,
  changesSavedLabel: Mw,
  fixFormErrors: Dw,
  nylasEditorTabs: Aw,
  nylasListConfigurations: Lw,
  nylasAdditionalParticipants: Ow,
  nylasAvailabilityPicker: _w,
  nylasBookingCalendarPicker: Iw,
  nylasBookingConfirmationRedirect: Rw,
  nylasBookingConfirmationType: Nw,
  nylasBookingFormConfig: Fw,
  nylasBufferTime: Uw,
  nylasCalendarPicker: zw,
  nylasCancellationPolicy: Hw,
  nylasConfirmationEmail: jw,
  nylasConnectedCalendars: qw,
  nylasCustomBookingFlow: Yw,
  nylasCustomEventSlug: Vw,
  nylasCustomizeBookingSettings: Gw,
  nylasEventDescription: Ww,
  nylasEventDuration: Kw,
  nylasEventInfo: Zw,
  nylasEventLimits: Jw,
  nylasEventLocation: Qw,
  nylasEventTitle: Xw,
  nylasLimitFutureBookings: e6,
  nylasMinBookingNotice: t6,
  nylasMinCancellationNotice: n6,
  nylasPageName: i6,
  nylasPageStyling: a6,
  nylasParticipantBookingCalendars: r6,
  nylasParticipantCustomAvailability: o6,
  nylasReminderEmails: s6,
  nylasSchedulingMethod: l6,
  nylasTimeslotInterval: u6,
  nylasEventTimeslot: c6,
  nylasEventCapacity: d6,
  nylasSelectEventType: f6,
  pageSettingsButton: g6,
  nylasEventCalendar: h6,
  default: Y8
});
qi.init({
  lng: "en",
  fallbackLng: "en",
  keySeparator: ".",
  resources: {
    en: {
      translation: M8
    },
    fr: {
      translation: A8
    },
    es: {
      translation: O8
    },
    ja: {
      translation: I8
    },
    de: {
      translation: N8
    },
    sv: {
      translation: U8
    },
    zh: {
      translation: H8
    },
    nl: {
      translation: q8
    },
    ko: {
      translation: V8
    }
  },
  interpolation: {
    escapeValue: !1
  }
});
var Ae = {}, Yi = {};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(n) {
    return n.charCodeAt(0);
  })
);
var Vi = {};
Object.defineProperty(Vi, "__esModule", { value: !0 });
Vi.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(n) {
    return n.charCodeAt(0);
  })
);
var gi = {};
(function(n) {
  var e;
  Object.defineProperty(n, "__esModule", { value: !0 }), n.replaceCodePoint = n.fromCodePoint = void 0;
  var t = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  n.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(r) {
    var o = "";
    return r > 65535 && (r -= 65536, o += String.fromCharCode(r >>> 10 & 1023 | 55296), r = 56320 | r & 1023), o += String.fromCharCode(r), o;
  };
  function i(r) {
    var o;
    return r >= 55296 && r <= 57343 || r > 1114111 ? 65533 : (o = t.get(r)) !== null && o !== void 0 ? o : r;
  }
  n.replaceCodePoint = i;
  function a(r) {
    return (0, n.fromCodePoint)(i(r));
  }
  n.default = a;
})(gi);
(function(n) {
  var e = ne && ne.__createBinding || (Object.create ? function(v, P, S, x) {
    x === void 0 && (x = S);
    var m = Object.getOwnPropertyDescriptor(P, S);
    (!m || ("get" in m ? !P.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return P[S];
    } }), Object.defineProperty(v, x, m);
  } : function(v, P, S, x) {
    x === void 0 && (x = S), v[x] = P[S];
  }), t = ne && ne.__setModuleDefault || (Object.create ? function(v, P) {
    Object.defineProperty(v, "default", { enumerable: !0, value: P });
  } : function(v, P) {
    v.default = P;
  }), i = ne && ne.__importStar || function(v) {
    if (v && v.__esModule)
      return v;
    var P = {};
    if (v != null)
      for (var S in v)
        S !== "default" && Object.prototype.hasOwnProperty.call(v, S) && e(P, v, S);
    return t(P, v), P;
  }, a = ne && ne.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.decodeXML = n.decodeHTMLStrict = n.decodeHTMLAttribute = n.decodeHTML = n.determineBranch = n.EntityDecoder = n.DecodingMode = n.BinTrieFlags = n.fromCodePoint = n.replaceCodePoint = n.decodeCodePoint = n.xmlDecodeTree = n.htmlDecodeTree = void 0;
  var r = a(Yi);
  n.htmlDecodeTree = r.default;
  var o = a(Vi);
  n.xmlDecodeTree = o.default;
  var l = i(gi);
  n.decodeCodePoint = l.default;
  var s = gi;
  Object.defineProperty(n, "replaceCodePoint", { enumerable: !0, get: function() {
    return s.replaceCodePoint;
  } }), Object.defineProperty(n, "fromCodePoint", { enumerable: !0, get: function() {
    return s.fromCodePoint;
  } });
  var u;
  (function(v) {
    v[v.NUM = 35] = "NUM", v[v.SEMI = 59] = "SEMI", v[v.EQUALS = 61] = "EQUALS", v[v.ZERO = 48] = "ZERO", v[v.NINE = 57] = "NINE", v[v.LOWER_A = 97] = "LOWER_A", v[v.LOWER_F = 102] = "LOWER_F", v[v.LOWER_X = 120] = "LOWER_X", v[v.LOWER_Z = 122] = "LOWER_Z", v[v.UPPER_A = 65] = "UPPER_A", v[v.UPPER_F = 70] = "UPPER_F", v[v.UPPER_Z = 90] = "UPPER_Z";
  })(u || (u = {}));
  var c = 32, f;
  (function(v) {
    v[v.VALUE_LENGTH = 49152] = "VALUE_LENGTH", v[v.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", v[v.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(f = n.BinTrieFlags || (n.BinTrieFlags = {}));
  function d(v) {
    return v >= u.ZERO && v <= u.NINE;
  }
  function g(v) {
    return v >= u.UPPER_A && v <= u.UPPER_F || v >= u.LOWER_A && v <= u.LOWER_F;
  }
  function b(v) {
    return v >= u.UPPER_A && v <= u.UPPER_Z || v >= u.LOWER_A && v <= u.LOWER_Z || d(v);
  }
  function p(v) {
    return v === u.EQUALS || b(v);
  }
  var h;
  (function(v) {
    v[v.EntityStart = 0] = "EntityStart", v[v.NumericStart = 1] = "NumericStart", v[v.NumericDecimal = 2] = "NumericDecimal", v[v.NumericHex = 3] = "NumericHex", v[v.NamedEntity = 4] = "NamedEntity";
  })(h || (h = {}));
  var E;
  (function(v) {
    v[v.Legacy = 0] = "Legacy", v[v.Strict = 1] = "Strict", v[v.Attribute = 2] = "Attribute";
  })(E = n.DecodingMode || (n.DecodingMode = {}));
  var B = (
    /** @class */
    function() {
      function v(P, S, x) {
        this.decodeTree = P, this.emitCodePoint = S, this.errors = x, this.state = h.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = E.Strict;
      }
      return v.prototype.startEntity = function(P) {
        this.decodeMode = P, this.state = h.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, v.prototype.write = function(P, S) {
        switch (this.state) {
          case h.EntityStart:
            return P.charCodeAt(S) === u.NUM ? (this.state = h.NumericStart, this.consumed += 1, this.stateNumericStart(P, S + 1)) : (this.state = h.NamedEntity, this.stateNamedEntity(P, S));
          case h.NumericStart:
            return this.stateNumericStart(P, S);
          case h.NumericDecimal:
            return this.stateNumericDecimal(P, S);
          case h.NumericHex:
            return this.stateNumericHex(P, S);
          case h.NamedEntity:
            return this.stateNamedEntity(P, S);
        }
      }, v.prototype.stateNumericStart = function(P, S) {
        return S >= P.length ? -1 : (P.charCodeAt(S) | c) === u.LOWER_X ? (this.state = h.NumericHex, this.consumed += 1, this.stateNumericHex(P, S + 1)) : (this.state = h.NumericDecimal, this.stateNumericDecimal(P, S));
      }, v.prototype.addToNumericResult = function(P, S, x, m) {
        if (S !== x) {
          var T = x - S;
          this.result = this.result * Math.pow(m, T) + parseInt(P.substr(S, T), m), this.consumed += T;
        }
      }, v.prototype.stateNumericHex = function(P, S) {
        for (var x = S; S < P.length; ) {
          var m = P.charCodeAt(S);
          if (d(m) || g(m))
            S += 1;
          else
            return this.addToNumericResult(P, x, S, 16), this.emitNumericEntity(m, 3);
        }
        return this.addToNumericResult(P, x, S, 16), -1;
      }, v.prototype.stateNumericDecimal = function(P, S) {
        for (var x = S; S < P.length; ) {
          var m = P.charCodeAt(S);
          if (d(m))
            S += 1;
          else
            return this.addToNumericResult(P, x, S, 10), this.emitNumericEntity(m, 2);
        }
        return this.addToNumericResult(P, x, S, 10), -1;
      }, v.prototype.emitNumericEntity = function(P, S) {
        var x;
        if (this.consumed <= S)
          return (x = this.errors) === null || x === void 0 || x.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (P === u.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === E.Strict)
          return 0;
        return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (P !== u.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, v.prototype.stateNamedEntity = function(P, S) {
        for (var x = this.decodeTree, m = x[this.treeIndex], T = (m & f.VALUE_LENGTH) >> 14; S < P.length; S++, this.excess++) {
          var y = P.charCodeAt(S);
          if (this.treeIndex = D(x, m, this.treeIndex + Math.max(1, T), y), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === E.Attribute && // We shouldn't have consumed any characters after the entity,
            (T === 0 || // And there should be no invalid characters.
            p(y)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (m = x[this.treeIndex], T = (m & f.VALUE_LENGTH) >> 14, T !== 0) {
            if (y === u.SEMI)
              return this.emitNamedEntityData(this.treeIndex, T, this.consumed + this.excess);
            this.decodeMode !== E.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, v.prototype.emitNotTerminatedNamedEntity = function() {
        var P, S = this, x = S.result, m = S.decodeTree, T = (m[x] & f.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(x, T, this.consumed), (P = this.errors) === null || P === void 0 || P.missingSemicolonAfterCharacterReference(), this.consumed;
      }, v.prototype.emitNamedEntityData = function(P, S, x) {
        var m = this.decodeTree;
        return this.emitCodePoint(S === 1 ? m[P] & ~f.VALUE_LENGTH : m[P + 1], x), S === 3 && this.emitCodePoint(m[P + 2], x), x;
      }, v.prototype.end = function() {
        var P;
        switch (this.state) {
          case h.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== E.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case h.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case h.NumericHex:
            return this.emitNumericEntity(0, 3);
          case h.NumericStart:
            return (P = this.errors) === null || P === void 0 || P.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case h.EntityStart:
            return 0;
        }
      }, v;
    }()
  );
  n.EntityDecoder = B;
  function _(v) {
    var P = "", S = new B(v, function(x) {
      return P += (0, l.fromCodePoint)(x);
    });
    return function(m, T) {
      for (var y = 0, w = 0; (w = m.indexOf("&", w)) >= 0; ) {
        P += m.slice(y, w), S.startEntity(T);
        var A = S.write(
          m,
          // Skip the "&"
          w + 1
        );
        if (A < 0) {
          y = w + S.end();
          break;
        }
        y = w + A, w = A === 0 ? y + 1 : y;
      }
      var R = P + m.slice(y);
      return P = "", R;
    };
  }
  function D(v, P, S, x) {
    var m = (P & f.BRANCH_LENGTH) >> 7, T = P & f.JUMP_TABLE;
    if (m === 0)
      return T !== 0 && x === T ? S : -1;
    if (T) {
      var y = x - T;
      return y < 0 || y >= m ? -1 : v[S + y] - 1;
    }
    for (var w = S, A = w + m - 1; w <= A; ) {
      var R = w + A >>> 1, H = v[R];
      if (H < x)
        w = R + 1;
      else if (H > x)
        A = R - 1;
      else
        return v[R + m];
    }
    return -1;
  }
  n.determineBranch = D;
  var I = _(r.default), F = _(o.default);
  function j(v, P) {
    return P === void 0 && (P = E.Legacy), I(v, P);
  }
  n.decodeHTML = j;
  function W(v) {
    return I(v, E.Attribute);
  }
  n.decodeHTMLAttribute = W;
  function q(v) {
    return I(v, E.Strict);
  }
  n.decodeHTMLStrict = q;
  function U(v) {
    return F(v, E.Strict);
  }
  n.decodeXML = U;
})(Ae);
var O;
(function(n) {
  n[n.Tab = 9] = "Tab", n[n.NewLine = 10] = "NewLine", n[n.FormFeed = 12] = "FormFeed", n[n.CarriageReturn = 13] = "CarriageReturn", n[n.Space = 32] = "Space", n[n.ExclamationMark = 33] = "ExclamationMark", n[n.Number = 35] = "Number", n[n.Amp = 38] = "Amp", n[n.SingleQuote = 39] = "SingleQuote", n[n.DoubleQuote = 34] = "DoubleQuote", n[n.Dash = 45] = "Dash", n[n.Slash = 47] = "Slash", n[n.Zero = 48] = "Zero", n[n.Nine = 57] = "Nine", n[n.Semi = 59] = "Semi", n[n.Lt = 60] = "Lt", n[n.Eq = 61] = "Eq", n[n.Gt = 62] = "Gt", n[n.Questionmark = 63] = "Questionmark", n[n.UpperA = 65] = "UpperA", n[n.LowerA = 97] = "LowerA", n[n.UpperF = 70] = "UpperF", n[n.LowerF = 102] = "LowerF", n[n.UpperZ = 90] = "UpperZ", n[n.LowerZ = 122] = "LowerZ", n[n.LowerX = 120] = "LowerX", n[n.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(O || (O = {}));
var C;
(function(n) {
  n[n.Text = 1] = "Text", n[n.BeforeTagName = 2] = "BeforeTagName", n[n.InTagName = 3] = "InTagName", n[n.InSelfClosingTag = 4] = "InSelfClosingTag", n[n.BeforeClosingTagName = 5] = "BeforeClosingTagName", n[n.InClosingTagName = 6] = "InClosingTagName", n[n.AfterClosingTagName = 7] = "AfterClosingTagName", n[n.BeforeAttributeName = 8] = "BeforeAttributeName", n[n.InAttributeName = 9] = "InAttributeName", n[n.AfterAttributeName = 10] = "AfterAttributeName", n[n.BeforeAttributeValue = 11] = "BeforeAttributeValue", n[n.InAttributeValueDq = 12] = "InAttributeValueDq", n[n.InAttributeValueSq = 13] = "InAttributeValueSq", n[n.InAttributeValueNq = 14] = "InAttributeValueNq", n[n.BeforeDeclaration = 15] = "BeforeDeclaration", n[n.InDeclaration = 16] = "InDeclaration", n[n.InProcessingInstruction = 17] = "InProcessingInstruction", n[n.BeforeComment = 18] = "BeforeComment", n[n.CDATASequence = 19] = "CDATASequence", n[n.InSpecialComment = 20] = "InSpecialComment", n[n.InCommentLike = 21] = "InCommentLike", n[n.BeforeSpecialS = 22] = "BeforeSpecialS", n[n.SpecialStartSequence = 23] = "SpecialStartSequence", n[n.InSpecialTag = 24] = "InSpecialTag", n[n.BeforeEntity = 25] = "BeforeEntity", n[n.BeforeNumericEntity = 26] = "BeforeNumericEntity", n[n.InNamedEntity = 27] = "InNamedEntity", n[n.InNumericEntity = 28] = "InNumericEntity", n[n.InHexEntity = 29] = "InHexEntity";
})(C || (C = {}));
function He(n) {
  return n === O.Space || n === O.NewLine || n === O.Tab || n === O.FormFeed || n === O.CarriageReturn;
}
function jt(n) {
  return n === O.Slash || n === O.Gt || He(n);
}
function er(n) {
  return n >= O.Zero && n <= O.Nine;
}
function G8(n) {
  return n >= O.LowerA && n <= O.LowerZ || n >= O.UpperA && n <= O.UpperZ;
}
function W8(n) {
  return n >= O.UpperA && n <= O.UpperF || n >= O.LowerA && n <= O.LowerF;
}
var _e;
(function(n) {
  n[n.NoValue = 0] = "NoValue", n[n.Unquoted = 1] = "Unquoted", n[n.Single = 2] = "Single", n[n.Double = 3] = "Double";
})(_e || (_e = {}));
const he = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  CdataEnd: new Uint8Array([93, 93, 62]),
  CommentEnd: new Uint8Array([45, 45, 62]),
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
  // `</title`
};
class m6 {
  constructor({ xmlMode: e = !1, decodeEntities: t = !0 }, i) {
    this.cbs = i, this.state = C.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = C.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = e, this.decodeEntities = t, this.entityTrie = e ? Ae.xmlDecodeTree : Ae.htmlDecodeTree;
  }
  reset() {
    this.state = C.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = C.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
  }
  write(e) {
    this.offset += this.buffer.length, this.buffer = e, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  /**
   * The current index within all of the written data.
   */
  getIndex() {
    return this.index;
  }
  /**
   * The start of the current section.
   */
  getSectionStart() {
    return this.sectionStart;
  }
  stateText(e) {
    e === O.Lt || !this.decodeEntities && this.fastForwardTo(O.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = C.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && e === O.Amp && (this.state = C.BeforeEntity);
  }
  stateSpecialStartSequence(e) {
    const t = this.sequenceIndex === this.currentSequence.length;
    if (!(t ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      jt(e)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (e | 32) === this.currentSequence[this.sequenceIndex]
    )))
      this.isSpecial = !1;
    else if (!t) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0, this.state = C.InTagName, this.stateInTagName(e);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(e) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (e === O.Gt || He(e)) {
        const t = this.index - this.currentSequence.length;
        if (this.sectionStart < t) {
          const i = this.index;
          this.index = t, this.cbs.ontext(this.sectionStart, t), this.index = i;
        }
        this.isSpecial = !1, this.sectionStart = t + 2, this.stateInClosingTagName(e);
        return;
      }
      this.sequenceIndex = 0;
    }
    (e | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === he.TitleEnd ? this.decodeEntities && e === O.Amp && (this.state = C.BeforeEntity) : this.fastForwardTo(O.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(e === O.Lt);
  }
  stateCDATASequence(e) {
    e === he.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === he.Cdata.length && (this.state = C.InCommentLike, this.currentSequence = he.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = C.InDeclaration, this.stateInDeclaration(e));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(e) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === e)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(e) {
    e === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === he.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = C.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(e) {
    return this.xmlMode ? !jt(e) : G8(e);
  }
  startSpecial(e, t) {
    this.isSpecial = !0, this.currentSequence = e, this.sequenceIndex = t, this.state = C.SpecialStartSequence;
  }
  stateBeforeTagName(e) {
    if (e === O.ExclamationMark)
      this.state = C.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (e === O.Questionmark)
      this.state = C.InProcessingInstruction, this.sectionStart = this.index + 1;
    else if (this.isTagStartChar(e)) {
      const t = e | 32;
      this.sectionStart = this.index, !this.xmlMode && t === he.TitleEnd[2] ? this.startSpecial(he.TitleEnd, 3) : this.state = !this.xmlMode && t === he.ScriptEnd[2] ? C.BeforeSpecialS : C.InTagName;
    } else
      e === O.Slash ? this.state = C.BeforeClosingTagName : (this.state = C.Text, this.stateText(e));
  }
  stateInTagName(e) {
    jt(e) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = C.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateBeforeClosingTagName(e) {
    He(e) || (e === O.Gt ? this.state = C.Text : (this.state = this.isTagStartChar(e) ? C.InClosingTagName : C.InSpecialComment, this.sectionStart = this.index));
  }
  stateInClosingTagName(e) {
    (e === O.Gt || He(e)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = C.AfterClosingTagName, this.stateAfterClosingTagName(e));
  }
  stateAfterClosingTagName(e) {
    (e === O.Gt || this.fastForwardTo(O.Gt)) && (this.state = C.Text, this.baseState = C.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(e) {
    e === O.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = C.InSpecialTag, this.sequenceIndex = 0) : this.state = C.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : e === O.Slash ? this.state = C.InSelfClosingTag : He(e) || (this.state = C.InAttributeName, this.sectionStart = this.index);
  }
  stateInSelfClosingTag(e) {
    e === O.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = C.Text, this.baseState = C.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : He(e) || (this.state = C.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateInAttributeName(e) {
    (e === O.Eq || jt(e)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = C.AfterAttributeName, this.stateAfterAttributeName(e));
  }
  stateAfterAttributeName(e) {
    e === O.Eq ? this.state = C.BeforeAttributeValue : e === O.Slash || e === O.Gt ? (this.cbs.onattribend(_e.NoValue, this.index), this.state = C.BeforeAttributeName, this.stateBeforeAttributeName(e)) : He(e) || (this.cbs.onattribend(_e.NoValue, this.index), this.state = C.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(e) {
    e === O.DoubleQuote ? (this.state = C.InAttributeValueDq, this.sectionStart = this.index + 1) : e === O.SingleQuote ? (this.state = C.InAttributeValueSq, this.sectionStart = this.index + 1) : He(e) || (this.sectionStart = this.index, this.state = C.InAttributeValueNq, this.stateInAttributeValueNoQuotes(e));
  }
  handleInAttributeValue(e, t) {
    e === t || !this.decodeEntities && this.fastForwardTo(t) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(t === O.DoubleQuote ? _e.Double : _e.Single, this.index), this.state = C.BeforeAttributeName) : this.decodeEntities && e === O.Amp && (this.baseState = this.state, this.state = C.BeforeEntity);
  }
  stateInAttributeValueDoubleQuotes(e) {
    this.handleInAttributeValue(e, O.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(e) {
    this.handleInAttributeValue(e, O.SingleQuote);
  }
  stateInAttributeValueNoQuotes(e) {
    He(e) || e === O.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(_e.Unquoted, this.index), this.state = C.BeforeAttributeName, this.stateBeforeAttributeName(e)) : this.decodeEntities && e === O.Amp && (this.baseState = this.state, this.state = C.BeforeEntity);
  }
  stateBeforeDeclaration(e) {
    e === O.OpeningSquareBracket ? (this.state = C.CDATASequence, this.sequenceIndex = 0) : this.state = e === O.Dash ? C.BeforeComment : C.InDeclaration;
  }
  stateInDeclaration(e) {
    (e === O.Gt || this.fastForwardTo(O.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = C.Text, this.sectionStart = this.index + 1);
  }
  stateInProcessingInstruction(e) {
    (e === O.Gt || this.fastForwardTo(O.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = C.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeComment(e) {
    e === O.Dash ? (this.state = C.InCommentLike, this.currentSequence = he.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = C.InDeclaration;
  }
  stateInSpecialComment(e) {
    (e === O.Gt || this.fastForwardTo(O.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = C.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeSpecialS(e) {
    const t = e | 32;
    t === he.ScriptEnd[3] ? this.startSpecial(he.ScriptEnd, 4) : t === he.StyleEnd[3] ? this.startSpecial(he.StyleEnd, 4) : (this.state = C.InTagName, this.stateInTagName(e));
  }
  stateBeforeEntity(e) {
    this.entityExcess = 1, this.entityResult = 0, e === O.Number ? this.state = C.BeforeNumericEntity : e === O.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = C.InNamedEntity, this.stateInNamedEntity(e));
  }
  stateInNamedEntity(e) {
    if (this.entityExcess += 1, this.trieIndex = Ae.determineBranch(this.entityTrie, this.trieCurrent, this.trieIndex + 1, e), this.trieIndex < 0) {
      this.emitNamedEntity(), this.index--;
      return;
    }
    this.trieCurrent = this.entityTrie[this.trieIndex];
    const t = this.trieCurrent & Ae.BinTrieFlags.VALUE_LENGTH;
    if (t) {
      const i = (t >> 14) - 1;
      if (!this.allowLegacyEntity() && e !== O.Semi)
        this.trieIndex += i;
      else {
        const a = this.index - this.entityExcess + 1;
        a > this.sectionStart && this.emitPartial(this.sectionStart, a), this.entityResult = this.trieIndex, this.trieIndex += i, this.entityExcess = 0, this.sectionStart = this.index + 1, i === 0 && this.emitNamedEntity();
      }
    }
  }
  emitNamedEntity() {
    if (this.state = this.baseState, this.entityResult === 0)
      return;
    switch ((this.entityTrie[this.entityResult] & Ae.BinTrieFlags.VALUE_LENGTH) >> 14) {
      case 1: {
        this.emitCodePoint(this.entityTrie[this.entityResult] & ~Ae.BinTrieFlags.VALUE_LENGTH);
        break;
      }
      case 2: {
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
        break;
      }
      case 3:
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
    }
  }
  stateBeforeNumericEntity(e) {
    (e | 32) === O.LowerX ? (this.entityExcess++, this.state = C.InHexEntity) : (this.state = C.InNumericEntity, this.stateInNumericEntity(e));
  }
  emitNumericEntity(e) {
    const t = this.index - this.entityExcess - 1;
    t + 2 + +(this.state === C.InHexEntity) !== this.index && (t > this.sectionStart && this.emitPartial(this.sectionStart, t), this.sectionStart = this.index + Number(e), this.emitCodePoint(Ae.replaceCodePoint(this.entityResult))), this.state = this.baseState;
  }
  stateInNumericEntity(e) {
    e === O.Semi ? this.emitNumericEntity(!0) : er(e) ? (this.entityResult = this.entityResult * 10 + (e - O.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
  }
  stateInHexEntity(e) {
    e === O.Semi ? this.emitNumericEntity(!0) : er(e) ? (this.entityResult = this.entityResult * 16 + (e - O.Zero), this.entityExcess++) : W8(e) ? (this.entityResult = this.entityResult * 16 + ((e | 32) - O.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
  }
  allowLegacyEntity() {
    return !this.xmlMode && (this.baseState === C.Text || this.baseState === C.InSpecialTag);
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === C.Text || this.state === C.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === C.InAttributeValueDq || this.state === C.InAttributeValueSq || this.state === C.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const e = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case C.Text: {
          this.stateText(e);
          break;
        }
        case C.SpecialStartSequence: {
          this.stateSpecialStartSequence(e);
          break;
        }
        case C.InSpecialTag: {
          this.stateInSpecialTag(e);
          break;
        }
        case C.CDATASequence: {
          this.stateCDATASequence(e);
          break;
        }
        case C.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(e);
          break;
        }
        case C.InAttributeName: {
          this.stateInAttributeName(e);
          break;
        }
        case C.InCommentLike: {
          this.stateInCommentLike(e);
          break;
        }
        case C.InSpecialComment: {
          this.stateInSpecialComment(e);
          break;
        }
        case C.BeforeAttributeName: {
          this.stateBeforeAttributeName(e);
          break;
        }
        case C.InTagName: {
          this.stateInTagName(e);
          break;
        }
        case C.InClosingTagName: {
          this.stateInClosingTagName(e);
          break;
        }
        case C.BeforeTagName: {
          this.stateBeforeTagName(e);
          break;
        }
        case C.AfterAttributeName: {
          this.stateAfterAttributeName(e);
          break;
        }
        case C.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(e);
          break;
        }
        case C.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(e);
          break;
        }
        case C.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(e);
          break;
        }
        case C.AfterClosingTagName: {
          this.stateAfterClosingTagName(e);
          break;
        }
        case C.BeforeSpecialS: {
          this.stateBeforeSpecialS(e);
          break;
        }
        case C.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(e);
          break;
        }
        case C.InSelfClosingTag: {
          this.stateInSelfClosingTag(e);
          break;
        }
        case C.InDeclaration: {
          this.stateInDeclaration(e);
          break;
        }
        case C.BeforeDeclaration: {
          this.stateBeforeDeclaration(e);
          break;
        }
        case C.BeforeComment: {
          this.stateBeforeComment(e);
          break;
        }
        case C.InProcessingInstruction: {
          this.stateInProcessingInstruction(e);
          break;
        }
        case C.InNamedEntity: {
          this.stateInNamedEntity(e);
          break;
        }
        case C.BeforeEntity: {
          this.stateBeforeEntity(e);
          break;
        }
        case C.InHexEntity: {
          this.stateInHexEntity(e);
          break;
        }
        case C.InNumericEntity: {
          this.stateInNumericEntity(e);
          break;
        }
        default:
          this.stateBeforeNumericEntity(e);
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === C.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const e = this.buffer.length + this.offset;
    this.state === C.InCommentLike ? this.currentSequence === he.CdataEnd ? this.cbs.oncdata(this.sectionStart, e, 0) : this.cbs.oncomment(this.sectionStart, e, 0) : this.state === C.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === C.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === C.InTagName || this.state === C.BeforeAttributeName || this.state === C.BeforeAttributeValue || this.state === C.AfterAttributeName || this.state === C.InAttributeName || this.state === C.InAttributeValueSq || this.state === C.InAttributeValueDq || this.state === C.InAttributeValueNq || this.state === C.InClosingTagName || this.cbs.ontext(this.sectionStart, e);
  }
  emitPartial(e, t) {
    this.baseState !== C.Text && this.baseState !== C.InSpecialTag ? this.cbs.onattribdata(e, t) : this.cbs.ontext(e, t);
  }
  emitCodePoint(e) {
    this.baseState !== C.Text && this.baseState !== C.InSpecialTag ? this.cbs.onattribentity(e) : this.cbs.ontextentity(e);
  }
}
const st = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), X = /* @__PURE__ */ new Set(["p"]), tr = /* @__PURE__ */ new Set(["thead", "tbody"]), nr = /* @__PURE__ */ new Set(["dd", "dt"]), ir = /* @__PURE__ */ new Set(["rt", "rp"]), K8 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", X],
  ["h1", X],
  ["h2", X],
  ["h3", X],
  ["h4", X],
  ["h5", X],
  ["h6", X],
  ["select", st],
  ["input", st],
  ["output", st],
  ["button", st],
  ["datalist", st],
  ["textarea", st],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", nr],
  ["dt", nr],
  ["address", X],
  ["article", X],
  ["aside", X],
  ["blockquote", X],
  ["details", X],
  ["div", X],
  ["dl", X],
  ["fieldset", X],
  ["figcaption", X],
  ["figure", X],
  ["footer", X],
  ["form", X],
  ["header", X],
  ["hr", X],
  ["main", X],
  ["nav", X],
  ["ol", X],
  ["pre", X],
  ["section", X],
  ["table", X],
  ["ul", X],
  ["rt", ir],
  ["rp", ir],
  ["tbody", tr],
  ["tfoot", tr]
]), Z8 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), ar = /* @__PURE__ */ new Set(["math", "svg"]), rr = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), J8 = /\s|\//;
class Gi {
  constructor(e, t = {}) {
    var i, a, r, o, l;
    this.options = t, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.lowerCaseTagNames = (i = t.lowerCaseTags) !== null && i !== void 0 ? i : !t.xmlMode, this.lowerCaseAttributeNames = (a = t.lowerCaseAttributeNames) !== null && a !== void 0 ? a : !t.xmlMode, this.tokenizer = new ((r = t.Tokenizer) !== null && r !== void 0 ? r : m6)(this.options, this), (l = (o = this.cbs).onparserinit) === null || l === void 0 || l.call(o, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(e, t) {
    var i, a;
    const r = this.getSlice(e, t);
    this.endIndex = t - 1, (a = (i = this.cbs).ontext) === null || a === void 0 || a.call(i, r), this.startIndex = t;
  }
  /** @internal */
  ontextentity(e) {
    var t, i;
    const a = this.tokenizer.getSectionStart();
    this.endIndex = a - 1, (i = (t = this.cbs).ontext) === null || i === void 0 || i.call(t, Ae.fromCodePoint(e)), this.startIndex = a;
  }
  isVoidElement(e) {
    return !this.options.xmlMode && Z8.has(e);
  }
  /** @internal */
  onopentagname(e, t) {
    this.endIndex = t;
    let i = this.getSlice(e, t);
    this.lowerCaseTagNames && (i = i.toLowerCase()), this.emitOpenTag(i);
  }
  emitOpenTag(e) {
    var t, i, a, r;
    this.openTagStart = this.startIndex, this.tagname = e;
    const o = !this.options.xmlMode && K8.get(e);
    if (o)
      for (; this.stack.length > 0 && o.has(this.stack[this.stack.length - 1]); ) {
        const l = this.stack.pop();
        (i = (t = this.cbs).onclosetag) === null || i === void 0 || i.call(t, l, !0);
      }
    this.isVoidElement(e) || (this.stack.push(e), ar.has(e) ? this.foreignContext.push(!0) : rr.has(e) && this.foreignContext.push(!1)), (r = (a = this.cbs).onopentagname) === null || r === void 0 || r.call(a, e), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(e) {
    var t, i;
    this.startIndex = this.openTagStart, this.attribs && ((i = (t = this.cbs).onopentag) === null || i === void 0 || i.call(t, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /** @internal */
  onopentagend(e) {
    this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
  }
  /** @internal */
  onclosetag(e, t) {
    var i, a, r, o, l, s;
    this.endIndex = t;
    let u = this.getSlice(e, t);
    if (this.lowerCaseTagNames && (u = u.toLowerCase()), (ar.has(u) || rr.has(u)) && this.foreignContext.pop(), this.isVoidElement(u))
      !this.options.xmlMode && u === "br" && ((a = (i = this.cbs).onopentagname) === null || a === void 0 || a.call(i, "br"), (o = (r = this.cbs).onopentag) === null || o === void 0 || o.call(r, "br", {}, !0), (s = (l = this.cbs).onclosetag) === null || s === void 0 || s.call(l, "br", !1));
    else {
      const c = this.stack.lastIndexOf(u);
      if (c !== -1)
        if (this.cbs.onclosetag) {
          let f = this.stack.length - c;
          for (; f--; )
            this.cbs.onclosetag(this.stack.pop(), f !== 0);
        } else
          this.stack.length = c;
      else
        !this.options.xmlMode && u === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = t + 1;
  }
  /** @internal */
  onselfclosingtag(e) {
    this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
  }
  closeCurrentTag(e) {
    var t, i;
    const a = this.tagname;
    this.endOpenTag(e), this.stack[this.stack.length - 1] === a && ((i = (t = this.cbs).onclosetag) === null || i === void 0 || i.call(t, a, !e), this.stack.pop());
  }
  /** @internal */
  onattribname(e, t) {
    this.startIndex = e;
    const i = this.getSlice(e, t);
    this.attribname = this.lowerCaseAttributeNames ? i.toLowerCase() : i;
  }
  /** @internal */
  onattribdata(e, t) {
    this.attribvalue += this.getSlice(e, t);
  }
  /** @internal */
  onattribentity(e) {
    this.attribvalue += Ae.fromCodePoint(e);
  }
  /** @internal */
  onattribend(e, t) {
    var i, a;
    this.endIndex = t, (a = (i = this.cbs).onattribute) === null || a === void 0 || a.call(i, this.attribname, this.attribvalue, e === _e.Double ? '"' : e === _e.Single ? "'" : e === _e.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(e) {
    const t = e.search(J8);
    let i = t < 0 ? e : e.substr(0, t);
    return this.lowerCaseTagNames && (i = i.toLowerCase()), i;
  }
  /** @internal */
  ondeclaration(e, t) {
    this.endIndex = t;
    const i = this.getSlice(e, t);
    if (this.cbs.onprocessinginstruction) {
      const a = this.getInstructionName(i);
      this.cbs.onprocessinginstruction(`!${a}`, `!${i}`);
    }
    this.startIndex = t + 1;
  }
  /** @internal */
  onprocessinginstruction(e, t) {
    this.endIndex = t;
    const i = this.getSlice(e, t);
    if (this.cbs.onprocessinginstruction) {
      const a = this.getInstructionName(i);
      this.cbs.onprocessinginstruction(`?${a}`, `?${i}`);
    }
    this.startIndex = t + 1;
  }
  /** @internal */
  oncomment(e, t, i) {
    var a, r, o, l;
    this.endIndex = t, (r = (a = this.cbs).oncomment) === null || r === void 0 || r.call(a, this.getSlice(e, t - i)), (l = (o = this.cbs).oncommentend) === null || l === void 0 || l.call(o), this.startIndex = t + 1;
  }
  /** @internal */
  oncdata(e, t, i) {
    var a, r, o, l, s, u, c, f, d, g;
    this.endIndex = t;
    const b = this.getSlice(e, t - i);
    this.options.xmlMode || this.options.recognizeCDATA ? ((r = (a = this.cbs).oncdatastart) === null || r === void 0 || r.call(a), (l = (o = this.cbs).ontext) === null || l === void 0 || l.call(o, b), (u = (s = this.cbs).oncdataend) === null || u === void 0 || u.call(s)) : ((f = (c = this.cbs).oncomment) === null || f === void 0 || f.call(c, `[CDATA[${b}]]`), (g = (d = this.cbs).oncommentend) === null || g === void 0 || g.call(d)), this.startIndex = t + 1;
  }
  /** @internal */
  onend() {
    var e, t;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i], !0))
        ;
    }
    (t = (e = this.cbs).onend) === null || t === void 0 || t.call(e);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var e, t, i, a;
    (t = (e = this.cbs).onreset) === null || t === void 0 || t.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (a = (i = this.cbs).onparserinit) === null || a === void 0 || a.call(i, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(e) {
    this.reset(), this.end(e);
  }
  getSlice(e, t) {
    for (; e - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let i = this.buffers[0].slice(e - this.bufferOffset, t - this.bufferOffset);
    for (; t - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), i += this.buffers[0].slice(0, t - this.bufferOffset);
    return i;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(e) {
    var t, i;
    if (this.ended) {
      (i = (t = this.cbs).onerror) === null || i === void 0 || i.call(t, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(e) {
    var t, i;
    if (this.ended) {
      (i = (t = this.cbs).onerror) === null || i === void 0 || i.call(t, new Error(".end() after done!"));
      return;
    }
    e && this.write(e), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(e) {
    this.write(e);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(e) {
    this.end(e);
  }
}
var J;
(function(n) {
  n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
})(J || (J = {}));
function p6(n) {
  return n.type === J.Tag || n.type === J.Script || n.type === J.Style;
}
const b6 = J.Root, y6 = J.Text, v6 = J.Directive, T6 = J.Comment, k6 = J.Script, E6 = J.Style, x6 = J.Tag, S6 = J.CDATA, C6 = J.Doctype, Q8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get ElementType() {
    return J;
  },
  isTag: p6,
  Root: b6,
  Text: y6,
  Directive: v6,
  Comment: T6,
  Script: k6,
  Style: E6,
  Tag: x6,
  CDATA: S6,
  Doctype: C6
});
class w6 {
  constructor() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(e) {
    this.parent = e;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(e) {
    this.prev = e;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(e) {
    this.next = e;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(e = !1) {
    return A6(this, e);
  }
}
class Wi extends w6 {
  /**
   * @param data The content of the data node
   */
  constructor(e) {
    super(), this.data = e;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(e) {
    this.data = e;
  }
}
class hi extends Wi {
  constructor() {
    super(...arguments), this.type = J.Text;
  }
  get nodeType() {
    return 3;
  }
}
class $6 extends Wi {
  constructor() {
    super(...arguments), this.type = J.Comment;
  }
  get nodeType() {
    return 8;
  }
}
class B6 extends Wi {
  constructor(e, t) {
    super(t), this.name = e, this.type = J.Directive;
  }
  get nodeType() {
    return 1;
  }
}
class Ki extends w6 {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(e) {
    super(), this.children = e;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var e;
    return (e = this.children[0]) !== null && e !== void 0 ? e : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(e) {
    this.children = e;
  }
}
class P6 extends Ki {
  constructor() {
    super(...arguments), this.type = J.CDATA;
  }
  get nodeType() {
    return 4;
  }
}
class mi extends Ki {
  constructor() {
    super(...arguments), this.type = J.Root;
  }
  get nodeType() {
    return 9;
  }
}
let M6 = class extends Ki {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(e, t, i = [], a = e === "script" ? J.Script : e === "style" ? J.Style : J.Tag) {
    super(i), this.name = e, this.attribs = t, this.type = a;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(e) {
    this.name = e;
  }
  get attributes() {
    return Object.keys(this.attribs).map((e) => {
      var t, i;
      return {
        name: e,
        value: this.attribs[e],
        namespace: (t = this["x-attribsNamespace"]) === null || t === void 0 ? void 0 : t[e],
        prefix: (i = this["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[e]
      };
    });
  }
};
function ke(n) {
  return p6(n);
}
function An(n) {
  return n.type === J.CDATA;
}
function nt(n) {
  return n.type === J.Text;
}
function Zi(n) {
  return n.type === J.Comment;
}
function X8(n) {
  return n.type === J.Directive;
}
function D6(n) {
  return n.type === J.Root;
}
function Qe(n) {
  return Object.prototype.hasOwnProperty.call(n, "children");
}
function A6(n, e = !1) {
  let t;
  if (nt(n))
    t = new hi(n.data);
  else if (Zi(n))
    t = new $6(n.data);
  else if (ke(n)) {
    const i = e ? Vn(n.children) : [], a = new M6(n.name, { ...n.attribs }, i);
    i.forEach((r) => r.parent = a), n.namespace != null && (a.namespace = n.namespace), n["x-attribsNamespace"] && (a["x-attribsNamespace"] = { ...n["x-attribsNamespace"] }), n["x-attribsPrefix"] && (a["x-attribsPrefix"] = { ...n["x-attribsPrefix"] }), t = a;
  } else if (An(n)) {
    const i = e ? Vn(n.children) : [], a = new P6(i);
    i.forEach((r) => r.parent = a), t = a;
  } else if (D6(n)) {
    const i = e ? Vn(n.children) : [], a = new mi(i);
    i.forEach((r) => r.parent = a), n["x-mode"] && (a["x-mode"] = n["x-mode"]), t = a;
  } else if (X8(n)) {
    const i = new B6(n.name, n.data);
    n["x-name"] != null && (i["x-name"] = n["x-name"], i["x-publicId"] = n["x-publicId"], i["x-systemId"] = n["x-systemId"]), t = i;
  } else
    throw new Error(`Not implemented yet: ${n.type}`);
  return t.startIndex = n.startIndex, t.endIndex = n.endIndex, n.sourceCodeLocation != null && (t.sourceCodeLocation = n.sourceCodeLocation), t;
}
function Vn(n) {
  const e = n.map((t) => A6(t, !0));
  for (let t = 1; t < e.length; t++)
    e[t].prev = e[t - 1], e[t - 1].next = e[t];
  return e;
}
const or = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class pn {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(e, t, i) {
    this.dom = [], this.root = new mi(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof t == "function" && (i = t, t = or), typeof e == "object" && (t = e, e = void 0), this.callback = e ?? null, this.options = t ?? or, this.elementCB = i ?? null;
  }
  onparserinit(e) {
    this.parser = e;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new mi(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(e) {
    this.handleCallback(e);
  }
  onclosetag() {
    this.lastNode = null;
    const e = this.tagStack.pop();
    this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
  }
  onopentag(e, t) {
    const i = this.options.xmlMode ? J.Tag : void 0, a = new M6(e, t, void 0, i);
    this.addNode(a), this.tagStack.push(a);
  }
  ontext(e) {
    const { lastNode: t } = this;
    if (t && t.type === J.Text)
      t.data += e, this.options.withEndIndices && (t.endIndex = this.parser.endIndex);
    else {
      const i = new hi(e);
      this.addNode(i), this.lastNode = i;
    }
  }
  oncomment(e) {
    if (this.lastNode && this.lastNode.type === J.Comment) {
      this.lastNode.data += e;
      return;
    }
    const t = new $6(e);
    this.addNode(t), this.lastNode = t;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const e = new hi(""), t = new P6([e]);
    this.addNode(t), e.parent = t, this.lastNode = e;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(e, t) {
    const i = new B6(e, t);
    this.addNode(i);
  }
  handleCallback(e) {
    if (typeof this.callback == "function")
      this.callback(e, this.dom);
    else if (e)
      throw e;
  }
  addNode(e) {
    const t = this.tagStack[this.tagStack.length - 1], i = t.children[t.children.length - 1];
    this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), i && (e.prev = i, i.next = e), e.parent = t, this.lastNode = null;
  }
}
const sr = /["&'<>$\x80-\uFFFF]/g, eP = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), tP = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (n, e) => n.codePointAt(e) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (n, e) => (n.charCodeAt(e) & 64512) === 55296 ? (n.charCodeAt(e) - 55296) * 1024 + n.charCodeAt(e + 1) - 56320 + 65536 : n.charCodeAt(e)
  )
);
function L6(n) {
  let e = "", t = 0, i;
  for (; (i = sr.exec(n)) !== null; ) {
    const a = i.index, r = n.charCodeAt(a), o = eP.get(r);
    o !== void 0 ? (e += n.substring(t, a) + o, t = a + 1) : (e += `${n.substring(t, a)}&#x${tP(n, a).toString(16)};`, t = sr.lastIndex += +((r & 64512) === 55296));
  }
  return e + n.substr(t);
}
function O6(n, e) {
  return function(i) {
    let a, r = 0, o = "";
    for (; a = n.exec(i); )
      r !== a.index && (o += i.substring(r, a.index)), o += e.get(a[0].charCodeAt(0)), r = a.index + 1;
    return o + i.substring(r);
  };
}
const nP = O6(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), iP = O6(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), aP = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((n) => [n.toLowerCase(), n])), rP = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((n) => [n.toLowerCase(), n])), oP = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function sP(n) {
  return n.replace(/"/g, "&quot;");
}
function lP(n, e) {
  var t;
  if (!n)
    return;
  const i = ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) === !1 ? sP : e.xmlMode || e.encodeEntities !== "utf8" ? L6 : nP;
  return Object.keys(n).map((a) => {
    var r, o;
    const l = (r = n[a]) !== null && r !== void 0 ? r : "";
    return e.xmlMode === "foreign" && (a = (o = rP.get(a)) !== null && o !== void 0 ? o : a), !e.emptyAttrs && !e.xmlMode && l === "" ? a : `${a}="${i(l)}"`;
  }).join(" ");
}
const lr = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function Ji(n, e = {}) {
  const t = "length" in n ? n : [n];
  let i = "";
  for (let a = 0; a < t.length; a++)
    i += uP(t[a], e);
  return i;
}
function uP(n, e) {
  switch (n.type) {
    case b6:
      return Ji(n.children, e);
    case C6:
    case v6:
      return gP(n);
    case T6:
      return pP(n);
    case S6:
      return mP(n);
    case k6:
    case E6:
    case x6:
      return fP(n, e);
    case y6:
      return hP(n, e);
  }
}
const cP = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), dP = /* @__PURE__ */ new Set(["svg", "math"]);
function fP(n, e) {
  var t;
  e.xmlMode === "foreign" && (n.name = (t = aP.get(n.name)) !== null && t !== void 0 ? t : n.name, n.parent && cP.has(n.parent.name) && (e = { ...e, xmlMode: !1 })), !e.xmlMode && dP.has(n.name) && (e = { ...e, xmlMode: "foreign" });
  let i = `<${n.name}`;
  const a = lP(n.attribs, e);
  return a && (i += ` ${a}`), n.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && lr.has(n.name)
  )) ? (e.xmlMode || (i += " "), i += "/>") : (i += ">", n.children.length > 0 && (i += Ji(n.children, e)), (e.xmlMode || !lr.has(n.name)) && (i += `</${n.name}>`)), i;
}
function gP(n) {
  return `<${n.data}>`;
}
function hP(n, e) {
  var t;
  let i = n.data || "";
  return ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) !== !1 && !(!e.xmlMode && n.parent && oP.has(n.parent.name)) && (i = e.xmlMode || e.encodeEntities !== "utf8" ? L6(i) : iP(i)), i;
}
function mP(n) {
  return `<![CDATA[${n.children[0].data}]]>`;
}
function pP(n) {
  return `<!--${n.data}-->`;
}
function _6(n, e) {
  return Ji(n, e);
}
function bP(n, e) {
  return Qe(n) ? n.children.map((t) => _6(t, e)).join("") : "";
}
function Qt(n) {
  return Array.isArray(n) ? n.map(Qt).join("") : ke(n) ? n.name === "br" ? `
` : Qt(n.children) : An(n) ? Qt(n.children) : nt(n) ? n.data : "";
}
function bn(n) {
  return Array.isArray(n) ? n.map(bn).join("") : Qe(n) && !Zi(n) ? bn(n.children) : nt(n) ? n.data : "";
}
function pi(n) {
  return Array.isArray(n) ? n.map(pi).join("") : Qe(n) && (n.type === J.Tag || An(n)) ? pi(n.children) : nt(n) ? n.data : "";
}
function I6(n) {
  return Qe(n) ? n.children : [];
}
function R6(n) {
  return n.parent || null;
}
function yP(n) {
  const e = R6(n);
  if (e != null)
    return I6(e);
  const t = [n];
  let { prev: i, next: a } = n;
  for (; i != null; )
    t.unshift(i), { prev: i } = i;
  for (; a != null; )
    t.push(a), { next: a } = a;
  return t;
}
function vP(n, e) {
  var t;
  return (t = n.attribs) === null || t === void 0 ? void 0 : t[e];
}
function TP(n, e) {
  return n.attribs != null && Object.prototype.hasOwnProperty.call(n.attribs, e) && n.attribs[e] != null;
}
function kP(n) {
  return n.name;
}
function EP(n) {
  let { next: e } = n;
  for (; e !== null && !ke(e); )
    ({ next: e } = e);
  return e;
}
function xP(n) {
  let { prev: e } = n;
  for (; e !== null && !ke(e); )
    ({ prev: e } = e);
  return e;
}
function Rt(n) {
  if (n.prev && (n.prev.next = n.next), n.next && (n.next.prev = n.prev), n.parent) {
    const e = n.parent.children, t = e.lastIndexOf(n);
    t >= 0 && e.splice(t, 1);
  }
  n.next = null, n.prev = null, n.parent = null;
}
function SP(n, e) {
  const t = e.prev = n.prev;
  t && (t.next = e);
  const i = e.next = n.next;
  i && (i.prev = e);
  const a = e.parent = n.parent;
  if (a) {
    const r = a.children;
    r[r.lastIndexOf(n)] = e, n.parent = null;
  }
}
function CP(n, e) {
  if (Rt(e), e.next = null, e.parent = n, n.children.push(e) > 1) {
    const t = n.children[n.children.length - 2];
    t.next = e, e.prev = t;
  } else
    e.prev = null;
}
function wP(n, e) {
  Rt(e);
  const { parent: t } = n, i = n.next;
  if (e.next = i, e.prev = n, n.next = e, e.parent = t, i) {
    if (i.prev = e, t) {
      const a = t.children;
      a.splice(a.lastIndexOf(i), 0, e);
    }
  } else
    t && t.children.push(e);
}
function $P(n, e) {
  if (Rt(e), e.parent = n, e.prev = null, n.children.unshift(e) !== 1) {
    const t = n.children[1];
    t.prev = e, e.next = t;
  } else
    e.next = null;
}
function BP(n, e) {
  Rt(e);
  const { parent: t } = n;
  if (t) {
    const i = t.children;
    i.splice(i.indexOf(n), 0, e);
  }
  n.prev && (n.prev.next = e), e.parent = t, e.prev = n.prev, e.next = n, n.prev = e;
}
function Ln(n, e, t = !0, i = 1 / 0) {
  return N6(n, Array.isArray(e) ? e : [e], t, i);
}
function N6(n, e, t, i) {
  const a = [], r = [e], o = [0];
  for (; ; ) {
    if (o[0] >= r[0].length) {
      if (o.length === 1)
        return a;
      r.shift(), o.shift();
      continue;
    }
    const l = r[0][o[0]++];
    if (n(l) && (a.push(l), --i <= 0))
      return a;
    t && Qe(l) && l.children.length > 0 && (o.unshift(0), r.unshift(l.children));
  }
}
function PP(n, e) {
  return e.find(n);
}
function Qi(n, e, t = !0) {
  let i = null;
  for (let a = 0; a < e.length && !i; a++) {
    const r = e[a];
    if (ke(r))
      n(r) ? i = r : t && r.children.length > 0 && (i = Qi(n, r.children, !0));
    else
      continue;
  }
  return i;
}
function F6(n, e) {
  return e.some((t) => ke(t) && (n(t) || F6(n, t.children)));
}
function MP(n, e) {
  const t = [], i = [e], a = [0];
  for (; ; ) {
    if (a[0] >= i[0].length) {
      if (i.length === 1)
        return t;
      i.shift(), a.shift();
      continue;
    }
    const r = i[0][a[0]++];
    ke(r) && (n(r) && t.push(r), r.children.length > 0 && (a.unshift(0), i.unshift(r.children)));
  }
}
const yn = {
  tag_name(n) {
    return typeof n == "function" ? (e) => ke(e) && n(e.name) : n === "*" ? ke : (e) => ke(e) && e.name === n;
  },
  tag_type(n) {
    return typeof n == "function" ? (e) => n(e.type) : (e) => e.type === n;
  },
  tag_contains(n) {
    return typeof n == "function" ? (e) => nt(e) && n(e.data) : (e) => nt(e) && e.data === n;
  }
};
function U6(n, e) {
  return typeof e == "function" ? (t) => ke(t) && e(t.attribs[n]) : (t) => ke(t) && t.attribs[n] === e;
}
function DP(n, e) {
  return (t) => n(t) || e(t);
}
function z6(n) {
  const e = Object.keys(n).map((t) => {
    const i = n[t];
    return Object.prototype.hasOwnProperty.call(yn, t) ? yn[t](i) : U6(t, i);
  });
  return e.length === 0 ? null : e.reduce(DP);
}
function AP(n, e) {
  const t = z6(n);
  return t ? t(e) : !0;
}
function LP(n, e, t, i = 1 / 0) {
  const a = z6(n);
  return a ? Ln(a, e, t, i) : [];
}
function OP(n, e, t = !0) {
  return Array.isArray(e) || (e = [e]), Qi(U6("id", n), e, t);
}
function pt(n, e, t = !0, i = 1 / 0) {
  return Ln(yn.tag_name(n), e, t, i);
}
function _P(n, e, t = !0, i = 1 / 0) {
  return Ln(yn.tag_type(n), e, t, i);
}
function IP(n) {
  let e = n.length;
  for (; --e >= 0; ) {
    const t = n[e];
    if (e > 0 && n.lastIndexOf(t, e - 1) >= 0) {
      n.splice(e, 1);
      continue;
    }
    for (let i = t.parent; i; i = i.parent)
      if (n.includes(i)) {
        n.splice(e, 1);
        break;
      }
  }
  return n;
}
var Se;
(function(n) {
  n[n.DISCONNECTED = 1] = "DISCONNECTED", n[n.PRECEDING = 2] = "PRECEDING", n[n.FOLLOWING = 4] = "FOLLOWING", n[n.CONTAINS = 8] = "CONTAINS", n[n.CONTAINED_BY = 16] = "CONTAINED_BY";
})(Se || (Se = {}));
function H6(n, e) {
  const t = [], i = [];
  if (n === e)
    return 0;
  let a = Qe(n) ? n : n.parent;
  for (; a; )
    t.unshift(a), a = a.parent;
  for (a = Qe(e) ? e : e.parent; a; )
    i.unshift(a), a = a.parent;
  const r = Math.min(t.length, i.length);
  let o = 0;
  for (; o < r && t[o] === i[o]; )
    o++;
  if (o === 0)
    return Se.DISCONNECTED;
  const l = t[o - 1], s = l.children, u = t[o], c = i[o];
  return s.indexOf(u) > s.indexOf(c) ? l === e ? Se.FOLLOWING | Se.CONTAINED_BY : Se.FOLLOWING : l === n ? Se.PRECEDING | Se.CONTAINS : Se.PRECEDING;
}
function RP(n) {
  return n = n.filter((e, t, i) => !i.includes(e, t + 1)), n.sort((e, t) => {
    const i = H6(e, t);
    return i & Se.PRECEDING ? -1 : i & Se.FOLLOWING ? 1 : 0;
  }), n;
}
function Xi(n) {
  const e = vn(HP, n);
  return e ? e.name === "feed" ? NP(e) : FP(e) : null;
}
function NP(n) {
  var e;
  const t = n.children, i = {
    type: "atom",
    items: pt("entry", t).map((o) => {
      var l;
      const { children: s } = o, u = { media: j6(s) };
      me(u, "id", "id", s), me(u, "title", "title", s);
      const c = (l = vn("link", s)) === null || l === void 0 ? void 0 : l.attribs.href;
      c && (u.link = c);
      const f = Je("summary", s) || Je("content", s);
      f && (u.description = f);
      const d = Je("updated", s);
      return d && (u.pubDate = new Date(d)), u;
    })
  };
  me(i, "id", "id", t), me(i, "title", "title", t);
  const a = (e = vn("link", t)) === null || e === void 0 ? void 0 : e.attribs.href;
  a && (i.link = a), me(i, "description", "subtitle", t);
  const r = Je("updated", t);
  return r && (i.updated = new Date(r)), me(i, "author", "email", t, !0), i;
}
function FP(n) {
  var e, t;
  const i = (t = (e = vn("channel", n.children)) === null || e === void 0 ? void 0 : e.children) !== null && t !== void 0 ? t : [], a = {
    type: n.name.substr(0, 3),
    id: "",
    items: pt("item", n.children).map((o) => {
      const { children: l } = o, s = { media: j6(l) };
      me(s, "id", "guid", l), me(s, "title", "title", l), me(s, "link", "link", l), me(s, "description", "description", l);
      const u = Je("pubDate", l) || Je("dc:date", l);
      return u && (s.pubDate = new Date(u)), s;
    })
  };
  me(a, "title", "title", i), me(a, "link", "link", i), me(a, "description", "description", i);
  const r = Je("lastBuildDate", i);
  return r && (a.updated = new Date(r)), me(a, "author", "managingEditor", i, !0), a;
}
const UP = ["url", "type", "lang"], zP = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function j6(n) {
  return pt("media:content", n).map((e) => {
    const { attribs: t } = e, i = {
      medium: t.medium,
      isDefault: !!t.isDefault
    };
    for (const a of UP)
      t[a] && (i[a] = t[a]);
    for (const a of zP)
      t[a] && (i[a] = parseInt(t[a], 10));
    return t.expression && (i.expression = t.expression), i;
  });
}
function vn(n, e) {
  return pt(n, e, !0, 1)[0];
}
function Je(n, e, t = !1) {
  return bn(pt(n, e, t, 1)).trim();
}
function me(n, e, t, i, a = !1) {
  const r = Je(t, i, a);
  r && (n[e] = r);
}
function HP(n) {
  return n === "rss" || n === "feed" || n === "rdf:RDF";
}
const jP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isTag: ke,
  isCDATA: An,
  isText: nt,
  isComment: Zi,
  isDocument: D6,
  hasChildren: Qe,
  getOuterHTML: _6,
  getInnerHTML: bP,
  getText: Qt,
  textContent: bn,
  innerText: pi,
  getChildren: I6,
  getParent: R6,
  getSiblings: yP,
  getAttributeValue: vP,
  hasAttrib: TP,
  getName: kP,
  nextElementSibling: EP,
  prevElementSibling: xP,
  removeElement: Rt,
  replaceElement: SP,
  appendChild: CP,
  append: wP,
  prependChild: $P,
  prepend: BP,
  filter: Ln,
  find: N6,
  findOneChild: PP,
  findOne: Qi,
  existsOne: F6,
  findAll: MP,
  testElement: AP,
  getElements: LP,
  getElementById: OP,
  getElementsByTagName: pt,
  getElementsByTagType: _P,
  removeSubsets: IP,
  get DocumentPosition() {
    return Se;
  },
  compareDocumentPosition: H6,
  uniqueSort: RP,
  getFeed: Xi
});
function q6(n, e) {
  const t = new pn(void 0, e);
  return new Gi(t, e).end(n), t.root;
}
function Y6(n, e) {
  return q6(n, e).children;
}
function qP(n, e, t) {
  const i = new pn(n, e, t);
  return new Gi(i, e);
}
const YP = { xmlMode: !0 };
function VP(n, e = YP) {
  return Xi(Y6(n, e));
}
const GP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseDocument: q6,
  parseDOM: Y6,
  createDomStream: qP,
  parseFeed: VP,
  Parser: Gi,
  DomHandler: pn,
  DefaultHandler: pn,
  Tokenizer: m6,
  ElementType: Q8,
  getFeed: Xi,
  DomUtils: jP
}), WP = /* @__PURE__ */ Mn(GP);
var KP = (n) => {
  if (typeof n != "string")
    throw new TypeError("Expected a string");
  return n.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function ur(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function ZP(n) {
  var e, t;
  return ur(n) === !1 ? !1 : (e = n.constructor, e === void 0 ? !0 : (t = e.prototype, !(ur(t) === !1 || t.hasOwnProperty("isPrototypeOf") === !1)));
}
const JP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isPlainObject: ZP
}), QP = /* @__PURE__ */ Mn(JP);
var XP = function(e) {
  return eM(e) && !tM(e);
};
function eM(n) {
  return !!n && typeof n == "object";
}
function tM(n) {
  var e = Object.prototype.toString.call(n);
  return e === "[object RegExp]" || e === "[object Date]" || aM(n);
}
var nM = typeof Symbol == "function" && Symbol.for, iM = nM ? Symbol.for("react.element") : 60103;
function aM(n) {
  return n.$$typeof === iM;
}
function rM(n) {
  return Array.isArray(n) ? [] : {};
}
function Pt(n, e) {
  return e.clone !== !1 && e.isMergeableObject(n) ? ft(rM(n), n, e) : n;
}
function oM(n, e, t) {
  return n.concat(e).map(function(i) {
    return Pt(i, t);
  });
}
function sM(n, e) {
  if (!e.customMerge)
    return ft;
  var t = e.customMerge(n);
  return typeof t == "function" ? t : ft;
}
function lM(n) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n).filter(function(e) {
    return Object.propertyIsEnumerable.call(n, e);
  }) : [];
}
function cr(n) {
  return Object.keys(n).concat(lM(n));
}
function V6(n, e) {
  try {
    return e in n;
  } catch {
    return !1;
  }
}
function uM(n, e) {
  return V6(n, e) && !(Object.hasOwnProperty.call(n, e) && Object.propertyIsEnumerable.call(n, e));
}
function cM(n, e, t) {
  var i = {};
  return t.isMergeableObject(n) && cr(n).forEach(function(a) {
    i[a] = Pt(n[a], t);
  }), cr(e).forEach(function(a) {
    uM(n, a) || (V6(n, a) && t.isMergeableObject(e[a]) ? i[a] = sM(a, t)(n[a], e[a], t) : i[a] = Pt(e[a], t));
  }), i;
}
function ft(n, e, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || oM, t.isMergeableObject = t.isMergeableObject || XP, t.cloneUnlessOtherwiseSpecified = Pt;
  var i = Array.isArray(e), a = Array.isArray(n), r = i === a;
  return r ? i ? t.arrayMerge(n, e, t) : cM(n, e, t) : Pt(e, t);
}
ft.all = function(e, t) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(i, a) {
    return ft(i, a, t);
  }, {});
};
var dM = ft, fM = dM, G6 = { exports: {} };
(function(n) {
  (function(e, t) {
    n.exports ? n.exports = t() : e.parseSrcset = t();
  })(ne, function() {
    return function(e) {
      function t(D) {
        return D === " " || // space
        D === "	" || // horizontal tab
        D === `
` || // new line
        D === "\f" || // form feed
        D === "\r";
      }
      function i(D) {
        var I, F = D.exec(e.substring(h));
        if (F)
          return I = F[0], h += I.length, I;
      }
      for (var a = e.length, r = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, l = /^[^ \t\n\r\u000c]+/, s = /[,]+$/, u = /^\d+$/, c = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, d, g, b, p, h = 0, E = []; ; ) {
        if (i(o), h >= a)
          return E;
        f = i(l), d = [], f.slice(-1) === "," ? (f = f.replace(s, ""), _()) : B();
      }
      function B() {
        for (i(r), g = "", b = "in descriptor"; ; ) {
          if (p = e.charAt(h), b === "in descriptor")
            if (t(p))
              g && (d.push(g), g = "", b = "after descriptor");
            else if (p === ",") {
              h += 1, g && d.push(g), _();
              return;
            } else if (p === "(")
              g = g + p, b = "in parens";
            else if (p === "") {
              g && d.push(g), _();
              return;
            } else
              g = g + p;
          else if (b === "in parens")
            if (p === ")")
              g = g + p, b = "in descriptor";
            else if (p === "") {
              d.push(g), _();
              return;
            } else
              g = g + p;
          else if (b === "after descriptor" && !t(p))
            if (p === "") {
              _();
              return;
            } else
              b = "in descriptor", h -= 1;
          h += 1;
        }
      }
      function _() {
        var D = !1, I, F, j, W, q = {}, U, v, P, S, x;
        for (W = 0; W < d.length; W++)
          U = d[W], v = U[U.length - 1], P = U.substring(0, U.length - 1), S = parseInt(P, 10), x = parseFloat(P), u.test(P) && v === "w" ? ((I || F) && (D = !0), S === 0 ? D = !0 : I = S) : c.test(P) && v === "x" ? ((I || F || j) && (D = !0), x < 0 ? D = !0 : F = x) : u.test(P) && v === "h" ? ((j || F) && (D = !0), S === 0 ? D = !0 : j = S) : D = !0;
        D ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + U + "'.") : (q.url = f, I && (q.w = I), F && (q.d = F), j && (q.h = j), E.push(q));
      }
    };
  });
})(G6);
var dr = ne.process, ea = { exports: {} }, Y = String, W6 = function() {
  return { isColorSupported: !1, reset: Y, bold: Y, dim: Y, italic: Y, underline: Y, inverse: Y, hidden: Y, strikethrough: Y, black: Y, red: Y, green: Y, yellow: Y, blue: Y, magenta: Y, cyan: Y, white: Y, gray: Y, bgBlack: Y, bgRed: Y, bgGreen: Y, bgYellow: Y, bgBlue: Y, bgMagenta: Y, bgCyan: Y, bgWhite: Y, blackBright: Y, redBright: Y, greenBright: Y, yellowBright: Y, blueBright: Y, magentaBright: Y, cyanBright: Y, whiteBright: Y, bgBlackBright: Y, bgRedBright: Y, bgGreenBright: Y, bgYellowBright: Y, bgBlueBright: Y, bgMagentaBright: Y, bgCyanBright: Y, bgWhiteBright: Y };
};
ea.exports = W6();
ea.exports.createColors = W6;
const gM = {}, hM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gM
}), Be = /* @__PURE__ */ Mn(hM);
let fr = ea.exports, gr = Be;
class Mt extends Error {
  constructor(e, t, i, a, r, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, r && (this.file = r), a && (this.source = a), o && (this.plugin = o), typeof t < "u" && typeof i < "u" && (typeof t == "number" ? (this.line = t, this.column = i) : (this.line = t.line, this.column = t.column, this.endLine = i.line, this.endColumn = i.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Mt);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source)
      return "";
    let t = this.source;
    e == null && (e = fr.isColorSupported);
    let i = (c) => c, a = (c) => c, r = (c) => c;
    if (e) {
      let { bold: c, gray: f, red: d } = fr.createColors(!0);
      a = (g) => c(d(g)), i = (g) => f(g), gr && (r = (g) => gr(g));
    }
    let o = t.split(/\r?\n/), l = Math.max(this.line - 3, 0), s = Math.min(this.line + 2, o.length), u = String(s).length;
    return o.slice(l, s).map((c, f) => {
      let d = l + 1 + f, g = " " + (" " + d).slice(-u) + " | ";
      if (d === this.line) {
        if (c.length > 160) {
          let p = 20, h = Math.max(0, this.column - p), E = Math.max(
            this.column + p,
            this.endColumn + p
          ), B = c.slice(h, E), _ = i(g.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, p - 1)).replace(/[^\t]/g, " ");
          return a(">") + i(g) + r(B) + `
 ` + _ + a("^");
        }
        let b = i(g.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return a(">") + i(g) + r(c) + `
 ` + b + a("^");
      }
      return " " + i(g) + r(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
}
var ta = Mt;
Mt.default = Mt;
const hr = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function mM(n) {
  return n[0].toUpperCase() + n.slice(1);
}
class bi {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let i = "@" + e.name, a = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? i += e.raws.afterName : a && (i += " "), e.nodes)
      this.block(e, i + a);
    else {
      let r = (e.raws.between || "") + (t ? ";" : "");
      this.builder(i + a + r, e);
    }
  }
  beforeAfter(e, t) {
    let i;
    e.type === "decl" ? i = this.raw(e, null, "beforeDecl") : e.type === "comment" ? i = this.raw(e, null, "beforeComment") : t === "before" ? i = this.raw(e, null, "beforeRule") : i = this.raw(e, null, "beforeClose");
    let a = e.parent, r = 0;
    for (; a && a.type !== "root"; )
      r += 1, a = a.parent;
    if (i.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let l = 0; l < r; l++)
          i += o;
    }
    return i;
  }
  block(e, t) {
    let i = this.raw(e, "between", "beforeOpen");
    this.builder(t + i + "{", e, "start");
    let a;
    e.nodes && e.nodes.length ? (this.body(e), a = this.raw(e, "after")) : a = this.raw(e, "after", "emptyBody"), a && this.builder(a), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let i = this.raw(e, "semicolon");
    for (let a = 0; a < e.nodes.length; a++) {
      let r = e.nodes[a], o = this.raw(r, "before");
      o && this.builder(o), this.stringify(r, t !== a || i);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), i = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + i + "*/", e);
  }
  decl(e, t) {
    let i = this.raw(e, "between", "colon"), a = e.prop + i + this.rawValue(e, "value");
    e.important && (a += e.raws.important || " !important"), t && (a += ";"), this.builder(a, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, i) {
    let a;
    if (i || (i = t), t && (a = e.raws[t], typeof a < "u"))
      return a;
    let r = e.parent;
    if (i === "before" && (!r || r.type === "root" && r.first === e || r && r.type === "document"))
      return "";
    if (!r)
      return hr[i];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[i] < "u")
      return o.rawCache[i];
    if (i === "before" || i === "after")
      return this.beforeAfter(e, i);
    {
      let l = "raw" + mM(i);
      this[l] ? a = this[l](o, e) : o.walk((s) => {
        if (a = s.raws[t], typeof a < "u")
          return !1;
      });
    }
    return typeof a > "u" && (a = hr[i]), o.rawCache[i] = a, a;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length > 0 && typeof i.raws.after < "u")
        return t = i.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let i;
    return e.walkComments((a) => {
      if (typeof a.raws.before < "u")
        return i = a.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i > "u" ? i = this.raw(t, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeDecl(e, t) {
    let i;
    return e.walkDecls((a) => {
      if (typeof a.raws.before < "u")
        return i = a.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i > "u" ? i = this.raw(t, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((i) => {
      if (i.type !== "decl" && (t = i.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && (i.parent !== e || e.first !== i) && typeof i.raws.before < "u")
        return t = i.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((i) => {
      if (typeof i.raws.between < "u")
        return t = i.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length === 0 && (t = i.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent)
      return e.raws.indent;
    let t;
    return e.walk((i) => {
      let a = i.parent;
      if (a && a !== e && a.parent && a.parent === e && typeof i.raws.before < "u") {
        let r = i.raws.before.split(`
`);
        return t = r[r.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length && i.last.type === "decl" && (t = i.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let i = e[t], a = e.raws[t];
    return a && a.value === i ? a.raw : i;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
}
var K6 = bi;
bi.default = bi;
let pM = K6;
function yi(n, e) {
  new pM(e).stringify(n);
}
var On = yi;
yi.default = yi;
var Nt = {};
Nt.isClean = Symbol("isClean");
Nt.my = Symbol("my");
let bM = ta, yM = K6, vM = On, { isClean: yt, my: TM } = Nt;
function vi(n, e) {
  let t = new n.constructor();
  for (let i in n) {
    if (!Object.prototype.hasOwnProperty.call(n, i) || i === "proxyCache")
      continue;
    let a = n[i], r = typeof a;
    i === "parent" && r === "object" ? e && (t[i] = e) : i === "source" ? t[i] = a : Array.isArray(a) ? t[i] = a.map((o) => vi(o, t)) : (r === "object" && a !== null && (a = vi(a)), t[i] = a);
  }
  return t;
}
function vt(n, e) {
  if (e && typeof e.offset < "u")
    return e.offset;
  let t = 1, i = 1, a = 0;
  for (let r = 0; r < n.length; r++) {
    if (i === e.line && t === e.column) {
      a = r;
      break;
    }
    n[r] === `
` ? (t = 1, i += 1) : t += 1;
  }
  return a;
}
class Ti {
  constructor(e = {}) {
    this.raws = {}, this[yt] = !1, this[TM] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let i of e[t])
          typeof i.clone == "function" ? this.append(i.clone()) : this.append(i);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = vi(this);
    for (let i in e)
      t[i] = e[i];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: i, start: a } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: a.column, line: a.line },
        { column: i.column, line: i.line },
        t
      );
    }
    return new bM(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[yt] = !0;
  }
  markDirty() {
    if (this[yt]) {
      this[yt] = !1;
      let e = this;
      for (; e = e.parent; )
        e[yt] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let a = this.source.input.css.slice(
        vt(this.source.input.css, this.source.start),
        vt(this.source.input.css, this.source.end)
      ).indexOf(e.word);
      a !== -1 && (t = this.positionInside(a));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, i = this.source.start.line, a = vt(this.source.input.css, this.source.start), r = a + e;
    for (let o = a; o < r; o++)
      this.source.input.css[o] === `
` ? (t = 1, i += 1) : t += 1;
    return { column: t, line: i };
  }
  prev() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, i = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = this.source.input.css.slice(
        vt(this.source.input.css, this.source.start),
        vt(this.source.input.css, this.source.end)
      ).indexOf(e.word);
      r !== -1 && (t = this.positionInside(r), i = this.positionInside(
        r + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? i = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? i = this.positionInside(e.endIndex) : e.index && (i = this.positionInside(e.index + 1));
    return (i.line < t.line || i.line === t.line && i.column <= t.column) && (i = { column: t.column + 1, line: t.line }), { end: i, start: t };
  }
  raw(e, t) {
    return new yM().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, i = !1;
      for (let a of e)
        a === this ? i = !0 : i ? (this.parent.insertAfter(t, a), t = a) : this.parent.insertBefore(t, a);
      i || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let i = {}, a = t == null;
    t = t || /* @__PURE__ */ new Map();
    let r = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache")
        continue;
      let l = this[o];
      if (Array.isArray(l))
        i[o] = l.map((s) => typeof s == "object" && s.toJSON ? s.toJSON(null, t) : s);
      else if (typeof l == "object" && l.toJSON)
        i[o] = l.toJSON(null, t);
      else if (o === "source") {
        let s = t.get(l.input);
        s == null && (s = r, t.set(l.input, r), r++), i[o] = {
          end: l.end,
          inputId: s,
          start: l.start
        };
      } else
        i[o] = l;
    }
    return a && (i.inputs = [...t.keys()].map((o) => o.toJSON())), i;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = vM) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (i) => {
      t += i;
    }), t;
  }
  warn(e, t, i) {
    let a = { node: this };
    for (let r in i)
      a[r] = i[r];
    return e.warn(t, a);
  }
  get proxyOf() {
    return this;
  }
}
var _n = Ti;
Ti.default = Ti;
let kM = _n;
class ki extends kM {
  constructor(e) {
    super(e), this.type = "comment";
  }
}
var In = ki;
ki.default = ki;
let EM = _n;
class Ei extends EM {
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
}
var Rn = Ei;
Ei.default = Ei;
let Z6 = In, J6 = Rn, xM = _n, { isClean: Q6, my: X6 } = Nt, na, e$, t$, ia;
function n$(n) {
  return n.map((e) => (e.nodes && (e.nodes = n$(e.nodes)), delete e.source, e));
}
function i$(n) {
  if (n[Q6] = !1, n.proxyOf.nodes)
    for (let e of n.proxyOf.nodes)
      i$(e);
}
class $e extends xM {
  append(...e) {
    for (let t of e) {
      let i = this.normalize(t, this.last);
      for (let a of i)
        this.proxyOf.nodes.push(a);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes)
        t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes)
      return;
    let t = this.getIterator(), i, a;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (i = this.indexes[t], a = e(this.proxyOf.nodes[i], i), a !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], a;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...i) => e[t](
          ...i.map((a) => typeof a == "function" ? (r, o) => a(r.toProxy(), o) : a)
        ) : t === "every" || t === "some" ? (i) => e[t](
          (a, ...r) => i(a.toProxy(), ...r)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((i) => i.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let i = this.index(e), a = this.normalize(t, this.proxyOf.nodes[i]).reverse();
    i = this.index(e);
    for (let o of a)
      this.proxyOf.nodes.splice(i + 1, 0, o);
    let r;
    for (let o in this.indexes)
      r = this.indexes[o], i < r && (this.indexes[o] = r + a.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let i = this.index(e), a = i === 0 ? "prepend" : !1, r = this.normalize(
      t,
      this.proxyOf.nodes[i],
      a
    ).reverse();
    i = this.index(e);
    for (let l of r)
      this.proxyOf.nodes.splice(i, 0, l);
    let o;
    for (let l in this.indexes)
      o = this.indexes[l], i <= o && (this.indexes[l] = o + r.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = n$(e$(e).nodes);
    else if (typeof e > "u")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new J6(e)];
    } else if (e.selector || e.selectors)
      e = [new ia(e)];
    else if (e.name)
      e = [new na(e)];
    else if (e.text)
      e = [new Z6(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((a) => (a[X6] || $e.rebuild(a), a = a.proxyOf, a.parent && a.parent.removeChild(a), a[Q6] && i$(a), a.raws || (a.raws = {}), typeof a.raws.before > "u" && t && typeof t.raws.before < "u" && (a.raws.before = t.raws.before.replace(/\S/g, "")), a.parent = this.proxyOf, a));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let i = this.normalize(t, this.first, "prepend").reverse();
      for (let a of i)
        this.proxyOf.nodes.unshift(a);
      for (let a in this.indexes)
        this.indexes[a] = this.indexes[a] + i.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes)
      e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let i in this.indexes)
      t = this.indexes[i], t >= e && (this.indexes[i] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, i) {
    return i || (i = t, t = {}), this.walkDecls((a) => {
      t.props && !t.props.includes(a.prop) || t.fast && !a.value.includes(t.fast) || (a.value = a.value.replace(e, i));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, i) => {
      let a;
      try {
        a = e(t, i);
      } catch (r) {
        throw t.addToError(r);
      }
      return a !== !1 && t.walk && (a = t.walk(e)), a;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, a) => {
      if (i.type === "atrule" && e.test(i.name))
        return t(i, a);
    }) : this.walk((i, a) => {
      if (i.type === "atrule" && i.name === e)
        return t(i, a);
    }) : (t = e, this.walk((i, a) => {
      if (i.type === "atrule")
        return t(i, a);
    }));
  }
  walkComments(e) {
    return this.walk((t, i) => {
      if (t.type === "comment")
        return e(t, i);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, a) => {
      if (i.type === "decl" && e.test(i.prop))
        return t(i, a);
    }) : this.walk((i, a) => {
      if (i.type === "decl" && i.prop === e)
        return t(i, a);
    }) : (t = e, this.walk((i, a) => {
      if (i.type === "decl")
        return t(i, a);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, a) => {
      if (i.type === "rule" && e.test(i.selector))
        return t(i, a);
    }) : this.walk((i, a) => {
      if (i.type === "rule" && i.selector === e)
        return t(i, a);
    }) : (t = e, this.walk((i, a) => {
      if (i.type === "rule")
        return t(i, a);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
}
$e.registerParse = (n) => {
  e$ = n;
};
$e.registerRule = (n) => {
  ia = n;
};
$e.registerAtRule = (n) => {
  na = n;
};
$e.registerRoot = (n) => {
  t$ = n;
};
var it = $e;
$e.default = $e;
$e.rebuild = (n) => {
  n.type === "atrule" ? Object.setPrototypeOf(n, na.prototype) : n.type === "rule" ? Object.setPrototypeOf(n, ia.prototype) : n.type === "decl" ? Object.setPrototypeOf(n, J6.prototype) : n.type === "comment" ? Object.setPrototypeOf(n, Z6.prototype) : n.type === "root" && Object.setPrototypeOf(n, t$.prototype), n[X6] = !0, n.nodes && n.nodes.forEach((e) => {
    $e.rebuild(e);
  });
};
let a$ = it;
class Tn extends a$ {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
}
var aa = Tn;
Tn.default = Tn;
a$.registerAtRule(Tn);
let SM = it, r$, o$;
class Dt extends SM {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new r$(new o$(), this, e).stringify();
  }
}
Dt.registerLazyResult = (n) => {
  r$ = n;
};
Dt.registerProcessor = (n) => {
  o$ = n;
};
var ra = Dt;
Dt.default = Dt;
let CM = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", wM = (n, e = 21) => (t = e) => {
  let i = "", a = t;
  for (; a--; )
    i += n[Math.random() * n.length | 0];
  return i;
}, $M = (n = 21) => {
  let e = "", t = n;
  for (; t--; )
    e += CM[Math.random() * 64 | 0];
  return e;
};
const BM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  nanoid: $M,
  customAlphabet: wM
}), PM = /* @__PURE__ */ Mn(BM);
let { existsSync: MM, readFileSync: DM } = Be, { dirname: Gn, join: AM } = Be, { SourceMapConsumer: mr, SourceMapGenerator: pr } = Be;
function LM(n) {
  return $ ? $.from(n, "base64").toString() : window.atob(n);
}
class xi {
  constructor(e, t) {
    if (t.map === !1)
      return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let i = t.map ? t.map.prev : void 0, a = this.loadMap(t.from, i);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Gn(this.mapFile)), a && (this.text = a);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new mr(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, i = /^data:application\/json;base64,/, a = /^data:application\/json;charset=utf-?8,/, r = /^data:application\/json,/, o = e.match(a) || e.match(r);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let l = e.match(t) || e.match(i);
    if (l)
      return LM(e.substr(l[0].length));
    let s = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + s);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t)
      return;
    let i = e.lastIndexOf(t.pop()), a = e.indexOf("*/", i);
    i > -1 && a > -1 && (this.annotation = this.getAnnotationURL(e.substring(i, a)));
  }
  loadFile(e) {
    if (this.root = Gn(e), MM(e))
      return this.mapFile = e, DM(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1)
      return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let i = t(e);
        if (i) {
          let a = this.loadFile(i);
          if (!a)
            throw new Error(
              "Unable to load previous source map: " + i.toString()
            );
          return a;
        }
      } else {
        if (t instanceof mr)
          return pr.fromSourceMap(t).toString();
        if (t instanceof pr)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let i = this.annotation;
        return e && (i = AM(Gn(e), i)), this.loadFile(i);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
}
var s$ = xi;
xi.default = xi;
let { nanoid: OM } = PM, { isAbsolute: Si, resolve: Ci } = Be, { SourceMapConsumer: _M, SourceMapGenerator: IM } = Be, { fileURLToPath: br, pathToFileURL: qt } = Be, yr = ta, RM = s$, Wn = Be, Kn = Symbol("fromOffsetCache"), NM = !!(_M && IM), vr = !!(Ci && Si);
class kn {
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, t.from && (!vr || /^\w+:\/\//.test(t.from) || Si(t.from) ? this.file = t.from : this.file = Ci(t.from)), vr && NM) {
      let i = new RM(this.css, t);
      if (i.text) {
        this.map = i;
        let a = i.consumer().file;
        !this.file && a && (this.file = this.mapResolve(a));
      }
    }
    this.file || (this.id = "<input css " + OM(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, i, a = {}) {
    let r, o, l;
    if (t && typeof t == "object") {
      let u = t, c = i;
      if (typeof u.offset == "number") {
        let f = this.fromOffset(u.offset);
        t = f.line, i = f.col;
      } else
        t = u.line, i = u.column;
      if (typeof c.offset == "number") {
        let f = this.fromOffset(c.offset);
        o = f.line, r = f.col;
      } else
        o = c.line, r = c.column;
    } else if (!i) {
      let u = this.fromOffset(t);
      t = u.line, i = u.col;
    }
    let s = this.origin(t, i, o, r);
    return s ? l = new yr(
      e,
      s.endLine === void 0 ? s.line : { column: s.column, line: s.line },
      s.endLine === void 0 ? s.column : { column: s.endColumn, line: s.endLine },
      s.source,
      s.file,
      a.plugin
    ) : l = new yr(
      e,
      o === void 0 ? t : { column: i, line: t },
      o === void 0 ? i : { column: r, line: o },
      this.css,
      this.file,
      a.plugin
    ), l.input = { column: i, endColumn: r, endLine: o, line: t, source: this.css }, this.file && (qt && (l.input.url = qt(this.file).toString()), l.input.file = this.file), l;
  }
  fromOffset(e) {
    let t, i;
    if (this[Kn])
      i = this[Kn];
    else {
      let r = this.css.split(`
`);
      i = new Array(r.length);
      let o = 0;
      for (let l = 0, s = r.length; l < s; l++)
        i[l] = o, o += r[l].length + 1;
      this[Kn] = i;
    }
    t = i[i.length - 1];
    let a = 0;
    if (e >= t)
      a = i.length - 1;
    else {
      let r = i.length - 2, o;
      for (; a < r; )
        if (o = a + (r - a >> 1), e < i[o])
          r = o - 1;
        else if (e >= i[o + 1])
          a = o + 1;
        else {
          a = o;
          break;
        }
    }
    return {
      col: e - i[a] + 1,
      line: a + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : Ci(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, i, a) {
    if (!this.map)
      return !1;
    let r = this.map.consumer(), o = r.originalPositionFor({ column: t, line: e });
    if (!o.source)
      return !1;
    let l;
    typeof i == "number" && (l = r.originalPositionFor({ column: a, line: i }));
    let s;
    Si(o.source) ? s = qt(o.source) : s = new URL(
      o.source,
      this.map.consumer().sourceRoot || qt(this.map.mapFile)
    );
    let u = {
      column: o.column,
      endColumn: l && l.column,
      endLine: l && l.line,
      line: o.line,
      url: s.toString()
    };
    if (s.protocol === "file:")
      if (br)
        u.file = br(s);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = r.sourceContentFor(o.source);
    return c && (u.source = c), u;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
  get from() {
    return this.file || this.id;
  }
}
var Nn = kn;
kn.default = kn;
Wn && Wn.registerInput && Wn.registerInput(kn);
let l$ = it, u$, c$;
class gt extends l$ {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, i) {
    let a = super.normalize(e);
    if (t) {
      if (i === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let r of a)
          r.raws.before = t.raws.before;
    }
    return a;
  }
  removeChild(e, t) {
    let i = this.index(e);
    return !t && i === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[i].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new u$(new c$(), this, e).stringify();
  }
}
gt.registerLazyResult = (n) => {
  u$ = n;
};
gt.registerProcessor = (n) => {
  c$ = n;
};
var Ft = gt;
gt.default = gt;
l$.registerRoot(gt);
let At = {
  comma(n) {
    return At.split(n, [","], !0);
  },
  space(n) {
    let e = [" ", `
`, "	"];
    return At.split(n, e);
  },
  split(n, e, t) {
    let i = [], a = "", r = !1, o = 0, l = !1, s = "", u = !1;
    for (let c of n)
      u ? u = !1 : c === "\\" ? u = !0 : l ? c === s && (l = !1) : c === '"' || c === "'" ? (l = !0, s = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (r = !0), r ? (a !== "" && i.push(a.trim()), a = "", r = !1) : a += c;
    return (t || a !== "") && i.push(a.trim()), i;
  }
};
var d$ = At;
At.default = At;
let f$ = it, FM = d$;
class En extends f$ {
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return FM.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, i = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(i);
  }
}
var oa = En;
En.default = En;
f$.registerRule(En);
let UM = aa, zM = In, HM = Rn, jM = Nn, qM = s$, YM = Ft, VM = oa;
function Lt(n, e) {
  if (Array.isArray(n))
    return n.map((a) => Lt(a));
  let { inputs: t, ...i } = n;
  if (t) {
    e = [];
    for (let a of t) {
      let r = { ...a, __proto__: jM.prototype };
      r.map && (r.map = {
        ...r.map,
        __proto__: qM.prototype
      }), e.push(r);
    }
  }
  if (i.nodes && (i.nodes = n.nodes.map((a) => Lt(a, e))), i.source) {
    let { inputId: a, ...r } = i.source;
    i.source = r, a != null && (i.source.input = e[a]);
  }
  if (i.type === "root")
    return new YM(i);
  if (i.type === "decl")
    return new HM(i);
  if (i.type === "rule")
    return new VM(i);
  if (i.type === "comment")
    return new zM(i);
  if (i.type === "atrule")
    return new UM(i);
  throw new Error("Unknown node type: " + n.type);
}
var GM = Lt;
Lt.default = Lt;
let { dirname: Xt, relative: g$, resolve: h$, sep: m$ } = Be, { SourceMapConsumer: p$, SourceMapGenerator: en } = Be, { pathToFileURL: Tr } = Be, WM = Nn, KM = !!(p$ && en), ZM = !!(Xt && h$ && g$ && m$);
class JM {
  constructor(e, t, i, a) {
    this.stringify = e, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), i = e.root || Xt(e.file), a;
      this.mapOpts.sourcesContent === !1 ? (a = new p$(e.text), a.sourcesContent && (a.sourcesContent = null)) : a = e.consumer(), this.map.applySourceMap(a, t, this.toUrl(this.path(i)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else
        this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), ZM && KM && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = en.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new en({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new en({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, i = "<no source>", a = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, r, o;
    this.stringify(this.root, (l, s, u) => {
      if (this.css += l, s && u !== "end" && (a.generated.line = e, a.generated.column = t - 1, s.source && s.source.start ? (a.source = this.sourcePath(s), a.original.line = s.source.start.line, a.original.column = s.source.start.column - 1, this.map.addMapping(a)) : (a.source = i, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), o = l.match(/\n/g), o ? (e += o.length, r = l.lastIndexOf(`
`), t = l.length - r) : t += l.length, s && u !== "start") {
        let c = s.parent || { raws: {} };
        (!(s.type === "decl" || s.type === "atrule" && !s.nodes) || s !== c.last || c.raws.semicolon) && (s.source && s.source.end ? (a.source = this.sourcePath(s), a.original.line = s.source.end.line, a.original.column = s.source.end.column - 1, a.generated.line = e, a.generated.column = t - 2, this.map.addMapping(a)) : (a.source = i, a.original.line = 1, a.original.column = 0, a.generated.line = e, a.generated.column = t - 1, this.map.addMapping(a)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e))
      return e;
    let t = this.memoizedPaths.get(e);
    if (t)
      return t;
    let i = this.opts.to ? Xt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (i = Xt(h$(i, this.mapOpts.annotation)));
    let a = g$(i, e);
    return this.memoizedPaths.set(e, a), a;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new WM(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let i = t.source.input.from;
          if (i && !e[i]) {
            e[i] = !0;
            let a = this.usesFileUrls ? this.toFileUrl(i) : this.toUrl(this.path(i));
            this.map.setSourceContent(a, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return $ ? $.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t)
      return t;
    if (Tr) {
      let i = Tr(e).toString();
      return this.memoizedFileURLs.set(e, i), i;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t)
      return t;
    m$ === "\\" && (e = e.replace(/\\/g, "/"));
    let i = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, i), i;
  }
}
var b$ = JM;
const Zn = "'".charCodeAt(0), kr = '"'.charCodeAt(0), Yt = "\\".charCodeAt(0), Er = "/".charCodeAt(0), Vt = `
`.charCodeAt(0), Tt = " ".charCodeAt(0), Gt = "\f".charCodeAt(0), Wt = "	".charCodeAt(0), Kt = "\r".charCodeAt(0), QM = "[".charCodeAt(0), XM = "]".charCodeAt(0), eD = "(".charCodeAt(0), tD = ")".charCodeAt(0), nD = "{".charCodeAt(0), iD = "}".charCodeAt(0), aD = ";".charCodeAt(0), rD = "*".charCodeAt(0), oD = ":".charCodeAt(0), sD = "@".charCodeAt(0), Zt = /[\t\n\f\r "#'()/;[\\\]{}]/g, Jt = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, lD = /.[\r\n"'(/\\]/, xr = /[\da-f]/i;
var uD = function(e, t = {}) {
  let i = e.css.valueOf(), a = t.ignoreErrors, r, o, l, s, u, c, f, d, g, b, p = i.length, h = 0, E = [], B = [];
  function _() {
    return h;
  }
  function D(W) {
    throw e.error("Unclosed " + W, h);
  }
  function I() {
    return B.length === 0 && h >= p;
  }
  function F(W) {
    if (B.length)
      return B.pop();
    if (h >= p)
      return;
    let q = W ? W.ignoreUnclosed : !1;
    switch (r = i.charCodeAt(h), r) {
      case Vt:
      case Tt:
      case Wt:
      case Kt:
      case Gt: {
        s = h;
        do
          s += 1, r = i.charCodeAt(s);
        while (r === Tt || r === Vt || r === Wt || r === Kt || r === Gt);
        c = ["space", i.slice(h, s)], h = s - 1;
        break;
      }
      case QM:
      case XM:
      case nD:
      case iD:
      case oD:
      case aD:
      case tD: {
        let U = String.fromCharCode(r);
        c = [U, U, h];
        break;
      }
      case eD: {
        if (b = E.length ? E.pop()[1] : "", g = i.charCodeAt(h + 1), b === "url" && g !== Zn && g !== kr && g !== Tt && g !== Vt && g !== Wt && g !== Gt && g !== Kt) {
          s = h;
          do {
            if (f = !1, s = i.indexOf(")", s + 1), s === -1)
              if (a || q) {
                s = h;
                break;
              } else
                D("bracket");
            for (d = s; i.charCodeAt(d - 1) === Yt; )
              d -= 1, f = !f;
          } while (f);
          c = ["brackets", i.slice(h, s + 1), h, s], h = s;
        } else
          s = i.indexOf(")", h + 1), o = i.slice(h, s + 1), s === -1 || lD.test(o) ? c = ["(", "(", h] : (c = ["brackets", o, h, s], h = s);
        break;
      }
      case Zn:
      case kr: {
        u = r === Zn ? "'" : '"', s = h;
        do {
          if (f = !1, s = i.indexOf(u, s + 1), s === -1)
            if (a || q) {
              s = h + 1;
              break;
            } else
              D("string");
          for (d = s; i.charCodeAt(d - 1) === Yt; )
            d -= 1, f = !f;
        } while (f);
        c = ["string", i.slice(h, s + 1), h, s], h = s;
        break;
      }
      case sD: {
        Zt.lastIndex = h + 1, Zt.test(i), Zt.lastIndex === 0 ? s = i.length - 1 : s = Zt.lastIndex - 2, c = ["at-word", i.slice(h, s + 1), h, s], h = s;
        break;
      }
      case Yt: {
        for (s = h, l = !0; i.charCodeAt(s + 1) === Yt; )
          s += 1, l = !l;
        if (r = i.charCodeAt(s + 1), l && r !== Er && r !== Tt && r !== Vt && r !== Wt && r !== Kt && r !== Gt && (s += 1, xr.test(i.charAt(s)))) {
          for (; xr.test(i.charAt(s + 1)); )
            s += 1;
          i.charCodeAt(s + 1) === Tt && (s += 1);
        }
        c = ["word", i.slice(h, s + 1), h, s], h = s;
        break;
      }
      default: {
        r === Er && i.charCodeAt(h + 1) === rD ? (s = i.indexOf("*/", h + 2) + 1, s === 0 && (a || q ? s = i.length : D("comment")), c = ["comment", i.slice(h, s + 1), h, s], h = s) : (Jt.lastIndex = h + 1, Jt.test(i), Jt.lastIndex === 0 ? s = i.length - 1 : s = Jt.lastIndex - 2, c = ["word", i.slice(h, s + 1), h, s], E.push(c), h = s);
        break;
      }
    }
    return h++, c;
  }
  function j(W) {
    B.push(W);
  }
  return {
    back: j,
    endOfFile: I,
    nextToken: F,
    position: _
  };
};
let cD = aa, dD = In, fD = Rn, gD = Ft, Sr = oa, hD = uD;
const Cr = {
  empty: !0,
  space: !0
};
function mD(n) {
  for (let e = n.length - 1; e >= 0; e--) {
    let t = n[e], i = t[3] || t[2];
    if (i)
      return i;
  }
}
class pD {
  constructor(e) {
    this.input = e, this.root = new gD(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new cD();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let i, a, r, o = !1, l = !1, s = [], u = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), i = e[0], i === "(" || i === "[" ? u.push(i === "(" ? ")" : "]") : i === "{" && u.length > 0 ? u.push("}") : i === u[u.length - 1] && u.pop(), u.length === 0)
        if (i === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (i === "{") {
          l = !0;
          break;
        } else if (i === "}") {
          if (s.length > 0) {
            for (r = s.length - 1, a = s[r]; a && a[0] === "space"; )
              a = s[--r];
            a && (t.source.end = this.getPosition(a[3] || a[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          s.push(e);
      else
        s.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(s), s.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(s), this.raw(t, "params", s), o && (e = s[s.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), l && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1)
      return;
    let i = 0, a;
    for (let r = t - 1; r >= 0 && (a = e[r], !(a[0] !== "space" && (i += 1, i === 2))); r--)
      ;
    throw this.input.error(
      "Missed semicolon",
      a[0] === "word" ? a[3] + 1 : a[2]
    );
  }
  colon(e) {
    let t = 0, i, a, r;
    for (let [o, l] of e.entries()) {
      if (a = l, r = a[0], r === "(" && (t += 1), r === ")" && (t -= 1), t === 0 && r === ":")
        if (!i)
          this.doubleColon(a);
        else {
          if (i[0] === "word" && i[1] === "progid")
            continue;
          return o;
        }
      i = a;
    }
    return !1;
  }
  comment(e) {
    let t = new dD();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let i = e[1].slice(2, -2);
    if (/^\s*$/.test(i))
      t.text = "", t.raws.left = i, t.raws.right = "";
    else {
      let a = i.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = a[2], t.raws.left = a[1], t.raws.right = a[3];
    }
  }
  createTokenizer() {
    this.tokenizer = hD(this.input);
  }
  decl(e, t) {
    let i = new fD();
    this.init(i, e[0][2]);
    let a = e[e.length - 1];
    for (a[0] === ";" && (this.semicolon = !0, e.pop()), i.source.end = this.getPosition(
      a[3] || a[2] || mD(e)
    ), i.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), i.raws.before += e.shift()[1];
    for (i.source.start = this.getPosition(e[0][2]), i.prop = ""; e.length; ) {
      let u = e[0][0];
      if (u === ":" || u === "space" || u === "comment")
        break;
      i.prop += e.shift()[1];
    }
    i.raws.between = "";
    let r;
    for (; e.length; )
      if (r = e.shift(), r[0] === ":") {
        i.raws.between += r[1];
        break;
      } else
        r[0] === "word" && /\w/.test(r[1]) && this.unknownWord([r]), i.raws.between += r[1];
    (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
    let o = [], l;
    for (; e.length && (l = e[0][0], !(l !== "space" && l !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let u = e.length - 1; u >= 0; u--) {
      if (r = e[u], r[1].toLowerCase() === "!important") {
        i.important = !0;
        let c = this.stringFrom(e, u);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (i.raws.important = c);
        break;
      } else if (r[1].toLowerCase() === "important") {
        let c = e.slice(0), f = "";
        for (let d = u; d > 0; d--) {
          let g = c[d][0];
          if (f.trim().startsWith("!") && g !== "space")
            break;
          f = c.pop()[1] + f;
        }
        f.trim().startsWith("!") && (i.important = !0, i.raws.important = f, e = c);
      }
      if (r[0] !== "space" && r[0] !== "comment")
        break;
    }
    e.some((u) => u[0] !== "space" && u[0] !== "comment") && (i.raws.between += o.map((u) => u[1]).join(""), o = []), this.raw(i, "value", o.concat(e), t), i.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new Sr();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, i = null, a = !1, r = null, o = [], l = e[1].startsWith("--"), s = [], u = e;
    for (; u; ) {
      if (i = u[0], s.push(u), i === "(" || i === "[")
        r || (r = u), o.push(i === "(" ? ")" : "]");
      else if (l && a && i === "{")
        r || (r = u), o.push("}");
      else if (o.length === 0)
        if (i === ";")
          if (a) {
            this.decl(s, l);
            return;
          } else
            break;
        else if (i === "{") {
          this.rule(s);
          return;
        } else if (i === "}") {
          this.tokenizer.back(s.pop()), t = !0;
          break;
        } else
          i === ":" && (a = !0);
      else
        i === o[o.length - 1] && (o.pop(), o.length === 0 && (r = null));
      u = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(r), t && a) {
      if (!l)
        for (; s.length && (u = s[s.length - 1][0], !(u !== "space" && u !== "comment")); )
          this.tokenizer.back(s.pop());
      this.decl(s, l);
    } else
      this.unknownWord(s);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, i, a) {
    let r, o, l = i.length, s = "", u = !0, c, f;
    for (let d = 0; d < l; d += 1)
      r = i[d], o = r[0], o === "space" && d === l - 1 && !a ? u = !1 : o === "comment" ? (f = i[d - 1] ? i[d - 1][0] : "empty", c = i[d + 1] ? i[d + 1][0] : "empty", !Cr[f] && !Cr[c] ? s.slice(-1) === "," ? u = !1 : s += r[1] : u = !1) : s += r[1];
    if (!u) {
      let d = i.reduce((g, b) => g + b[1], "");
      e.raws[t] = { raw: d, value: s };
    }
    e[t] = s;
  }
  rule(e) {
    e.pop();
    let t = new Sr();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      i = e.pop()[1] + i;
    return i;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, i = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      i += e.shift()[1];
    return i;
  }
  spacesFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      i = e.pop()[1] + i;
    return i;
  }
  stringFrom(e, t) {
    let i = "";
    for (let a = t; a < e.length; a++)
      i += e[a][1];
    return e.splice(t, e.length - t), i;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word",
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
}
var bD = pD;
let yD = it, vD = Nn, TD = bD;
function xn(n, e) {
  let t = new vD(n, e), i = new TD(t);
  try {
    i.parse();
  } catch (a) {
    throw a;
  }
  return i.root;
}
var sa = xn;
xn.default = xn;
yD.registerParse(xn);
class wi {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (let i in t)
      this[i] = t[i];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
}
var y$ = wi;
wi.default = wi;
let kD = y$;
class $i {
  constructor(e, t, i) {
    this.processor = e, this.messages = [], this.root = t, this.opts = i, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let i = new kD(e, t);
    return this.messages.push(i), i;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
  get content() {
    return this.css;
  }
}
var la = $i;
$i.default = $i;
let ED = it, xD = ra, SD = b$, CD = sa, wr = la, wD = Ft, $D = On, { isClean: Me, my: BD } = Nt;
const PD = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, MD = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, DD = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, ht = 0;
function kt(n) {
  return typeof n == "object" && typeof n.then == "function";
}
function v$(n) {
  let e = !1, t = PD[n.type];
  return n.type === "decl" ? e = n.prop.toLowerCase() : n.type === "atrule" && (e = n.name.toLowerCase()), e && n.append ? [
    t,
    t + "-" + e,
    ht,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : n.append ? [t, ht, t + "Exit"] : [t, t + "Exit"];
}
function $r(n) {
  let e;
  return n.type === "document" ? e = ["Document", ht, "DocumentExit"] : n.type === "root" ? e = ["Root", ht, "RootExit"] : e = v$(n), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: n,
    visitorIndex: 0,
    visitors: []
  };
}
function Bi(n) {
  return n[Me] = !1, n.nodes && n.nodes.forEach((e) => Bi(e)), n;
}
let Pi = {};
class Xe {
  constructor(e, t, i) {
    this.stringified = !1, this.processed = !1;
    let a;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      a = Bi(t);
    else if (t instanceof Xe || t instanceof wr)
      a = Bi(t.root), t.map && (typeof i.map > "u" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      let r = CD;
      i.syntax && (r = i.syntax.parse), i.parser && (r = i.parser), r.parse && (r = r.parse);
      try {
        a = r(t, i);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      a && !a[BD] && ED.rebuild(a);
    }
    this.result = new wr(e, a, i), this.helpers = { ...Pi, postcss: Pi, result: this.result }, this.plugins = this.processor.plugins.map((r) => typeof r == "object" && r.prepare ? { ...r, ...r.prepare(this.result) } : r);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let i = this.result.lastPlugin;
    try {
      t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin && (e.plugin = i.postcssPlugin, e.setMessage());
    } catch (a) {
      console && console.error && console.error(a);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, i, a) => {
      this.listeners[i] || (this.listeners[i] = []), this.listeners[i].push([t, a]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let i in t) {
          if (!MD[i] && /^[A-Z]/.test(i))
            throw new Error(
              `Unknown event ${i} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!DD[i])
            if (typeof t[i] == "object")
              for (let a in t[i])
                a === "*" ? e(t, i, t[i][a]) : e(
                  t,
                  i + "-" + a.toLowerCase(),
                  t[i][a]
                );
            else
              typeof t[i] == "function" && e(t, i, t[i]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let t = this.plugins[e], i = this.runOnRoot(t);
      if (kt(i))
        try {
          await i;
        } catch (a) {
          throw this.handleError(a);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Me]; ) {
        e[Me] = !0;
        let t = [$r(e)];
        for (; t.length > 0; ) {
          let i = this.visitTick(t);
          if (kt(i))
            try {
              await i;
            } catch (a) {
              let r = t[t.length - 1].node;
              throw this.handleError(a, r);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [t, i] of this.listeners.OnceExit) {
          this.result.lastPlugin = t;
          try {
            if (e.type === "document") {
              let a = e.nodes.map(
                (r) => i(r, this.helpers)
              );
              await Promise.all(a);
            } else
              await i(e, this.helpers);
          } catch (a) {
            throw this.handleError(a);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (i) => e.Once(i, this.helpers)
          );
          return kt(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = $D;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let a = new SD(t, this.result.root, this.result.opts).generate();
    return this.result.css = a[0], this.result.map = a[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (kt(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Me]; )
        e[Me] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [i, a] of e) {
      this.result.lastPlugin = i;
      let r;
      try {
        r = a(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (kt(r))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: i, visitors: a } = t;
    if (i.type !== "root" && i.type !== "document" && !i.parent) {
      e.pop();
      return;
    }
    if (a.length > 0 && t.visitorIndex < a.length) {
      let [o, l] = a[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === a.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return l(i.toProxy(), this.helpers);
      } catch (s) {
        throw this.handleError(s, i);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, l;
      for (; l = i.nodes[i.indexes[o]]; )
        if (i.indexes[o] += 1, !l[Me]) {
          l[Me] = !0, e.push($r(l));
          return;
        }
      t.iterator = 0, delete i.indexes[o];
    }
    let r = t.events;
    for (; t.eventIndex < r.length; ) {
      let o = r[t.eventIndex];
      if (t.eventIndex += 1, o === ht) {
        i.nodes && i.nodes.length && (i[Me] = !0, t.iterator = i.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Me] = !0;
    let t = v$(e);
    for (let i of t)
      if (i === ht)
        e.nodes && e.each((a) => {
          a[Me] || this.walkSync(a);
        });
      else {
        let a = this.listeners[i];
        if (a && this.visitSync(a, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
}
Xe.registerPostcss = (n) => {
  Pi = n;
};
var T$ = Xe;
Xe.default = Xe;
wD.registerLazyResult(Xe);
xD.registerLazyResult(Xe);
let AD = b$, LD = sa;
const OD = la;
let _D = On;
class Mi {
  constructor(e, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = i, this._map = void 0;
    let a, r = _D;
    this.result = new OD(this._processor, a, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let l = new AD(r, a, this._opts, t);
    if (l.isMap()) {
      let [s, u] = l.generate();
      s && (this.result.css = s), u && (this.result.map = u);
    } else
      l.clearAnnotation(), this.result.css = l.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = LD;
    try {
      e = t(this._css, this._opts);
    } catch (i) {
      this.error = i;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
}
var ID = Mi;
Mi.default = Mi;
let RD = ra, ND = T$, FD = ID, UD = Ft;
class Ot {
  constructor(e = []) {
    this.version = "8.4.49", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let i of e)
      if (i.postcss === !0 ? i = i() : i.postcss && (i = i.postcss), typeof i == "object" && Array.isArray(i.plugins))
        t = t.concat(i.plugins);
      else if (typeof i == "object" && i.postcssPlugin)
        t.push(i);
      else if (typeof i == "function")
        t.push(i);
      else if (!(typeof i == "object" && (i.parse || i.stringify)))
        throw new Error(i + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new FD(this, e, t) : new ND(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
}
var zD = Ot;
Ot.default = Ot;
UD.registerProcessor(Ot);
RD.registerProcessor(Ot);
let k$ = aa, E$ = In, HD = it, jD = ta, x$ = Rn, S$ = ra, qD = GM, YD = Nn, VD = T$, GD = d$, WD = _n, KD = sa, ua = zD, ZD = la, C$ = Ft, w$ = oa, JD = On, QD = y$;
function Q(...n) {
  return n.length === 1 && Array.isArray(n[0]) && (n = n[0]), new ua(n);
}
Q.plugin = function(e, t) {
  let i = !1;
  function a(...o) {
    console && console.warn && !i && (i = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), dr.env.LANG && dr.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let l = t(...o);
    return l.postcssPlugin = e, l.postcssVersion = new ua().version, l;
  }
  let r;
  return Object.defineProperty(a, "postcss", {
    get() {
      return r || (r = a()), r;
    }
  }), a.process = function(o, l, s) {
    return Q([a(s)]).process(o, l);
  }, a;
};
Q.stringify = JD;
Q.parse = KD;
Q.fromJSON = qD;
Q.list = GD;
Q.comment = (n) => new E$(n);
Q.atRule = (n) => new k$(n);
Q.decl = (n) => new x$(n);
Q.rule = (n) => new w$(n);
Q.root = (n) => new C$(n);
Q.document = (n) => new S$(n);
Q.CssSyntaxError = jD;
Q.Declaration = x$;
Q.Container = HD;
Q.Processor = ua;
Q.Document = S$;
Q.Comment = E$;
Q.Warning = QD;
Q.AtRule = k$;
Q.Result = ZD;
Q.Input = YD;
Q.Rule = w$;
Q.Root = C$;
Q.Node = WD;
VD.registerPostcss(Q);
var XD = Q;
Q.default = Q;
const eA = WP, Br = KP, { isPlainObject: tA } = QP, Pr = fM, nA = G6.exports, { parse: iA } = XD, aA = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], rA = ["script", "style"];
function xt(n, e) {
  n && Object.keys(n).forEach(function(t) {
    e(n[t], t);
  });
}
function je(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function Mr(n, e) {
  const t = [];
  return xt(n, function(i) {
    e(i) && t.push(i);
  }), t;
}
function oA(n) {
  for (const e in n)
    if (je(n, e))
      return !1;
  return !0;
}
function sA(n) {
  return n.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
var lA = _t;
const uA = /^[^\0\t\n\f\r /<=>]+$/;
function _t(n, e, t) {
  if (n == null)
    return "";
  typeof n == "number" && (n = n.toString());
  let i = "", a = "";
  function r(m, T) {
    const y = this;
    this.tag = m, this.attribs = T || {}, this.tagPosition = i.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (h.length) {
        const w = h[h.length - 1];
        w.text += y.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      h.length && aA.includes(this.tag) && h[h.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, _t.defaults, e), e.parser = Object.assign({}, cA, e.parser);
  const o = function(m) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf(m) > -1;
  };
  rA.forEach(function(m) {
    o(m) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${m}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const l = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let s, u;
  e.allowedAttributes && (s = {}, u = {}, xt(e.allowedAttributes, function(m, T) {
    s[T] = [];
    const y = [];
    m.forEach(function(w) {
      typeof w == "string" && w.indexOf("*") >= 0 ? y.push(Br(w).replace(/\\\*/g, ".*")) : s[T].push(w);
    }), y.length && (u[T] = new RegExp("^(" + y.join("|") + ")$"));
  }));
  const c = {}, f = {}, d = {};
  xt(e.allowedClasses, function(m, T) {
    if (s && (je(s, T) || (s[T] = []), s[T].push("class")), c[T] = m, Array.isArray(m)) {
      const y = [];
      c[T] = [], d[T] = [], m.forEach(function(w) {
        typeof w == "string" && w.indexOf("*") >= 0 ? y.push(Br(w).replace(/\\\*/g, ".*")) : w instanceof RegExp ? d[T].push(w) : c[T].push(w);
      }), y.length && (f[T] = new RegExp("^(" + y.join("|") + ")$"));
    }
  });
  const g = {};
  let b;
  xt(e.transformTags, function(m, T) {
    let y;
    typeof m == "function" ? y = m : typeof m == "string" && (y = _t.simpleTransform(m)), T === "*" ? b = y : g[T] = y;
  });
  let p, h, E, B, _, D, I = !1;
  j();
  const F = new eA.Parser({
    onopentag: function(m, T) {
      if (e.enforceHtmlBoundary && m === "html" && j(), _) {
        D++;
        return;
      }
      const y = new r(m, T);
      h.push(y);
      let w = !1;
      const A = !!y.text;
      let R;
      if (je(g, m) && (R = g[m](m, T), y.attribs = T = R.attribs, R.text !== void 0 && (y.innerText = R.text), m !== R.tagName && (y.name = m = R.tagName, B[p] = R.tagName)), b && (R = b(m, T), y.attribs = T = R.attribs, m !== R.tagName && (y.name = m = R.tagName, B[p] = R.tagName)), (!o(m) || e.disallowedTagsMode === "recursiveEscape" && !oA(E) || e.nestingLimit != null && p >= e.nestingLimit) && (w = !0, E[p] = !0, (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && l.indexOf(m) !== -1 && (_ = !0, D = 1), E[p] = !0), p++, w) {
        if (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard")
          return;
        a = i, i = "";
      }
      i += "<" + m, m === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (y.innerText = ""), (!s || je(s, m) || s["*"]) && xt(T, function(H, z) {
        if (!uA.test(z)) {
          delete y.attribs[z];
          return;
        }
        if (H === "" && !e.allowedEmptyAttributes.includes(z) && (e.nonBooleanAttributes.includes(z) || e.nonBooleanAttributes.includes("*"))) {
          delete y.attribs[z];
          return;
        }
        let ie = !1;
        if (!s || je(s, m) && s[m].indexOf(z) !== -1 || s["*"] && s["*"].indexOf(z) !== -1 || je(u, m) && u[m].test(z) || u["*"] && u["*"].test(z))
          ie = !0;
        else if (s && s[m]) {
          for (const G of s[m])
            if (tA(G) && G.name && G.name === z) {
              ie = !0;
              let V = "";
              if (G.multiple === !0) {
                const be = H.split(" ");
                for (const fe of be)
                  G.values.indexOf(fe) !== -1 && (V === "" ? V = fe : V += " " + fe);
              } else
                G.values.indexOf(H) >= 0 && (V = H);
              H = V;
            }
        }
        if (ie) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(z) !== -1 && q(m, H)) {
            delete y.attribs[z];
            return;
          }
          if (m === "script" && z === "src") {
            let G = !0;
            try {
              const V = U(H);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const be = (e.allowedScriptHostnames || []).find(function(re) {
                  return re === V.url.hostname;
                }), fe = (e.allowedScriptDomains || []).find(function(re) {
                  return V.url.hostname === re || V.url.hostname.endsWith(`.${re}`);
                });
                G = be || fe;
              }
            } catch {
              G = !1;
            }
            if (!G) {
              delete y.attribs[z];
              return;
            }
          }
          if (m === "iframe" && z === "src") {
            let G = !0;
            try {
              const V = U(H);
              if (V.isRelativeUrl)
                G = je(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const be = (e.allowedIframeHostnames || []).find(function(re) {
                  return re === V.url.hostname;
                }), fe = (e.allowedIframeDomains || []).find(function(re) {
                  return V.url.hostname === re || V.url.hostname.endsWith(`.${re}`);
                });
                G = be || fe;
              }
            } catch {
              G = !1;
            }
            if (!G) {
              delete y.attribs[z];
              return;
            }
          }
          if (z === "srcset")
            try {
              let G = nA(H);
              if (G.forEach(function(V) {
                q("srcset", V.url) && (V.evil = !0);
              }), G = Mr(G, function(V) {
                return !V.evil;
              }), G.length)
                H = sA(Mr(G, function(V) {
                  return !V.evil;
                })), y.attribs[z] = H;
              else {
                delete y.attribs[z];
                return;
              }
            } catch {
              delete y.attribs[z];
              return;
            }
          if (z === "class") {
            const G = c[m], V = c["*"], be = f[m], fe = d[m], re = f["*"], le = [
              be,
              re
            ].concat(fe).filter(function(Pe) {
              return Pe;
            });
            if (G && V ? H = x(H, Pr(G, V), le) : H = x(H, G || V, le), !H.length) {
              delete y.attribs[z];
              return;
            }
          }
          if (z === "style") {
            if (e.parseStyleAttributes)
              try {
                const G = iA(m + " {" + H + "}", { map: !1 }), V = v(G, e.allowedStyles);
                if (H = P(V), H.length === 0) {
                  delete y.attribs[z];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + m + " {" + H + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete y.attribs[z];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          i += " " + z, H && H.length ? i += '="' + W(H, !0) + '"' : e.allowedEmptyAttributes.includes(z) && (i += '=""');
        } else
          delete y.attribs[z];
      }), e.selfClosing.indexOf(m) !== -1 ? i += " />" : (i += ">", y.innerText && !A && !e.textFilter && (i += W(y.innerText), I = !0)), w && (i = a + W(i), a = "");
    },
    ontext: function(m) {
      if (_)
        return;
      const T = h[h.length - 1];
      let y;
      if (T && (y = T.tag, m = T.innerText !== void 0 ? T.innerText : m), e.disallowedTagsMode === "completelyDiscard" && !o(y))
        m = "";
      else if ((e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && (y === "script" || y === "style"))
        i += m;
      else {
        const w = W(m, !1);
        e.textFilter && !I ? i += e.textFilter(w, y) : I || (i += w);
      }
      if (h.length) {
        const w = h[h.length - 1];
        w.text += m;
      }
    },
    onclosetag: function(m, T) {
      if (_)
        if (D--, !D)
          _ = !1;
        else
          return;
      const y = h.pop();
      if (!y)
        return;
      if (y.tag !== m) {
        h.push(y);
        return;
      }
      _ = e.enforceHtmlBoundary ? m === "html" : !1, p--;
      const w = E[p];
      if (w) {
        if (delete E[p], e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          y.updateParentNodeText();
          return;
        }
        a = i, i = "";
      }
      if (B[p] && (m = B[p], delete B[p]), e.exclusiveFilter && e.exclusiveFilter(y)) {
        i = i.substr(0, y.tagPosition);
        return;
      }
      if (y.updateParentNodeMediaChildren(), y.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf(m) !== -1 || // Escaped tag, closing tag is implied
      T && !o(m) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        w && (i = a, a = "");
        return;
      }
      i += "</" + m + ">", w && (i = a + W(i), a = ""), I = !1;
    }
  }, e.parser);
  return F.write(n), F.end(), i;
  function j() {
    i = "", p = 0, h = [], E = {}, B = {}, _ = !1, D = 0;
  }
  function W(m, T) {
    return typeof m != "string" && (m = m + ""), e.parser.decodeEntities && (m = m.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), T && (m = m.replace(/"/g, "&quot;"))), m = m.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), T && (m = m.replace(/"/g, "&quot;")), m;
  }
  function q(m, T) {
    for (T = T.replace(/[\x00-\x20]+/g, ""); ; ) {
      const A = T.indexOf("<!--");
      if (A === -1)
        break;
      const R = T.indexOf("-->", A + 4);
      if (R === -1)
        break;
      T = T.substring(0, A) + T.substring(R + 3);
    }
    const y = T.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!y)
      return T.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : !1;
    const w = y[1].toLowerCase();
    return je(e.allowedSchemesByTag, m) ? e.allowedSchemesByTag[m].indexOf(w) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(w) === -1;
  }
  function U(m) {
    if (m = m.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), m.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let T = "relative://relative-site";
    for (let A = 0; A < 100; A++)
      T += `/${A}`;
    const y = new URL(m, T);
    return {
      isRelativeUrl: y && y.hostname === "relative-site" && y.protocol === "relative:",
      url: y
    };
  }
  function v(m, T) {
    if (!T)
      return m;
    const y = m.nodes[0];
    let w;
    return T[y.selector] && T["*"] ? w = Pr(
      T[y.selector],
      T["*"]
    ) : w = T[y.selector] || T["*"], w && (m.nodes[0].nodes = y.nodes.reduce(S(w), [])), m;
  }
  function P(m) {
    return m.nodes[0].nodes.reduce(function(T, y) {
      return T.push(
        `${y.prop}:${y.value}${y.important ? " !important" : ""}`
      ), T;
    }, []).join(";");
  }
  function S(m) {
    return function(T, y) {
      return je(m, y.prop) && m[y.prop].some(function(A) {
        return A.test(y.value);
      }) && T.push(y), T;
    };
  }
  function x(m, T, y) {
    return T ? (m = m.split(/\s+/), m.filter(function(w) {
      return T.indexOf(w) !== -1 || y.some(function(A) {
        return A.test(w);
      });
    }).join(" ")) : m;
  }
}
const cA = {
  decodeEntities: !0
};
_t.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
_t.simpleTransform = function(n, e, t) {
  return t = t === void 0 ? !0 : t, e = e || {}, function(i, a) {
    let r;
    if (t)
      for (r in e)
        a[r] = e[r];
    else
      a = e;
    return {
      tagName: n,
      attribs: a
    };
  };
};
const dA = lA;
var $$ = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i();
  })(ne, function() {
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(r, o, l) {
      var s = o.prototype;
      l.utc = function(p) {
        var h = { date: p, utc: !0, args: arguments };
        return new o(h);
      }, s.utc = function(p) {
        var h = l(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? h.add(this.utcOffset(), t) : h;
      }, s.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = s.parse;
      s.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), u.call(this, p);
      };
      var c = s.init;
      s.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else
          c.call(this);
      };
      var f = s.utcOffset;
      s.utcOffset = function(p, h) {
        var E = this.$utils().u;
        if (E(p))
          return this.$u ? 0 : E(this.$offset) ? f.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(I) {
          I === void 0 && (I = "");
          var F = I.match(i);
          if (!F)
            return null;
          var j = ("" + F[0]).match(a) || ["-", 0, 0], W = j[0], q = 60 * +j[1] + +j[2];
          return q === 0 ? 0 : W === "+" ? q : -q;
        }(p), p === null))
          return this;
        var B = Math.abs(p) <= 16 ? 60 * p : p, _ = this;
        if (h)
          return _.$offset = B, _.$u = p === 0, _;
        if (p !== 0) {
          var D = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (_ = this.local().add(B + D, t)).$offset = B, _.$x.$localOffset = D;
        } else
          _ = this.utc();
        return _;
      };
      var d = s.format;
      s.format = function(p) {
        var h = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, h);
      }, s.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, s.isUTC = function() {
        return !!this.$u;
      }, s.toISOString = function() {
        return this.toDate().toISOString();
      }, s.toString = function() {
        return this.toDate().toUTCString();
      };
      var g = s.toDate;
      s.toDate = function(p) {
        return p === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
      };
      var b = s.diff;
      s.diff = function(p, h, E) {
        if (p && this.$u === p.$u)
          return b.call(this, p, h, E);
        var B = this.local(), _ = l(p).local();
        return b.call(B, _, h, E);
      };
    };
  });
})($$);
const fA = $$.exports;
var B$ = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i();
  })(ne, function() {
    var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, i = {};
    return function(a, r, o) {
      var l, s = function(d, g, b) {
        b === void 0 && (b = {});
        var p = new Date(d), h = function(E, B) {
          B === void 0 && (B = {});
          var _ = B.timeZoneName || "short", D = E + "|" + _, I = i[D];
          return I || (I = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: E, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: _ }), i[D] = I), I;
        }(g, b);
        return h.formatToParts(p);
      }, u = function(d, g) {
        for (var b = s(d, g), p = [], h = 0; h < b.length; h += 1) {
          var E = b[h], B = E.type, _ = E.value, D = t[B];
          D >= 0 && (p[D] = parseInt(_, 10));
        }
        var I = p[3], F = I === 24 ? 0 : I, j = p[0] + "-" + p[1] + "-" + p[2] + " " + F + ":" + p[4] + ":" + p[5] + ":000", W = +d;
        return (o.utc(j).valueOf() - (W -= W % 1e3)) / 6e4;
      }, c = r.prototype;
      c.tz = function(d, g) {
        d === void 0 && (d = l);
        var b = this.utcOffset(), p = this.toDate(), h = p.toLocaleString("en-US", { timeZone: d }), E = Math.round((p - new Date(h)) / 1e3 / 60), B = o(h).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(p.getTimezoneOffset() / 15) - E, !0);
        if (g) {
          var _ = B.utcOffset();
          B = B.add(b - _, "minute");
        }
        return B.$x.$timezone = d, B;
      }, c.offsetName = function(d) {
        var g = this.$x.$timezone || o.tz.guess(), b = s(this.valueOf(), g, { timeZoneName: d }).find(function(p) {
          return p.type.toLowerCase() === "timezonename";
        });
        return b && b.value;
      };
      var f = c.startOf;
      c.startOf = function(d, g) {
        if (!this.$x || !this.$x.$timezone)
          return f.call(this, d, g);
        var b = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return f.call(b, d, g).tz(this.$x.$timezone, !0);
      }, o.tz = function(d, g, b) {
        var p = b && g, h = b || g || l, E = u(+o(), h);
        if (typeof d != "string")
          return o(d).tz(h);
        var B = function(F, j, W) {
          var q = F - 60 * j * 1e3, U = u(q, W);
          if (j === U)
            return [q, j];
          var v = u(q -= 60 * (U - j) * 1e3, W);
          return U === v ? [q, U] : [F - 60 * Math.min(U, v) * 1e3, Math.max(U, v)];
        }(o.utc(d, p).valueOf(), E, h), _ = B[0], D = B[1], I = o(_).utcOffset(D);
        return I.$x.$timezone = h, I;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(d) {
        l = d;
      };
    };
  });
})(B$);
const gA = B$.exports;
var hA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
      return "" + o + (o === 1 ? "er" : "");
    } };
    return a.default.locale(r, null, !0), r;
  });
})(hA);
var mA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(o) {
      return o + "º";
    } };
    return a.default.locale(r, null, !0), r;
  });
})(mA);
var pA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(s) {
      return s && typeof s == "object" && "default" in s ? s : { default: s };
    }
    var a = i(t), r = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
    function o(s, u, c) {
      var f = r[c];
      return Array.isArray(f) && (f = f[u ? 0 : 1]), f.replace("%d", s);
    }
    var l = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(s) {
      return s + ".";
    }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: o, m: o, mm: o, h: o, hh: o, d: o, dd: o, M: o, MM: o, y: o, yy: o } };
    return a.default.locale(l, null, !0), l;
  });
})(pA);
var bA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "nl", weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"), weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"), weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"), months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), ordinal: function(o) {
      return "[" + o + (o === 1 || o === 8 || o >= 20 ? "ste" : "de") + "]";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD-MM-YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "over %s", past: "%s geleden", s: "een paar seconden", m: "een minuut", mm: "%d minuten", h: "een uur", hh: "%d uur", d: "een dag", dd: "%d dagen", M: "een maand", MM: "%d maanden", y: "een jaar", yy: "%d jaar" } };
    return a.default.locale(r, null, !0), r;
  });
})(bA);
var yA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "sv", weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"), weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"), weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"), months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"), weekStart: 1, yearStart: 4, ordinal: function(o) {
      var l = o % 10;
      return "[" + o + (l === 1 || l === 2 ? "a" : "e") + "]";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY-MM-DD", LL: "D MMMM YYYY", LLL: "D MMMM YYYY [kl.] HH:mm", LLLL: "dddd D MMMM YYYY [kl.] HH:mm", lll: "D MMM YYYY HH:mm", llll: "ddd D MMM YYYY HH:mm" }, relativeTime: { future: "om %s", past: "för %s sedan", s: "några sekunder", m: "en minut", mm: "%d minuter", h: "en timme", hh: "%d timmar", d: "en dag", dd: "%d dagar", M: "en månad", MM: "%d månader", y: "ett år", yy: "%d år" } };
    return a.default.locale(r, null, !0), r;
  });
})(yA);
var vA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(o) {
      return o + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(o) {
      return o < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return a.default.locale(r, null, !0), r;
  });
})(vA);
var TA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "zh-cn", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(o, l) {
      return l === "W" ? o + "周" : o + "日";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日Ah点mm分", LLLL: "YYYY年M月D日ddddAh点mm分", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s内", past: "%s前", s: "几秒", m: "1 分钟", mm: "%d 分钟", h: "1 小时", hh: "%d 小时", d: "1 天", dd: "%d 天", M: "1 个月", MM: "%d 个月", y: "1 年", yy: "%d 年" }, meridiem: function(o, l) {
      var s = 100 * o + l;
      return s < 600 ? "凌晨" : s < 900 ? "早上" : s < 1100 ? "上午" : s < 1300 ? "中午" : s < 1800 ? "下午" : "晚上";
    } };
    return a.default.locale(r, null, !0), r;
  });
})(TA);
var kA = { exports: {} };
(function(n, e) {
  (function(t, i) {
    n.exports = i(Fe.exports);
  })(ne, function(t) {
    function i(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = i(t), r = { name: "ko", weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"), weekdaysShort: "일_월_화_수_목_금_토".split("_"), weekdaysMin: "일_월_화_수_목_금_토".split("_"), months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), ordinal: function(o) {
      return o;
    }, formats: { LT: "A h:mm", LTS: "A h:mm:ss", L: "YYYY.MM.DD.", LL: "YYYY년 MMMM D일", LLL: "YYYY년 MMMM D일 A h:mm", LLLL: "YYYY년 MMMM D일 dddd A h:mm", l: "YYYY.MM.DD.", ll: "YYYY년 MMMM D일", lll: "YYYY년 MMMM D일 A h:mm", llll: "YYYY년 MMMM D일 dddd A h:mm" }, meridiem: function(o) {
      return o < 12 ? "오전" : "오후";
    }, relativeTime: { future: "%s 후", past: "%s 전", s: "몇 초", m: "1분", mm: "%d분", h: "한 시간", hh: "%d시간", d: "하루", dd: "%d일", M: "한 달", MM: "%d달", y: "일 년", yy: "%d년" } };
    return a.default.locale(r, null, !0), r;
  });
})(kA);
ve.extend(fA);
ve.extend(gA);
const EA = {
  textFilter: function(n) {
    return n.replace(/&amp;/g, "&");
  }
};
function jA(n) {
  return ve().tz(n).format("Z");
}
function qA(n) {
  return dA(n, EA);
}
function YA(...n) {
  if (window && window.localStorage && window.localStorage.getItem("debug")) {
    console.groupCollapsed(...n);
    const e = new Error();
    e.name = "Debug", console.debug(e.stack), console.groupEnd();
  }
}
function VA(...n) {
  console.error(...n);
}
function GA() {
  return Math.random().toString(36).substr(2, 9);
}
function WA(n) {
  return n.toString().replace(/^on/, "");
}
function KA(n) {
  return new Date(n.getFullYear(), n.getMonth() + 1, 0);
}
function ZA(n) {
  return new Date(n.getFullYear(), n.getMonth(), 1);
}
function JA(n, e) {
  return n.getFullYear() === e.getFullYear() && n.getMonth() === e.getMonth() && n.getDate() === e.getDate();
}
function QA(n, e, t) {
  const i = ve(n).tz(t), a = ve(e);
  return i.year() === a.year() && i.month() === a.month() && i.date() === a.date();
}
function XA(n, e, t = "en-US") {
  return ve(n).tz(e).locale(t).format("dddd, MMMM D, YYYY");
}
function e5(n, e) {
  return n.getFullYear() === e.getFullYear() && n.getMonth() === e.getMonth();
}
const t5 = (n) => n === "" ? !0 : /^(0[0-9]|1[0-2]|^[0-9])(:[0-5][0-9][ap]m?|:[0-5][0-9]|:[0-5]|:)?$/i.test(n), n5 = (n) => /^(0[1-9]|1[0-2]):([0-5][0-9])(am|pm)$/i.test(n);
function i5(n = null) {
  let e = ve();
  n && (e = n);
  const t = e.minute() % 15;
  let i;
  return t !== 0 ? i = e.add(15 - t, "minute") : i = e, i;
}
function a5(n) {
  const e = ve();
  let t = "";
  const [i, a] = n.split(":");
  i.length === 1 ? t += "0" + i : i.length === 2 && (t += i), t += ":", a === void 0 || a == "" ? t += "00" : a.length === 1 ? t += a + "0" : t += a;
  const r = t.slice(-1);
  return r === "a" && (t += "m"), r === "p" && (t += "m"), t.slice(-1) !== "m" && (t.split(":")[0] == "00" ? t += "am" : t += e.format("a")), t;
}
function r5(n) {
  const [e, t] = n.split(":").map((l) => parseInt(l, 10));
  let i = e;
  const a = i >= 12 ? "pm" : "am";
  i = i % 12, i = i || 12;
  const r = i.toString().padStart(2, "0"), o = t.toString().padStart(2, "0");
  return `${r}:${o}${a}`;
}
function o5(n) {
  const [e, t] = n.split(/(am|pm)/i), [i, a] = e.split(":").map((o) => parseInt(o, 10));
  let r = i;
  return t.toLowerCase() === "pm" && r < 12 ? r += 12 : t.toLowerCase() === "am" && r === 12 && (r = 0), `${r.toString().padStart(2, "0")}:${a.toString().padStart(2, "0")}`;
}
function s5(n) {
  const [e, t] = n.match(/(\d+):(\d+)(am|pm)/).slice(1);
  let i = parseInt(e, 10) * 60 + parseInt(t, 10);
  return n.includes("pm") && parseInt(e, 10) < 12 && (i += 12 * 60), n.includes("am") && parseInt(e, 10) === 12 && (i -= 12 * 60), i;
}
function l5(n) {
  const e = Math.floor(n / 60), t = n % 60;
  return `${e}:${t < 10 ? "0" : ""}${t}`;
}
function u5() {
  const n = navigator.userAgent, e = /Chrome/.test(n) && /Google Inc/.test(navigator.vendor), t = /Safari/.test(n) && /Apple Computer/.test(navigator.vendor), i = /Firefox/.test(n), a = /Trident/.test(n), r = /Edge/.test(n);
  return e && /Edg/.test(n) ? "Edge (Chromium)" : e ? "Chrome" : t ? "Safari" : i ? "Firefox" : a ? "Internet Explorer" : r ? "Edge (Legacy)" : "Unknown";
}
function Dr(n, e = null) {
  return e ? [null, e] : [n, null];
}
function c5(n, e) {
  const t = {
    "config.id": e == null ? void 0 : e.id,
    id: e == null ? void 0 : e.id,
    slug: e == null ? void 0 : e.slug
  };
  return Object.keys(t).forEach((i) => {
    t[i] && (n = n.replace(`{${i}}`, t[i]));
  }), n;
}
function d5(n) {
  if (n.keyCode < 48 || n.keyCode > 90 && n.keyCode < 96 || n.keyCode > 111 && n.keyCode < 186 || n.keyCode > 222 || n.keyCode === 32 || n.keyCode === 91 || n.keyCode === 92 || n.keyCode === 93 || n.keyCode >= 112 && n.keyCode <= 123 || n.keyCode >= 37 && n.keyCode <= 40 || n.ctrlKey || n.altKey || n.metaKey)
    return !0;
  const e = [
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    219,
    220,
    221,
    222
  ];
  return n.shiftKey && e.includes(n.keyCode), !1;
}
function f5(n, e) {
  const t = new Date(n);
  return t.setDate(t.getDate() + e), t.setHours(23), t.setMinutes(59), t.setSeconds(0), t.setMilliseconds(0), t;
}
function Jn(n) {
  return n && typeof n == "object" && !Array.isArray(n);
}
function Ar(n, e) {
  if (Array.isArray(n) && Array.isArray(e) && n !== e) {
    if (n.some((t) => t.is_organizer) && e.some((t) => t.is_organizer))
      n = n.map((t) => ({ ...t, is_organizer: !1 }));
    else if (!e.some((t) => t.is_organizer)) {
      let t = !1;
      n = n.map((i) => t ? i : (t = !0, { ...i, is_organizer: !0 }));
    }
    return n.map((t, i) => e[i] ? Ar(t, e[i]) : t).concat(e.slice(n.length));
  } else if (Jn(n) && Jn(e)) {
    const t = Object.assign({}, n);
    return Object.keys(e).forEach((i) => {
      Jn(e[i]) && i in n ? t[i] = Ar(n[i], e[i]) : t[i] = e[i];
    }), t;
  }
  return e;
}
function g5(n) {
  if (n < 60)
    return `${n} ${tn("time.minutes")}`;
  const e = Math.floor(n / 60), t = n % 60, i = tn(`time.${e > 1 ? "hours" : "hour"}`), a = t ? `${t} ${tn(`time.${t > 1 ? "minutes" : "minute"}`)}` : "";
  return `${e} ${i} ${a}`;
}
function h5(n, e) {
  n.forEach((t) => {
    var r;
    const i = (r = e.shadowRoot) == null ? void 0 : r.querySelector(`slot[name="${t}"]`), a = i == null ? void 0 : i.assignedNodes();
    a && a.length === 0 && console.warn(`${e.nodeName} No content provided for slot="${t}".`);
  });
}
function m5(n) {
  const e = $.from(n, "base64"), t = e.slice(0, 16), i = e.slice(16, 32), a = e.slice(32);
  function r(u) {
    const c = u.toString("hex");
    return `${c.slice(0, 8)}-${c.slice(8, 12)}-${c.slice(12, 16)}-${c.slice(16, 20)}-${c.slice(20)}`;
  }
  const o = r(t), l = r(i), s = a.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  return [o, l, s];
}
const tn = (n) => qi.t(n), p5 = (n) => typeof n != "string" ? "" : n.charAt(0).toUpperCase() + n.slice(1), b5 = (n) => tn(`months.${n}`), y5 = (n) => {
  try {
    return new URL(n), !0;
  } catch {
    return !1;
  }
}, v5 = (n) => new Promise((e, t) => {
  if (n === "")
    return e(!0);
  const i = new Image();
  i.src = n, i.onerror = () => {
    t(!1);
  }, i.onload = () => {
    e(!0);
  };
});
function T5(n, e, t, i, a = "UTC") {
  var f, d, g;
  const r = {
    0: L.SU,
    1: L.MO,
    2: L.TU,
    3: L.WE,
    4: L.TH,
    5: L.FR,
    6: L.SA
  }, o = ve.tz(n, a).toDate(), l = r[o.getDay()], s = o.getDate(), u = Math.ceil(s / 7), c = t ? ve.tz(t, a).toDate() : void 0;
  switch (e) {
    case "none":
      return null;
    case "daily":
      return new L({
        freq: L.DAILY,
        until: c
      }).toString();
    case "weekly":
      return new L({
        freq: L.WEEKLY,
        byweekday: l,
        until: c
      }).toString();
    case "monthly":
      return new L({
        freq: L.MONTHLY,
        byweekday: [l.nth(u)],
        until: c
      }).toString();
    case "yearly":
      return new L({
        freq: L.YEARLY,
        dtstart: o,
        until: c
      }).toString();
    case "custom": {
      if (!i)
        throw new Error("Custom options must be provided for custom recurrence.");
      const b = i.frequency === "weekly" ? (f = i.daysOfWeek) == null ? void 0 : f.map((h) => L[h]) : i.frequency === "monthly" && !i.monthlySameDate ? [l.nth(u)] : void 0, p = i.frequency === "monthly" && i.monthlySameDate ? ve.tz(n, a).date() : void 0;
      return new L({
        freq: {
          daily: L.DAILY,
          weekly: L.WEEKLY,
          monthly: L.MONTHLY,
          yearly: L.YEARLY
        }[i.frequency || "daily"],
        interval: i.interval || 1,
        byweekday: b,
        bymonthday: p,
        until: ((d = i.end) == null ? void 0 : d.type) === "on" ? ve.tz(i.end.date, a).toDate() : void 0,
        count: ((g = i.end) == null ? void 0 : g.type) === "after" ? i.end.count : void 0
      }).toString();
    }
    default:
      throw new Error(`Invalid option: ${e}`);
  }
}
function k5(n, e) {
  const t = ve(n).startOf("day");
  let i, a;
  switch (e) {
    case "week": {
      i = t.startOf("week"), a = t.endOf("week");
      break;
    }
    case "month": {
      i = t.startOf("month").startOf("week"), a = t.endOf("month").endOf("week");
      break;
    }
    case "day": {
      i = t.startOf("day"), a = t.endOf("day");
      break;
    }
    default:
      throw new Error('Invalid viewType. Use "week", "month", or "day".');
  }
  return {
    startTime: i.unix(),
    endTime: a.unix()
  };
}
class E5 {
  constructor(e) {
    this.defaultAuthArgs = [], this.session = e;
  }
  setActiveGrantId(e) {
    this.activeGrantId = e;
  }
  async request({ method: e, path: t, body: i, headers: a }) {
    try {
      const r = await this.session.fetch(`grants/me/${t}`, {
        method: e,
        headers: a ? new Headers(a) : void 0,
        body: i,
        ...this.session.isMultiAccount() && this.activeGrantId ? { grant_id: this.activeGrantId } : {}
      });
      if (typeof r > "u")
        throw new Error("Response is undefined");
      return Dr(r);
    } catch (r) {
      let o = String(r);
      return String(r).includes("Access token not found") && (o = "Session expired, please log in again. Redirecting...", setTimeout(() => {
        localStorage.removeItem("grant"), localStorage.removeItem("user"), window.location.reload();
      }, 1e3)), Dr(null, {
        message: o
      });
    }
  }
  async currentUser() {
    const e = this.session.isMultiAccount() ? this.activeGrantId : void 0, t = await this.session.getProfile(e);
    if (await this.session.isLoggedIn()) {
      const a = (await this.session.fetch("grants/me", {
        method: "GET",
        ...this.session.isMultiAccount() && this.activeGrantId ? { grant_id: this.activeGrantId } : {}
      })).data;
      if (!t || !a)
        return null;
      const r = a.email;
      return {
        id: t.sub,
        email: r,
        name: t.name,
        provider: t.provider
      };
    }
    return null;
  }
  async authenticationUrl(e) {
    const t = (e == null ? void 0 : e.provider) || "google";
    let a = this.defaultAuthArgs.find((r) => r.provider === t) || {};
    return e && (a = { ...a, ...e }), this.session.auth(a);
  }
  setDefaultAuthArgs(e) {
    this.defaultAuthArgs = e;
  }
}
PB({});
async function xA() {
}
const SA = xA, CA = (n, e) => {
  if (!(typeof window > "u"))
    return SA(), fB(JSON.parse('[["nylas-scheduler-editor",[[1,"nylas-scheduler-editor",{"configurationId":[1025,"configuration-id"],"nylasApiRequest":[1040],"nylasSessionsConfig":[16],"defaultAuthArgs":[16],"eventOverrides":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"defaultSchedulerConfigState":[16],"mode":[1],"additionalParticipants":[16],"hideEditorTabs":[16],"conferenceProviders":[16],"requiresSlug":[4,"requires-slug"],"enableUserFeedback":[4,"enable-user-feedback"],"defaultLanguage":[1,"default-language"],"localization":[16],"nylasBranding":[4,"nylas-branding"],"experimentalFeatures":[16],"enableEventTypes":[16],"automaticComponentRegistration":[32],"selectedLanguage":[32],"langVersion":[32],"store":[64],"schedulerConnector":[64]},[[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"],[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"configurationId":["configurationIdChanged"],"localization":["updateLocalization"],"nylasBranding":["updateNylasBranding"],"experimentalFeatures":["updateExperimentalFeatures"],"enableEventTypes":["updateEnableEventTypes"]}]]],["nylas-scheduling",[[1,"nylas-scheduling",{"mode":[1],"defaultSchedulerState":[16],"sessionId":[1,"session-id"],"schedulerApiUrl":[1,"scheduler-api-url"],"bookingInfo":[16],"rescheduleBookingRef":[1,"reschedule-booking-ref"],"cancelBookingRef":[1,"cancel-booking-ref"],"organizerConfirmationBookingRef":[1,"organizer-confirmation-booking-ref"],"configurationId":[1,"configuration-id"],"slug":[1],"clientId":[1,"client-id"],"nylasBranding":[4,"nylas-branding"],"eventOverrides":[16],"isLoading":[4,"is-loading"],"themeConfig":[16],"localization":[16],"showNotification":[4,"show-notification"],"enableUserFeedback":[4,"enable-user-feedback"],"hour12":[4,"hour-1-2"],"automaticComponentRegistration":[32],"selectedDateLabel":[32],"refConfigId":[32],"language":[32],"showFeedbackModal":[32],"bookingInfoConfirmed":[32],"getNylasSchedulerStore":[64],"getNylasSchedulerConnector":[64],"getRef":[64]},[[0,"languageChanged","languageChanged"],[0,"registerComponent","registerComponentHandler"],[0,"unregisterComponent","unregisterComponentHandler"],[0,"monthChanged","monthChangedHandler"],[0,"detailsConfirmed","bookButtonClickedHandler"],[0,"dateSelected","dateSelectedHandler"],[0,"cancelBookedEventError","cancelBookedEventErrorHandler"],[0,"cancelBookedEventValidationError","cancelBookedEventValidationErrorHandler"],[0,"rescheduleBookedEventError","rescheduleBookedEventErrorHandler"],[0,"confirmBookingError","confirmBookingErrorHandler"],[0,"feedbackModalClosed","feedbackModalClosedHandler"],[0,"validateTimeslotError","eventIsFullHandler"],[0,"feedbackSubmitted","feedbackSubmittedHandler"]],{"bookingInfo":["bookingInfoChanged"],"rescheduleBookingRef":["rescheduleBookingRefChanged"],"cancelBookingRef":["cancelBookingRefChanged"],"organizerConfirmationBookingRef":["organizerConfirmationBookingRefChanged"],"localization":["localizationChanged"],"themeConfig":["themeConfigChanged"]}]]],["archive-icon",[[2,"archive-icon",{"width":[1],"height":[1]}]]],["arrow-icon",[[2,"arrow-icon",{"width":[1],"height":[1]}]]],["bold-icon",[[2,"bold-icon",{"width":[1],"height":[1]}]]],["document-refresh-icon",[[2,"document-refresh-icon",{"width":[1],"height":[1]}]]],["folder-icon",[[2,"folder-icon",{"width":[1],"height":[1]}]]],["forward-icon",[[2,"forward-icon",{"width":[1],"height":[1]}]]],["inbox-icon",[[2,"inbox-icon",{"width":[1],"height":[1]}]]],["italic-icon",[[2,"italic-icon",{"width":[1],"height":[1]}]]],["play-icon",[[2,"play-icon",{"width":[1],"height":[1]}]]],["refresh-icon",[[2,"refresh-icon",{"width":[1],"height":[1]}]]],["reply-all-icon",[[2,"reply-all-icon",{"width":[1],"height":[1]}]]],["reply-icon",[[2,"reply-icon",{"width":[1],"height":[1]}]]],["sent-icon",[[2,"sent-icon",{"width":[1],"height":[1]}]]],["spam-icon",[[2,"spam-icon",{"width":[1],"height":[1]}]]],["star-icon",[[2,"star-icon",{"width":[1],"height":[1]}]]],["stop-icon",[[2,"stop-icon",{"width":[1],"height":[1]}]]],["trash-fill-icon",[[2,"trash-fill-icon",{"width":[1],"height":[1]}]]],["underline-icon",[[2,"underline-icon",{"width":[1],"height":[1]}]]],["delete-icon",[[2,"delete-icon",{"width":[1],"height":[1]}]]],["person-icon",[[2,"person-icon",{"width":[1],"height":[1]}]]],["warning-icon",[[2,"warning-icon",{"width":[1],"height":[1]}]]],["calendar-cancel-icon",[[2,"calendar-cancel-icon",{"width":[1],"height":[1]}]]],["calendar-icon",[[2,"calendar-icon",{"width":[1],"height":[1]}]]],["calendar-check-icon_2",[[2,"checkmark-circle-icon",{"width":[1],"height":[1]}],[2,"calendar-check-icon",{"width":[1],"height":[1]}]]],["radio-button-group",[[1,"radio-button-group",{"name":[1],"options":[16],"defaultSelectedValue":[1,"default-selected-value"],"label":[1],"required":[4],"readOnly":[4,"read-only"],"selectedValue":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]],{"defaultSelectedValue":["handleDefaultSelectedValueChange"]}]]],["checkbox-component",[[1,"checkbox-component",{"name":[1],"checked":[4],"label":[1],"readOnly":[4,"read-only"],"required":[4],"isChecked":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"]],{"checked":["checkedPropChangedHandler"]}]]],["toggle-switch",[[1,"toggle-switch",{"name":[1],"checked":[4],"label":[1],"isChecked":[32]},null,{"checked":["checkedChanged"]}]]],["translate-icon",[[2,"translate-icon",{"width":[1],"height":[1]}]]],["textarea-component",[[1,"textarea-component",{"name":[1],"defaultValue":[1,"default-value"],"label":[1],"placeholder":[1],"required":[4],"readOnly":[4,"read-only"],"autoFocus":[4,"auto-focus"],"maxLength":[2,"max-length"],"type":[1],"tooltip":[1],"value":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"],[4,"triggerValidation","handletriggerValidation"]]]]],["nylas-form-card",[[65,"nylas-form-card"]]],["multi-select-dropdown_2",[[1,"multi-select-dropdown",{"name":[1],"label":[1],"options":[16],"error":[1025],"required":[4],"readOnly":[4,"read-only"],"multipleOptionsSelectedLabel":[1,"multiple-options-selected-label"],"selectAtLeastOneOptionLabel":[1,"select-at-least-one-option-label"],"availableOptions":[32],"isOpen":[32],"ariaActivedescendant":[32],"shouldFocusFirstOption":[32]},[[6,"click","handleOutsideClick"],[4,"bookingFormSubmitted","handleBookingFormSubmitted"]],{"options":["optionsChangedHandler"]}],[1,"nylas-date-component",{"name":[1],"defaultValue":[1,"default-value"],"label":[1],"placeholder":[1],"required":[4],"readOnly":[4,"read-only"],"autoFocus":[4,"auto-focus"],"pattern":[16],"maxLength":[2,"max-length"],"patternError":[1,"pattern-error"],"requiredError":[1,"required-error"],"minDate":[1,"min-date"],"hasError":[4,"has-error"],"value":[32],"error":[32],"isDateValid":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"],[4,"formSubmitted","handleFormSubmitted"]],{"defaultValue":["handleDefaultValueChange"]}]]],["input-component",[[1,"input-component",{"name":[1],"defaultValue":[1,"default-value"],"label":[1],"type":[1],"placeholder":[1],"required":[4],"readOnly":[4,"read-only"],"autoFocus":[4,"auto-focus"],"pattern":[16],"maxLength":[2,"max-length"],"patternError":[1,"pattern-error"],"requiredError":[1,"required-error"],"maxValue":[2,"max-value"],"minValue":[2,"min-value"],"value":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"],[4,"formSubmitted","handleFormSubmitted"]],{"defaultValue":["handleDefaultValueChange"]}]]],["globe-icon_2",[[1,"nylas-time-window-picker",{"time":[1],"minimumStartTime":[1,"minimum-start-time"],"placeholder":[1],"name":[1],"hasError":[516,"has-error"],"language":[1],"err":[32],"showTimes":[32],"ariaActivedescendant":[32],"times":[32],"shouldAutoScroll":[32]},[[6,"click","handleOutsideClick"]],{"minimumStartTime":["minimumStartTimeChangedHandler"]}],[2,"globe-icon",{"width":[1],"height":[1]}]]],["input-dropdown_2",[[2,"time-period-selector",{"timePeriods":[16],"defaultSelectedPeriod":[1,"default-selected-period"],"defaultSelectedNumber":[2,"default-selected-number"],"hasError":[4,"has-error"],"selectedPeriod":[32],"selectedNumber":[32],"numberOptions":[32],"timePeriodOptions":[32]},[[0,"inputOptionChanged","inputOptionChangedHandler"],[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"defaultSelectedPeriod":["defaultSelectedPeriodChanged"],"defaultSelectedNumber":["defaultSelectedNumberChanged"],"timePeriods":["timePeriodsChanged"]}],[1,"input-dropdown",{"name":[1],"options":[16],"defaultInputOption":[16],"inputValue":[1,"input-value"],"pluralizedLabel":[1,"pluralized-label"],"filterable":[4],"selectedOption":[32],"isOpen":[32],"typedValue":[32],"filteredOptions":[32],"ariaActivedescendant":[32],"shouldAutoScroll":[32]},[[6,"click","handleOutsideClick"]],{"options":["optionsChangedHandler"],"defaultInputOption":["defaultSelectedOptionChangedHandler"],"inputValue":["inputValueChangedHandler"]}]]],["google-meet-icon_5",[[2,"google-meet-icon",{"width":[1],"height":[1]}],[2,"location-icon",{"width":[1],"height":[1]}],[2,"location-off-icon",{"width":[1],"height":[1]}],[2,"microsoft-teams-icon",{"width":[1],"height":[1]}],[2,"zoom-icon",{"width":[1],"height":[1]}]]],["add-circle-icon_2",[[2,"add-circle-icon",{"width":[1],"height":[1]}],[2,"close-icon",{"width":[1],"height":[1]}]]],["button-component_2",[[6,"button-component",{"variant":[1],"disabled":[4],"type":[1],"tooltip":[1],"isLoading":[4,"is-loading"],"clickHandler":[16],"mouseOverHandler":[16],"mouseOutHandler":[16],"focusHandler":[16],"blurHandler":[16]}],[1,"loading-icon",{"width":[1],"height":[1]}]]],["info-icon_2",[[1,"tooltip-component",{"position":[1]}],[2,"info-icon",{"width":[1],"height":[1]}]]],["chevron-icon_3",[[1,"select-dropdown",{"name":[1],"options":[16],"defaultSelectedOption":[16],"withSearch":[4,"with-search"],"searchPlaceholder":[1,"search-placeholder"],"label":[1],"required":[4],"readOnly":[4,"read-only"],"pluralizedLabel":[1,"pluralized-label"],"dropdownButtonText":[1,"dropdown-button-text"],"withChevron":[4,"with-chevron"],"emptyValue":[1,"empty-value"],"errorMessage":[1,"error-message"],"selectedOption":[32],"isOpen":[32],"searchValue":[32],"filteredOptions":[32],"ariaActivedescendant":[32],"error":[32]},[[4,"bookingFormSubmitted","handleBookingFormSubmitted"],[4,"formSubmitted","handleFormSubmitted"],[6,"click","handleOutsideClick"]],{"options":["optionsChangedHandler"],"defaultSelectedOption":["defaultSelectedOptionChangedHandler"]}],[2,"search-icon",{"width":[1],"height":[1]}],[2,"chevron-icon",{"width":[1],"height":[1]}]]],["checkmark-icon_15",[[65,"nylas-event-location",{"name":[1],"currentUser":[16],"userProvider":[1,"user-provider"],"eventConferencing":[16],"conferenceProviders":[16],"selectedConfiguration":[16],"eventLocation":[1,"event-location"],"selectedLanguage":[1,"selected-language"],"location":[32],"grantId":[32],"selectedLocationOption":[32],"userProviderState":[32],"locationOptions":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"currentUser":["currentUserChangedHandler"],"conferenceProviders":["conferenceProvidersChanged"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-additional-participants",{"name":[1],"selectedConfiguration":[16],"currentUser":[16],"currentUserCalendars":[16],"participantOptions":[16],"eventParticipants":[16],"roundRobinConfig":[4,"round-robin-config"],"selectedLanguage":[1,"selected-language"],"participants":[32],"participantErrors":[32],"includeOrganizerAsParticipant":[32],"isRoundRobinConfig":[32],"error":[32]},[[0,"inputOptionChanged","onInputOptionChanged"]],{"name":["elementNameChangedHandler"],"currentUser":["selectedConfigurationAndCurrentUserChangedHandler"],"selectedConfiguration":["selectedConfigurationAndCurrentUserChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[1,"nylas-feedback-form",{"themeConfig":[8,"theme-config"],"feedbackMessage":[32]},[[4,"nylasFormInputChanged","handleFormInputChanged"]]],[65,"nylas-reminder-time",{"name":[1],"eventReminderTimeMinutes":[2,"event-reminder-time-minutes"],"selectedLanguage":[1,"selected-language"],"selectedNumber":[32],"selectedPeriod":[32],"errorState":[32]},[[4,"nylasSuggestReminderMinutes","nylasSuggestReminderMinutesHandler"],[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"eventReminderTimeMinutes":["eventReminderTimeMinutesChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-event-description",{"selectedConfiguration":[16],"eventDescription":[1,"event-description"],"name":[1],"selectedLanguage":[1,"selected-language"],"hideAutoPopulateButton":[4,"hide-auto-populate-button"],"noTemplates":[4,"no-templates"],"description":[32],"showTokens":[32],"availableTokens":[32],"filteredTokens":[32],"ariaActivedescendant":[32],"currentWord":[32],"validationError":[32],"additionalFieldTokens":[32]},[[4,"valueChanged","valueChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-event-title",{"selectedConfiguration":[16],"eventTitle":[1,"event-title"],"name":[1],"selectedLanguage":[1,"selected-language"],"noTemplates":[4,"no-templates"],"showTokens":[32],"availableTokens":[32],"filteredTokens":[32],"ariaActivedescendant":[32],"currentWord":[32],"validationError":[32],"configEventTitle":[32],"additionalFieldTokens":[32]},[[8,"formSubmitted","formSubmittedHandler"],[4,"valueChanged","valueChangedHandler"]],{"name":["elementNameChangedHandler"],"ariaActivedescendant":["ariaActivedescendantChangedHandler"],"selectedConfiguration":["configChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[1,"input-color-picker",{"name":[1],"defaultSelectedColor":[1,"default-selected-color"],"selectedColor":[32],"isOpen":[32],"ariaActivedescendant":[32],"errorMessage":[32]},[[6,"click","handleOutsideClick"]]],[65,"input-image-url",{"imageUrl":[1,"image-url"],"errorMessage":[1,"error-message"],"name":[1],"currentImageUrl":[32],"error":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangedHandler"],[0,"nylasFormInputBlurred","nylasFormInputBlurHandler"]],{"name":["elementNameChangedHandler"],"errorMessage":["errorMessageChangedHandler"]}],[65,"nylas-event-info",{"selectedLanguage":[1,"selected-language"]},null,{"selectedLanguage":["selectedLanguageChangedHandler"]}],[2,"checkmark-icon",{"width":[1],"height":[1]}],[2,"dragable-icon",{"width":[1],"height":[1]}],[2,"eye-icon",{"width":[1],"height":[1]}],[2,"feedback-icon",{"width":[1],"height":[1]}],[2,"trash-icon",{"width":[1],"height":[1]}],[2,"copy-icon",{"width":[1],"height":[1]}]]],["nylas-event-calendar_3",[[65,"nylas-event-calendar",{"selectedConfiguration":[16],"name":[1],"selectedLanguage":[1,"selected-language"],"groupEvents":[16],"currentUser":[16],"calendars":[16],"masterGroupEvents":[16],"isLoading":[4,"is-loading"],"selectedView":[32],"events":[32],"calendar":[32],"selectedEvent":[32],"selectedDateRangeString":[32],"showEditEventDetails":[32],"showCreateEventDetails":[32],"editOptionChoices":[32],"updateOptionChoices":[32],"deleteOptionChoices":[32],"editOptions":[32],"showEditOptions":[32],"updateOptions":[32],"showUpdateOptions":[32],"deleteOptions":[32],"showDeleteOptions":[32],"unsavedChanges":[32],"showConfirmDiscardUnsavedChangesModal":[32],"createNewGroupEventTimeslot":[32],"formError":[32],"formErrors":[32],"loadingOptions":[32],"showChooseParticipantsModal":[32],"importParticipants":[32],"selectedImportParticipants":[32]},[[0,"valueChanged","valueChangedHandler"],[0,"timeWindowFormError","timeWindowFormErrorHandler"],[0,"dateTimeInputError","dateTimeInputErrorHandler"],[4,"saveGroupEventChangesError","saveGroupEventChangesErrorHandler"],[0,"selectedOptionsChanged","selectedOptionsChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"],"groupEvents":["groupEventsChangedHandler"],"isLoading":["isLoadingChangedHandler"]}],[65,"nylas-event-timeslot",{"name":[1],"initialValue":[16],"selectedLanguage":[1,"selected-language"],"currentUser":[16],"selectedDate":[32],"selectedStartTime":[32],"selectedEndTime":[32],"selectedTimezone":[32],"selectedRecurrenceType":[32],"timeRangeError":[32],"selectedRrule":[32],"recurrenceOptions":[32],"repeatEveryInterval":[32],"repeatEveryFrequency":[32],"repeatOnDays":[32],"repeatMonthlySameDate":[32],"repeatEndType":[32],"repeatEndAfter":[32],"repeatEndOn":[32],"monthRecurrenceOptions":[32],"endDate":[32],"hasDateTimeInputError":[32]},[[0,"timeChange","setTime"],[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormInputChanged","nylasFormInputChangedHandler"],[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-event-capacity",{"name":[1],"capacity":[2],"selectedLanguage":[1,"selected-language"],"selectedEventCapacity":[32],"error":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangeHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}]]],["clock-icon_4",[[2,"person-clipboard-icon",{"width":[1],"height":[1]}],[2,"plus-icon",{"width":[1],"height":[1]}],[2,"edit-icon",{"width":[1],"height":[1]}],[2,"clock-icon",{"width":[1],"height":[1]}]]],["calendar-agenda-fill-icon_36",[[65,"nylas-participants-custom-availability",{"selectedConfiguration":[16],"name":[1],"participants":[16],"selectedLanguage":[1,"selected-language"],"selectedParticipants":[32]},[[0,"nylasFormSwitchToggled","nylasFormSwitchToggledHandler"],[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"participants":["participantsChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-limit-future-bookings",{"selectedConfiguration":[16],"availableDaysInFuture":[2,"available-days-in-future"],"name":[1],"selectedLanguage":[1,"selected-language"],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-connected-calendars",{"name":[1],"selectedConfiguration":[16],"participants":[16],"calendars":[16],"participantOptions":[16],"selectedLanguage":[1,"selected-language"],"selectedCalendars":[32],"participantCalendars":[32],"participantDefaultSelectedCalendars":[32]},[[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"calendars":["calendarsChangedHandler"],"participants":["participantsChangedHandler"],"participantOptions":["participantOptionsChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-participant-booking-calendars",{"selectedConfiguration":[16],"name":[1],"participants":[16],"calendars":[16],"participantOptions":[16],"selectedLanguage":[1,"selected-language"],"selectedCalendars":[32],"participantCalendars":[32],"participantDefaultSelectedCalendar":[32]},[[0,"valueChanged","handleValueChanged"]],{"name":["elementNameChangedHandler"],"calendars":["calendarsChangedHandler"],"participants":["participantsChangedHandler"],"participantOptions":["participantOptionsChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-timeslot-interval",{"selectedConfiguration":[16],"name":[1],"eventDurationMinutes":[2,"event-duration-minutes"],"selectedLanguage":[1,"selected-language"],"internalEventDurationMinutes":[32],"selectedInterval":[32],"selectedRoundTo":[32],"componentLoaded":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormRadioChanged","nylasFormRadioChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-buffer-time",{"selectedConfiguration":[16],"name":[1],"buffer":[16],"selectedLanguage":[1,"selected-language"],"selectedBeforeBufferTime":[32],"selectedAfterBufferTime":[32],"componentLoaded":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-event-duration",{"selectedConfiguration":[16],"name":[1],"eventDurationMinutes":[2,"event-duration-minutes"],"selectedLanguage":[1,"selected-language"],"duration":[32],"durationMinutes":[32],"durationIncrement":[32],"error":[32],"durationMinutesOptions":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"inputOptionChanged","inputOptionChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[2,"calendar-info-icon",{"width":[1],"height":[1]}],[2,"calendar-patterns-icon",{"width":[1],"height":[1]}],[2,"people-icon",{"width":[1],"height":[1]}],[65,"nylas-reminder-emails",{"selectedConfiguration":[16],"eventReminders":[16],"name":[1],"selectedLanguage":[1,"selected-language"],"reminders":[32],"reminderErrors":[32],"participants":[32],"clearError":[32]},[[0,"valueChanged","handleValueChanged"],[0,"nylasFormDropdownChanged","handleNylasFormDropdownChanged"],[0,"nylasFormInputChanged","handleNylasFormInputChanged"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-confirmation-email",{"selectedConfiguration":[16],"confirmationEmailTemplate":[16],"participants":[16],"name":[1],"nylasBranding":[4,"nylas-branding"],"isOpen":[4,"is-open"],"selectedLanguage":[1,"selected-language"],"confirmationEmail":[32],"isConfirmationEmailOpen":[32],"participantsState":[32],"invalidImageErrorMessage":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangeHandler"],[0,"valueChanged","valueChangedHandler"],[0,"nylasFormInputImageUrlInvalid","nylasFormInputImageUrlInvalidHandler"],[0,"nylasFormSwitchToggled","nyalsFormSwitchToggledHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"nylasBranding":["nylasBrandingChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-availability-picker",{"name":[1],"selectedConfiguration":[16],"openHours":[16],"defaultTimezone":[1,"default-timezone"],"hideHeader":[4,"hide-header"],"selectedLanguage":[1,"selected-language"],"schedule":[32],"timezone":[32],"overlapDays":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"timeChange","setTime"],[0,"timeWindowFormError","setFormError"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["configChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-booking-form-config",{"selectedConfiguration":[16],"name":[1],"additionalFields":[16],"selectedLanguage":[1,"selected-language"],"staticFields":[32],"formFields":[32],"formFieldsOrder":[32],"count":[32],"watchFields":[32],"fieldTypes":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormInputChanged","nylasFormInputChangedHandler"],[4,"valueChanged","valueChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-disable-emails",{"selectedConfiguration":[16],"name":[1],"selectedLanguage":[1,"selected-language"],"organizerLocale":[32],"disableEmails":[32]},[[0,"nylasFormSwitchToggled","nyalsFormSwitchToggledHandler"],[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-min-booking-notice",{"selectedConfiguration":[16],"name":[1],"minBookingNotice":[2,"min-booking-notice"],"selectedLanguage":[1,"selected-language"],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-min-cancellation-notice",{"selectedConfiguration":[16],"name":[1],"minCancellationNotice":[2,"min-cancellation-notice"],"selectedLanguage":[1,"selected-language"],"selectedNumber":[32],"selectedPeriod":[32]},[[0,"timePeriodChanged","timePeriodChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-booking-confirmation-redirect",{"selectedConfiguration":[16],"name":[1],"redirectUrl":[1,"redirect-url"],"redirectUrlErrorMessage":[1,"redirect-url-error-message"],"selectedLanguage":[1,"selected-language"],"currentRedirectUrl":[32],"acceptUrl":[32],"componentLoaded":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[0,"nylasFormInputBlurred","nylasFormInputBlurHandler"],[4,"formSubmitted","formSubmittedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-custom-event-slug",{"selectedConfiguration":[16],"defaultUrlSlug":[1,"default-url-slug"],"isOpen":[4,"is-open"],"slugErrorMessage":[1,"slug-error-message"],"name":[1],"requiresSlug":[4,"requires-slug"],"selectedLanguage":[1,"selected-language"],"urlSlug":[32],"focus":[32],"copied":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangeHandler"],[0,"nylasFormInputFocused","nylasFormInputFocusHandler"],[0,"nylasFormInputBlurred","nylasFormInputBlurHandler"],[8,"formSubmitted","formSubmittedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-scheduling-method",{"selectedConfiguration":[16],"name":[1],"participantOptions":[16],"readOnly":[4,"read-only"],"selectedLanguage":[1,"selected-language"],"showSubTitle":[4,"show-sub-title"],"selectedBookingType":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-booking-calendar-picker",{"calendars":[16],"currentUser":[16],"currentUserCalendars":[16],"name":[1],"defaultBookingCalendar":[1,"default-booking-calendar"],"hideHeader":[4,"hide-header"],"expressFlow":[4,"express-flow"],"selectedLanguage":[1,"selected-language"],"selectedCalendar":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"currentUserCalendars":["currentUserCalendarsChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-booking-confirmation-type",{"selectedConfiguration":[16],"name":[1],"bookingType":[1,"booking-type"],"showComponent":[4,"show-component"],"selectedLanguage":[1,"selected-language"],"selectedBookingType":[32],"showDropdown":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-calendar-picker",{"name":[1],"currentUser":[16],"calendars":[16],"defaultSelectedCalendars":[16],"selectedLanguage":[1,"selected-language"],"selectedCalendars":[32],"error":[32]},[[0,"selectedOptionsChanged","selectedOptionsChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-page-name",{"selectedConfiguration":[16],"name":[1],"pageName":[1,"page-name"],"showToggle":[4,"show-toggle"],"isOpen":[4,"is-open"],"required":[4],"selectedLanguage":[1,"selected-language"],"requirePageName":[4,"require-page-name"],"currentPageName":[32],"pageNameErrorMessage":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangeHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-customize-booking-settings",{"selectedConfiguration":[16],"defaultHideAdditionalGuests":[4,"default-hide-additional-guests"],"defaultHideCancellationOptions":[4,"default-hide-cancellation-options"],"defaultHideReschedulingOptions":[4,"default-hide-rescheduling-options"],"name":[1],"selectedLanguage":[1,"selected-language"],"showSettings":[16],"allowGuestsToInvite":[32],"hideCancellationOptions":[32],"hideReschedulingOptions":[32]},[[0,"nylasFormCheckboxToggled","checkboxToggledHandler"]],{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-cancellation-policy",{"selectedConfiguration":[16],"cancellationPolicy":[1,"cancellation-policy"],"name":[1],"selectedLanguage":[1,"selected-language"],"message":[32]},null,{"name":["elementNameChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-page-styling",{"selectedConfiguration":[16],"name":[1],"appearance":[16],"isOpen":[4,"is-open"],"selectedLanguage":[1,"selected-language"],"currentAppearance":[32],"customInputsSlot":[32]},[[4,"nylasFormInputChanged","nylasFormInputChangeHandler"],[4,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"],[4,"valueChanged","valueChangedHandler"],[4,"nylasFormCheckboxToggled","checkboxToggledHandler"],[4,"nylasFormRadioChanged","radioChangedHandler"]],{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"],"selectedConfiguration":["selectedConfigurationChangedHandler"]}],[65,"nylas-custom-booking-flow",{"selectedLanguage":[1,"selected-language"]},null,{"selectedLanguage":["selectedLanguageChangedHandler"]}],[65,"nylas-event-limits",{"selectedLanguage":[1,"selected-language"]},null,{"selectedLanguage":["selectedLanguageChangedHandler"]}],[2,"calendar-agenda-fill-icon",{"width":[1],"height":[1]}],[2,"calendar-agenda-icon",{"width":[1],"height":[1]}],[2,"envelope-fill-icon",{"width":[1],"height":[1]}],[2,"envelope-icon",{"width":[1],"height":[1]}],[2,"flow-icon",{"width":[1],"height":[1]}],[2,"paintbrush-fill-icon",{"width":[1],"height":[1]}],[2,"paintbrush-icon",{"width":[1],"height":[1]}]]],["google-logo-icon_6",[[6,"nylas-editor-tabs",{"calendars":[16],"selectedConfiguration":[16],"configurations":[16],"currentUser":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"mode":[1],"hideEditorTabs":[16],"enableUserFeedback":[4,"enable-user-feedback"],"selectedLanguage":[1,"selected-language"],"selectedEventType":[1,"selected-event-type"],"action":[32],"showFeedbackModal":[32],"activeTab":[32],"isLoading":[32],"hasUnsavedChanges":[32],"changesSaved":[32],"formState":[32],"error":[32],"schedulerConfigCreatedEventHandler":[64],"setError":[64]},[[0,"valueChanged","handleValueChanged"],[0,"feedbackModalClosed","feedbackModalClosedHandler"],[0,"feedbackSubmitted","feedbackSubmittedHandler"]],{"selectedConfiguration":["configChangedHandler"],"currentUser":["userChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[6,"nylas-editor-tabs-group",{"calendars":[16],"selectedConfiguration":[16],"configurations":[16],"currentUser":[16],"schedulerPreviewLink":[1,"scheduler-preview-link"],"mode":[1],"hideEditorTabs":[16],"enableUserFeedback":[4,"enable-user-feedback"],"selectedLanguage":[1,"selected-language"],"selectedEventType":[1,"selected-event-type"],"selectedGroupEvent":[16],"action":[32],"showFeedbackModal":[32],"activeTab":[32],"isLoading":[32],"hasUnsavedChanges":[32],"changesSaved":[32],"formState":[32],"error":[32],"schedulerConfigCreatedEventHandler":[64],"setError":[64],"resetError":[64]},[[0,"valueChanged","handleValueChanged"],[0,"feedbackModalClosed","feedbackModalClosedHandler"],[0,"feedbackSubmitted","feedbackSubmittedHandler"],[0,"importGroupEvent","importGroupEventHandler"],[0,"saveGroupEventChanges","saveGroupEventChangesHandler"],[0,"deleteGroupEvent","deleteGroupEventHandler"],[0,"createGroupEvent","createGroupEventHandler"]],{"selectedConfiguration":["configChangedHandler"],"selectedGroupEvent":["selectedGroupEventChangedHandler"],"currentUser":["userChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[1,"nylas-list-configurations",{"configurations":[16],"selectedLanguage":[1,"selected-language"],"schedulerPreviewLink":[1,"scheduler-preview-link"],"listConfigurationsNextCursor":[1,"list-configurations-next-cursor"],"state":[32],"error":[32],"currentCursor":[32],"previousCursors":[32],"disableNextPageButton":[32],"deleteConfigurationId":[32],"showDeleteButtonLoading":[32],"registerCallback":[64],"getState":[64],"setState":[64],"setError":[64],"hideDeleteConfirmation":[64]},[[0,"nylasFormDropdownChanged","handleNylasFormDropdownChanged"]],{"listConfigurationsNextCursor":["listConfigurationsNextCursorChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[1,"nylas-select-event-type",{"participantOptions":[16],"name":[1],"selectedLanguage":[1,"selected-language"],"enableEventTypes":[16]},null,{"name":["elementNameChangedHandler"],"selectedLanguage":["selectedLanguageChangedHandler"]}],[2,"google-logo-icon",{"width":[1],"height":[1]}],[2,"microsoft-logo-icon",{"width":[1],"height":[1]}]]],["nylas-booked-event-card_12",[[1,"nylas-booking-form",{"isLoading":[4,"is-loading"],"bookingInfo":[16],"eventInfo":[16],"configSettings":[16],"themeConfig":[8,"theme-config"],"selectedTimeslot":[16],"name":[32],"email":[32],"guestEmails":[32],"guestEmailErrors":[32],"isNameValid":[32],"isEmailValid":[32],"additionalFields":[32],"validationError":[32],"backButtonLoading":[32],"firstRender":[32]},[[0,"nylasFormInputChanged","nylasFormInputChangedHandler"],[0,"nylasFormDropdownChanged","selectOptionChangedHandler"],[0,"selectedOptionsChanged","selecedOptionsChangedHandler"],[0,"nylasFormSwitchToggled","switchToggledHandler"],[0,"nylasFormCheckboxToggled","checkboxToggledHandler"],[0,"nylasFormRadioChanged","radioChangedHandler"],[0,"nylasFormDropdownDefaultSelected","dropdownDefaultSelectedHandler"]],{"bookingInfo":["bookingInfoChangedHandler"],"configSettings":["configSettingsChangedHandler"],"themeConfig":["themeConfigChanged"]}],[1,"nylas-cancel-booking-form",{"cancelBookingId":[1,"cancel-booking-id"],"rejectBookingId":[1,"reject-booking-id"],"selectedTimeslot":[16],"configSettings":[16],"eventInfo":[16],"isLoading":[4,"is-loading"],"themeConfig":[8,"theme-config"],"cancellationReason":[32],"cancellationError":[32],"cancellationPolicy":[32]},[[0,"nylasFormInputChanged","handleNylasFormInputChanged"]],{"configSettings":["configSettingsChangedHandler"],"themeConfig":["themeConfigChanged"]}],[1,"nylas-booked-event-card",{"eventInfo":[16],"rescheduleBookingId":[1,"reschedule-booking-id"],"bookingInfo":[16],"configSettings":[16],"isLoading":[4,"is-loading"],"themeConfig":[8,"theme-config"],"selectedTimezone":[1,"selected-timezone"],"selectedTimeslot":[16],"selectedLanguage":[1,"selected-language"],"hour12":[4,"hour-1-2"],"startTime":[32],"endTime":[32]},null,{"themeConfig":["themeConfigChanged"]}],[1,"nylas-locale-switch",{"themeConfig":[8,"theme-config"],"bookingInfo":[16],"selectedTimezone":[1025,"selected-timezone"],"selectedLanguage":[1025,"selected-language"],"searchPlaceholder":[32]},[[0,"nylasFormDropdownChanged","nylasFormDropdownChangedHandler"]],{"themeConfig":["themeConfigChanged"],"bookingInfo":["bookingInfoChangedHandler"]}],[1,"nylas-cancelled-event-card",{"configSettings":[16],"themeConfig":[8,"theme-config"],"cancelledEventInfo":[16],"isClosing":[32]},null,{"themeConfig":["themeConfigChanged"]}],[1,"nylas-confirmed-event-card",{"configSettings":[16],"themeConfig":[8,"theme-config"],"confirmedEventInfo":[16],"isClosing":[32]},null,{"themeConfig":["themeConfigChanged"]}],[1,"nylas-date-picker",{"selectableDates":[16],"configSettings":[16],"themeConfig":[8,"theme-config"],"selectedTimezone":[1,"selected-timezone"],"selectedDate":[16],"selectedLanguage":[1,"selected-language"],"isLoading":[4,"is-loading"],"eventDuration":[2,"event-duration"],"month":[32],"dates":[32],"disableNextMonthButton":[32],"selectableDatesTimezone":[32]},null,{"configSettings":["configSettingsChanged"],"selectedLanguage":["selectedLanguageChanged"],"themeConfig":["themeConfigChanged"],"selectedDate":["selectedDateChanged"],"selectedTimezone":["selectedTimezoneChanged"],"selectableDates":["selectableDatesChanged"]}],[1,"nylas-organizer-confirmation-card",{"configSettings":[16],"isLoading":[4,"is-loading"],"themeConfig":[8,"theme-config"],"organizerConfirmationBookingId":[1,"organizer-confirmation-booking-id"],"selectedLanguage":[1,"selected-language"],"action":[32],"resetAction":[64]},null,{"themeConfig":["themeConfigChanged"]}],[1,"nylas-notification",{"ttl":[8],"allowedCategories":[16],"notifications":[32]},[[16,"nylasSchedulerError","onError"],[16,"nylasSchedulerWarning","onWarning"],[16,"nylasSchedulerInfo","onInfo"],[16,"nylasSchedulerSuccess","onSuccess"]]],[1,"nylas-selected-event-card",{"themeConfig":[8,"theme-config"],"selectedDate":[16],"selectedTimeslot":[16],"selectedTimezone":[1,"selected-timezone"],"selectedLanguage":[1,"selected-language"],"hour12":[4,"hour-1-2"],"startTime":[32],"endTime":[32]},null,{"themeConfig":["themeConfigChanged"]}],[1,"nylas-timeslot-picker",{"availability":[16],"isLoading":[4,"loading-state"],"themeConfig":[8,"theme-config"],"selectedTimeslot":[16],"selectedTimezone":[1,"selected-timezone"],"selectedDate":[16],"selectedLanguage":[1,"selected-language"],"hour12":[4,"hour-1-2"],"times":[32],"hoveredTimeslotIndex":[32],"selectedTimeslotIndex":[32],"emitValidateTimeslotError":[64]},null,{"selectedLanguage":["selectedLanguageChanged"],"selectedDate":["selectedDateChanged"],"availability":["availabilityChanged"],"themeConfig":["themeConfigChanged"]}],[2,"nylas-logo",{"width":[1],"height":[1]}]]]]'), e);
};
(function() {
  if (typeof window < "u" && window.Reflect !== void 0 && window.customElements !== void 0) {
    var n = HTMLElement;
    window.HTMLElement = function() {
      return Reflect.construct(n, [], this.constructor);
    }, HTMLElement.prototype = n.prototype, HTMLElement.prototype.constructor = HTMLElement, Object.setPrototypeOf(HTMLElement, n);
  }
})();
const wA = (n) => n.toLowerCase().split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(""), P$ = (n) => n.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), $A = (n, e, t = {}) => {
  if (n instanceof Element) {
    const i = BA(n.classList, e, t);
    i !== "" && (n.className = i), Object.keys(e).forEach((a) => {
      if (!(a === "children" || a === "style" || a === "ref" || a === "class" || a === "className" || a === "forwardedRef"))
        if (a.indexOf("on") === 0 && a[2] === a[2].toUpperCase()) {
          const r = a.substring(2), o = r[0].toLowerCase() + r.substring(1);
          M$(o) || MA(n, o, e[a]);
        } else
          n[a] = e[a], typeof e[a] === "string" && n.setAttribute(P$(a), e[a]);
    });
  }
}, BA = (n, e, t) => {
  const i = e.className || e.class, a = t.className || t.class, r = Qn(n), o = Qn(i ? i.split(" ") : []), l = Qn(a ? a.split(" ") : []), s = [];
  return r.forEach((u) => {
    o.has(u) ? (s.push(u), o.delete(u)) : l.has(u) || s.push(u);
  }), o.forEach((u) => s.push(u)), s.join(" ");
}, PA = (n) => {
  switch (n) {
    case "doubleclick":
      return "dblclick";
  }
  return n;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
const M$ = (n) => {
  if (typeof document > "u")
    return !0;
  {
    const e = "on" + PA(n);
    let t = e in document;
    if (!t) {
      const i = document.createElement("div");
      i.setAttribute(e, "return;"), t = typeof i[e] == "function";
    }
    return t;
  }
}, MA = (n, e, t) => {
  const i = n.__events || (n.__events = {}), a = i[e];
  a && n.removeEventListener(e, a), n.addEventListener(
    e,
    i[e] = function(o) {
      t && t.call(this, o);
    }
  );
}, Qn = (n) => {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((t) => e.set(t, t)), e;
}, DA = (n, e) => {
  typeof n == "function" ? n(e) : n != null && (n.current = e);
}, AA = (...n) => (e) => {
  n.forEach((t) => {
    DA(t, e);
  });
}, LA = (n, e) => {
  const t = (i, a) => /* @__PURE__ */ O$(n, { ...i, forwardedRef: a });
  return t.displayName = e, Lr.forwardRef(t);
}, k = (n, e, t, i) => {
  i !== void 0 && i();
  const a = wA(n), r = class extends Lr.Component {
    constructor(l) {
      super(l);
      Un(this, "componentEl");
      Un(this, "setComponentElRef", (l) => {
        this.componentEl = l;
      });
    }
    componentDidMount() {
      this.componentDidUpdate(this.props);
    }
    componentDidUpdate(l) {
      $A(this.componentEl, this.props, l);
    }
    render() {
      const { children: l, forwardedRef: s, style: u, className: c, ref: f, ...d } = this.props;
      let g = Object.keys(d).reduce((p, h) => {
        const E = d[h];
        if (h.indexOf("on") === 0 && h[2] === h[2].toUpperCase()) {
          const B = h.substring(2).toLowerCase();
          typeof document < "u" && M$(B) && (p[h] = E);
        } else {
          const B = typeof E;
          (B === "string" || B === "boolean" || B === "number") && (p[P$(h)] = E);
        }
        return p;
      }, {});
      t && (g = t(this.props, g));
      const b = {
        ...g,
        ref: AA(s, this.setComponentElRef),
        style: u
      };
      return L$(n, b, l);
    }
    static get displayName() {
      return a;
    }
  };
  return e && (r.contextType = e), LA(r, a);
};
CA();
const x5 = /* @__PURE__ */ k("add-circle-icon"), S5 = /* @__PURE__ */ k("archive-icon"), C5 = /* @__PURE__ */ k("arrow-icon"), w5 = /* @__PURE__ */ k("bold-icon"), $5 = /* @__PURE__ */ k("button-component"), B5 = /* @__PURE__ */ k("calendar-agenda-fill-icon"), P5 = /* @__PURE__ */ k("calendar-agenda-icon"), M5 = /* @__PURE__ */ k("calendar-cancel-icon"), D5 = /* @__PURE__ */ k("calendar-check-icon"), A5 = /* @__PURE__ */ k("calendar-icon"), L5 = /* @__PURE__ */ k("calendar-info-icon"), O5 = /* @__PURE__ */ k("calendar-patterns-icon"), _5 = /* @__PURE__ */ k("checkbox-component"), I5 = /* @__PURE__ */ k("checkmark-circle-icon"), R5 = /* @__PURE__ */ k("checkmark-icon"), N5 = /* @__PURE__ */ k("chevron-icon"), F5 = /* @__PURE__ */ k("clock-icon"), U5 = /* @__PURE__ */ k("close-icon"), z5 = /* @__PURE__ */ k("copy-icon"), H5 = /* @__PURE__ */ k("delete-icon"), j5 = /* @__PURE__ */ k("document-refresh-icon"), q5 = /* @__PURE__ */ k("dragable-icon"), Y5 = /* @__PURE__ */ k("edit-icon"), V5 = /* @__PURE__ */ k("envelope-fill-icon"), G5 = /* @__PURE__ */ k("envelope-icon"), W5 = /* @__PURE__ */ k("eye-icon"), K5 = /* @__PURE__ */ k("feedback-icon"), Z5 = /* @__PURE__ */ k("flow-icon"), J5 = /* @__PURE__ */ k("folder-icon"), Q5 = /* @__PURE__ */ k("forward-icon"), X5 = /* @__PURE__ */ k("globe-icon"), eL = /* @__PURE__ */ k("google-logo-icon"), tL = /* @__PURE__ */ k("google-meet-icon"), nL = /* @__PURE__ */ k("inbox-icon"), iL = /* @__PURE__ */ k("info-icon"), aL = /* @__PURE__ */ k("input-color-picker"), rL = /* @__PURE__ */ k("input-component"), oL = /* @__PURE__ */ k("input-dropdown"), sL = /* @__PURE__ */ k("input-image-url"), lL = /* @__PURE__ */ k("italic-icon"), uL = /* @__PURE__ */ k("loading-icon"), cL = /* @__PURE__ */ k("location-icon"), dL = /* @__PURE__ */ k("location-off-icon"), fL = /* @__PURE__ */ k("microsoft-logo-icon"), gL = /* @__PURE__ */ k("microsoft-teams-icon"), hL = /* @__PURE__ */ k("multi-select-dropdown"), mL = /* @__PURE__ */ k("nylas-additional-participants"), pL = /* @__PURE__ */ k("nylas-availability-picker"), bL = /* @__PURE__ */ k("nylas-booked-event-card"), yL = /* @__PURE__ */ k("nylas-booking-calendar-picker"), vL = /* @__PURE__ */ k("nylas-booking-confirmation-redirect"), TL = /* @__PURE__ */ k("nylas-booking-confirmation-type"), kL = /* @__PURE__ */ k("nylas-booking-form"), EL = /* @__PURE__ */ k("nylas-booking-form-config"), xL = /* @__PURE__ */ k("nylas-buffer-time"), SL = /* @__PURE__ */ k("nylas-calendar-picker"), CL = /* @__PURE__ */ k("nylas-cancel-booking-form"), wL = /* @__PURE__ */ k("nylas-cancellation-policy"), $L = /* @__PURE__ */ k("nylas-cancelled-event-card"), BL = /* @__PURE__ */ k("nylas-confirmation-email"), PL = /* @__PURE__ */ k("nylas-confirmed-event-card"), ML = /* @__PURE__ */ k("nylas-connected-calendars"), DL = /* @__PURE__ */ k("nylas-custom-booking-flow"), AL = /* @__PURE__ */ k("nylas-custom-event-slug"), LL = /* @__PURE__ */ k("nylas-customize-booking-settings"), OL = /* @__PURE__ */ k("nylas-date-component"), _L = /* @__PURE__ */ k("nylas-date-picker"), IL = /* @__PURE__ */ k("nylas-disable-emails"), RL = /* @__PURE__ */ k("nylas-editor-tabs"), NL = /* @__PURE__ */ k("nylas-editor-tabs-group"), FL = /* @__PURE__ */ k("nylas-event-calendar"), UL = /* @__PURE__ */ k("nylas-event-capacity"), zL = /* @__PURE__ */ k("nylas-event-description"), HL = /* @__PURE__ */ k("nylas-event-duration"), jL = /* @__PURE__ */ k("nylas-event-info"), qL = /* @__PURE__ */ k("nylas-event-limits"), YL = /* @__PURE__ */ k("nylas-event-location"), VL = /* @__PURE__ */ k("nylas-event-timeslot"), GL = /* @__PURE__ */ k("nylas-event-title"), WL = /* @__PURE__ */ k("nylas-feedback-form"), KL = /* @__PURE__ */ k("nylas-form-card"), ZL = /* @__PURE__ */ k("nylas-limit-future-bookings"), JL = /* @__PURE__ */ k("nylas-list-configurations"), QL = /* @__PURE__ */ k("nylas-locale-switch"), XL = /* @__PURE__ */ k("nylas-logo"), eO = /* @__PURE__ */ k("nylas-min-booking-notice"), tO = /* @__PURE__ */ k("nylas-min-cancellation-notice"), nO = /* @__PURE__ */ k("nylas-notification"), iO = /* @__PURE__ */ k("nylas-organizer-confirmation-card"), aO = /* @__PURE__ */ k("nylas-page-name"), rO = /* @__PURE__ */ k("nylas-page-styling"), oO = /* @__PURE__ */ k("nylas-participant-booking-calendars"), sO = /* @__PURE__ */ k("nylas-participants-custom-availability"), lO = /* @__PURE__ */ k("nylas-reminder-emails"), uO = /* @__PURE__ */ k("nylas-reminder-time"), cO = /* @__PURE__ */ k("nylas-scheduler-editor"), dO = /* @__PURE__ */ k("nylas-scheduling"), fO = /* @__PURE__ */ k("nylas-scheduling-method"), gO = /* @__PURE__ */ k("nylas-select-event-type"), hO = /* @__PURE__ */ k("nylas-selected-event-card"), mO = /* @__PURE__ */ k("nylas-time-window-picker"), pO = /* @__PURE__ */ k("nylas-timeslot-interval"), bO = /* @__PURE__ */ k("nylas-timeslot-picker"), yO = /* @__PURE__ */ k("paintbrush-fill-icon"), vO = /* @__PURE__ */ k("paintbrush-icon"), TO = /* @__PURE__ */ k("people-icon"), kO = /* @__PURE__ */ k("person-clipboard-icon"), EO = /* @__PURE__ */ k("person-icon"), xO = /* @__PURE__ */ k("play-icon"), SO = /* @__PURE__ */ k("plus-icon"), CO = /* @__PURE__ */ k("radio-button-group"), wO = /* @__PURE__ */ k("refresh-icon"), $O = /* @__PURE__ */ k("reply-all-icon"), BO = /* @__PURE__ */ k("reply-icon"), PO = /* @__PURE__ */ k("search-icon"), MO = /* @__PURE__ */ k("select-dropdown"), DO = /* @__PURE__ */ k("sent-icon"), AO = /* @__PURE__ */ k("spam-icon"), LO = /* @__PURE__ */ k("star-icon"), OO = /* @__PURE__ */ k("stop-icon"), _O = /* @__PURE__ */ k("textarea-component"), IO = /* @__PURE__ */ k("time-period-selector"), RO = /* @__PURE__ */ k("toggle-switch"), NO = /* @__PURE__ */ k("tooltip-component"), FO = /* @__PURE__ */ k("translate-icon"), UO = /* @__PURE__ */ k("trash-fill-icon"), zO = /* @__PURE__ */ k("trash-icon"), HO = /* @__PURE__ */ k("underline-icon"), jO = /* @__PURE__ */ k("warning-icon"), qO = /* @__PURE__ */ k("zoom-icon");
export {
  UA as $,
  KA as A,
  $ as B,
  ZA as C,
  JA as D,
  g5 as E,
  FA as F,
  b5 as G,
  H$ as H,
  jA as I,
  QA as J,
  s5 as K,
  r5 as L,
  o5 as M,
  E5 as N,
  y5 as O,
  h5 as P,
  l5 as Q,
  T5 as R,
  v5 as S,
  d5 as T,
  u5 as U,
  VA as V,
  a5 as W,
  t5 as X,
  i5 as Y,
  n5 as Z,
  CA as _,
  NA as a,
  AL as a$,
  x5 as a0,
  S5 as a1,
  C5 as a2,
  w5 as a3,
  $5 as a4,
  B5 as a5,
  P5 as a6,
  M5 as a7,
  D5 as a8,
  A5 as a9,
  rL as aA,
  oL as aB,
  sL as aC,
  lL as aD,
  uL as aE,
  cL as aF,
  dL as aG,
  fL as aH,
  gL as aI,
  hL as aJ,
  mL as aK,
  pL as aL,
  bL as aM,
  yL as aN,
  vL as aO,
  TL as aP,
  kL as aQ,
  EL as aR,
  xL as aS,
  SL as aT,
  CL as aU,
  wL as aV,
  $L as aW,
  BL as aX,
  PL as aY,
  ML as aZ,
  DL as a_,
  L5 as aa,
  O5 as ab,
  _5 as ac,
  I5 as ad,
  R5 as ae,
  N5 as af,
  F5 as ag,
  U5 as ah,
  z5 as ai,
  H5 as aj,
  j5 as ak,
  q5 as al,
  Y5 as am,
  V5 as an,
  G5 as ao,
  W5 as ap,
  K5 as aq,
  Z5 as ar,
  J5 as as,
  Q5 as at,
  X5 as au,
  eL as av,
  tL as aw,
  nL as ax,
  iL as ay,
  aL as az,
  YA as b,
  HO as b$,
  LL as b0,
  OL as b1,
  _L as b2,
  IL as b3,
  RL as b4,
  NL as b5,
  FL as b6,
  UL as b7,
  zL as b8,
  HL as b9,
  mO as bA,
  pO as bB,
  bO as bC,
  yO as bD,
  vO as bE,
  TO as bF,
  kO as bG,
  EO as bH,
  xO as bI,
  SO as bJ,
  CO as bK,
  wO as bL,
  $O as bM,
  BO as bN,
  PO as bO,
  MO as bP,
  DO as bQ,
  AO as bR,
  LO as bS,
  OO as bT,
  _O as bU,
  IO as bV,
  RO as bW,
  NO as bX,
  FO as bY,
  UO as bZ,
  zO as b_,
  jL as ba,
  qL as bb,
  YL as bc,
  VL as bd,
  GL as be,
  WL as bf,
  KL as bg,
  ZL as bh,
  JL as bi,
  QL as bj,
  XL as bk,
  eO as bl,
  tO as bm,
  nO as bn,
  iO as bo,
  aO as bp,
  rO as bq,
  oO as br,
  sO as bs,
  lO as bt,
  uO as bu,
  cO as bv,
  dO as bw,
  fO as bx,
  gO as by,
  hO as bz,
  ne as c,
  jO as c0,
  qO as c1,
  ve as d,
  PB as e,
  Dr as f,
  G$ as g,
  Nr as h,
  qi as i,
  k5 as j,
  m5 as k,
  f5 as l,
  p5 as m,
  Sa as n,
  GA as o,
  dr as p,
  WA as q,
  zA as r,
  Ar as s,
  gA as t,
  fA as u,
  c5 as v,
  XA as w,
  dA as x,
  qA as y,
  e5 as z
};
